import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** Represents non-fractional signed whole numeric values. Since the value may exceed the size of a 32-bit integer, it's encoded as a string. */
  BigInt: any;
  /** An ISO 8601-encoded date */
  ISO8601Date: any;
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: string | Date;
  /** Represents untyped JSON */
  JSON: any;
};

/** Represents an accessory item that can be included with rentals or purchases */
export type Accessory = {
  __typename?: 'Accessory';
  /** ID of the accessory group this accessory belongs to. */
  accessoryGroupId?: Maybe<Scalars['Int']>;
  /** Indicates if the accessory is currently active. */
  active?: Maybe<Scalars['Boolean']>;
  /** Buffer time for the accessory in minutes. */
  buffer?: Maybe<Scalars['Float']>;
  /**
   * ID of the category to which the accessory belongs.
   * @deprecated Use sf_categories instead
   */
  categoryId?: Maybe<Scalars['Int']>;
  /** Name of the collection this accessory belongs to. */
  collectionName?: Maybe<Scalars['String']>;
  /** Timestamp when the accessory was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Timestamp when the accessory was deleted, if applicable. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Comma-separated names of departments associated with the accessory. */
  departmentNames?: Maybe<Scalars['String']>;
  /** Description of the accessory. */
  description?: Maybe<Scalars['String']>;
  /** Shared quantity of the accessory across groups. */
  groupSharedQuantity?: Maybe<Scalars['Int']>;
  /** Height of the accessory in centimeters. */
  height?: Maybe<Scalars['Float']>;
  /** Height of the accessory in feet. */
  heightFt?: Maybe<Scalars['Float']>;
  /** Unique identifier for the accessory. */
  id: Scalars['ID'];
  /** ID of the import history record associated with this accessory. */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** Group to which the accessory belongs, used for inventory management. */
  inventoryGroup?: Maybe<AccessoryGroup>;
  /** Notes related to the inventory of the accessory. */
  inventoryNotes?: Maybe<Scalars['String']>;
  /** Indicates if the accessory is available across multiple locations. */
  isMultilocation: Scalars['Boolean'];
  /** Length of the accessory in centimeters. */
  length?: Maybe<Scalars['Float']>;
  /** Length of the accessory in feet. */
  lengthFt?: Maybe<Scalars['Float']>;
  /** Lifespan of the accessory in days. */
  lifespanTime?: Maybe<Scalars['Int']>;
  /** Unit of measurement for the lifespan (e.g., days, months). */
  lifespanUnit?: Maybe<Scalars['String']>;
  /** ID of the location where the accessory is stored. */
  locationId?: Maybe<Scalars['Int']>;
  /** Quantity of the accessory reserved for maintenance purposes. */
  maintenanceQuantity: Scalars['Int'];
  /** Material of the accessory. */
  material?: Maybe<Scalars['String']>;
  /** Indicates if the accessory is shared across multiple locations. */
  multilocationShared?: Maybe<Scalars['Boolean']>;
  /** Name of the accessory. */
  name?: Maybe<Scalars['String']>;
  /** Additional notes about the accessory. */
  notes?: Maybe<Scalars['String']>;
  /** List of pictures associated with the accessory. */
  pictures: Array<Picture>;
  /** Type of product this accessory represents. */
  productType: Scalars['String'];
  /** List of purchase order inventories associated with this accessory. */
  purchaseOrderInventories?: Maybe<Array<PurchaseOrderInventory>>;
  /** Purchase price of the accessory. */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** Total quantity of the accessory available. */
  quantity?: Maybe<Scalars['Int']>;
  /** Serialization status of the accessory. */
  serializationStatus?: Maybe<Scalars['String']>;
  /** List of storefront categories associated with this accessory. */
  sfCategories: Array<StorefrontCategory>;
  /** List of storefront sub-categories associated with this accessory. */
  sfSubCategories: Array<StorefrontCategory>;
  /** List of storefront tags associated with the accessory. */
  sfTags: Array<StorefrontTag>;
  /** Indicates if the accessory notes should be included in rental orders. */
  shouldIncludeNotesInRentals?: Maybe<Scalars['Boolean']>;
  /** Unique token for the accessory, used for identification in APIs. */
  token?: Maybe<Scalars['String']>;
  /** Turnover time for the accessory in minutes. */
  turnoverTime?: Maybe<Scalars['Int']>;
  /** Unit of measurement for the turnover time (e.g., minutes, hours). */
  turnoverUnit?: Maybe<Scalars['String']>;
  /** Timestamp when the accessory was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Location of the accessory in the warehouse. */
  warehouseLocation?: Maybe<Scalars['String']>;
  /** Weight of the accessory in kilograms. */
  weight?: Maybe<Scalars['Float']>;
  /** Width of the accessory in centimeters. */
  width?: Maybe<Scalars['Float']>;
  /** Width of the accessory in feet. */
  widthFt?: Maybe<Scalars['Float']>;
};

/** Represents the relationship between an accessory and a bundle. */
export type AccessoryBundleRelationship = {
  __typename?: 'AccessoryBundleRelationship';
  /** The accessory associated with the relationship. */
  accessory?: Maybe<Accessory>;
  /** ID of the associated accessory. */
  accessoryId?: Maybe<Scalars['Int']>;
  /** ID of the associated bundle. */
  bundleId?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the relationship. */
  id: Scalars['ID'];
  /** Position of the accessory within the bundle. */
  position?: Maybe<Scalars['Int']>;
  /** Quantity of the accessory in the bundle. */
  quantity?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a group of accessories. */
export type AccessoryGroup = {
  __typename?: 'AccessoryGroup';
  /** ID of the associated business. */
  businessId?: Maybe<Scalars['Int']>;
  /** Timestamp when the accessory group was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the accessory group. */
  id: Scalars['ID'];
  /** List of accessories in the group. */
  inventoryObjects: Array<Accessory>;
  /** Name of the accessory group. */
  name?: Maybe<Scalars['String']>;
  /** Timestamp when the accessory group was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Accessory */
export type AccessoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Location's ID */
  locationId?: InputMaybe<Scalars['String']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['String']>;
};

/** An order with add-on quantity reserved pending checkout */
export type AddOnReservedOrder = {
  __typename?: 'AddOnReservedOrder';
  /** Event start date and time of the rental order */
  eventStartDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Name of the rental order */
  name?: Maybe<Scalars['String']>;
  /** Current status of the rental order */
  status: Scalars['String'];
  /** Token of the rental order */
  token: Scalars['String'];
  /** The quantity reserved for this order pending checkout */
  quantity: Scalars['Int'];
};

/** Represents an add-on item that can be included with rentals or purchases */
export type AddOn = {
  __typename?: 'AddOn';
  /** Indicates whether the add-on is currently active */
  active?: Maybe<Scalars['Boolean']>;
  /** The ID of the add-on group to which this add-on belongs */
  addOnGroupId?: Maybe<Scalars['Int']>;
  /** The buffer time for the add-on, in minutes */
  buffer?: Maybe<Scalars['Float']>;
  /**
   * The ID of the category to which the add-on belongs
   * @deprecated Use sf_categories instead
   */
  categoryId?: Maybe<Scalars['Int']>;
  /** The name of the collection to which the add-on belongs */
  collectionName?: Maybe<Scalars['String']>;
  /** The date and time when the add-on was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The custom shared quantity for the add-on */
  customSharedQuantity?: Maybe<Scalars['Int']>;
  /** The date and time when the add-on was deleted, if applicable */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Comma-separated names of departments associated with the add-on */
  departmentNames?: Maybe<Scalars['String']>;
  /** A detailed description of the add-on */
  description?: Maybe<Scalars['String']>;
  /** The Google Analytics description for the add-on */
  gaDescription?: Maybe<Scalars['String']>;
  /** The Google Analytics keywords for the add-on */
  gaKeywords?: Maybe<Scalars['String']>;
  /** The shared quantity for the add-on group, if applicable */
  groupSharedQuantity?: Maybe<Scalars['Int']>;
  /** The height of the add-on, in meters */
  height?: Maybe<Scalars['Float']>;
  /** The height of the add-on in feet */
  heightFt?: Maybe<Scalars['Float']>;
  /** The unique identifier of the add-on */
  id: Scalars['ID'];
  /** The ID of the import history record associated with the add-on */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** The initial quantity of the add-on */
  initialQuantity?: Maybe<Scalars['Int']>;
  /** The inventory group to which the add-on belongs */
  inventoryGroup?: Maybe<AddOnGroup>;
  /** Notes related to the inventory of the add-on */
  inventoryNotes?: Maybe<Scalars['String']>;
  /** Indicates whether the add-on is available in multiple locations */
  isMultilocation: Scalars['Boolean'];
  /** The length of the add-on, in meters */
  length?: Maybe<Scalars['Float']>;
  /** The length of the add-on in feet */
  lengthFt?: Maybe<Scalars['Float']>;
  /** The lifespan of the add-on, in days */
  lifespanTime?: Maybe<Scalars['Int']>;
  /** The unit of time for the lifespan, e.g., 'days', 'months' */
  lifespanUnit?: Maybe<Scalars['String']>;
  /** The location where the add-on is stored */
  location?: Maybe<Location>;
  /** The ID of the location where the add-on is stored */
  locationId?: Maybe<Scalars['Int']>;
  /** The quantity of the add-on currently under maintenance */
  maintenanceQuantity?: Maybe<Scalars['Int']>;
  /** Indicates whether the add-on is shared in the marketplace */
  marketplaceShared?: Maybe<Scalars['Boolean']>;
  /** The material of the add-on */
  material?: Maybe<Scalars['String']>;
  /** The custom shared quantity for the marketplace */
  mpCustomSharedQuantity?: Maybe<Scalars['Int']>;
  /** The type of shared quantity for the marketplace */
  mpSharedQuantityType?: Maybe<Scalars['String']>;
  /** Indicates whether the add-on is shared across multiple locations */
  multilocationShared?: Maybe<Scalars['Boolean']>;
  /** The name of the add-on */
  name?: Maybe<Scalars['String']>;
  /** Additional notes about the add-on */
  notes?: Maybe<Scalars['String']>;
  /** List of pictures associated with the add-on */
  pictures: Array<Picture>;
  /** The price of the add-on */
  pricing?: Maybe<Scalars['Float']>;
  /** The type of product, e.g., 'add-on' */
  productType: Scalars['String'];
  /** List of purchase order inventories associated with the add-on */
  purchaseOrderInventories?: Maybe<Array<PurchaseOrderInventory>>;
  /** The purchase price of the add-on */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** The available quantity of the add-on */
  quantity?: Maybe<Scalars['Int']>;
  /** The total quantity of the add-on sold */
  quantitySold?: Maybe<Scalars['Int']>;
  /** Serialization status of the add-on */
  serializationStatus?: Maybe<Scalars['String']>;
  /** List of storefront categories associated with the add-on */
  sfCategories: Array<StorefrontCategory>;
  /** The custom shared quantity for the storefront */
  sfCustomSharedQuantity?: Maybe<Scalars['Int']>;
  /** The type of shared quantity for the storefront */
  sfSharedQuantityType?: Maybe<Scalars['String']>;
  /** List of storefront sub-categories associated with the add-on. */
  sfSubCategories: Array<StorefrontCategory>;
  /** List of storefront tags associated with the add-on */
  sfTags: Array<StorefrontTag>;
  /** The type of shared quantity for the add-on */
  sharedQuantityType?: Maybe<Scalars['String']>;
  /** Indicates whether notes should be included in rental agreements */
  shouldIncludeNotesInRentals?: Maybe<Scalars['Boolean']>;
  /** Indicates whether to show the price in the storefront */
  showPriceStorefront?: Maybe<Scalars['Boolean']>;
  /** The URL-friendly slug for the add-on */
  slug?: Maybe<Scalars['String']>;
  /** Indicates whether the add-on is shared in the storefront */
  storefrontShared?: Maybe<Scalars['Boolean']>;
  /** Indicates whether the add-on is tax-exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** A unique token for the add-on, used for identification */
  token?: Maybe<Scalars['String']>;
  /** The time it takes for the add-on to be ready for the next use, in minutes */
  turnoverTime?: Maybe<Scalars['Int']>;
  /** The unit of time for the turnover time, e.g., 'minutes', 'hours' */
  turnoverUnit?: Maybe<Scalars['String']>;
  /** The date and time when the add-on was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The location of the add-on within the warehouse */
  warehouseLocation?: Maybe<Scalars['String']>;
  /** The weight of the add-on, in kilograms */
  weight?: Maybe<Scalars['Float']>;
  /** The width of the add-on, in meters */
  width?: Maybe<Scalars['Float']>;
  /** The width of the add-on in feet */
  widthFt?: Maybe<Scalars['Float']>;
};


/** Represents an add-on item that can be included with rentals or purchases */
export type AddOnSfSubCategoriesArgs = {
  maxDepth?: InputMaybe<Scalars['Int']>;
};

/** Represents the relationship between an add-on and a bundle. */
export type AddOnBundleRelationship = {
  __typename?: 'AddOnBundleRelationship';
  /** The add-on associated with the relationship. */
  addOn?: Maybe<AddOn>;
  /** ID of the associated add-on. */
  addOnId?: Maybe<Scalars['Int']>;
  /** ID of the associated bundle. */
  bundleId?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the relationship. */
  id: Scalars['ID'];
  /** Position of the add-on within the bundle. */
  position?: Maybe<Scalars['Int']>;
  /** Quantity of the add-on in the bundle. */
  quantity?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a group of add-ons. */
export type AddOnGroup = {
  __typename?: 'AddOnGroup';
  /** ID of the associated business. */
  businessId?: Maybe<Scalars['Int']>;
  /** Timestamp when the add-on group was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the add-on group. */
  id: Scalars['ID'];
  /** List of add-ons in the group. */
  inventoryObjects: Array<AddOn>;
  /** Name of the add-on group. */
  name?: Maybe<Scalars['String']>;
  /** Timestamp when the add-on group was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating an AddOn */
export type AddOnInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Location's ID */
  locationId?: InputMaybe<Scalars['String']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['String']>;
};

/** Inventory ledger entry or supplier record in add-on purchase history */
export type AddOnInventoryLedgerItemUnion = InventoryLedgerEntry | Supplier;

/** Represents the relationship between an add-on and a product. */
export type AddOnProductRelationship = {
  __typename?: 'AddOnProductRelationship';
  /** The add-on associated with the relationship. */
  addOn?: Maybe<AddOn>;
  /** ID of the associated add-on. */
  addOnId?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the relationship. */
  id: Scalars['ID'];
  /** ID of the import history record. */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** ID of the associated product. */
  productId?: Maybe<Scalars['Int']>;
  /** Quantity of the add-on in the product. */
  quantity?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents an admin user. */
export type Admin = {
  __typename?: 'Admin';
  /** Unique identifier for the admin. */
  id: Scalars['ID'];
  /** Name of the admin. */
  name: Scalars['String'];
};

/** Represents a company entity with its associated details and relationships */
export type ApiKey = {
  __typename?: 'ApiKey';
  /** Access type for the ApiKey (e.g., "read", "write", "read_write") */
  accessType?: Maybe<Scalars['String']>;
  /** ID of the business associated with the ApiKey */
  businessId: Scalars['ID'];
  /** Timestamp when the ApiKey was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the ApiKey */
  id: Scalars['ID'];
  /** Last 4 letters of the ApiKey */
  tokenSuffix: Scalars['String'];
};

/** Autogenerated input type of ArchivePickedSerializedInventory */
export type ArchivePickedSerializedInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['ID'];
};

/** Autogenerated return type of ArchivePickedSerializedInventory. */
export type ArchivePickedSerializedInventoryPayload = {
  __typename?: 'ArchivePickedSerializedInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of AssignItemsToLoadList */
export type AssignItemsToLoadListInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The IDs of the RentalInventory */
  rentalInventoryIds: Array<RentalInventoryIdInput>;
  /** The ID of the RentalTransportTruckRelationship */
  rentalTransportTruckRelationshipId: Scalars['ID'];
};

/** Autogenerated return type of AssignItemsToLoadList. */
export type AssignItemsToLoadListPayload = {
  __typename?: 'AssignItemsToLoadListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of error messages */
  errors: Array<Scalars['String']>;
  /** The RentalTransport */
  rentalTransport?: Maybe<RentalTransport>;
};

/** Autogenerated input type of AssignTrucksToRentalTransport */
export type AssignTrucksToRentalTransportInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The ID of the RentalTransport */
  rentalTransportId: Scalars['ID'];
  /** The ID of the Truck to assign items to */
  truckIdToAssignItems?: InputMaybe<Scalars['ID']>;
  /** The IDs of the Trucks */
  truckIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of AssignTrucksToRentalTransport. */
export type AssignTrucksToRentalTransportPayload = {
  __typename?: 'AssignTrucksToRentalTransportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of error messages */
  errors: Array<Scalars['String']>;
  /** The RentalTransport */
  rentalTransport?: Maybe<RentalTransport>;
};

/** Represents availability information for products, add-ons, and bundles within a specified period */
export type Availability = {
  __typename?: 'Availability';
  /** List of add-ons with their availability */
  addOns?: Maybe<Array<AvailabilityObject>>;
  /** List of bundles with their availability */
  bundles?: Maybe<Array<AvailabilityObject>>;
  /** List of products with their availability */
  products?: Maybe<Array<AvailabilityObject>>;
  /** The end date and time of the validity period for the availability data */
  validPeriodEnd: Scalars['ISO8601DateTime'];
  /** The start date and time of the validity period for the availability data */
  validPeriodStart: Scalars['ISO8601DateTime'];
};

/** Represents the availability status of a product. */
export type AvailabilityObject = {
  __typename?: 'AvailabilityObject';
  /** Quantity of the product that is available. */
  available?: Maybe<Scalars['Int']>;
  /** Quantity of the product that is available in the San Francisco location. */
  availableSf?: Maybe<Scalars['Int']>;
  /** Unique identifier for the availability status. */
  id?: Maybe<Scalars['Int']>;
  /** Quantity of the product that is under maintenance. */
  maintenance?: Maybe<Scalars['Int']>;
  /** Quantity of the product that is under multi-location maintenance. */
  multilocationMaintenance?: Maybe<Scalars['Int']>;
  /** Quantity of the product that is unavailable. */
  unavailable?: Maybe<Scalars['Int']>;
};

/** Availability results for a specific location */
export type AvailabilityResults = {
  __typename?: 'AvailabilityResults';
  /** Available Quantity */
  availableQuantity: Scalars['Int'];
  /** Reventals Inventory ID */
  reventalsInventoryId: Scalars['Int'];
};

/** A bank account associated with a user or business. */
export type BankAccount = {
  __typename?: 'BankAccount';
  /** Indicates if the bank account is active. */
  active?: Maybe<Scalars['Boolean']>;
  /** The name of the bank. */
  bankName?: Maybe<Scalars['String']>;
  /** The timestamp when the bank account was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the bank account. */
  id: Scalars['ID'];
  /** The last four digits of the bank account number. */
  last4?: Maybe<Scalars['String']>;
  /** The ID of the owner (user or business) of the bank account. */
  ownerId: Scalars['ID'];
  /** The type of the owner (e.g., User, Business). */
  ownerType: Scalars['String'];
  /** Payment information associated with the bank account. */
  paymentInfo?: Maybe<Scalars['String']>;
  /** The payment processor used (e.g., grailpay). */
  paymentProcessor: Scalars['String'];
  /** The unique token of the bank account. */
  token: Scalars['String'];
  /** The timestamp when the bank account was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents the result of a bearer token validation. */
export type BearerTokenValidator = {
  __typename?: 'BearerTokenValidator';
  /** ID of the business associated with the bearer token. */
  businessId: Scalars['Int'];
  /** List of location IDs associated with the bearer token. */
  locationIds: Array<Scalars['Int']>;
};

/** Represents a billing note. */
export type BillingNote = {
  __typename?: 'BillingNote';
  /** Amount associated with the billing note. */
  amount?: Maybe<Scalars['Float']>;
  /** Name of the author of the billing note. */
  authorName?: Maybe<Scalars['String']>;
  /** Name of the company associated with the billing note. */
  companyName?: Maybe<Scalars['String']>;
  /** Deletion date of the billing note. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Name of the employee associated with the billing note. */
  employeeName?: Maybe<Scalars['String']>;
  /** Unique identifier for the billing note. */
  id: Scalars['ID'];
  /** Indicates if the author is the primary contact. */
  isAuthorPrimary?: Maybe<Scalars['Boolean']>;
  /** Indicates if the company is the primary contact. */
  isCompanyPrimary?: Maybe<Scalars['Boolean']>;
  /** Message content of the billing note. */
  message?: Maybe<Scalars['String']>;
  /** Type of the billing note. */
  noteType?: Maybe<Scalars['String']>;
  /** Payment date associated with the billing note. */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Payment information for the billing note. */
  paymentInfo?: Maybe<Scalars['String']>;
};

/** Arguments for deleting a billing note. */
export type BillingNoteInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Billing note amount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Billing note author name */
  authorName?: InputMaybe<Scalars['String']>;
  /** Billing note company name */
  companyName?: InputMaybe<Scalars['String']>;
  /** Billing note deleted date */
  deletedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Billing note employee name */
  employeeName?: InputMaybe<Scalars['String']>;
  /** The billing note id */
  id: Scalars['Int'];
  /** Billing note responsable is customer primary */
  isAuthorPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Billing note responsable is company primary */
  isCompanyPrimary?: InputMaybe<Scalars['Boolean']>;
  /** Billing note message */
  message?: InputMaybe<Scalars['String']>;
  /** Billing note type */
  noteType?: InputMaybe<Scalars['String']>;
  /** Billing note payment date */
  paymentDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Billing note payment info */
  paymentInfo?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of BulkSetStorefrontTags */
export type BulkSetStorefrontTagsInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  sfTags: Array<StorefrontTagInput>;
};

/** Autogenerated return type of BulkSetStorefrontTags. */
export type BulkSetStorefrontTagsPayload = {
  __typename?: 'BulkSetStorefrontTagsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sfTags?: Maybe<Array<StorefrontTag>>;
};

/** Represents a bundle of products, add-ons, and accessories that can be rented or purchased together */
export type Bundle = {
  __typename?: 'Bundle';
  /** List of accessory-bundle relationships associated with the bundle */
  accessoryBundleRelationships: Array<AccessoryBundleRelationship>;
  /** Indicates whether the bundle is currently active */
  active?: Maybe<Scalars['Boolean']>;
  /** List of add-on-bundle relationships associated with the bundle */
  addOnBundleRelationships: Array<AddOnBundleRelationship>;
  /**
   * The ID of the category to which the bundle belongs
   * @deprecated Use sf_categories instead
   */
  categoryId?: Maybe<Scalars['Int']>;
  /** The name of the collection to which the bundle belongs */
  collectionName?: Maybe<Scalars['String']>;
  /** The date and time when the bundle was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The custom shared quantity for the bundle */
  customSharedQuantity?: Maybe<Scalars['Int']>;
  /** The daily rental price of the bundle */
  dailyPrice?: Maybe<Scalars['Float']>;
  /** Indicates whether the bundle is exempt from damage waiver */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** The default pricing model for the bundle */
  defaultPricing?: Maybe<Scalars['String']>;
  /** The date and time when the bundle was deleted, if applicable */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Comma-separated department names associated with the bundle */
  departmentNames?: Maybe<Scalars['String']>;
  /** A detailed description of the bundle */
  description?: Maybe<Scalars['String']>;
  /** Indicates whether the bundle is eligible for discounts */
  discountEligible?: Maybe<Scalars['Boolean']>;
  /** The discount percentage applied to the bundle */
  discountPercent?: Maybe<Scalars['Float']>;
  /** List of flat prices associated with the bundle */
  flatPrices: Array<FlatPrice>;
  /** The Google Analytics description for the bundle */
  gaDescription?: Maybe<Scalars['String']>;
  /** The Google Analytics keywords for the bundle */
  gaKeywords?: Maybe<Scalars['String']>;
  /** The half-day rental price of the bundle */
  halfDayPrice?: Maybe<Scalars['Float']>;
  /** The hourly rental price of the bundle */
  hourlyPrice?: Maybe<Scalars['Float']>;
  /** The unique identifier of the bundle */
  id: Scalars['ID'];
  /** Notes related to the inventory of the bundle */
  inventoryNotes?: Maybe<Scalars['String']>;
  /** Indicates whether the bundle is available in multiple locations */
  isMultilocation: Scalars['Boolean'];
  /** The location where the bundle is stored */
  location?: Maybe<Location>;
  /** The ID of the location where the bundle is stored */
  locationId?: Maybe<Scalars['Int']>;
  /** Indicates whether the bundle is shared in the marketplace */
  marketplaceShared?: Maybe<Scalars['Boolean']>;
  /** The monthly rental price of the bundle */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** The custom shared quantity for the marketplace */
  mpCustomSharedQuantity?: Maybe<Scalars['Int']>;
  /** The type of shared quantity for the marketplace */
  mpSharedQuantityType?: Maybe<Scalars['String']>;
  /** The name of the bundle */
  name?: Maybe<Scalars['String']>;
  /** Additional notes about the bundle */
  notes?: Maybe<Scalars['String']>;
  /** The permission type for the bundle, e.g., 'public', 'private' */
  permissionType?: Maybe<Scalars['String']>;
  /** List of picture URLs associated with the bundle */
  pictureUrls: Array<Scalars['String']>;
  /** List of pictures associated with the bundle */
  pictures: Array<Picture>;
  /** Indicates whether the price of the bundle is locked */
  priceLocked?: Maybe<Scalars['Boolean']>;
  /** List of product-bundle relationships associated with the bundle */
  productBundleRelationships: Array<ProductBundleRelationship>;
  /** The type of product, e.g., 'bundle' */
  productType: Scalars['String'];
  /** The purchase price of the bundle */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** List of storefront categories associated with the bundle */
  sfCategories: Array<StorefrontCategory>;
  /** The custom shared quantity for the storefront */
  sfCustomSharedQuantity?: Maybe<Scalars['Int']>;
  /** The type of shared quantity for the storefront */
  sfSharedQuantityType?: Maybe<Scalars['String']>;
  /** List of storefront sub-categories associated with the bundle. */
  sfSubCategories: Array<StorefrontCategory>;
  /** List of storefront tags associated with the bundle */
  sfTags: Array<StorefrontTag>;
  /** The type of shared quantity for the bundle */
  sharedQuantityType?: Maybe<Scalars['String']>;
  /** Indicates whether notes should be included in rental agreements */
  shouldIncludeNotesInRentals?: Maybe<Scalars['Boolean']>;
  /** Indicates whether to show the items in the bundle to the customer */
  showItemsToCustomer?: Maybe<Scalars['Boolean']>;
  /** Indicates whether to show the price in the storefront */
  showPriceStorefront?: Maybe<Scalars['Boolean']>;
  /** The URL-friendly slug for the bundle */
  slug?: Maybe<Scalars['String']>;
  /** Indicates whether the bundle is shared in the storefront */
  storefrontShared?: Maybe<Scalars['Boolean']>;
  /** The tax exemption setting for the bundle */
  taxExemptionSetting?: Maybe<Scalars['Int']>;
  /** A unique token for the bundle, used for identification */
  token?: Maybe<Scalars['String']>;
  /** The total quantity of the bundle available */
  totalQuantity: Scalars['Int'];
  /** The time it takes for the bundle to be ready for the next use, in minutes */
  turnoverTime?: Maybe<Scalars['Int']>;
  /** The unit of time for the turnover time, e.g., 'minutes', 'hours' */
  turnoverUnit?: Maybe<Scalars['String']>;
  /** The date and time when the bundle was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The weekly rental price of the bundle */
  weeklyPrice?: Maybe<Scalars['Float']>;
};


/** Represents a bundle of products, add-ons, and accessories that can be rented or purchased together */
export type BundleSfSubCategoriesArgs = {
  maxDepth?: InputMaybe<Scalars['Int']>;
};

/** Represents a business entity. */
export type Business = {
  __typename?: 'Business';
  /** Timestamp when activation was applied. */
  activationAppliedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp when activation was requested. */
  activationRequestedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the business is active. */
  active?: Maybe<Scalars['Boolean']>;
  /** Indicates if closed order editing is allowed. */
  allowClosedOrderEditing?: Maybe<Scalars['Boolean']>;
  /** Authentication token for the business. */
  authToken?: Maybe<Scalars['String']>;
  /** Minimum days after which auto-booking is allowed. */
  autoBookMinimumDaysAfter?: Maybe<Scalars['Int']>;
  /** Indicates if auto-reserve is enabled. */
  autoReserveEnabled?: Maybe<Scalars['Boolean']>;
  /** Available basic user count for the business. */
  availableBasicUserCount?: Maybe<Scalars['Int']>;
  /** Available user count for the business. */
  availableUserCount?: Maybe<Scalars['Int']>;
  /** Billing interval for the business. */
  billingInterval?: Maybe<Scalars['String']>;
  /** Indicates if the business can get a merchant account. */
  canGetMerchantAccount?: Maybe<Scalars['Boolean']>;
  /** Timestamp when cancellation was requested. */
  cancellationRequested?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if cash charge is enabled. */
  cashChargeEnabled?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the business was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Percentage fee for credit card transactions. */
  creditCardPercent?: Maybe<Scalars['Float']>;
  /** Custom reply-to email for the business. */
  customReplyToEmail?: Maybe<Scalars['String']>;
  /** Custom sales tax percentage for the business. */
  customSalesTaxPercent?: Maybe<Scalars['Float']>;
  /** Custom storefront amount for the business. */
  customStorefrontAmount: Scalars['Float'];
  /** Indicates if custom storefront amount is enabled. */
  customStorefrontAmountEnabled?: Maybe<Scalars['Boolean']>;
  /** Custom subscription amount for the business. */
  customSubscriptionAmount?: Maybe<Scalars['Float']>;
  /** Indicates if custom subscription amount is enabled. */
  customSubscriptionAmountEnabled?: Maybe<Scalars['Boolean']>;
  /** Customer self-service fee for the business. */
  customerSelfServiceFee?: Maybe<Scalars['Float']>;
  /** Customer self-service tax for the business. */
  customerSelfServiceTax?: Maybe<Scalars['Float']>;
  /** Fixed fee for damage waivers. */
  damageWaiverFixedFee?: Maybe<Scalars['Float']>;
  /** Percentage fee for damage waivers. */
  damageWaiverPercent?: Maybe<Scalars['Float']>;
  /** Indicates if damage waiver is tax exempt. */
  damageWaiverTaxExempt?: Maybe<Scalars['Boolean']>;
  /** Default agreement ID for the business. */
  defaultAgreementId?: Maybe<Scalars['Int']>;
  /** Default end date for the business. */
  defaultEnd?: Maybe<Scalars['ISO8601DateTime']>;
  /** Default setup time for the business. */
  defaultSetupTime?: Maybe<Scalars['Int']>;
  /** Default start date for the business. */
  defaultStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp when the business was deleted. */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Fixed fee for deposits. */
  depositFixedFee?: Maybe<Scalars['Float']>;
  /** Percentage fee for deposits. */
  depositPercent?: Maybe<Scalars['Float']>;
  /** Timestamp when downgrade was requested. */
  downgradeRequestedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Email address of the business. */
  email?: Maybe<Scalars['String']>;
  /** Number of days after expiration. */
  expireDaysAfter?: Maybe<Scalars['Int']>;
  /** Number of days before expiration. */
  expireDaysBefore?: Maybe<Scalars['Int']>;
  /** Field from which expiration is calculated. */
  expireFromField?: Maybe<Scalars['String']>;
  /** Facebook token for the business. */
  facebookToken?: Maybe<Scalars['String']>;
  /** Facebook token expiration date for the business. */
  facebookTokenExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if force storefront is enabled. */
  forceStorefront?: Maybe<Scalars['Boolean']>;
  /** From email type for the business. */
  fromEmailType?: Maybe<Scalars['String']>;
  /** Indicates if GPS API is connected. */
  gpsApiConnected?: Maybe<Scalars['Boolean']>;
  /** GPS API key for the business. */
  gpsApiKey?: Maybe<Scalars['String']>;
  /** GPS device count for the business. */
  gpsDeviceCount?: Maybe<Scalars['Int']>;
  /** GPS organization ID for the business. */
  gpsOrgId?: Maybe<Scalars['String']>;
  /** GPS provider for the business. */
  gpsProvider?: Maybe<Scalars['String']>;
  /** GPS subscription amount for the business. */
  gpsSubscriptionAmount?: Maybe<Scalars['Int']>;
  /** Unique identifier for the business. */
  id: Scalars['ID'];
  /** Internal operation fee for the business. */
  internalOperationFee?: Maybe<Scalars['Float']>;
  /** Internal operation tax for the business. */
  internalOperationTax?: Maybe<Scalars['Float']>;
  /** Indicates if TG admins are logged as TapGoods employees. */
  logTgAdminsAsTapgoodsEmployees?: Maybe<Scalars['Boolean']>;
  /** Marketplace fee for the business. */
  marketPlaceFee?: Maybe<Scalars['Float']>;
  /** Marketplace tax for the business. */
  marketPlaceTax?: Maybe<Scalars['Float']>;
  /** Marketplace customer percentage for the business. */
  marketplaceCustomerPercent?: Maybe<Scalars['Float']>;
  /** Minimum item total for delivery. */
  minimumItemTotalForDelivery?: Maybe<Scalars['Float']>;
  /** Minimum item total for pickup. */
  minimumItemTotalForPickup?: Maybe<Scalars['Float']>;
  /** Indicates if multilocation reports are enabled. */
  multilocationReportsEnabled?: Maybe<Scalars['Boolean']>;
  /** Name of the business. */
  name?: Maybe<Scalars['String']>;
  /** New Lite primary yearly plan type. */
  newLitePrimaryYearlyPlanType?: Maybe<Scalars['Int']>;
  /** Indicates if overpayments are enabled. */
  overpaymentsEnabled?: Maybe<Scalars['Boolean']>;
  /** Payment processor for the business. */
  paymentProcessor?: Maybe<Scalars['String']>;
  /** Payment reminder options for the business. */
  paymentReminderOptions?: Maybe<Scalars['String']>;
  /** Payment terms for the business. */
  paymentTerms?: Maybe<Scalars['String']>;
  /** Payment token for the business. */
  paymentToken?: Maybe<Scalars['String']>;
  /** Permissions for the business. */
  permissions?: Maybe<BusinessPermissions>;
  /** Pricing tier ID for the business. */
  pricingTierId?: Maybe<Scalars['Int']>;
  /** ProPay country for the business. */
  propayCountry?: Maybe<Scalars['String']>;
  /** ProPay payer ID for the business. */
  propayPayerId?: Maybe<Scalars['String']>;
  /** Indicates if rentals expire. */
  rentalsExpire?: Maybe<Scalars['Boolean']>;
  /** Indicates if reports are included. */
  reportsIncluded?: Maybe<Scalars['Boolean']>;
  /** Indicates if room activity settings are enabled. */
  roomActivitySettingsEnabled?: Maybe<Scalars['Boolean']>;
  /** Sales tax type for the business. */
  salesTaxType?: Maybe<Scalars['String']>;
  /** SES verified domains CSV for the business. */
  sesVerifiedDomainsCsv?: Maybe<Scalars['String']>;
  /** Indicates if auto-booking is allowed. */
  shouldAllowAutoBook?: Maybe<Scalars['Boolean']>;
  /** Indicates if emails should be sent from the user. */
  shouldSendEmailsFromUser?: Maybe<Scalars['Boolean']>;
  /** Indicates if inventory photos are shown in emails. */
  showInventoryPhotoInEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if inventory photos are shown in PDF. */
  showInventoryPhotoInPdf?: Maybe<Scalars['Boolean']>;
  /** Indicates if routing assignments are shown. */
  showRoutingAssignments?: Maybe<Scalars['Boolean']>;
  /** Indicates if soft holds are shown. */
  showSoftHolds?: Maybe<Scalars['Boolean']>;
  /** Indicates if subtotals are shown in sections. */
  showSubtotalsInSections?: Maybe<Scalars['Boolean']>;
  /** Indicates if unit pricing is shown to customers. */
  showUnitPricingToCustomers?: Maybe<Scalars['Boolean']>;
  /** Indicates if signature is required. */
  signatureRequired?: Maybe<Scalars['Boolean']>;
  /** Software tier for the business. */
  softwareTier?: Maybe<Scalars['String']>;
  /** Storefront business percentage for the business. */
  storefrontBusinessPercent?: Maybe<Scalars['Float']>;
  /** Indicates if storefront is included. */
  storefrontIncluded?: Maybe<Scalars['Boolean']>;
  /** Storefront percentage for the business. */
  storefrontPercent?: Maybe<Scalars['Float']>;
  /** Storefront tier for the business. */
  storefrontTier?: Maybe<Scalars['String']>;
  /** Stripe customer token for the business. */
  stripeCustomerToken?: Maybe<Scalars['String']>;
  /** Subdomain for the business. */
  subdomain?: Maybe<Scalars['String']>;
  /** Subscription tier for the business. */
  subscriptionTier?: Maybe<Scalars['String']>;
  /** Support level for the business. */
  supportLevel?: Maybe<Scalars['Int']>;
  /** Term signature for the business. */
  termSignature?: Maybe<Scalars['String']>;
  /** Term signer name for the business. */
  termSignerName?: Maybe<Scalars['String']>;
  /** Indicates if TG payment has failed. */
  tgPaymentFailed?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the business was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Live webhook URL for the business. */
  webhookLive?: Maybe<Scalars['String']>;
  /** Webhook mode for the business. */
  webhookMode: Scalars['String'];
  /** Webhook signing key for the business. */
  webhookSigningKey?: Maybe<Scalars['String']>;
  /** Test webhook URL for the business. */
  webhookTest?: Maybe<Scalars['String']>;
  /** Website URL of the business. */
  website?: Maybe<Scalars['String']>;
  /** Yearly revenue estimate for the business. */
  yearlyRevenueEstimate?: Maybe<Scalars['String']>;
};

/** Represents the payment terms for a business. */
export type BusinessPaymentTerm = {
  __typename?: 'BusinessPaymentTerm';
  /** ID of the associated business. */
  businessId?: Maybe<Scalars['Int']>;
  /** Content of the payment term. */
  content?: Maybe<Scalars['String']>;
  /** Timestamp when the payment term was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the payment term. */
  id: Scalars['ID'];
  /** ID of the associated location. */
  locationId?: Maybe<Scalars['Int']>;
  /** Net value of the payment term. */
  netValue?: Maybe<Scalars['Int']>;
  /** Type of the payment term. */
  termType?: Maybe<Scalars['Int']>;
  /** Timestamp when the payment term was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents the permissions available for a business. */
export type BusinessPermissions = {
  __typename?: 'BusinessPermissions';
  /** Indicates if activation applied at is enabled. */
  activationAppliedAt?: Maybe<Scalars['Boolean']>;
  /** Indicates if advanced permissions are enabled. */
  advancedPermissionsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if advanced pricing is enabled. */
  advancedPricingEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if async rentals are enabled. */
  asyncRentalsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if auto-reserve is enabled. */
  autoReserveEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if auto-billing is enabled. */
  autobillingEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if availability calendars are enabled. */
  availabilityCalendars?: Maybe<Scalars['Boolean']>;
  /** Indicates if bulk export of invoices is enabled. */
  bulkExportInvoices?: Maybe<Scalars['Boolean']>;
  /** Indicates if bundles are enabled. */
  bundlesEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if combined rate pricing is enabled. */
  combinedRatePricing?: Maybe<Scalars['Boolean']>;
  /** Indicates if credit terms are enabled. */
  creditTermsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if custom proposals are enabled. */
  customProposals?: Maybe<Scalars['Boolean']>;
  /** Indicates if customizable design and content are enabled. */
  customizableDesignAndContent?: Maybe<Scalars['Boolean']>;
  /** Indicates if customizable permissions are enabled. */
  customizablePermissions?: Maybe<Scalars['Boolean']>;
  /** Indicates if cycle billing is enabled. */
  cycleBilling?: Maybe<Scalars['Boolean']>;
  /** Indicates if delivery tickets are enabled. */
  deliveryTicketsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if disclaimers are enabled. */
  disclaimersEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if discounts and fees management is enabled. */
  discountsAndFees?: Maybe<Scalars['Boolean']>;
  /** Indicates if document management is enabled. */
  documentsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if business can charge credit card fees. */
  enableSurcharging?: Maybe<Scalars['Boolean']>;
  /** Indicates if essential reports are enabled. */
  essentialReports?: Maybe<Scalars['Boolean']>;
  /** Indicates if event grouping is enabled. */
  eventGroupingEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if flow sheet management is enabled. */
  flowSheetEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if force multi-location is enabled. */
  forceMultilocation?: Maybe<Scalars['Boolean']>;
  /** Indicates if force unlimited items is enabled. */
  forceUnlimitedItems?: Maybe<Scalars['Boolean']>;
  /** Indicates if force unlimited serialized items is enabled. */
  forceUnlimitedSerializedItems?: Maybe<Scalars['Boolean']>;
  /** Indicates if general ledger is enabled. */
  generalLedgerEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if Google Calendar integration is enabled. */
  googleCalendar?: Maybe<Scalars['Boolean']>;
  /** Indicates if GPS tracking is enabled. */
  gpsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if history tracking is enabled. */
  historyEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if import wizard is enabled. */
  importWizardEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if late change notifications are enabled. */
  lateChangeNotifications?: Maybe<Scalars['Boolean']>;
  /** Indicates if load lists are enabled. */
  loadListsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if maintenance scheduling is enabled. */
  maintenceScheduling?: Maybe<Scalars['Boolean']>;
  /** Indicates if NPS customer surveys are enabled. */
  npsCustomerSurveys?: Maybe<Scalars['Boolean']>;
  /** Indicates if POS devices are enabled. */
  posDevicesEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if purchase orders are enabled. */
  purchaseOrdersEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if quick view orders are enabled. */
  quickViewOrdersEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if QuickBooks integration is enabled. */
  quickbooksIntegration?: Maybe<Scalars['Boolean']>;
  /** Indicates if recurring services are enabled. */
  recurringServicesEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if rental versioning is enabled. */
  rentalVersioningEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if rental versioning show conversion popup is enabled. */
  rentalVersioningShowConversionPopup?: Maybe<Scalars['Boolean']>;
  /** Indicates if robust and custom reports are enabled. */
  robustAndCustomReports?: Maybe<Scalars['Boolean']>;
  /** Indicates if role-based permissions are enabled. */
  rolesEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if routing and tracking are enabled. */
  routingAndTrackingEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if sales tax zones are enabled. */
  salesTaxZones?: Maybe<Scalars['Boolean']>;
  /** Indicates if scheduled maintenance is enabled. */
  scheduledMaintenanceEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if secondary orders are enabled. */
  secondaryOrdersEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if TG brand is shown in emails. */
  showTgBrandInEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if TG brand is shown in storefronts. */
  showTgBrandInStorefronts?: Maybe<Scalars['Boolean']>;
  /** Indicates if simplified general ledger is enabled. */
  simplifiedGeneralLedger?: Maybe<Scalars['Boolean']>;
  /** Indicates if soft holds are enabled. */
  softHoldsEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if subrental management is enabled. */
  subrentalManagement?: Maybe<Scalars['Boolean']>;
  /** Indicates if two-factor authentication is enabled. */
  twoFactorEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if variable sales tax is enabled. */
  variableSalesTax?: Maybe<Scalars['Boolean']>;
  /** Indicates if WordPress feature is enabled. */
  wordPressFeatureEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if work order management is enabled. */
  workOrderEnabled?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of CancelPurchaseOrder */
export type CancelPurchaseOrderInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  purchaseOrderId: Scalars['ID'];
};

/** Autogenerated return type of CancelPurchaseOrder. */
export type CancelPurchaseOrderPayload = {
  __typename?: 'CancelPurchaseOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedInventories?: Maybe<Array<Scalars['ID']>>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Represents a change history entry for tracking modifications made to rentals or other entities */
export type ChangeHistoryEntry = {
  __typename?: 'ChangeHistoryEntry';
  /** Indicates whether the change can be reverted */
  allowRevert?: Maybe<Scalars['Boolean']>;
  /** The ID of the object that was changed */
  changeableId?: Maybe<Scalars['Int']>;
  /** The type of the object that was changed */
  changeableType?: Maybe<Scalars['String']>;
  /** The date and time when the change history entry was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** A detailed description of the change */
  description?: Maybe<Scalars['String']>;
  /** The employee who made the change */
  employee?: Maybe<Employee>;
  /** The ID of the employee who made the change */
  employeeId?: Maybe<Scalars['Int']>;
  /** The type of the employee who made the change */
  employeeType?: Maybe<Scalars['String']>;
  /** The unique identifier of the change history entry */
  id: Scalars['ID'];
  /** A message describing the change */
  message?: Maybe<Scalars['String']>;
  /** The ID of the owner of the change */
  ownerId?: Maybe<Scalars['Int']>;
  /** The type of the owner of the change */
  ownerType?: Maybe<Scalars['String']>;
  /** The rental associated with the change history entry */
  rental?: Maybe<Rental>;
  /** The ID of the rental associated with the change */
  rentalId?: Maybe<Scalars['Int']>;
  /** The token of the rental associated with the change */
  rentalToken?: Maybe<Scalars['String']>;
  /** The date and time when the change history entry was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type ChangeHistoryEntryCollection = {
  __typename?: 'ChangeHistoryEntryCollection';
  collection: Array<ChangeHistoryEntry>;
  metadata: CollectionMetadata;
};

/** Autogenerated input type of CheckInAllPurchaseOrderInventory */
export type CheckInAllPurchaseOrderInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  purchaseOrderId: Scalars['ID'];
  purchaseOrderInventories: Array<PurchaseOrderInventoryInput>;
};

/** Autogenerated return type of CheckInAllPurchaseOrderInventory. */
export type CheckInAllPurchaseOrderInventoryPayload = {
  __typename?: 'CheckInAllPurchaseOrderInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Represents an entry in the client success history log */
export type ClientSuccessHistoryEntry = {
  __typename?: 'ClientSuccessHistoryEntry';
  /** Admin who created the entry */
  admin: Admin;
  /** Billing note associated with the entry, if applicable */
  billingNote?: Maybe<BillingNote>;
  /** Timestamp when the entry was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Type of the entry (e.g., 'rental', 'refund') */
  entryType: Scalars['String'];
  /** Unique identifier for the entry */
  id: Scalars['ID'];
  /** Name associated with the refund, if applicable */
  refundName?: Maybe<Scalars['String']>;
  /** Rental associated with the entry, if applicable */
  rental: Rental;
};

export type CollectionMetadata = {
  __typename?: 'CollectionMetadata';
  currentPage: Scalars['Int'];
  limitValue: Scalars['Int'];
  totalCount: Scalars['Int'];
  totalPages: Scalars['Int'];
};

/** Represents a column filter configuration for rentals based on rental status and employee */
export type ColumnFilter = {
  __typename?: 'ColumnFilter';
  /** Employee associated with the column filter */
  employee: Employee;
  /** Unique identifier for the column filter */
  id: Scalars['ID'];
  /** Status of the rental associated with the filter */
  rentalStatus: Scalars['String'];
  /** Settings for the column filter */
  settings: Scalars['JSON'];
};

/** Represents a commissioned customer */
export type CommissionedCustomer = {
  __typename?: 'CommissionedCustomer';
  /** The timestamp when the record was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The first name of the commissioned customer. Required field. */
  firstName?: Maybe<Scalars['String']>;
  /** The unique identifier for the commissioned customer record. */
  id: Scalars['ID'];
  /** The last name of the commissioned customer. Required field. */
  lastName?: Maybe<Scalars['String']>;
  /** The commission rate (as a decimal) that this customer receives for referred business. Must be a number greater than 0. For example, 0.15 represents a 15% commission rate. */
  rate?: Maybe<Scalars['Float']>;
  /** The timestamp when the record was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Document relationship with a rental */
export type CommissionedCustomerRentalRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the commissioned customer */
  commissionedCustomerId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Represents the relationship between a commodity and a product */
export type CommodityProductRelationship = {
  __typename?: 'CommodityProductRelationship';
  /** The commodity associated with the relationship */
  commodity: Product;
  /** The ID of the commodity */
  commodityId: Scalars['Int'];
  /** The date and time when the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the relationship */
  id: Scalars['ID'];
  /** The ID of the product */
  productId: Scalars['Int'];
  /** The quantity of the commodity */
  quantity: Scalars['Int'];
  /** The date and time when the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a company entity with its associated details and relationships */
export type Company = {
  __typename?: 'Company';
  /** Account owner associated with the company */
  accountOwner?: Maybe<Employee>;
  /** ID of the account owner */
  accountOwnerId?: Maybe<Scalars['Int']>;
  /** Indicates if the company is active */
  active?: Maybe<Scalars['Boolean']>;
  /** ID of the company credit limit group */
  companyCreditLimitGroupId?: Maybe<Scalars['Int']>;
  /** Relationships between the company and its locations */
  companyLocationRelationships?: Maybe<Array<CompanyLocationRelationship>>;
  /** Timestamp when the company was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Credit limit for the company */
  creditLimit?: Maybe<Scalars['Int']>;
  /** Custom deposit amount for the company */
  customDepositAmount?: Maybe<Scalars['Float']>;
  /** Relationships between the company and its locations */
  customerLocationRelationships?: Maybe<Array<CustomerLocationRelationship>>;
  /** Type of deposit associated with the company */
  depositType?: Maybe<Scalars['String']>;
  /** Discounts associated with the company */
  discounts?: Maybe<Array<Discount>>;
  /** Documents associated with the company */
  documents?: Maybe<Array<Document>>;
  /** Indicates if the company is GST tax exempt */
  gstTaxExempt?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the company */
  id: Scalars['ID'];
  /** ID of the import history associated with the company */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** Main contact address for the company */
  mainContactAddress?: Maybe<PhysicalAddress>;
  /** Main contact email for the company */
  mainContactEmail?: Maybe<EmailAddress>;
  /** Main phone number for the company */
  mainPhoneNumber?: Maybe<PhoneNumber>;
  /** Name of the company */
  name?: Maybe<Scalars['String']>;
  /** Notes about the company */
  notes?: Maybe<Scalars['String']>;
  /** ID of the parent company, if any */
  parentId?: Maybe<Scalars['Int']>;
  /** Primary contact email for the company */
  primaryContactEmail?: Maybe<Scalars['String']>;
  /** ProPay payer ID for the company */
  propayPayerId?: Maybe<Scalars['String']>;
  /** Indicates if the company is PST tax exempt */
  pstTaxExempt?: Maybe<Scalars['Boolean']>;
  /** Indicates if credit terms are shared across locations */
  shareCreditTermsAcrossLocations?: Maybe<Scalars['Boolean']>;
  /** Indicates if deposits should be applied */
  shouldApplyDeposits?: Maybe<Scalars['Boolean']>;
  /** Indicates if the company should deposit one full payment */
  shouldDepositOneFullPayment?: Maybe<Scalars['Boolean']>;
  /** Status of the company */
  status?: Maybe<Scalars['Int']>;
  /** Stripe token for the company */
  stripeToken?: Maybe<Scalars['String']>;
  /** Indicates if the company is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Tax exemption number for the company */
  taxExemptionNumber?: Maybe<Scalars['String']>;
  /** Token for the company */
  token?: Maybe<Scalars['String']>;
  /** Timestamp when the company was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Venues associated with the company */
  venues?: Maybe<Array<Venue>>;
};

/** Represents the relationship between a company and an event */
export type CompanyEventRelationship = {
  __typename?: 'CompanyEventRelationship';
  /** The company associated with the relationship */
  company: Company;
  /** The ID of the company */
  companyId: Scalars['Int'];
  /** The event associated with the relationship */
  event: Event;
  /** The ID of the event */
  eventId: Scalars['Int'];
  /** The unique identifier of the relationship */
  id: Scalars['ID'];
};

/** Arguments for creating or updating a Company */
export type CompanyInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Company's deposit type */
  depositType?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Company's physical address */
  mainContactAddressAttributes?: InputMaybe<PhysicalAddressInput>;
  /** Company's email */
  mainContactEmailAttributes?: InputMaybe<EmailAddressInput>;
  /** Company's phone number */
  mainPhoneNumberAttributes?: InputMaybe<PhoneNumberInput>;
  /** Customer's first name */
  name?: InputMaybe<Scalars['String']>;
};

export type CompanyLocationRelationship = {
  __typename?: 'CompanyLocationRelationship';
  /** The associated Company record. */
  company?: Maybe<Company>;
  /** The ID of the associated Company record. */
  companyId: Scalars['Int'];
  /** The timestamp when this relationship was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The type of deposit required for this company. */
  depositType?: Maybe<Scalars['String']>;
  /** A list of documents associated with this company-location relationship. */
  documents?: Maybe<Array<Document>>;
  /** The primary email address for the company. Uses the main contact email or first available email. */
  email?: Maybe<Scalars['String']>;
  /** The unique identifier for this company-location relationship. */
  id: Scalars['ID'];
  /** The ID of the associated Location record. */
  locationId: Scalars['Int'];
  /** The name of the company. */
  name?: Maybe<Scalars['String']>;
  /** The timestamp when this relationship was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type CompanyLocationRelationshipCollection = {
  __typename?: 'CompanyLocationRelationshipCollection';
  collection: Array<CompanyLocationRelationship>;
  metadata: CollectionMetadata;
};

/** Arguments for creating or updating a CompanyLocationRelationship */
export type CompanyLocationRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The attributes for the company */
  companyAttributes?: InputMaybe<CompanyInput>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Represents the relationship between a company and a rental */
export type CompanyRentalRelationship = {
  __typename?: 'CompanyRentalRelationship';
  /** The company associated with the relationship */
  company?: Maybe<Company>;
  /** The ID of the company */
  companyId: Scalars['String'];
  /** The date and time when the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the relationship */
  id: Scalars['ID'];
  /** Indicates if this relationship is the primary contact for the rental */
  isPrimaryContact: Scalars['Boolean'];
  /** The ID of the rental */
  rentalId: Scalars['String'];
  /** The tax exemption number associated with the company */
  taxExemptionNumber?: Maybe<Scalars['String']>;
  /** The date and time when the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a CompanyRentalRelationship */
export type CompanyRentalRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The attributes for the company */
  companyAttributes?: InputMaybe<CompanyInput>;
  /** The ID of the company */
  companyId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Is this the primary contact for the rental? */
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  /** Tax Exemption Number */
  taxExemptionNumber?: InputMaybe<Scalars['String']>;
};

/** Represents a conversation between a supplier and a tenant */
export type Conversation = {
  __typename?: 'Conversation';
  /** The date and time when the conversation was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the conversation */
  id: Scalars['ID'];
  /** The messages exchanged in the conversation */
  messages: Array<Message>;
  /** The location information of the supplier */
  supplierLocationInfo?: Maybe<Location>;
  /** The rental information of the supplier */
  supplierRentalInfo?: Maybe<Rental>;
  /** The location information of the tenant */
  tenantLocationInfo?: Maybe<Location>;
  /** The rental information of the tenant */
  tenantRentalInfo?: Maybe<Rental>;
  /** The date and time when the conversation was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a custom tax that can be applied to rental items */
export type CustomTax = {
  __typename?: 'CustomTax';
  /** Tax amount or percentage value */
  amount: Scalars['Float'];
  /** Type of amount (e.g., "percent" or "fixed") */
  amountType: Scalars['String'];
  /** When this tax was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the custom tax */
  id: Scalars['ID'];
  /** Name of the custom tax */
  name: Scalars['String'];
  /** Associations between this tax and rental items */
  rentalItemCustomTaxRelationships?: Maybe<Array<RentalItemCustomTaxRelationship>>;
  /** When this tax was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a customer entity with its associated details and relationships */
export type Customer = {
  __typename?: 'Customer';
  /** Indicates if the customer is active */
  active?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the confirmation was sent to the customer */
  confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Token used for confirming the customer's account */
  confirmationToken?: Maybe<Scalars['String']>;
  /** Timestamp when the customer's account was confirmed */
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp when the customer was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Timestamp when the customer last signed in */
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** IP address of the customer during the last sign-in */
  currentSignInIp?: Maybe<Scalars['String']>;
  /** Type of deposit associated with the customer */
  depositType?: Maybe<Scalars['String']>;
  /** Driver's license number of the customer */
  driverLicenseNumber?: Maybe<Scalars['String']>;
  /** State of the driver's license */
  driverLicenseState?: Maybe<Scalars['String']>;
  /** Email address of the customer */
  email?: Maybe<Scalars['String']>;
  /** First name of the customer */
  firstName?: Maybe<Scalars['String']>;
  /** Timestamp when the customer first signed in */
  firstSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the customer has signed in at least once */
  hasSignedIn?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the customer */
  id: Scalars['ID'];
  /** ID of the import history associated with the customer */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** Indicates if the customer has been migrated from another system */
  isMigrated?: Maybe<Scalars['Boolean']>;
  /** Last name of the customer */
  lastName?: Maybe<Scalars['String']>;
  /** Timestamp when the customer last signed in */
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** IP address of the customer during the last sign-in */
  lastSignInIp?: Maybe<Scalars['String']>;
  /** Full name of the customer */
  name?: Maybe<Scalars['String']>;
  /** Indicates if the customer has opted in for communications */
  optedIn?: Maybe<Scalars['Boolean']>;
  /** Phone numbers associated with the customer */
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  /** ProPay payer ID for the customer */
  propayPayerId?: Maybe<Scalars['String']>;
  /** Provider of the customer */
  provider: Scalars['String'];
  /** Timestamp when the customer was last remembered */
  rememberCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Number of times the customer has signed in */
  signInCount: Scalars['Int'];
  /** Type of Stripe Connect account for the customer */
  stripeConnectType?: Maybe<Scalars['String']>;
  /** Stripe token for the customer */
  stripeToken?: Maybe<Scalars['String']>;
  /** Title of the customer */
  title?: Maybe<Scalars['String']>;
  /** Token for the customer */
  token?: Maybe<Scalars['String']>;
  /** Tokens associated with the customer */
  tokens?: Maybe<Scalars['String']>;
  /** Unique identifier for the customer in the provider's system */
  uid: Scalars['String'];
  /** Email address that is not yet confirmed */
  unconfirmedEmail?: Maybe<Scalars['String']>;
  /** Timestamp when the customer was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents the relationship between a customer and an event */
export type CustomerEventRelationship = {
  __typename?: 'CustomerEventRelationship';
  /** The customer associated with the relationship */
  customer: Customer;
  /** The ID of the customer */
  customerId: Scalars['Int'];
  /** The event associated with the relationship */
  event: Event;
  /** The ID of the event */
  eventId: Scalars['Int'];
  /** The unique identifier of the relationship */
  id: Scalars['ID'];
};

/** Represents the relationship between a customer and a location, including customer details and preferences */
export type CustomerLocationRelationship = {
  __typename?: 'CustomerLocationRelationship';
  /** Indicates if the customer location relationship is active */
  active?: Maybe<Scalars['Boolean']>;
  /** Companies associated with the customer */
  companies?: Maybe<Array<Company>>;
  /** Timestamp when the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Custom deposit amount for the customer */
  customDepositAmount?: Maybe<Scalars['Float']>;
  /** ID of the customer associated with the relationship */
  customerId?: Maybe<Scalars['Int']>;
  /** Type of deposit associated with the customer */
  depositType?: Maybe<Scalars['String']>;
  /** Discounts associated with the customer */
  discounts?: Maybe<Array<Discount>>;
  /** Documents associated with the customer */
  documents?: Maybe<Array<Document>>;
  /** Driver's license number of the customer */
  driverLicenseNumber?: Maybe<Scalars['String']>;
  /** State of the driver's license */
  driverLicenseState?: Maybe<Scalars['String']>;
  /** Email address of the customer */
  email?: Maybe<Scalars['String']>;
  /** Custom fields from the customer */
  fieldsFromCustomer?: Maybe<Scalars['String']>;
  /** First name of the customer */
  firstName?: Maybe<Scalars['String']>;
  /** Unique identifier for the customer location relationship */
  id: Scalars['ID'];
  /** ID of the import history associated with the customer */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** Indicates if the customer is a planner */
  isPlanner?: Maybe<Scalars['Boolean']>;
  /** Last name of the customer */
  lastName?: Maybe<Scalars['String']>;
  /** ID of the location associated with the relationship */
  locationId?: Maybe<Scalars['Int']>;
  /** Full name of the customer */
  name?: Maybe<Scalars['String']>;
  /** Notes associated with the customer location relationship */
  notes?: Maybe<Scalars['String']>;
  /** Primary phone number of the customer */
  phoneNumber?: Maybe<PhoneNumber>;
  /** Physical address of the customer */
  physicalAddress?: Maybe<PhysicalAddress>;
  /** ProPay payer ID for the customer */
  propayPayerId?: Maybe<Scalars['String']>;
  /** QuickBooks ID for the customer */
  qbId?: Maybe<Scalars['String']>;
  /** Indicates if deposits should be applied */
  shouldApplyDeposits?: Maybe<Scalars['Boolean']>;
  /** Indicates if discounts should be applied */
  shouldApplyDiscounts?: Maybe<Scalars['Boolean']>;
  /** Indicates if the customer should deposit one full payment */
  shouldDepositOneFullPayment?: Maybe<Scalars['Boolean']>;
  /** Type of Stripe Connect account for the customer */
  stripeConnectType?: Maybe<Scalars['String']>;
  /** Stripe token for the customer */
  stripeToken?: Maybe<Scalars['String']>;
  /** Indicates if the customer is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Title of the customer */
  title?: Maybe<Scalars['String']>;
  /** Token for the customer */
  token?: Maybe<Scalars['String']>;
  /** Timestamp when the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Venues associated with the customer */
  venues?: Maybe<Array<Venue>>;
};

export type CustomerLocationRelationshipCollection = {
  __typename?: 'CustomerLocationRelationshipCollection';
  collection: Array<CustomerLocationRelationship>;
  metadata: CollectionMetadata;
};

/** Arguments for creating or updating a CustomerLocationRelationship */
export type CustomerLocationRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Customer deposit type */
  depositType?: InputMaybe<Scalars['String']>;
  /** Customer documents */
  documentsAttributes?: InputMaybe<Array<DocumentInput>>;
  /** Customer DLN */
  driverLicenseNumber?: InputMaybe<Scalars['String']>;
  /** Customer DLS */
  driverLicenseState?: InputMaybe<Scalars['String']>;
  /** Customer Email */
  email?: InputMaybe<Scalars['String']>;
  /** Customer's first name */
  firstName?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Customer Last name */
  isPlanner?: InputMaybe<Scalars['Boolean']>;
  /** Customer Last name */
  lastName?: InputMaybe<Scalars['String']>;
  /** Customer phone number */
  phoneNumberAttributes?: InputMaybe<PhoneNumberInput>;
  /** Customer physical address */
  physicalAddressAttributes?: InputMaybe<PhysicalAddressInput>;
  /** Customer title */
  title?: InputMaybe<Scalars['String']>;
  /** Customer token */
  token?: InputMaybe<Scalars['String']>;
};

/** Represents the relationship between a customer and a rental */
export type CustomerRentalRelationship = {
  __typename?: 'CustomerRentalRelationship';
  /** Indicates if emails should be automatically sent to the client */
  autosendEmails?: Maybe<Scalars['Boolean']>;
  /** The client associated with the relationship */
  client: CustomerRentalRelationshipClient;
  /** The ID of the client */
  clientId: Scalars['Int'];
  /** The type of the client */
  clientType: Scalars['String'];
  /** The first name of the client */
  firstName?: Maybe<Scalars['String']>;
  /** The unique identifier of the relationship */
  id: Scalars['ID'];
  /** Indicates if this relationship is the primary contact for the rental */
  isPrimaryContact: Scalars['Boolean'];
  /** The last name of the client */
  lastName?: Maybe<Scalars['String']>;
  /** The ID of the rental */
  rentalId: Scalars['Int'];
  /** The Stripe Connect type for the client */
  stripeConnectType?: Maybe<Scalars['String']>;
  /** The Stripe token for the client */
  stripeToken?: Maybe<Scalars['String']>;
  /** The tax exemption number associated with the client */
  taxExemptionNumber?: Maybe<Scalars['String']>;
};

export type CustomerRentalRelationshipClient = CustomerLocationRelationship;

/** Arguments for creating or updating a CustomerRentalRelationship */
export type CustomerRentalRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Should we autosend emails to this customer? */
  autosendEmails?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the customer */
  clientId?: InputMaybe<Scalars['Int']>;
  /** The ID of the customer */
  clientType: Scalars['String'];
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Is this the primary contact for the rental? */
  isPrimaryContact?: InputMaybe<Scalars['Boolean']>;
  /** The Stripe Connect Type for the customer */
  stripeConnectType?: InputMaybe<Scalars['String']>;
  /** The Stripe Token for the customer */
  stripeToken?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of DeleteBearerToken */
export type DeleteBearerTokenInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['Int'];
};

/** Autogenerated return type of DeleteBearerToken. */
export type DeleteBearerTokenPayload = {
  __typename?: 'DeleteBearerTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationErrors>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteEvent */
export type DeleteEventInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of DeleteEvent. */
export type DeleteEventPayload = {
  __typename?: 'DeleteEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  event?: Maybe<Event>;
};

/** Autogenerated input type of DeleteRedirectHost */
export type DeleteRedirectHostInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of DeleteRedirectHost. */
export type DeleteRedirectHostPayload = {
  __typename?: 'DeleteRedirectHostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  redirectHost?: Maybe<RedirectHost>;
};

/** Autogenerated input type of DeleteRefundLine */
export type DeleteRefundLineInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  billingNote: BillingNoteInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  refundLine: RefundLineInput;
};

/** Autogenerated return type of DeleteRefundLine. */
export type DeleteRefundLinePayload = {
  __typename?: 'DeleteRefundLinePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of DeleteRole */
export type DeleteRoleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  role: RoleInput;
};

/** Autogenerated return type of DeleteRole. */
export type DeleteRolePayload = {
  __typename?: 'DeleteRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  deletedRole?: Maybe<Scalars['ID']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of DeleteStorefrontCategory */
export type DeleteStorefrontCategoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of DeleteStorefrontCategory. */
export type DeleteStorefrontCategoryPayload = {
  __typename?: 'DeleteStorefrontCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  sfCategory?: Maybe<StorefrontCategory>;
};

/** Autogenerated input type of DeleteStorefrontTag */
export type DeleteStorefrontTagInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated input type of DeleteStorefrontTagItemRelationship */
export type DeleteStorefrontTagItemRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
};

/** Autogenerated return type of DeleteStorefrontTagItemRelationship. */
export type DeleteStorefrontTagItemRelationshipPayload = {
  __typename?: 'DeleteStorefrontTagItemRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sfTagItemRelationship?: Maybe<StorefrontTagItemRelationship>;
};

/** Autogenerated return type of DeleteStorefrontTag. */
export type DeleteStorefrontTagPayload = {
  __typename?: 'DeleteStorefrontTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sfTag?: Maybe<StorefrontTag>;
};

/** Represents a delivery ticket */
export type DeliveryTicket = {
  __typename?: 'DeliveryTicket';
  /** Additional information about the delivery */
  additionalDeliveryInfo?: Maybe<Scalars['String']>;
  /** The business check-in signature for the delivery ticket */
  businessCheckinSignature?: Maybe<Scalars['String']>;
  /** The company of the business check-in signer for the delivery ticket */
  businessCheckinSignerCompany?: Maybe<Scalars['String']>;
  /** The name of the business check-in signer for the delivery ticket */
  businessCheckinSignerName?: Maybe<Scalars['String']>;
  /** The title of the business check-in signer for the delivery ticket */
  businessCheckinSignerTitle?: Maybe<Scalars['String']>;
  /** The business checkout signature for the delivery ticket */
  businessCheckoutSignature?: Maybe<Scalars['String']>;
  /** The company of the business checkout signer for the delivery ticket */
  businessCheckoutSignerCompany?: Maybe<Scalars['String']>;
  /** The name of the business checkout signer for the delivery ticket */
  businessCheckoutSignerName?: Maybe<Scalars['String']>;
  /** The title of the business checkout signer for the delivery ticket */
  businessCheckoutSignerTitle?: Maybe<Scalars['String']>;
  /** The business signature for the delivery ticket */
  businessSignature?: Maybe<Scalars['String']>;
  /** The name of the business signer for the delivery ticket */
  businessSignerName?: Maybe<Scalars['String']>;
  /** The carrier type for the delivery */
  carrierType?: Maybe<Scalars['String']>;
  /** The status of the delivery ticket check-in */
  checkedInStatus?: Maybe<Scalars['String']>;
  /** The check-in signature for the delivery ticket */
  checkinSignature?: Maybe<Scalars['String']>;
  /** The company of the check-in signer for the delivery ticket */
  checkinSignerCompany?: Maybe<Scalars['String']>;
  /** The name of the check-in signer for the delivery ticket */
  checkinSignerName?: Maybe<Scalars['String']>;
  /** The title of the check-in signer for the delivery ticket */
  checkinSignerTitle?: Maybe<Scalars['String']>;
  /** The checkout signature for the delivery ticket */
  checkoutSignature?: Maybe<Scalars['String']>;
  /** The company of the checkout signer for the delivery ticket */
  checkoutSignerCompany?: Maybe<Scalars['String']>;
  /** The name of the checkout signer for the delivery ticket */
  checkoutSignerName?: Maybe<Scalars['String']>;
  /** The title of the checkout signer for the delivery ticket */
  checkoutSignerTitle?: Maybe<Scalars['String']>;
  /** The date and time when the delivery ticket was closed */
  closedDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time when the delivery ticket was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The date and time when the delivery ticket was deleted */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The city for the delivery address */
  deliveryAddressCity?: Maybe<Scalars['String']>;
  /** The country for the delivery address */
  deliveryAddressCountry?: Maybe<Scalars['String']>;
  /** The locale for the delivery address */
  deliveryAddressLocale?: Maybe<Scalars['String']>;
  /** The location name for the delivery address */
  deliveryAddressLocationName?: Maybe<Scalars['String']>;
  /** The postal code for the delivery address */
  deliveryAddressPostalCode?: Maybe<Scalars['String']>;
  /** The first line of the street address for the delivery */
  deliveryAddressStreetAddress1?: Maybe<Scalars['String']>;
  /** The second line of the street address for the delivery */
  deliveryAddressStreetAddress2?: Maybe<Scalars['String']>;
  /** The cost of delivery for the ticket */
  deliveryCost?: Maybe<Scalars['Float']>;
  /** The tracking number for the delivery */
  deliveryTrackingNumber?: Maybe<Scalars['String']>;
  /** The type of delivery for the ticket */
  deliveryType?: Maybe<Scalars['String']>;
  /** The end date and time for the delivery */
  endDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The beginning time for the end window */
  endWindowBeginning?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time for the flip */
  flipDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notes regarding the flip */
  flipNotes?: Maybe<Scalars['String']>;
  /** Indicates if the delivery ticket has an auto-book notification */
  hasAutobookNotification?: Maybe<Scalars['Boolean']>;
  /** Indicates if the delivery ticket has a flip */
  hasFlip?: Maybe<Scalars['Boolean']>;
  /** Indicates if the delivery ticket has a set by time */
  hasSetByTime?: Maybe<Scalars['Boolean']>;
  /** The unique identifier of the delivery ticket */
  id: Scalars['ID'];
  /** The number of items in the delivery ticket */
  itemCount?: Maybe<Scalars['Int']>;
  /** The ID of the associated location */
  locationId?: Maybe<Scalars['Int']>;
  /** The name of the delivery ticket */
  name?: Maybe<Scalars['String']>;
  /** Indicates if the delivery ticket is on alert */
  onAlert?: Maybe<Scalars['Boolean']>;
  /** Indicates if the delivery ticket is on progress to the next stage */
  onProgressToNext?: Maybe<Scalars['Boolean']>;
  /** The picked status of the delivery ticket */
  pickedStatus?: Maybe<Scalars['String']>;
  /** The city for the pickup address */
  pickupAddressCity?: Maybe<Scalars['String']>;
  /** The country for the pickup address */
  pickupAddressCountry?: Maybe<Scalars['String']>;
  /** The locale for the pickup address */
  pickupAddressLocale?: Maybe<Scalars['String']>;
  /** The location name for the pickup address */
  pickupAddressLocationName?: Maybe<Scalars['String']>;
  /** The postal code for the pickup address */
  pickupAddressPostalCode?: Maybe<Scalars['String']>;
  /** The first line of the street address for the pickup */
  pickupAddressStreetAddress1?: Maybe<Scalars['String']>;
  /** The second line of the street address for the pickup */
  pickupAddressStreetAddress2?: Maybe<Scalars['String']>;
  /** Indicates if the pickup address is the same as the delivery address */
  pickupSameAsDelivery?: Maybe<Scalars['Boolean']>;
  /** The preferred delivery window for the ticket */
  preferredDeliveryWindow?: Maybe<Scalars['String']>;
  /** The preferred pickup window for the ticket */
  preferredPickupWindow?: Maybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The tracking number for the return */
  returnTrackingNumber?: Maybe<Scalars['String']>;
  /** The sequence number of the delivery ticket */
  sequence: Scalars['Int'];
  /** The date and time when the delivery ticket was set by time */
  setByTimeDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notes associated with the set by time for the delivery ticket */
  setByTimeNotes?: Maybe<Scalars['String']>;
  /** The signature for the delivery ticket */
  signature?: Maybe<Scalars['String']>;
  /** The start date and time for the delivery */
  startDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The finish time for the start window */
  startWindowFinish?: Maybe<Scalars['ISO8601DateTime']>;
  /** The status of the delivery ticket */
  status?: Maybe<Scalars['String']>;
  /** The time zone for the delivery */
  timeZone?: Maybe<Scalars['String']>;
  /** The date and time when the delivery ticket was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type Details = {
  __typename?: 'Details';
  amount?: Maybe<Scalars['Float']>;
  displayOrder?: Maybe<Scalars['Int']>;
  eventStartDate?: Maybe<Scalars['ISO8601DateTime']>;
  grandTaxTotal?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  locationId?: Maybe<Scalars['ID']>;
  orderName?: Maybe<Scalars['String']>;
  overallTotal?: Maybe<Scalars['Float']>;
  payment?: Maybe<Scalars['Float']>;
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  refundAmount?: Maybe<Scalars['Float']>;
  subTotalForTax?: Maybe<Scalars['Float']>;
  taxAmountDue?: Maybe<Scalars['Float']>;
  taxName?: Maybe<Scalars['String']>;
  taxPaymentsBasedOnTotal?: Maybe<Scalars['Float']>;
  taxPercent?: Maybe<Scalars['Float']>;
  taxType?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** A legal disclaimer or policy that can be associated with rentals, products, or other inventory items. Disclaimers present terms, conditions, or waivers that customers must acknowledge, and can include formatted text and file attachments for additional documentation. */
export type Disclaimer = {
  __typename?: 'Disclaimer';
  /** The timestamp when this disclaimer was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The main content of the disclaimer. Supports basic text formatting. */
  description?: Maybe<Scalars['String']>;
  /** Connections between this disclaimer and specific rental agreements. */
  disclaimerRentalRelationships?: Maybe<Array<DisclaimerRentalRelationship>>;
  /** The type of the attached file (e.g., PDF, Word document, image). */
  fileContentType?: Maybe<Scalars['String']>;
  /** The name of the attached file, if one exists. */
  fileFileName?: Maybe<Scalars['String']>;
  /** The size of the attached file in bytes. */
  fileFileSize?: Maybe<Scalars['Int']>;
  /** When the attached file was last modified. */
  fileUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A unique ID that identifies this disclaimer in the system. */
  id: Scalars['ID'];
  /** The ID of the location this disclaimer belongs to. */
  locationId?: Maybe<Scalars['Int']>;
  /** An alternative name for the disclaimer that can be used in place of the title. */
  name: Scalars['String'];
  /** A short, descriptive name for the disclaimer. This field is required. */
  title: Scalars['String'];
  /** The timestamp when this disclaimer was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents the relationship between a disclaimer and a rental */
export type DisclaimerRentalRelationship = {
  __typename?: 'DisclaimerRentalRelationship';
  /** Indicates if the disclaimer rental relationship should be destroyed */
  _destroy?: Maybe<Scalars['String']>;
  /** The business signature for the disclaimer rental relationship */
  businessSignature?: Maybe<Scalars['String']>;
  /** The name of the business signer for the disclaimer rental relationship */
  businessSignerName?: Maybe<Scalars['String']>;
  /** The date and time when the business submitted the disclaimer rental relationship */
  businessSubmittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time when the disclaimer rental relationship was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time when the customer submitted the disclaimer rental relationship */
  customerSubmittedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the associated disclaimer */
  disclaimerId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the disclaimer rental relationship */
  id?: Maybe<Scalars['ID']>;
  /** The name of the disclaimer rental relationship */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The RV ID associated with the disclaimer rental relationship */
  rvId?: Maybe<Scalars['String']>;
  /** The signature for the disclaimer rental relationship */
  signature?: Maybe<Scalars['String']>;
  /** Indicates if a signature is required for the disclaimer rental relationship */
  signatureRequired?: Maybe<Scalars['Boolean']>;
  /** The name of the signer for the disclaimer rental relationship */
  signerName?: Maybe<Scalars['String']>;
  /** The title of the disclaimer rental relationship */
  title?: Maybe<Scalars['String']>;
  /** The date and time when the disclaimer rental relationship was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Input type for creating or updating a disclaimer rental relationship */
export type DisclaimerRentalRelationshipInput = {
  /** Indicates if the disclaimer rental relationship should be destroyed */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The business signature for the disclaimer rental relationship */
  businessSignature?: InputMaybe<Scalars['String']>;
  /** The name of the business signer for the disclaimer rental relationship */
  businessSignerName?: InputMaybe<Scalars['String']>;
  /** The date and time when the business submitted the disclaimer rental relationship */
  businessSubmittedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The date and time when the disclaimer rental relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The date and time when the customer submitted the disclaimer rental relationship */
  customerSubmittedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the associated disclaimer */
  disclaimerId?: InputMaybe<Scalars['Int']>;
  /** The unique identifier of the disclaimer rental relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the disclaimer rental relationship */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** The RV ID associated with the disclaimer rental relationship */
  rvId?: InputMaybe<Scalars['String']>;
  /** The signature for the disclaimer rental relationship */
  signature?: InputMaybe<Scalars['String']>;
  /** Indicates if a signature is required for the disclaimer rental relationship */
  signatureRequired?: InputMaybe<Scalars['Boolean']>;
  /** The name of the signer for the disclaimer rental relationship */
  signerName?: InputMaybe<Scalars['String']>;
  /** The title of the disclaimer rental relationship */
  title?: InputMaybe<Scalars['String']>;
  /** The date and time when the disclaimer rental relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type Discount = {
  __typename?: 'Discount';
  /** Whether the discount is currently active and available for use */
  active?: Maybe<Scalars['Boolean']>;
  /** The value of the discount (either percentage or fixed amount) */
  amount?: Maybe<Scalars['Float']>;
  /** ID of the business that owns this discount */
  businessId?: Maybe<Scalars['Int']>;
  /** Timestamp when the discount was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Relationships between this discount and rentals it applies to */
  discountRentalRelationships?: Maybe<Array<DiscountRentalRelationship>>;
  /** The type of target this discount applies to (e.g., rental, company, customer) */
  discountTargetType?: Maybe<Scalars['String']>;
  /** The type of discount (e.g., percentage, fixed_amount) */
  discountType?: Maybe<Scalars['String']>;
  /** Unique identifier for the discount */
  id: Scalars['ID'];
  /** Whether this is a custom discount created by a user */
  isCustom?: Maybe<Scalars['Boolean']>;
  /** ID of the location this discount is associated with */
  locationId?: Maybe<Scalars['Int']>;
  /** ID of the multilocation setting this discount belongs to */
  multilocationSettingId?: Maybe<Scalars['Int']>;
  /** The display name of the discount */
  name?: Maybe<Scalars['String']>;
  /** ID of the rental this discount is associated with (if any) */
  rentalId?: Maybe<Scalars['Int']>;
  /** Timestamp when the discount was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The type of value (e.g., percentage, fixed) */
  valueType?: Maybe<Scalars['String']>;
};

export type DiscountInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  amount?: InputMaybe<Scalars['Float']>;
  businessId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  discountRentalRelationshipsAttributes?: InputMaybe<Array<DiscountRentalRelationshipInput>>;
  discountTargetType?: InputMaybe<Scalars['String']>;
  discountType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isCustom?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['Int']>;
  multilocationSettingId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  rentalId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  valueType?: InputMaybe<Scalars['String']>;
};

/** Represents the relationship between a discount and a rental */
export type DiscountRentalRelationship = {
  __typename?: 'DiscountRentalRelationship';
  /** Indicates if the discount rental relationship should be destroyed */
  _destroy?: Maybe<Scalars['String']>;
  /** Indicates if the discount rental relationship is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The amount of the discount */
  amount?: Maybe<Scalars['Float']>;
  /** The date and time when the discount rental relationship was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The discount associated with the rental relationship */
  discount?: Maybe<Discount>;
  /** The ID of the associated discount */
  discountId?: Maybe<Scalars['Int']>;
  /** The target type of the discount */
  discountTargetType?: Maybe<Scalars['String']>;
  /** The type of discount for the rental relationship */
  discountType?: Maybe<Scalars['String']>;
  /** The unique identifier of the discount rental relationship */
  id?: Maybe<Scalars['ID']>;
  /** The name of the discount */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The RV ID associated with the discount rental relationship */
  rvId?: Maybe<Scalars['String']>;
  /** The date and time when the discount rental relationship was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The value type of the discount */
  valueType?: Maybe<Scalars['String']>;
};

/** Input type for creating or updating a discount rental relationship */
export type DiscountRentalRelationshipInput = {
  /** Indicates if the discount rental relationship should be destroyed */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Indicates if the discount rental relationship is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The amount of the discount */
  amount?: InputMaybe<Scalars['Float']>;
  /** The date and time when the discount rental relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The attributes of the discount */
  discountAttributes?: InputMaybe<DiscountInput>;
  /** The ID of the associated discount */
  discountId?: InputMaybe<Scalars['Int']>;
  /** The target type of the discount */
  discountTargetType?: InputMaybe<Scalars['String']>;
  /** The type of discount for the rental relationship */
  discountType?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the discount rental relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the discount */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** The RV ID associated with the discount rental relationship */
  rvId?: InputMaybe<Scalars['String']>;
  /** The date and time when the discount rental relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The value type of the discount */
  valueType?: InputMaybe<Scalars['String']>;
};

/** Represents a document */
export type Document = {
  __typename?: 'Document';
  /** The date and time when the document was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The rental relationships associated with the document */
  documentRentalRelationships?: Maybe<Array<DocumentRentalRelationship>>;
  /** The type of the document */
  documentType?: Maybe<Scalars['String']>;
  /** The ID of the documentable object */
  documentableId?: Maybe<Scalars['Int']>;
  /** The type of the documentable object */
  documentableType?: Maybe<Scalars['String']>;
  /** The employee associated with the document */
  employee?: Maybe<Employee>;
  /** Indicates if the document is expirable */
  expirable?: Maybe<Scalars['Boolean']>;
  /** The expiration date and time of the document */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The file associated with the document */
  file?: Maybe<Scalars['String']>;
  /** The content type of the document */
  fileContentType?: Maybe<Scalars['String']>;
  /** The file name of the document */
  fileFileName?: Maybe<Scalars['String']>;
  /** The file size of the document */
  fileFileSize?: Maybe<Scalars['Int']>;
  /** The last updated date and time of the document */
  fileUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The URL of the file */
  fileUrl?: Maybe<Scalars['String']>;
  /** The unique identifier of the document */
  id: Scalars['ID'];
  /** The ID of the associated location */
  locationId?: Maybe<Scalars['Int']>;
  /** The name of the document */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The date and time when the document was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL of the document */
  url?: Maybe<Scalars['String']>;
  /** Indicates if the document is visible to the customer */
  visibleToCustomer?: Maybe<Scalars['Boolean']>;
};

/** Represents the relationship between a document and an event */
export type DocumentEventRelationship = {
  __typename?: 'DocumentEventRelationship';
  /** The document associated with the event relationship */
  document?: Maybe<Document>;
  /** The ID of the associated document */
  documentId?: Maybe<Scalars['Int']>;
  /** The ID of the employee associated with the document event relationship */
  employeeId?: Maybe<Scalars['String']>;
  /** The event associated with the document relationship */
  event?: Maybe<Event>;
  /** The ID of the associated event */
  eventId?: Maybe<Scalars['Int']>;
  /** Indicates if the document event relationship is expirable */
  expirable?: Maybe<Scalars['Boolean']>;
  /** The expiration date and time of the document event relationship */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier of the document event relationship */
  id?: Maybe<Scalars['ID']>;
};

/** Arguments for creating or updating an DocumentEventRelationship */
export type DocumentEventRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Relationship Status */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Document's attributes */
  documentAttributes?: InputMaybe<DocumentInput>;
  /** ID of the document */
  documentId?: InputMaybe<Scalars['Int']>;
  /** Employee's id */
  employeeId?: InputMaybe<Scalars['String']>;
  /** ID of the rental */
  eventId?: InputMaybe<Scalars['String']>;
  /** Can this document expire */
  expirable?: InputMaybe<Scalars['Boolean']>;
  /** When does the document expire */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Arguments for creating or updating a Document */
export type DocumentInput = {
  /** Indicates if the document should be destroyed */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The creation date and time of the document */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Document type */
  documentType?: InputMaybe<Scalars['String']>;
  /** The ID of the documentable object */
  documentableId?: InputMaybe<Scalars['Int']>;
  /** The type of the documentable object */
  documentableType?: InputMaybe<Scalars['String']>;
  /** Indicates if the document has been edited */
  edited?: InputMaybe<Scalars['Boolean']>;
  /** Employee's id */
  employeeId?: InputMaybe<Scalars['String']>;
  /** Indicates if the document is expirable */
  expirable?: InputMaybe<Scalars['Boolean']>;
  /** The expiration date and time of the document */
  expiresAt?: InputMaybe<Scalars['String']>;
  /** File */
  file?: InputMaybe<Scalars['String']>;
  /** The content type of the file */
  fileContentType?: InputMaybe<Scalars['String']>;
  /** File file name */
  fileFileName?: InputMaybe<Scalars['String']>;
  /** The file size of the document */
  fileFileSize?: InputMaybe<Scalars['Int']>;
  /** The last updated date and time of the file */
  fileUpdatedAt?: InputMaybe<Scalars['String']>;
  /** The URL of the file */
  fileUrl?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** User given file name */
  name?: InputMaybe<Scalars['String']>;
  /** Indicates if the document is visible to the customer */
  visibleToCustomer?: InputMaybe<Scalars['Boolean']>;
};

/** Represents the relationship between a document and a rental */
export type DocumentRentalRelationship = {
  __typename?: 'DocumentRentalRelationship';
  /** Indicates if the document rental relationship is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The date and time when the document rental relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The document associated with the document rental relationship */
  document: Document;
  /** The ID of the associated document */
  documentId?: Maybe<Scalars['Int']>;
  /** The employee associated with the document rental relationship */
  employee: Employee;
  /** The ID of the employee associated with the document rental relationship */
  employeeId?: Maybe<Scalars['Int']>;
  /** Indicates if the document rental relationship is expirable */
  expirable?: Maybe<Scalars['Boolean']>;
  /** Indicates if the document rental relationship is expired */
  expired: Scalars['Boolean'];
  /** The expiration date and time of the document rental relationship */
  expiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier of the document rental relationship */
  id: Scalars['ID'];
  /** The rental associated with the document rental relationship */
  rental?: Maybe<Rental>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The date and time when the document rental relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Document relationship with a rental */
export type DocumentRentalRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Relationship Status */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Document's attributes */
  documentAttributes?: InputMaybe<DocumentInput>;
  /** ID of the document */
  documentId?: InputMaybe<Scalars['String']>;
  /** Employee's id */
  employeeId?: InputMaybe<Scalars['String']>;
  /** Can this document expire */
  expirable?: InputMaybe<Scalars['Boolean']>;
  /** When does the document expire */
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the rental */
  rentalId?: InputMaybe<Scalars['String']>;
};

/** Represents a domain */
export type Domain = {
  __typename?: 'Domain';
  /** The ID of the domainable object */
  domainableId?: Maybe<Scalars['Int']>;
  /** The type of the domainable object */
  domainableType?: Maybe<Scalars['String']>;
  /** The unique identifier of the domain */
  id: Scalars['ID'];
  /** The name of the domain */
  name?: Maybe<Scalars['String']>;
};

/** Represents a driver */
export type Driver = {
  __typename?: 'Driver';
  /** Indicates if the driver is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The date and time when the driver was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the employee associated with the driver */
  employeeId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the driver */
  id: Scalars['ID'];
  /** The name of the driver */
  name: Scalars['String'];
  /** The ID of the rental transport associated with the driver */
  rentalTransportId?: Maybe<Scalars['Int']>;
  /** The role of the driver */
  role?: Maybe<Scalars['String']>;
  /** The ID of the truck associated with the driver */
  truckId?: Maybe<Scalars['Int']>;
  /** The ID of the truck route associated with the driver */
  truckRouteId?: Maybe<Scalars['Int']>;
  /** The date and time when the driver was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Driver or other employee related to truck route */
export type DriverInput = {
  /** Set to "1" to delete this driver */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the employee */
  employeeId: Scalars['Int'];
  /** ID of the driver */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the driver */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the rental transport */
  rentalTransportId?: InputMaybe<Scalars['Int']>;
  /** Role of the employee (ex: Driver) */
  role: Scalars['String'];
  /** ID of the truck */
  truckId?: InputMaybe<Scalars['Int']>;
  /** ID of the truck route */
  truckRouteId?: InputMaybe<Scalars['Int']>;
};

/** Represents an email sent within the system, including details about the sender, recipient, and associated documents */
export type Email = {
  __typename?: 'Email';
  /** Documents attached to the email */
  documents: Array<Document>;
  /** Unique identifier for the email */
  id: Scalars['ID'];
  /** Action of the mailer that sent the email */
  mailerAction: Scalars['String'];
  /** Class of the mailer that sent the email */
  mailerKlass: Scalars['String'];
  /** Email address of the recipient who opened the email */
  openedRecipient: Scalars['String'];
  /** Email address of the recipient */
  recipient: Scalars['String'];
  /** Name of the sender of the email */
  senderName: Scalars['String'];
  /** Timestamp when the email was sent */
  sentAt: Scalars['ISO8601DateTime'];
};

/** An email address object */
export type EmailAddress = {
  __typename?: 'EmailAddress';
  /** Whether the email address is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The date and time the email address was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The email address */
  emailAddress?: Maybe<Scalars['String']>;
  /** The unique identifier of the email address */
  id: Scalars['ID'];
  /** The ID of the associated mailable object */
  mailableId?: Maybe<Scalars['Int']>;
  /** The type of the associated mailable object */
  mailableType?: Maybe<Scalars['String']>;
  /** Whether this is the primary contact email */
  primaryContactEmail?: Maybe<Scalars['Boolean']>;
  /** The type of email address */
  type?: Maybe<Scalars['String']>;
  /** The date and time the email address was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a EmailAddress */
export type EmailAddressInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Is this email active? */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The email address of the addressable */
  emailAddress?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Is this the primary contact email? */
  primaryContactEmail?: InputMaybe<Scalars['Boolean']>;
};

/** Email settings for a location */
export type EmailSetting = {
  __typename?: 'EmailSetting';
  /** Whether to automatically cc the business */
  automaticallyCcBusiness?: Maybe<Scalars['Boolean']>;
  /** Whether to automatically cc the managers */
  automaticallyCcManagers?: Maybe<Scalars['Boolean']>;
  /** Business ID */
  businessId?: Maybe<Scalars['Int']>;
  /** Custom email note */
  customEmailNote?: Maybe<Scalars['String']>;
  /** Custom name */
  customName?: Maybe<Scalars['String']>;
  /** Custom subject */
  customSubject?: Maybe<Scalars['String']>;
  /** Days after */
  daysAfter?: Maybe<Scalars['Int']>;
  /** Days before */
  daysBefore?: Maybe<Scalars['Int']>;
  /** Follow up days after */
  followUpDaysAfter?: Maybe<Scalars['Int']>;
  /** Follow up days before */
  followUpDaysBefore?: Maybe<Scalars['Int']>;
  /** ID */
  id: Scalars['ID'];
  /** Location ID */
  locationId?: Maybe<Scalars['Int']>;
  /** Comma-separated days before anchor (quote reminder, order reminder, quote expiration) */
  multiDaysBefore?: Maybe<Scalars['String']>;
  /** Setting type */
  settingType?: Maybe<Scalars['String']>;
  /** Whether to send email */
  shouldSend?: Maybe<Scalars['Boolean']>;
  /** Whether to send follow up email */
  shouldSendFollowUp?: Maybe<Scalars['Boolean']>;
  /** Subscription type */
  subscriptionType?: Maybe<Scalars['String']>;
};

export type Employee = {
  __typename?: 'Employee';
  active?: Maybe<Scalars['Boolean']>;
  businessId?: Maybe<Scalars['Int']>;
  checkInPrintSettings?: Maybe<Scalars['JSON']>;
  checkOutPrintSettings?: Maybe<Scalars['JSON']>;
  city?: Maybe<Scalars['String']>;
  compliedTermId?: Maybe<Scalars['Int']>;
  confirmationSentAt?: Maybe<Scalars['ISO8601DateTime']>;
  confirmationToken?: Maybe<Scalars['String']>;
  confirmedAt?: Maybe<Scalars['ISO8601DateTime']>;
  consumedTimestep?: Maybe<Scalars['Int']>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['ISO8601DateTime'];
  currentSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  currentSignInIp?: Maybe<Scalars['String']>;
  disableOtherLoginCheck?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  employeeLocationRelationships?: Maybe<Array<EmployeeLocationRelationship>>;
  employeeRentalRelationships?: Maybe<Array<EmployeeRentalRelationship>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDriver?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']>;
  lastSignInIp?: Maybe<Scalars['String']>;
  lastSystemUpdateId?: Maybe<Scalars['Int']>;
  locale?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  operationPrintSettings?: Maybe<Scalars['JSON']>;
  otpRequiredForLogin?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<PhoneNumber>;
  postalCode?: Maybe<Scalars['String']>;
  provider: Scalars['String'];
  rememberCreatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  role?: Maybe<Scalars['String']>;
  signInCount: Scalars['Int'];
  streetAddress1?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  tokens?: Maybe<Scalars['String']>;
  uid: Scalars['String'];
  unconfirmedEmail?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An employee event relationship object */
export type EmployeeEventRelationship = {
  __typename?: 'EmployeeEventRelationship';
  /** Flag indicating whether the relationship should be destroyed */
  _destroy?: Maybe<Scalars['Int']>;
  /** Whether the relationship is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The name of the commission associated with the relationship */
  commissionName?: Maybe<Scalars['String']>;
  /** The commission percentage associated with the relationship */
  commissionPercent?: Maybe<Scalars['Float']>;
  /** The date and time the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The employee associated with the relationship */
  employee: Employee;
  /** The roles associated with the employee event relationship */
  employeeEventRoles?: Maybe<Array<EmployeeEventRole>>;
  /** The ID of the associated employee */
  employeeId?: Maybe<Scalars['Int']>;
  /** The event associated with the relationship */
  event: Event;
  /** The ID of the associated event */
  eventId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the employee event relationship */
  id: Scalars['ID'];
  /** The name of the employee event relationship */
  name?: Maybe<Scalars['String']>;
  /** The RV ID associated with the relationship */
  rvId?: Maybe<Scalars['String']>;
  /** The date and time the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Document relationship with an event */
export type EmployeeEventRelationshipInput = {
  /** Should this relationship be destroyed? */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Is this relationship active? */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Name of the employee commission */
  commissionName?: InputMaybe<Scalars['String']>;
  /** Percentage of the employee commission */
  commissionPercent?: InputMaybe<Scalars['Float']>;
  employeeEventRolesAttributes?: InputMaybe<Array<EmployeeEventRoleInput>>;
  /** ID of the employee */
  employeeId?: InputMaybe<Scalars['Int']>;
  /** ID of the event */
  eventId?: InputMaybe<Scalars['Int']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Name of the employee */
  name?: InputMaybe<Scalars['String']>;
};

/** An employee event role object */
export type EmployeeEventRole = {
  __typename?: 'EmployeeEventRole';
  /** The date and time the employee event role was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the associated employee event relationship */
  employeeEventRelationshipId: Scalars['Int'];
  /** The unique identifier of the employee event role */
  id: Scalars['ID'];
  /** The name of the employee event role */
  name: Scalars['String'];
  /** The role associated with the employee event */
  role: Role;
  /** The ID of the role associated with the employee event */
  roleId: Scalars['String'];
  /** The date and time the employee event role was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating aRole for an Employee in an Event */
export type EmployeeEventRoleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the role */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the role */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the role */
  roleId?: InputMaybe<Scalars['String']>;
};

export type EmployeeLocationRelationship = {
  __typename?: 'EmployeeLocationRelationship';
  /** Status of the calendar synchronization for the employee (e.g., "active", "inactive"). */
  calendarSyncRentalStatus?: Maybe<Scalars['String']>;
  /** ID of the commission structure associated with the employee, if applicable. */
  commissionId?: Maybe<Scalars['Int']>;
  /** Timestamp when the employee location relationship was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Email of the employee. */
  employeeEmail?: Maybe<Scalars['String']>;
  /** ID of the employee associated with this relationship. */
  employeeId?: Maybe<Scalars['String']>;
  /** List of roles associated with the employee at the location. */
  employeeRoleRelationships: Array<EmployeeRoleRelationship>;
  /** Google access token for the employee, used for calendar synchronization. */
  googleAccessToken?: Maybe<Scalars['String']>;
  /** Google Calendar ID associated with the employee. */
  googleCalendarId?: Maybe<Scalars['String']>;
  /** Google refresh token for the employee, used to obtain a new access token when the current one expires. */
  googleRefreshToken?: Maybe<Scalars['String']>;
  /** Unique identifier for the employee location relationship. */
  id: Scalars['ID'];
  /** Indicates if the employee is a driver. */
  isDriver?: Maybe<Scalars['Boolean']>;
  /** ID of the location where the employee is assigned. */
  locationId?: Maybe<Scalars['String']>;
  /** Full name of the employee. */
  name?: Maybe<Scalars['String']>;
  /** Nowsta access token for the employee, used for integration with Nowsta services. */
  nowstaAccessToken?: Maybe<Scalars['String']>;
  /** Filters applied to the Nowsta integration for the employee, such as rental types or statuses. */
  nowstaRentalFilters?: Maybe<Scalars['String']>;
  /** Type of payment method used by the employee (e.g., "hourly", "salary"). */
  paymentType?: Maybe<Scalars['String']>;
  /** Expiration time of the Google access token. */
  tokenExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Timestamp when the employee location relationship was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An employee rental relationship object */
export type EmployeeRentalRelationship = {
  __typename?: 'EmployeeRentalRelationship';
  /** Flag indicating whether the relationship should be destroyed */
  _destroy?: Maybe<Scalars['Int']>;
  /** Whether the relationship is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The name of the commission associated with the relationship */
  commissionName?: Maybe<Scalars['String']>;
  /** The commission percentage associated with the relationship */
  commissionPercent?: Maybe<Scalars['Float']>;
  /** The date and time the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The employee associated with the relationship */
  employee: Employee;
  /** The ID of the associated employee */
  employeeId?: Maybe<Scalars['Int']>;
  /** The roles associated with the employee rental relationship */
  employeeRentalRoles?: Maybe<Array<EmployeeRentalRole>>;
  /** The unique identifier of the employee rental relationship */
  id: Scalars['ID'];
  /** The name of the employee rental relationship */
  name?: Maybe<Scalars['String']>;
  /** The rental associated with the relationship */
  rental: Rental;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The RV ID associated with the relationship */
  rvId?: Maybe<Scalars['String']>;
  /** The date and time the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Document relationship with a rental */
export type EmployeeRentalRelationshipInput = {
  /** Delete relationship flag */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Is this relationship active? */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Name of the employee commission */
  commissionName?: InputMaybe<Scalars['String']>;
  /** Percentage of the employee commission */
  commissionPercent?: InputMaybe<Scalars['Float']>;
  /** ID of the employee */
  employeeId?: InputMaybe<Scalars['String']>;
  employeeRentalRolesAttributes?: InputMaybe<Array<EmployeeRentalRoleInput>>;
  /** ID of the relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of the rental */
  rentalId?: InputMaybe<Scalars['String']>;
};

/** An employee rental role object */
export type EmployeeRentalRole = {
  __typename?: 'EmployeeRentalRole';
  /** The date and time the employee rental role was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The ID of the associated employee rental relationship */
  employeeRentalRelationshipId: Scalars['Int'];
  /** The unique identifier of the employee rental role */
  id: Scalars['ID'];
  /** The name of the employee rental role */
  name: Scalars['String'];
  /** The role associated with the employee rental */
  role: Role;
  /** The ID of the role associated with the employee rental */
  roleId: Scalars['String'];
  /** The date and time the employee rental role was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating aRole for an Employee in a Rental */
export type EmployeeRentalRoleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the employee rental role */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of the role */
  roleId?: InputMaybe<Scalars['ID']>;
};

/** An employee role relationship object */
export type EmployeeRoleRelationship = {
  __typename?: 'EmployeeRoleRelationship';
  /** The ID of the associated employee location relationship */
  employeeLocationRelationshipId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the employee role relationship */
  id: Scalars['ID'];
  /** The name of the employee role relationship */
  name?: Maybe<Scalars['String']>;
  /** The ID of the role associated with the employee */
  roleId?: Maybe<Scalars['String']>;
  /** The key of the role associated with the employee */
  roleKey?: Maybe<Scalars['String']>;
};

export type Event = {
  __typename?: 'Event';
  /** Indicates if the event is currently active in the system. An event is typically considered active if it's not cancelled, completed, or archived, and its dates are within the current timeframe (or in the future for upcoming events). */
  active?: Maybe<Scalars['Boolean']>;
  /** A list of relationships that link companies to this event. */
  companyEventRelationships?: Maybe<Array<CompanyEventRelationship>>;
  /** The timestamp when the event was created. */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A list of relationships that link other customers or contacts to this event. */
  customerEventRelationships?: Maybe<Array<CustomerEventRelationship>>;
  /** The ID of the primary customer associated with the event. */
  customerId?: Maybe<Scalars['ID']>;
  /** A list of relationships that link documents to this event. */
  documentEventRelationships?: Maybe<Array<DocumentEventRelationship>>;
  /** A list of documents related to the event. */
  documents?: Maybe<Array<Document>>;
  /** A list of relationships that link employees (team members) to this event. */
  employeeEventRelationships?: Maybe<Array<EmployeeEventRelationship>>;
  /** The end date and time of the event. This can be null if the event does not have a defined end time. */
  eventEndDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The start date and time of the event. Example: '2025-07-28T08:00:00-05:00'. */
  eventStartDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** A list of relationships that link venues to this event. */
  eventVenueRelationships?: Maybe<Array<EventVenueRelationship>>;
  /** The unique numerical ID of the event. */
  id: Scalars['ID'];
  /** The token of the most recent event in a recurring series. */
  latestRecurrenceToken?: Maybe<Scalars['String']>;
  /** The ID of the most recent recurring rental in a recurring event. */
  latestRecurrentRentalId?: Maybe<Scalars['ID']>;
  /** The details of the location where the event will take place. */
  location?: Maybe<Location>;
  /** The ID of the location (business unit) the event belongs to. */
  locationId?: Maybe<Scalars['ID']>;
  /** The name or title of the event. */
  name?: Maybe<Scalars['String']>;
  /** A list of internal notes linked to the event. */
  notes?: Maybe<Array<Note>>;
  /** A list of parent rentals, useful for grouped events. */
  parentRentals?: Maybe<Array<Rental>>;
  /** The number of times the event is set to repeat. */
  recurrencePeriodCount?: Maybe<Scalars['Int']>;
  /** Indicates whether the event is part of a recurring series. */
  recurring?: Maybe<Scalars['Boolean']>;
  /** The referral source for this event. This is a free-form text field that can be used to track how the customer found out about the event. Common values might include marketing channels, partner names, or other referral sources. */
  referralSource?: Maybe<Scalars['String']>;
  /** An object containing all financial totals for the event, including: subtotal, taxes, fees, discounts, and payment information. Use this for displaying complete financial summaries. */
  rentalTotal: RentalTotal;
  /** A list of all rentals directly associated with the event. */
  rentals?: Maybe<Array<Rental>>;
  /** The total number of rentals associated with this event. */
  rentalsCount?: Maybe<Scalars['Int']>;
  /** The number of secondary orders linked to this event. */
  secondaryOrdersCount?: Maybe<Scalars['Int']>;
  /** The origin from which the event was created. Valid values: 'standard', 'connect', 'multilocation', 'display', 'marketplace', 'storefront', 'reventals', 'reventals_via_revops'. */
  source?: Maybe<Scalars['String']>;
  /** The current status of the event (e.g., 'open', 'cancelled', 'draft'). */
  status: Scalars['String'];
  /** A list of employees who are team members for this event. */
  teamMembers?: Maybe<Array<Employee>>;
  /** The time zone of the event (e.g., 'America/Bahia'). */
  timeZone?: Maybe<Scalars['String']>;
  /** A unique identifier (token) that can be used to fetch or reference the event. */
  token: Scalars['String'];
  /** The internal type of the event, such as 'StandardEvent'. */
  type?: Maybe<Scalars['String']>;
  /** The timestamp of the last time the event was updated. */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** A list of the venues associated with the event. */
  venues?: Maybe<Array<Venue>>;
};

/** An item in the event billing summary */
export type EventBillingItem = {
  __typename?: 'EventBillingItem';
  /** The ID of the inventory item */
  inventoryId?: Maybe<Scalars['Int']>;
  /** The name of the item */
  name?: Maybe<Scalars['String']>;
  /** The quantities of the item */
  quantities?: Maybe<Array<Scalars['Int']>>;
  /** The total quantity of the item */
  quantityTotal?: Maybe<Scalars['Int']>;
  /** The total amount for the item */
  total?: Maybe<Scalars['Int']>;
};

/** The different types of rental items in the event billing summary */
export type EventBillingRentalTypes = {
  __typename?: 'EventBillingRentalTypes';
  /** The accessory items in the event billing summary */
  Accessories?: Maybe<Array<EventBillingItem>>;
  /** The bundle items in the event billing summary */
  Bundles?: Maybe<Array<EventBillingItem>>;
  /** The rental items in the event billing summary */
  Items?: Maybe<Array<EventBillingItem>>;
  /** The labor items in the event billing summary */
  Labor?: Maybe<Array<EventBillingItem>>;
  /** The purchase items in the event billing summary */
  Purchases?: Maybe<Array<EventBillingItem>>;
  /** The staff items in the event billing summary */
  Staff?: Maybe<Array<EventBillingItem>>;
};

/** The summary of billing information for an event */
export type EventBillingSummary = {
  __typename?: 'EventBillingSummary';
  /** The groups of dates for the event */
  dateGroups?: Maybe<Array<Array<Scalars['String']>>>;
  /** The different types of rental items for the event */
  rentalTypes?: Maybe<EventBillingRentalTypes>;
  /** The total number of days for the event */
  totalDays?: Maybe<Scalars['Int']>;
  /** The total number of weeks for the event */
  totalWeeks?: Maybe<Scalars['Int']>;
};

export type EventCollection = {
  __typename?: 'EventCollection';
  collection: Array<Event>;
  metadata: CollectionMetadata;
};

/** Arguments for creating or updating an Event */
export type EventInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether the event is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** ID of the customer associated with the event */
  customerId?: InputMaybe<Scalars['Int']>;
  /** Documents */
  documentEventRelationshipsAttributes?: InputMaybe<Array<DocumentEventRelationshipInput>>;
  /** EER */
  employeeEventRelationshipsAttributes?: InputMaybe<Array<EmployeeEventRelationshipInput>>;
  /** End date and time of the event */
  eventEndDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Start date and time of the event */
  eventStartDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Location's ID */
  locationId?: InputMaybe<Scalars['String']>;
  /** Name of the event */
  name?: InputMaybe<Scalars['String']>;
  /** Note */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Number of periods for the recurring event */
  recurrencePeriodCount?: InputMaybe<Scalars['Int']>;
  /** Whether the event is recurring */
  recurring?: InputMaybe<Scalars['Boolean']>;
  /** Referral source of the event */
  referralSource?: InputMaybe<Scalars['String']>;
  /** Number of rentals associated with the event */
  rentalsCount?: InputMaybe<Scalars['Int']>;
  /** Source of the event */
  source?: InputMaybe<Scalars['String']>;
  /** ID of the rental to start the event from */
  startFromRentalId?: InputMaybe<Scalars['ID']>;
  /** Status of the event */
  status?: InputMaybe<Scalars['String']>;
  /** Time zone of the event */
  timeZone?: InputMaybe<Scalars['String']>;
  /** Event type */
  type?: InputMaybe<Scalars['String']>;
};

/** An event venue relationship object */
export type EventVenueRelationship = {
  __typename?: 'EventVenueRelationship';
  /** The event associated with the relationship */
  event?: Maybe<Event>;
  /** The ID of the associated event */
  eventId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the event venue relationship */
  id?: Maybe<Scalars['ID']>;
  /** The venue associated with the relationship */
  venue?: Maybe<Venue>;
  /** The ID of the associated venue */
  venueId?: Maybe<Scalars['Int']>;
};

/** An expense object */
export type Expense = {
  __typename?: 'Expense';
  /** Flag indicating whether the expense should be destroyed */
  _destroy?: Maybe<Scalars['String']>;
  /** Whether the expense is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The amount of the expense */
  amount?: Maybe<Scalars['Float']>;
  /** The date and time the expense was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier of the expense */
  id?: Maybe<Scalars['ID']>;
  /** The name of the expense */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The ID of the associated rental vehicle */
  rvId?: Maybe<Scalars['ID']>;
  /** The date and time the expense was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** An input object for creating or updating expenses */
export type ExpenseInput = {
  /** Flag indicating whether the expense should be destroyed */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether the expense is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The amount of the expense */
  amount?: InputMaybe<Scalars['Float']>;
  /** The date and time the expense was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier of the expense */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the expense */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** The date and time the expense was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of ExportEventBillingSummary */
export type ExportEventBillingSummaryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ExportEventBillingSummary. */
export type ExportEventBillingSummaryPayload = {
  __typename?: 'ExportEventBillingSummaryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  exportProgressId: Scalars['ID'];
};

/** Autogenerated input type of ExportEventInvoice */
export type ExportEventInvoiceInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of ExportEventInvoice. */
export type ExportEventInvoicePayload = {
  __typename?: 'ExportEventInvoicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  exportProgressId: Scalars['ID'];
};

/** Autogenerated input type of ExportInvoices */
export type ExportInvoicesInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalTokens: Scalars['String'];
};

/** Autogenerated return type of ExportInvoices. */
export type ExportInvoicesPayload = {
  __typename?: 'ExportInvoicesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  message: Scalars['String'];
};

/** Autogenerated return type of ExportPurchaseOrder. */
export type ExportPurchaseOrderPayload = {
  __typename?: 'ExportPurchaseOrderPayload';
  errors?: Maybe<Array<Scalars['String']>>;
  exportProgressId?: Maybe<Scalars['ID']>;
  status: Scalars['String'];
};

/** Autogenerated input type of ExportRentalSlips */
export type ExportRentalSlipsInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Printer resolution in DPI (default: 203) */
  dpi?: InputMaybe<Scalars['Int']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The token of the rental to generate slips for */
  rentalToken: Scalars['String'];
  /** Number of slips to generate */
  slipCount: Scalars['Int'];
};

/** Autogenerated return type of ExportRentalSlips. */
export type ExportRentalSlipsPayload = {
  __typename?: 'ExportRentalSlipsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ID of the ExportProgress record to poll */
  exportProgressId: Scalars['ID'];
};

/** Autogenerated input type of ExportStorefrontInventory */
export type ExportStorefrontInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** ID of the location to export inventory for */
  locationId: Scalars['ID'];
};

/** Autogenerated return type of ExportStorefrontInventory. */
export type ExportStorefrontInventoryPayload = {
  __typename?: 'ExportStorefrontInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Errors encountered while starting the export */
  errors: Array<Scalars['String']>;
  /** ID of the ExportProgress record to poll for completion */
  exportProgressId?: Maybe<Scalars['ID']>;
  /** Status of the export request: started or failed */
  status: Scalars['String'];
};

/** Represents a fee associated with rentals, events, or other entities within the system */
export type Fee = {
  __typename?: 'Fee';
  /** Indicates if the fee is currently active */
  active?: Maybe<Scalars['Boolean']>;
  /** Amount of the fee */
  amount?: Maybe<Scalars['Float']>;
  /** Indicates if the fee should be auto-populated */
  autoPopulate?: Maybe<Scalars['Boolean']>;
  /** ID of the business associated with the fee */
  businessId?: Maybe<Scalars['Int']>;
  /** Timestamp when the fee was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Relationships between the fee and rentals */
  feeRentalRelationships?: Maybe<Array<FeeRentalRelationship>>;
  /** Type of the fee target (e.g., 'customer', 'company') */
  feeTargetType?: Maybe<Scalars['String']>;
  /** Type of the fee (e.g., 'rental', 'event') */
  feeType?: Maybe<Scalars['String']>;
  /** ID of the feeable entity (e.g., rental, event) */
  feeableId?: Maybe<Scalars['Int']>;
  /** Type of the feeable entity (e.g., 'Rental', 'Event') */
  feeableType?: Maybe<Scalars['String']>;
  /** Unique identifier for the fee */
  id: Scalars['ID'];
  /** ID of the location associated with the fee */
  locationId?: Maybe<Scalars['Int']>;
  /** Name of the fee */
  name?: Maybe<Scalars['String']>;
  /** Indicates if the fee is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the fee was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Type of value for the fee (e.g., 'percentage', 'fixed') */
  valueType?: Maybe<Scalars['String']>;
};

/** An input object for creating or updating fees */
export type FeeInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether the fee is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The amount of the fee */
  amount?: InputMaybe<Scalars['Float']>;
  /** Whether the fee should be auto populated */
  autoPopulate?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the associated business */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The date and time the fee was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The rental relationships associated with the fee */
  feeRentalRelationshipsAttributes?: InputMaybe<Array<FeeRentalRelationshipInput>>;
  /** The target type for the fee */
  feeTargetType?: InputMaybe<Scalars['String']>;
  /** The type of the fee */
  feeType?: InputMaybe<Scalars['String']>;
  /** The ID of the associated feeable object */
  feeableId?: InputMaybe<Scalars['Int']>;
  /** The type of the associated feeable object */
  feeableType?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the fee */
  id?: InputMaybe<Scalars['ID']>;
  /** The ID of the associated location */
  locationId?: InputMaybe<Scalars['Int']>;
  /** The name of the fee */
  name?: InputMaybe<Scalars['String']>;
  /** Whether the fee is tax exempt */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** The date and time the fee was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The type of value for the fee */
  valueType?: InputMaybe<Scalars['String']>;
};

/** A fee rental relationship object */
export type FeeRentalRelationship = {
  __typename?: 'FeeRentalRelationship';
  /** Flag indicating whether the fee rental relationship should be destroyed */
  _destroy?: Maybe<Scalars['String']>;
  /** Whether the fee rental relationship is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The amount of the fee */
  amount?: Maybe<Scalars['Float']>;
  /** The date and time the fee rental relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The fee associated with the rental relationship */
  fee?: Maybe<Fee>;
  /** The ID of the associated fee */
  feeId?: Maybe<Scalars['Int']>;
  /** The target type for the fee */
  feeTargetType?: Maybe<Scalars['String']>;
  /** The type of the fee */
  feeType?: Maybe<Scalars['String']>;
  /** The unique identifier of the fee rental relationship */
  id: Scalars['ID'];
  /** The name of the fee */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** The ID of the associated rental vehicle */
  rvId: Scalars['String'];
  /** Whether the fee is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The date and time the fee rental relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The type of value for the fee */
  valueType?: Maybe<Scalars['String']>;
};

/** An input object for creating or updating fee rental relationships */
export type FeeRentalRelationshipInput = {
  /** Flag indicating whether the fee rental relationship should be destroyed */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether the fee rental relationship is active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The amount of the fee */
  amount?: InputMaybe<Scalars['Float']>;
  /** The date and time the fee rental relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The attributes of the fee */
  feeAttributes?: InputMaybe<FeeInput>;
  /** The ID of the associated fee */
  feeId?: InputMaybe<Scalars['Int']>;
  /** The target type for the fee */
  feeTargetType?: InputMaybe<Scalars['String']>;
  /** The type of the fee */
  feeType?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the fee rental relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the fee */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the associated rental */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** The ID of the associated rental vehicle */
  rvId?: InputMaybe<Scalars['String']>;
  /** Whether the fee is tax exempt */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** The date and time the fee rental relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The type of value for the fee */
  valueType?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of FetchMissingSubrentedInventory */
export type FetchMissingSubrentedInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['ID'];
};

/** Autogenerated return type of FetchMissingSubrentedInventory. */
export type FetchMissingSubrentedInventoryPayload = {
  __typename?: 'FetchMissingSubrentedInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  hasMismatch: Scalars['Boolean'];
  inventories?: Maybe<Array<MissingSubrentedInventory>>;
};

export type FieldError = {
  __typename?: 'FieldError';
  field?: Maybe<Scalars['String']>;
  messages?: Maybe<Array<Scalars['String']>>;
};

/** A flat price object */
export type FlatPrice = {
  __typename?: 'FlatPrice';
  /** The amount of the flat price */
  amount?: Maybe<Scalars['Float']>;
  /** The date and time the flat price was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the flat price */
  id: Scalars['ID'];
  /** The name of the flat price */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated pricing label */
  pricingLabelId?: Maybe<Scalars['Int']>;
  /** The ID of the associated product */
  productId?: Maybe<Scalars['Int']>;
  /** The type of the associated product */
  productType?: Maybe<Scalars['String']>;
  /** The date and time the flat price was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** An input object for creating or updating flat prices */
export type FlatPriceInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The amount of the flat price */
  amount?: InputMaybe<Scalars['Float']>;
  /** The date and time the flat price was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier of the flat price */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the flat price */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the associated pricing label */
  pricingLabelId?: InputMaybe<Scalars['Int']>;
  /** The ID of the associated product */
  productId?: InputMaybe<Scalars['Int']>;
  /** The type of the associated product */
  productType?: InputMaybe<Scalars['String']>;
  /** The date and time the flat price was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of GenerateBearerToken */
export type GenerateBearerTokenInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  accessType?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of GenerateBearerToken. */
export type GenerateBearerTokenPayload = {
  __typename?: 'GenerateBearerTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<ValidationErrors>;
  response: Scalars['String'];
};

/** A collection of inventory items */
export type Inventories = {
  __typename?: 'Inventories';
  /** A list of inventory items */
  collection?: Maybe<Array<Inventory>>;
  /** Metadata about the inventory collection */
  metadata?: Maybe<Metadata>;
};

export type Inventory = Accessory | AddOn | Bundle | Product;

/** A single inventory ledger adjustment for an add-on, product, or accessory */
export type InventoryLedgerEntry = {
  __typename?: 'InventoryLedgerEntry';
  /** On-hand quantity after this adjustment */
  balanceAfter?: Maybe<Scalars['Int']>;
  /** When the adjustment occurred */
  date: Scalars['ISO8601DateTime'];
  /** Effective date including turnover time for add operations */
  dateWithTurnoverTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Details of the inventory ledger entry, such as notes, and suppliers information */
  details?: Maybe<Scalars['JSON']>;
  /** Unique identifier of the ledger entry */
  id: Scalars['ID'];
  /** add or remove */
  operation: Scalars['String'];
  /** Signed quantity delta (positive add, negative remove) */
  quantity: Scalars['Int'];
  /** ID of the related rental */
  rentalId?: Maybe<Scalars['Int']>;
  /** Name of the related rental order */
  rentalName?: Maybe<Scalars['String']>;
  /** Token of the related rental */
  rentalToken?: Maybe<Scalars['String']>;
  /** Sub-rented quantity associated with this entry */
  subRentedQuantity?: Maybe<Scalars['Int']>;
  /** Turnover time in seconds applied to this entry */
  turnoverTimeInSeconds?: Maybe<Scalars['Int']>;
};

export type InventoryLedgerEntryCollection = {
  __typename?: 'InventoryLedgerEntryCollection';
  /** Ledger entries followed by supplier records */
  collection: Array<AddOnInventoryLedgerItemUnion>;
  metadata: CollectionMetadata;
};

/** Inventory type enum */
export enum InventoryTypeEnum {
  Accessory = 'Accessory',
  AddOn = 'AddOn',
  Bundle = 'Bundle',
  Product = 'Product'
}

/** An item note object */
export type ItemNote = {
  __typename?: 'ItemNote';
  /** The date and time the item note was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the item note */
  id: Scalars['ID'];
  /** The content of the item note */
  message?: Maybe<Scalars['String']>;
  /** The ID of the noteable item */
  noteableId?: Maybe<Scalars['Int']>;
  /** The type of the noteable item */
  noteableType?: Maybe<Scalars['String']>;
  /** Whether to include notes in rentals */
  shouldIncludeNotesInRentals?: Maybe<Scalars['Boolean']>;
  /** The date and time the item note was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the note is visible to operations */
  visibleToOperations?: Maybe<Scalars['Boolean']>;
};

/** An input object for creating or updating item notes */
export type ItemNoteInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the item note */
  id?: InputMaybe<Scalars['ID']>;
  /** The content of the item note */
  message?: InputMaybe<Scalars['String']>;
  /** The ID of the noteable item */
  noteableId?: InputMaybe<Scalars['Int']>;
  /** The type of the noteable item */
  noteableType?: InputMaybe<Scalars['String']>;
  /** Whether to include notes in rentals */
  shouldIncludeNotesInRentals?: InputMaybe<Scalars['Boolean']>;
  /** Whether the note is visible to operations */
  visibleToOperations?: InputMaybe<Scalars['Boolean']>;
};

/** A load list */
export type LoadList = {
  __typename?: 'LoadList';
  /** The date and time the load list was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the load list */
  id: Scalars['ID'];
  /** The entries of the load list */
  loadListEntries?: Maybe<Array<LoadListEntry>>;
  /** The ID of the associated rental transport truck relationship */
  rentalTransportTruckRelationshipId?: Maybe<Scalars['Int']>;
  /** The date and time the load list was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A load list entry */
export type LoadListEntry = {
  __typename?: 'LoadListEntry';
  /** The date and time the load list entry was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the load list entry */
  id: Scalars['ID'];
  /** The ID of the load list */
  loadListId: Scalars['Int'];
  /** The ID of the rental accessory */
  rentalAccessoryId?: Maybe<Scalars['Int']>;
  /** The ID of the rental add-on */
  rentalAddOnId?: Maybe<Scalars['Int']>;
  /** The ID of the rental bundle */
  rentalBundleId?: Maybe<Scalars['Int']>;
  /** The ID of the rental inventory (read-only) */
  rentalInventoryId?: Maybe<Scalars['Int']>;
  /** The type of rental inventory (read-only) */
  rentalInventoryType?: Maybe<Scalars['String']>;
  /** The ID of the rental item */
  rentalItemId?: Maybe<Scalars['Int']>;
  /** The date and time the load list entry was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A location representing a physical or virtual store or warehouse. */
export type Location = {
  __typename?: 'Location';
  /** Indicates if the location is active. */
  active?: Maybe<Scalars['Boolean']>;
  /** Indicates if advanced pricing is enabled for the location. */
  advancedPricingEnabled?: Maybe<Scalars['Boolean']>;
  /** The assigned reply-to email address for the location. */
  assignedReplyToEmail?: Maybe<Scalars['String']>;
  /** The minimum number of days after which auto-booking can occur. */
  autoBookMinimumDaysAfter?: Maybe<Scalars['Int']>;
  /** The minimum number of days after customer pickup for auto-booking. */
  autoBookMinimumDaysAfterCustomerPickup?: Maybe<Scalars['Int']>;
  /** The minimum number of days after shipping for auto-booking. */
  autoBookMinimumDaysAfterShipping?: Maybe<Scalars['Int']>;
  /** Indicates if closed orders should be automatically converted. */
  autoConvertClosedOrders?: Maybe<Scalars['Boolean']>;
  /** Indicates if headers should be created automatically. */
  autoCreateHeader?: Maybe<Scalars['Boolean']>;
  /** Indicates if auto-reserve is enabled for the location. */
  autoReserveEnabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the business this location belongs to. */
  businessId?: Maybe<Scalars['Int']>;
  /** The business payment terms associated with the location. */
  businessPaymentTerms?: Maybe<Array<BusinessPaymentTerm>>;
  /** Indicates if the location can get a merchant account. */
  canGetMerchantAccount?: Maybe<Scalars['Boolean']>;
  /** Indicates if a credit card fee should be charged. */
  chargeCreditCardFee?: Maybe<Scalars['Boolean']>;
  /** The timestamp when the location was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The name of the credit card fee. */
  creditCardFeeName?: Maybe<Scalars['String']>;
  /** The percentage fee for credit card transactions. */
  creditCardPercent?: Maybe<Scalars['Float']>;
  /** A custom reply-to email address for the location. */
  customReplyToEmail?: Maybe<Scalars['String']>;
  /** A custom sales tax percentage for the location. */
  customSalesTaxPercent?: Maybe<Scalars['Float']>;
  /** A custom subscription amount for the storefront. */
  customSubscriptionAmount?: Maybe<Scalars['Float']>;
  /** Indicates if a custom subscription amount is enabled. */
  customSubscriptionAmountEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if customer notes are visible. */
  customerNoteVisibility?: Maybe<Scalars['Boolean']>;
  /** The fixed fee for damage waivers. */
  damageWaiverFixedFee?: Maybe<Scalars['Float']>;
  /** The percentage fee for damage waivers. */
  damageWaiverPercent?: Maybe<Scalars['Float']>;
  /** Indicates if the damage waiver is tax exempt. */
  damageWaiverTaxExempt?: Maybe<Scalars['Boolean']>;
  /** The ID of the default rental agreement for the location. */
  defaultAgreementId?: Maybe<Scalars['Int']>;
  /** The ID of the default disclaimer for the location. */
  defaultDisclaimerId?: Maybe<Scalars['Int']>;
  /** The default end time for rentals at this location. */
  defaultEnd?: Maybe<Scalars['ISO8601DateTime']>;
  /** The default email address for receiving messages. */
  defaultMessageEmail?: Maybe<Scalars['String']>;
  /** The default start time for rentals at this location. */
  defaultStart?: Maybe<Scalars['ISO8601DateTime']>;
  /** The default team email address for receiving messages. */
  defaultTeamMessageEmail?: Maybe<Scalars['String']>;
  /** Indicates if delivery auto-booking is enabled. */
  deliveryAutoBookEnabled?: Maybe<Scalars['Boolean']>;
  /** The fixed fee for deposits. */
  depositFixedFee?: Maybe<Scalars['Float']>;
  /** The percentage fee for deposits. */
  depositPercent?: Maybe<Scalars['Float']>;
  /** Default discount display mode for new rentals created at this location. One of: 'summary_only', 'subtotal_strike', 'column'. */
  discountDisplay?: Maybe<Scalars['String']>;
  /** Indicates if aggregated inventory prices should be displayed. */
  displayAggregatedInventoryPrices?: Maybe<Scalars['Boolean']>;
  /** Indicates if discounts should be displayed. */
  displayDiscount?: Maybe<Scalars['Boolean']>;
  /** The type of 'do not reply' email used for communications. */
  doNotReplyEmailType?: Maybe<Scalars['String']>;
  /** The email address associated with the location. */
  email?: Maybe<Scalars['String']>;
  /** A suffix to append to email subjects. */
  emailSubjectSuffix?: Maybe<Scalars['String']>;
  /** The number of days after which rentals expire. */
  expireDaysAfter?: Maybe<Scalars['Int']>;
  /** The number of days before which rentals expire. */
  expireDaysBefore?: Maybe<Scalars['Int']>;
  /** The field from which to determine rental expiration. */
  expireFromField?: Maybe<Scalars['String']>;
  /** The Facebook token associated with the location. */
  facebookToken?: Maybe<Scalars['String']>;
  /** The expiration timestamp of the Facebook token. */
  facebookTokenExpiresAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The number of days until the final payment is due. */
  finalPaymentDueDateDaysNum?: Maybe<Scalars['Int']>;
  /** The option for calculating the final payment due date. */
  finalPaymentDueDateDaysOption?: Maybe<Scalars['String']>;
  /** The type of final payment due date. */
  finalPaymentDueDateType?: Maybe<Scalars['String']>;
  /** The fiscal year for the location. */
  fiscalYear?: Maybe<Scalars['Int']>;
  /** The type of 'from' email used for communications. */
  fromEmailType?: Maybe<Scalars['String']>;
  /** The GST number for the location. */
  gstNumber?: Maybe<Scalars['String']>;
  /** The sorting method for headers. */
  headerSortBy?: Maybe<Scalars['String']>;
  /** The unique identifier of the location. */
  id: Scalars['ID'];
  /** Indicates if emails about expired documents should be ignored. */
  ignoreExpiredDocumentEmails?: Maybe<Scalars['Boolean']>;
  /** The latest published storefront shop setting for the location. */
  latestStorefrontShopSetting?: Maybe<StorefrontShopSetting>;
  /** The custom email address for receiving lead emails. */
  leadsCustomEmail?: Maybe<Scalars['String']>;
  /** The locale setting for the location. */
  locale?: Maybe<Scalars['String']>;
  /** A code representing the location. */
  locationCode?: Maybe<Scalars['String']>;
  /** The color associated with the location. */
  locationColor?: Maybe<Scalars['String']>;
  /** Indicates if orders should be manually synced to QuickBooks. */
  manuallySyncOrdersToQb?: Maybe<Scalars['Boolean']>;
  /** The minimum item total required for delivery. */
  minimumItemTotalForDelivery?: Maybe<Scalars['Float']>;
  /** The minimum item total required for pickup. */
  minimumItemTotalForPickup?: Maybe<Scalars['Float']>;
  /** The multilocation settings associated with the location. */
  multilocationSetting?: Maybe<MultilocationSetting>;
  /** The name of the location. */
  name?: Maybe<Scalars['String']>;
  /** Indicates if no-cost subrental transfers are allowed. */
  noCostSubrentalTransfer?: Maybe<Scalars['Boolean']>;
  /** The position of notes on invoices. */
  noteInvoicePosition?: Maybe<Scalars['String']>;
  /** The email address for notifications related to this location. */
  notificationEmailAddress?: Maybe<Scalars['String']>;
  /** Indicates if operations notes are visible. */
  operationsNoteVisibility?: Maybe<Scalars['Boolean']>;
  /** The order durations available at the location. */
  orderDurations: Array<OrderDuration>;
  /** The overbooking setting for the storefront. */
  overbookingOnSf?: Maybe<Scalars['String']>;
  /** Indicates if the first payment notification is enabled. */
  paymentNotification1Enabled?: Maybe<Scalars['Boolean']>;
  /** The number associated with the first payment notification. */
  paymentNotification1Num?: Maybe<Scalars['Int']>;
  /** Indicates if the second payment notification is enabled. */
  paymentNotification2Enabled?: Maybe<Scalars['Boolean']>;
  /** The number associated with the second payment notification. */
  paymentNotification2Num?: Maybe<Scalars['Int']>;
  /** Indicates if the third payment notification is enabled. */
  paymentNotification3Enabled?: Maybe<Scalars['Boolean']>;
  /** The number associated with the third payment notification. */
  paymentNotification3Num?: Maybe<Scalars['Int']>;
  /** The option for payment notification days. */
  paymentNotificationDaysOption?: Maybe<Scalars['String']>;
  /** Email addresses to receive payment notifications. */
  paymentNotificationEmails?: Maybe<Scalars['String']>;
  /** The type of payment notification. */
  paymentNotificationType?: Maybe<Scalars['String']>;
  /** The payment processor used by the location (e.g., grailpay). */
  paymentProcessor?: Maybe<Scalars['String']>;
  /** Options for payment reminders. */
  paymentReminderOptions?: Maybe<Scalars['String']>;
  /** The phone number associated with the location. */
  phoneNumber?: Maybe<PhoneNumber>;
  /** The physical address of the location. */
  physicalAddress?: Maybe<PhysicalAddress>;
  /** Custom email addresses for receiving pick list emails. */
  pickListCustomEmails?: Maybe<Scalars['String']>;
  /** The option for pick list delivery before. */
  pickListDeliveryBeforeOption?: Maybe<Scalars['String']>;
  /** The number of days before delivery to send the pick list. */
  pickListDeliveryDaysCount?: Maybe<Scalars['Int']>;
  /** The option for calculating pick list delivery days. */
  pickListDeliveryDaysOption?: Maybe<Scalars['String']>;
  /** The option for pick list off-shelf before. */
  pickListOffShelfBeforeOption?: Maybe<Scalars['String']>;
  /** The number of days before the off-shelf date to send the pick list. */
  pickListOffShelfDaysCount?: Maybe<Scalars['Int']>;
  /** The option for calculating pick list off-shelf days. */
  pickListOffShelfDaysOption?: Maybe<Scalars['String']>;
  /** The option for pick list order start before. */
  pickListOrderStartBeforeOption?: Maybe<Scalars['String']>;
  /** The number of days before the order start date to send the pick list. */
  pickListOrderStartDaysCount?: Maybe<Scalars['Int']>;
  /** The option for calculating pick list order start days. */
  pickListOrderStartDaysOption?: Maybe<Scalars['String']>;
  /** Indicates if pick-up auto-booking is enabled. */
  pickUpAutoBookEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if point-of-sale is enabled for the location. */
  posEnabled?: Maybe<Scalars['Boolean']>;
  /** The country code for ProPay integration. */
  propayCountry?: Maybe<Scalars['String']>;
  /** The ID of the quick view template associated with the location. */
  quickViewTemplateId?: Maybe<Scalars['ID']>;
  /** The method of recognizing revenue at the location. */
  recognizingRevenue?: Maybe<Scalars['String']>;
  /** The rental agreements associated with the location. */
  rentalAgreements?: Maybe<Array<RentalAgreement>>;
  /** Indicates if rentals expire. */
  rentalsExpire?: Maybe<Scalars['Boolean']>;
  /** The type of sales tax applied at the location. */
  salesTaxType?: Maybe<Scalars['String']>;
  /** The billing interval for the storefront subscription. */
  sfBillingInterval?: Maybe<Scalars['String']>;
  /** The subscription tier for the storefront. */
  sfSubscriptionTier?: Maybe<Scalars['String']>;
  /** Indicates if shipping auto-booking is enabled. */
  shipAutoBookEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if auto-booking is allowed. */
  shouldAllowAutoBook?: Maybe<Scalars['Boolean']>;
  /** Indicates if charges and fees should be combined in QuickBooks. */
  shouldCombineChargesAndFeesQb?: Maybe<Scalars['Boolean']>;
  /** Indicates if payments and refunds should be combined in QuickBooks. */
  shouldCombinePaymentsAndRefundsQb?: Maybe<Scalars['Boolean']>;
  /** Indicates if delivery address changes should be tracked. */
  shouldDeliveryAddressChange?: Maybe<Scalars['Boolean']>;
  /** Indicates if pick list changes should be tracked. */
  shouldPickListChange?: Maybe<Scalars['Boolean']>;
  /** Indicates if lead emails should be received. */
  shouldReceiveLeadsEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if lead emails should be sent to the company email. */
  shouldReceiveLeadsToCompanyEmail?: Maybe<Scalars['Boolean']>;
  /** Indicates if lead emails should be sent to a custom email address. */
  shouldReceiveLeadsToCustomEmail?: Maybe<Scalars['Boolean']>;
  /** Indicates if message emails should be received. */
  shouldReceiveMessageEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if message emails should be sent to a specific email address. */
  shouldReceiveMessageEmailsToEmail?: Maybe<Scalars['Boolean']>;
  /** Indicates if message emails should be sent to the team. */
  shouldReceiveMessageEmailsToTeam?: Maybe<Scalars['Boolean']>;
  /** Indicates if pick list emails should be received. */
  shouldReceivePickListEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if pick list emails should be sent to the company email. */
  shouldReceivePickListToCompanyEmail?: Maybe<Scalars['Boolean']>;
  /** Indicates if pick list emails should be sent to custom email addresses. */
  shouldReceivePickListToCustomEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if emails should be sent from the user. */
  shouldSendEmailsFromUser?: Maybe<Scalars['Boolean']>;
  /** Indicates if inventory photos should be shown in emails. */
  showInventoryPhotoInEmails?: Maybe<Scalars['Boolean']>;
  /** Indicates if inventory photos should be shown in PDFs. */
  showInventoryPhotoInPdf?: Maybe<Scalars['Boolean']>;
  /** Indicates if the 'set by' time should be shown to customers. */
  showSetByTimeToCustomers?: Maybe<Scalars['Boolean']>;
  /** Indicates if soft holds are shown. */
  showSoftHolds?: Maybe<Scalars['Boolean']>;
  /** Indicates if subtotals should be shown in sections. */
  showSubtotalsInSections?: Maybe<Scalars['Boolean']>;
  /** Indicates if unit pricing should be shown to customers. */
  showUnitPricingToCustomers?: Maybe<Scalars['Boolean']>;
  /** Indicates if a signature is required for pickups or deliveries. */
  signatureRequired?: Maybe<Scalars['Boolean']>;
  /** Indicates if smart pricing is active for the location. */
  smartPricingActive?: Maybe<Scalars['Boolean']>;
  /** Indicates if the storefront is included for this location. */
  storefrontIncluded?: Maybe<Scalars['Boolean']>;
  /** The storefront settings associated with the location. */
  storefrontSetting?: Maybe<StorefrontSetting>;
  /** The storefront shop settings associated with the location. */
  storefrontShopSettings?: Maybe<Array<StorefrontShopSetting>>;
  /** The Stripe customer token associated with the location. */
  stripeCustomerToken?: Maybe<Scalars['String']>;
  /** The subdomain for the location's online presence. */
  subdomain?: Maybe<Scalars['String']>;
  /** Indicates if tax breakdowns should be shown. */
  taxBreakdown?: Maybe<Scalars['Boolean']>;
  /** The unique token of the location. */
  token?: Maybe<Scalars['String']>;
  /** The timestamp when the location was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Indicates if the remit-to address should be used. */
  useRemitToAddress?: Maybe<Scalars['Boolean']>;
  /** The website URL of the location. */
  website?: Maybe<Scalars['String']>;
  /** The Zapier account ID associated with the location. */
  zapierAccountId?: Maybe<Scalars['String']>;
  /** The Zapier webhook ID associated with the location. */
  zapierWebhookId?: Maybe<Scalars['String']>;
  /** The Zapier webhook URL associated with the location. */
  zapierWebhookUrl?: Maybe<Scalars['String']>;
};

/** A location with available inventory */
export type LocationWithAvailableInventory = {
  __typename?: 'LocationWithAvailableInventory';
  /** Location Address */
  address: Scalars['String'];
  /** Does the location have enough inventory to fulfill the whole order? */
  fulfillsWholeOrder: Scalars['Boolean'];
  /** Location ID */
  id: Scalars['ID'];
  /** Inventory available at the location */
  inventory: Array<AvailabilityResults>;
  /** Location Name */
  name: Scalars['String'];
};

/** A message object */
export type Message = {
  __typename?: 'Message';
  /** The content of the message */
  content: Scalars['String'];
  /** The conversation the message belongs to */
  conversation: Conversation;
  /** The date and time the message was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the message */
  id: Scalars['ID'];
  /** The sender of the message */
  sender: Sender;
  /** The date and time the message was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Metadata information for paginated results */
export type Metadata = {
  __typename?: 'Metadata';
  /** The current page number */
  currentPage?: Maybe<Scalars['Int']>;
  /** The maximum number of items per page */
  limitValue?: Maybe<Scalars['Int']>;
  /** The total number of items available */
  totalCount?: Maybe<Scalars['Int']>;
  /** The total number of pages available */
  totalPages?: Maybe<Scalars['Int']>;
};

/** Information about missing subrented inventory */
export type MissingSubrentedInventory = {
  __typename?: 'MissingSubrentedInventory';
  /** The unique identifier of the missing subrented inventory */
  id: Scalars['ID'];
  /** The number of missing items */
  missingItems: Scalars['Int'];
  /** The locations where the inventory is missing */
  subrentedLocations: Array<MissingSubrentedLocation>;
  /** The title of the missing subrented inventory */
  title: Scalars['String'];
  /** The type of the missing subrented inventory */
  type: Scalars['String'];
};

/** Information about a missing subrented location */
export type MissingSubrentedLocation = {
  __typename?: 'MissingSubrentedLocation';
  /** The amount subrented at the location */
  amountSubrented?: Maybe<Scalars['Int']>;
  /** The unique identifier of the missing subrented location */
  id: Scalars['ID'];
  /** Whether this is the current location */
  isCurrentLocation: Scalars['Boolean'];
  /** The name of the missing subrented location */
  name: Scalars['String'];
};

/** Settings for multilocation support */
export type MultilocationSetting = {
  __typename?: 'MultilocationSetting';
  /** The minimum number of days after which auto booking is allowed */
  autoBookMinimumDaysAfter?: Maybe<Scalars['Int']>;
  /** Whether to automatically convert multilocation subrentals */
  autoConvertMultilocationSubrentals?: Maybe<Scalars['Boolean']>;
  /** The ID of the business */
  businessId?: Maybe<Scalars['String']>;
  /** The date and time the setting was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the multilocation setting */
  id: Scalars['ID'];
  /** Whether to label subrentals with the location code */
  labelSubrentalsWithLocationCode?: Maybe<Scalars['Boolean']>;
  /** The code of the location */
  locationCode?: Maybe<Scalars['String']>;
  /** The ID of the location */
  locationId?: Maybe<Scalars['String']>;
  /** Whether multilocation is enabled */
  multilocationEnabled?: Maybe<Scalars['Boolean']>;
  /** The ID of the multilocation group */
  multilocationGroupId?: Maybe<Scalars['String']>;
  /** Whether auto booking should be allowed */
  shouldAllowAutoBook?: Maybe<Scalars['Boolean']>;
  /** The date and time the setting was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Root mutation for the GraphQL API */
export type Mutation = {
  __typename?: 'Mutation';
  /** Archives picked serialized inventory */
  archivePickedSerializedInventory?: Maybe<ArchivePickedSerializedInventoryPayload>;
  /** Assigns items to a load list */
  assignItemsToLoadList?: Maybe<AssignItemsToLoadListPayload>;
  /** Assigns trucks to a rental transport */
  assignTrucksToRentalTransport?: Maybe<AssignTrucksToRentalTransportPayload>;
  bulkSetStorefrontTags?: Maybe<BulkSetStorefrontTagsPayload>;
  /** Cancels a purchase order */
  cancelPurchaseOrder?: Maybe<CancelPurchaseOrderPayload>;
  /** Checks in all inventory for a purchase order */
  checkInAllPurchaseOrderInventory?: Maybe<CheckInAllPurchaseOrderInventoryPayload>;
  /** Deletes a bearer token */
  deleteBearerToken?: Maybe<DeleteBearerTokenPayload>;
  /** Deletes an event */
  deleteEvent?: Maybe<DeleteEventPayload>;
  /** Deletes a redirect host */
  deleteRedirectHost?: Maybe<DeleteRedirectHostPayload>;
  /** Deletes a refund line */
  deleteRefundLine?: Maybe<DeleteRefundLinePayload>;
  /** Deletes a role */
  deleteRole?: Maybe<DeleteRolePayload>;
  deleteStorefrontCategory?: Maybe<DeleteStorefrontCategoryPayload>;
  /** Deletes a new storefront tag */
  deleteStorefrontTag?: Maybe<DeleteStorefrontTagPayload>;
  /** Deletes a storefront tag-item relationship */
  deleteStorefrontTagItemRelationship?: Maybe<DeleteStorefrontTagItemRelationshipPayload>;
  /** Exports an event billing summary */
  exportEventBillingSummary?: Maybe<ExportEventBillingSummaryPayload>;
  /** Exports an event invoice */
  exportEventInvoice?: Maybe<ExportEventInvoicePayload>;
  /** Exports invoices */
  exportInvoices?: Maybe<ExportInvoicesPayload>;
  /** Exports a purchase order */
  exportPurchaseOrder?: Maybe<ExportPurchaseOrderPayload>;
  /** Exports ZPL slip labels for a rental */
  exportRentalSlips?: Maybe<ExportRentalSlipsPayload>;
  /** Exports active storefront inventory for a location as CSV */
  exportStorefrontInventory?: Maybe<ExportStorefrontInventoryPayload>;
  /** Fetches missing subrented inventory */
  fetchMissingSubrentedInventory?: Maybe<FetchMissingSubrentedInventoryPayload>;
  /** Generates a bearer token */
  generateBearerToken?: Maybe<GenerateBearerTokenPayload>;
  /** Reactivates serialized products */
  reactivateSerializedProducts?: Maybe<ReactivateSerializedProductsPayload>;
  /** Reassigns drivers */
  reassignDrivers?: Maybe<ReassignDriversPayload>;
  /** Resolves missing subrented inventory */
  resolveMissingSubrentedInventory?: Maybe<ResolveMissingSubrentedInventoryPayload>;
  /** Returns picked serialized inventory */
  returnPickedSerializedInventory?: Maybe<ReturnPickedSerializedInventoryPayload>;
  /** Reverts a change history entry */
  revertChangeHistoryEntry?: Maybe<RevertChangeHistoryEntryPayload>;
  /** Sets an accessory */
  setAccessory?: Maybe<SetAccessoryPayload>;
  /** Sets an add-on */
  setAddOn?: Maybe<SetAddOnPayload>;
  /** Sets the relationship between a company and a location */
  setCompanyLocationRelationship?: Maybe<SetCompanyLocationRelationshipPayload>;
  /** Sets the relationship between a customer and a location */
  setCustomerLocationRelationship?: Maybe<SetCustomerLocationRelationshipPayload>;
  /** Sets employee rental relationships */
  setEmployeeRentalRelationships?: Maybe<SetEmployeeRentalRelationshipsPayload>;
  /** Sets an event */
  setEvent?: Maybe<SetEventPayload>;
  /** Sets a pick list */
  setPickList?: Maybe<SetPickListPayload>;
  /** Sets a product */
  setProduct?: Maybe<SetProductPayload>;
  /** Sets a purchase order */
  setPurchaseOrder?: Maybe<SetPurchaseOrderPayload>;
  /** Sets a redirect host */
  setRedirectHost?: Maybe<SetRedirectHostPayload>;
  /** Sets a refund */
  setRefund?: Maybe<SetRefundPayload>;
  /** Sets a rental */
  setRental?: Maybe<SetRentalPayload>;
  /** Sets rental staff */
  setRentalStaffs?: Maybe<SetRentalStaffsPayload>;
  /** Sets a role */
  setRole?: Maybe<SetRolePayload>;
  /** Sets a secondary order */
  setSecondaryOrder?: Maybe<SetSecondaryOrderPayload>;
  setStorefrontCategory?: Maybe<SetStorefrontCategoryPayload>;
  /** Creates or updates a new storefront tag */
  setStorefrontTag?: Maybe<SetStorefrontTagPayload>;
  /** Associates a storefront tag with an item of any type */
  setStorefrontTagItemRelationship?: Maybe<SetStorefrontTagItemRelationshipPayload>;
  /** Sets a truck route */
  setTruckRoute?: Maybe<SetTruckRoutePayload>;
  /** Sets a vendor */
  setVendor?: Maybe<SetVendorPayload>;
  /** Sets a venue */
  setVenue?: Maybe<SetVenuePayload>;
  /** Sets webhook settings */
  setWebhookSettings?: Maybe<SetWebhookSettingsPayload>;
  /** Syncs a rental manually to QuickBooks */
  syncRentalManuallyToQb?: Maybe<SyncRentalManuallyToQbPayload>;
  /** Syncs a rental to QuickBooks */
  syncRentalToQb?: Maybe<SyncRentalToQbPayload>;
  /** Unassigns trucks from a rental transport */
  unassignTrucksFromRentalTransport?: Maybe<UnassignTrucksFromRentalTransportPayload>;
  /** Updates a column filter */
  updateColumnFilter?: Maybe<UpdateColumnFilterPayload>;
  /** Updates a quick view template */
  updateQuickViewTemplate?: Maybe<UpdateQuickViewTemplatePayload>;
  /** Initiates Worldpay hosted payment setup; returns redirect_url and transaction_setup_id */
  worldpayHostedPaymentSetup?: Maybe<WorldpayHostedPaymentSetupPayload>;
};


/** Root mutation for the GraphQL API */
export type MutationArchivePickedSerializedInventoryArgs = {
  input: ArchivePickedSerializedInventoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationAssignItemsToLoadListArgs = {
  input: AssignItemsToLoadListInput;
};


/** Root mutation for the GraphQL API */
export type MutationAssignTrucksToRentalTransportArgs = {
  input: AssignTrucksToRentalTransportInput;
};


/** Root mutation for the GraphQL API */
export type MutationBulkSetStorefrontTagsArgs = {
  input: BulkSetStorefrontTagsInput;
};


/** Root mutation for the GraphQL API */
export type MutationCancelPurchaseOrderArgs = {
  input: CancelPurchaseOrderInput;
};


/** Root mutation for the GraphQL API */
export type MutationCheckInAllPurchaseOrderInventoryArgs = {
  input: CheckInAllPurchaseOrderInventoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteBearerTokenArgs = {
  input: DeleteBearerTokenInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteEventArgs = {
  input: DeleteEventInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteRedirectHostArgs = {
  input: DeleteRedirectHostInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteRefundLineArgs = {
  input: DeleteRefundLineInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteStorefrontCategoryArgs = {
  input: DeleteStorefrontCategoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteStorefrontTagArgs = {
  input: DeleteStorefrontTagInput;
};


/** Root mutation for the GraphQL API */
export type MutationDeleteStorefrontTagItemRelationshipArgs = {
  input: DeleteStorefrontTagItemRelationshipInput;
};


/** Root mutation for the GraphQL API */
export type MutationExportEventBillingSummaryArgs = {
  input: ExportEventBillingSummaryInput;
};


/** Root mutation for the GraphQL API */
export type MutationExportEventInvoiceArgs = {
  input: ExportEventInvoiceInput;
};


/** Root mutation for the GraphQL API */
export type MutationExportInvoicesArgs = {
  input: ExportInvoicesInput;
};


/** Root mutation for the GraphQL API */
export type MutationExportPurchaseOrderArgs = {
  emails?: InputMaybe<Array<Scalars['String']>>;
  purchaseOrderId: Scalars['ID'];
};


/** Root mutation for the GraphQL API */
export type MutationExportRentalSlipsArgs = {
  input: ExportRentalSlipsInput;
};


/** Root mutation for the GraphQL API */
export type MutationExportStorefrontInventoryArgs = {
  input: ExportStorefrontInventoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationFetchMissingSubrentedInventoryArgs = {
  input: FetchMissingSubrentedInventoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationGenerateBearerTokenArgs = {
  input: GenerateBearerTokenInput;
};


/** Root mutation for the GraphQL API */
export type MutationReactivateSerializedProductsArgs = {
  input: ReactivateSerializedProductsInput;
};


/** Root mutation for the GraphQL API */
export type MutationReassignDriversArgs = {
  input: ReassignDriversInput;
};


/** Root mutation for the GraphQL API */
export type MutationResolveMissingSubrentedInventoryArgs = {
  input: ResolveMissingSubrentedInventoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationReturnPickedSerializedInventoryArgs = {
  input: ReturnPickedSerializedInventoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationRevertChangeHistoryEntryArgs = {
  input: RevertChangeHistoryEntryInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetAccessoryArgs = {
  input: SetAccessoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetAddOnArgs = {
  input: SetAddOnInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetCompanyLocationRelationshipArgs = {
  input: SetCompanyLocationRelationshipInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetCustomerLocationRelationshipArgs = {
  input: SetCustomerLocationRelationshipInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetEmployeeRentalRelationshipsArgs = {
  input: SetEmployeeRentalRelationshipsInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetEventArgs = {
  input: SetEventInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetPickListArgs = {
  input: SetPickListInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetProductArgs = {
  input: SetProductInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetPurchaseOrderArgs = {
  input: SetPurchaseOrderInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetRedirectHostArgs = {
  input: SetRedirectHostInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetRefundArgs = {
  input: SetRefundInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetRentalArgs = {
  input: SetRentalInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetRentalStaffsArgs = {
  input: SetRentalStaffsInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetRoleArgs = {
  input: SetRoleInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetSecondaryOrderArgs = {
  input: SetSecondaryOrderInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetStorefrontCategoryArgs = {
  input: SetStorefrontCategoryInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetStorefrontTagArgs = {
  input: SetStorefrontTagInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetStorefrontTagItemRelationshipArgs = {
  input: SetStorefrontTagItemRelationshipInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetTruckRouteArgs = {
  input: SetTruckRouteInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetVendorArgs = {
  input: SetVendorInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetVenueArgs = {
  input: SetVenueInput;
};


/** Root mutation for the GraphQL API */
export type MutationSetWebhookSettingsArgs = {
  input: SetWebhookSettingsInput;
};


/** Root mutation for the GraphQL API */
export type MutationSyncRentalManuallyToQbArgs = {
  input: SyncRentalManuallyToQbInput;
};


/** Root mutation for the GraphQL API */
export type MutationSyncRentalToQbArgs = {
  input: SyncRentalToQbInput;
};


/** Root mutation for the GraphQL API */
export type MutationUnassignTrucksFromRentalTransportArgs = {
  input: UnassignTrucksFromRentalTransportInput;
};


/** Root mutation for the GraphQL API */
export type MutationUpdateColumnFilterArgs = {
  input: UpdateColumnFilterInput;
};


/** Root mutation for the GraphQL API */
export type MutationUpdateQuickViewTemplateArgs = {
  input: UpdateQuickViewTemplateInput;
};


/** Root mutation for the GraphQL API */
export type MutationWorldpayHostedPaymentSetupArgs = {
  input: WorldpayHostedPaymentSetupInput;
};

/** A type representing a person's name */
export type Name = {
  __typename?: 'Name';
  /** The date and time the name was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The first name of the person */
  firstName?: Maybe<Scalars['String']>;
  /** The unique identifier of the name */
  id: Scalars['ID'];
  /** The last name of the person */
  lastName?: Maybe<Scalars['String']>;
  /** The ID of the entity that the name belongs to */
  nameableId?: Maybe<Scalars['Int']>;
  /** The type of the entity that the name belongs to */
  nameableType?: Maybe<Scalars['String']>;
  /** The date and time the name was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Name */
export type NameInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Is this name active? */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The first name of the Name */
  firstName?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The last name of the Name */
  lastName?: InputMaybe<Scalars['String']>;
  /** The id of the nameable */
  nameableId?: InputMaybe<Scalars['String']>;
  /** The type of the nameable. Should be a model name. */
  nameableType?: InputMaybe<Scalars['String']>;
};

/** A type representing a note */
export type Note = {
  __typename?: 'Note';
  /** The date and time the note was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Debug information for the note */
  debug?: Maybe<Scalars['String']>;
  /** The employee associated with the note */
  employee?: Maybe<Employee>;
  /** The ID of the employee associated with the note */
  employeeId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the note */
  id: Scalars['ID'];
  /** The position of the note in the invoice */
  invoicePosition?: Maybe<Scalars['String']>;
  /** The content of the note */
  message?: Maybe<Scalars['String']>;
  /** The type of the note */
  noteType?: Maybe<Scalars['String']>;
  /** The ID of the entity that the note is associated with */
  noteableId?: Maybe<Scalars['Int']>;
  /** The type of the entity that the note is associated with */
  noteableType?: Maybe<Scalars['String']>;
  /** The position of the note in the picklist */
  picklistPosition?: Maybe<Scalars['String']>;
  /** The date and time the note was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Whether the note is visible to the customer */
  visibleToCustomer?: Maybe<Scalars['Boolean']>;
  /** Whether the note is visible to operations */
  visibleToOperations?: Maybe<Scalars['Boolean']>;
};

/** Arguments for creating or updating a Note */
export type NoteInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Id of the employee */
  employeeId?: InputMaybe<Scalars['Int']>;
  /** First name of the employee */
  firstName?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Position of this note */
  invoicePosition?: InputMaybe<Scalars['String']>;
  /** Last name of the employee */
  lastName?: InputMaybe<Scalars['String']>;
  /** Message on the note */
  message?: InputMaybe<Scalars['String']>;
  /** Note type */
  noteType?: InputMaybe<Scalars['String']>;
  /** Position of this note on picklist prints */
  picklistPosition?: InputMaybe<Scalars['String']>;
  /** Role of the employee */
  role?: InputMaybe<Scalars['String']>;
  /** Can customers see this note */
  visibleToCustomer?: InputMaybe<Scalars['Boolean']>;
  /** Can operations see this note */
  visibleToOperations?: InputMaybe<Scalars['Boolean']>;
};

/** A type representing the duration of an order */
export type OrderDuration = {
  __typename?: 'OrderDuration';
  /** The breakpoint for the order duration */
  breakpoint: Scalars['String'];
  /** The date and time the order duration was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the order duration */
  id: Scalars['ID'];
  /** The ID of the location associated with the order duration */
  locationId: Scalars['Int'];
  /** The multiplier for the order duration */
  multiplier?: Maybe<Scalars['Float']>;
  /** The rate for the order duration */
  rate: Scalars['String'];
  /** The secondary multiplier for the order duration */
  secondaryMultiplier?: Maybe<Scalars['Float']>;
  /** The secondary rate for the order duration */
  secondaryRate?: Maybe<Scalars['String']>;
  /** The date and time the order duration was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for original inventory */
export type OriginalInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the original inventory */
  id?: InputMaybe<Scalars['ID']>;
  /** The serialization status of the original inventory */
  serializationStatus?: InputMaybe<Scalars['String']>;
  /** The serialized products associated with the original inventory */
  serializedProductsAttributes?: InputMaybe<Array<SerializedProductInput>>;
};

/** Objects which can be original inventory */
export type OriginalInventoryUnion = Accessory | AddOn | Product;

/** A type representing a phone number */
export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  /** Whether the phone number is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The cell phone number */
  cell?: Maybe<Scalars['String']>;
  /** The country code of the phone number */
  country?: Maybe<Scalars['String']>;
  /** The date and time the phone number was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The extension number for the phone */
  extension?: Maybe<Scalars['String']>;
  /** The fax number */
  fax?: Maybe<Scalars['String']>;
  /** The unique identifier of the phone number */
  id: Scalars['ID'];
  /** Whether the phone number is the main contact number */
  mainContactNumber?: Maybe<Scalars['Boolean']>;
  /** The office phone number */
  office?: Maybe<Scalars['String']>;
  /** The type of phone number */
  phoneType?: Maybe<Scalars['String']>;
  /** The ID of the entity that the phone number is associated with */
  phoneableId?: Maybe<Scalars['Int']>;
  /** The type of the entity that the phone number is associated with */
  phoneableType?: Maybe<Scalars['String']>;
  /** The type of the phone number */
  type?: Maybe<Scalars['Int']>;
  /** The date and time the phone number was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a PhoneNumber */
export type PhoneNumberInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Is this number active? */
  active?: InputMaybe<Scalars['Boolean']>;
  /** cell */
  cell?: InputMaybe<Scalars['String']>;
  /** extension */
  extension?: InputMaybe<Scalars['String']>;
  /** fax */
  fax?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Is this the main contact number? */
  mainContactNumber?: InputMaybe<Scalars['Boolean']>;
  /** office */
  office?: InputMaybe<Scalars['String']>;
  /** Phone Type */
  phoneType?: InputMaybe<Scalars['String']>;
};

/** A type representing a physical address */
export type PhysicalAddress = {
  __typename?: 'PhysicalAddress';
  /** Whether the physical address is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The type of the physical address (e.g., residential, commercial) */
  addressType?: Maybe<Scalars['String']>;
  /** The ID of the entity that the physical address is associated with */
  addressableId?: Maybe<Scalars['Int']>;
  /** The type of the entity that the physical address is associated with */
  addressableType?: Maybe<Scalars['String']>;
  /** The city of the physical address */
  city?: Maybe<Scalars['String']>;
  /** The country of the physical address */
  country?: Maybe<Scalars['String']>;
  /** The date and time the physical address was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the physical address */
  id: Scalars['ID'];
  /** The latitude of the physical address */
  latitude?: Maybe<Scalars['Float']>;
  /** The locale of the physical address */
  locale?: Maybe<Scalars['String']>;
  /** The longitude of the physical address */
  longitude?: Maybe<Scalars['Float']>;
  /** Whether the physical address is the main contact address */
  mainContactAddress?: Maybe<Scalars['Boolean']>;
  /** The name associated with the physical address */
  name?: Maybe<Scalars['String']>;
  /** The postal code of the physical address */
  postalCode?: Maybe<Scalars['String']>;
  /** The first line of the street address */
  streetAddress1?: Maybe<Scalars['String']>;
  /** The second line of the street address */
  streetAddress2?: Maybe<Scalars['String']>;
  /** The tax rate for the physical address */
  taxRate?: Maybe<Scalars['Float']>;
  /** The date and time the physical address was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a PhysicalAddress */
export type PhysicalAddressInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  /** The city of the physical address */
  city?: InputMaybe<Scalars['String']>;
  /** country */
  country?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The locale of the physical address */
  locale?: InputMaybe<Scalars['String']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** The postal code of the physical address */
  postalCode?: InputMaybe<Scalars['String']>;
  /** The first line of the street address */
  streetAddress1?: InputMaybe<Scalars['String']>;
  /** The second line of the street address */
  streetAddress2?: InputMaybe<Scalars['String']>;
};

/** A type representing an accessory in a pick list */
export type PickListAccessory = {
  __typename?: 'PickListAccessory';
  /** The accessory details */
  accessory?: Maybe<Accessory>;
  /** The ID of the accessory */
  accessoryId?: Maybe<Scalars['Int']>;
  /** Whether the accessory is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The quantity of the accessory that has been checked in */
  checkedInQuantity?: Maybe<Scalars['Int']>;
  /** The date and time the accessory was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Whether the accessory is exempt from damage waiver */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** The quantity of the accessory that is damaged */
  damagedQuantity?: Maybe<Scalars['Int']>;
  /** The ID of the delivery ticket associated with the accessory */
  deliveryTicketId?: Maybe<Scalars['Int']>;
  /** The description of the accessory */
  description?: Maybe<Scalars['String']>;
  /** The fee associated with the accessory */
  fee?: Maybe<Fee>;
  /** The unique identifier of the accessory */
  id: Scalars['ID'];
  /** The Imgix URL for the accessory's image */
  imgixUrl?: Maybe<Scalars['String']>;
  /** The type of inventory the accessory belongs to */
  inventoryType: Scalars['String'];
  /** Notes regarding any lack of accessories */
  lackNotes?: Maybe<Scalars['String']>;
  /** The last known missing quantity of the accessory */
  lastMissingQuantity?: Maybe<Scalars['Int']>;
  /** The maximum quantity of the accessory allowed in a secondary order */
  maxQuantityInSecondaryOrder?: Maybe<Scalars['Int']>;
  /** The quantity of the accessory that is missing */
  missingQuantity?: Maybe<Scalars['Int']>;
  /** The name of the accessory */
  name?: Maybe<Scalars['String']>;
  /** Any notes related to the accessory */
  notes?: Maybe<Scalars['String']>;
  /** The number of available accessories */
  numberAvailable?: Maybe<Scalars['Int']>;
  /** The number of accessories available for soft hold */
  numberAvailableForSoftHold?: Maybe<Scalars['Int']>;
  /** The quantity of the accessory that has been picked */
  pickedQuantity?: Maybe<Scalars['Int']>;
  /** The position of the accessory in the pick list */
  position?: Maybe<Scalars['Int']>;
  /** The name of the product category the accessory belongs to */
  productCategoryName?: Maybe<Scalars['String']>;
  /** The notes associated with the product */
  productNotes?: Maybe<Array<ItemNote>>;
  /** The quantity of the accessory */
  quantity?: Maybe<Scalars['Int']>;
  /** The rental accessories associated with the accessory */
  rentalAccessories?: Maybe<Array<RentalAccessory>>;
  /** The ID of the rental associated with the accessory */
  rentalId?: Maybe<Scalars['Int']>;
  /** Whether the accessory was set manually */
  setManually?: Maybe<Scalars['Boolean']>;
  /** The status of the accessory */
  status?: Maybe<Scalars['String']>;
  /** The sub-rentals associated with the accessory */
  subRentals?: Maybe<Array<SubRental>>;
  /** Whether the accessory is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The date and time the accessory was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A type representing an add-on in a pick list */
export type PickListAddOn = {
  __typename?: 'PickListAddOn';
  /** Whether the add-on is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The add-on details */
  addOn?: Maybe<AddOn>;
  /** The ID of the add-on */
  addOnId?: Maybe<Scalars['Int']>;
  /** The date and time the add-on was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Whether the add-on is exempt from damage waiver */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** The ID of the delivery ticket associated with the add-on */
  deliveryTicketId?: Maybe<Scalars['Int']>;
  /** The description of the add-on */
  description?: Maybe<Scalars['String']>;
  /** The unique identifier of the add-on */
  id: Scalars['ID'];
  /** The Imgix URL for the add-on's image */
  imgixUrl?: Maybe<Scalars['String']>;
  /** The type of inventory the add-on belongs to */
  inventoryType: Scalars['String'];
  /** Notes regarding any lack of add-ons */
  lackNotes?: Maybe<Scalars['String']>;
  /** The maximum quantity of the add-on allowed in a secondary order */
  maxQuantityInSecondaryOrder?: Maybe<Scalars['Int']>;
  /** The name of the add-on */
  name?: Maybe<Scalars['String']>;
  /** Any notes related to the add-on */
  notes?: Maybe<Scalars['String']>;
  /** The number of available add-ons */
  numberAvailable?: Maybe<Scalars['Int']>;
  /** The number of add-ons available for soft hold */
  numberAvailableForSoftHold?: Maybe<Scalars['Int']>;
  /** The quantity of the add-on that has been picked */
  pickedQuantity?: Maybe<Scalars['Int']>;
  /** The position of the add-on in the pick list */
  position?: Maybe<Scalars['Int']>;
  /** The position of the add-on within its section */
  positionInSection?: Maybe<Scalars['Int']>;
  /** The notes associated with the product */
  productNotes?: Maybe<Array<ItemNote>>;
  /** The quantity of the add-on */
  quantity?: Maybe<Scalars['Int']>;
  /** The rental add-ons associated with the add-on */
  rentalAddOns?: Maybe<Array<RentalAddOn>>;
  /** The ID of the rental associated with the add-on */
  rentalId?: Maybe<Scalars['Int']>;
  /** The ID of the rental section associated with the add-on */
  rentalSectionId?: Maybe<Scalars['Int']>;
  /** The quantity of the add-on that has been returned */
  returnedQuantity?: Maybe<Scalars['Int']>;
  /** The selected price of the add-on */
  selectedPrice?: Maybe<Scalars['Float']>;
  /** Whether the add-on was set manually */
  setManually?: Maybe<Scalars['Boolean']>;
  /** The status of the add-on */
  status?: Maybe<Scalars['String']>;
  /** The sub-rentals associated with the add-on */
  subRentals?: Maybe<Array<SubRental>>;
  /** Whether the add-on is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The date and time the add-on was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** PickList wrapper input for [PickListItem, PickListAccessories, PickListAddOn] */
export type PickListInputWrapper = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Total checked in quantity from a pick list item/accessory/add_on */
  checkedInQuantity?: InputMaybe<Scalars['Int']>;
  /** The relationship's id */
  id: Scalars['Int'];
  /** Total picked quantity from a pick list item/accessory/add_on */
  pickedQuantity?: InputMaybe<Scalars['Int']>;
  /** Status from a pick list item */
  status?: InputMaybe<Scalars['String']>;
};

/** A type representing an item in a pick list */
export type PickListItem = {
  __typename?: 'PickListItem';
  /** Whether the item is active */
  active?: Maybe<Scalars['Boolean']>;
  /** The quantity of the item that has been checked in */
  checkedInQuantity?: Maybe<Scalars['Int']>;
  /** The date and time the item was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The daily price of the item */
  dailyPrice?: Maybe<Scalars['Float']>;
  /** Whether the item is exempt from damage waiver */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** The quantity of the item that is damaged */
  damagedQuantity?: Maybe<Scalars['Int']>;
  /** The ID of the delivery ticket associated with the item */
  deliveryTicketId?: Maybe<Scalars['Int']>;
  /** The description of the item */
  description?: Maybe<Scalars['String']>;
  /** The IDs of any discounts applied to the item */
  discountIds?: Maybe<Scalars['String']>;
  /** The expense associated with the item */
  expense?: Maybe<Scalars['Float']>;
  /** The fees associated with the item */
  fee?: Maybe<Fee>;
  /** The flat price of the item */
  flatPrice?: Maybe<Scalars['Float']>;
  /** The holiday hourly price of the item */
  holidayHourlyPrice?: Maybe<Scalars['Float']>;
  /** The hourly price of the item */
  hourlyPrice?: Maybe<Scalars['Float']>;
  /** The unique identifier of the item */
  id: Scalars['ID'];
  /** The Imgix URL for the item's image */
  imgixUrl?: Maybe<Scalars['String']>;
  /** The type of inventory the item belongs to */
  inventoryType: Scalars['String'];
  /** Notes regarding any lack of items */
  lackNotes?: Maybe<Scalars['String']>;
  /** The last known missing quantity of the item */
  lastMissingQuantity?: Maybe<Scalars['Int']>;
  /** The maximum quantity of the item allowed in a secondary order */
  maxQuantityInSecondaryOrder?: Maybe<Scalars['Int']>;
  /** The quantity of the item that is missing */
  missingQuantity?: Maybe<Scalars['Int']>;
  /** The monthly price of the item */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** The name of the item */
  name?: Maybe<Scalars['String']>;
  /** Any notes related to the item */
  notes?: Maybe<Scalars['String']>;
  /** The number of available items */
  numberAvailable?: Maybe<Scalars['Int']>;
  /** The number of items available for soft hold */
  numberAvailableForSoftHold?: Maybe<Scalars['Int']>;
  /** The rental period of the item */
  period?: Maybe<Scalars['String']>;
  /** The quantity of the item that has been picked */
  pickedQuantity?: Maybe<Scalars['Int']>;
  /** The position of the item in the pick list */
  position?: Maybe<Scalars['Int']>;
  /** The position of the item within its section */
  positionInSection?: Maybe<Scalars['Int']>;
  /** The product details */
  product?: Maybe<Product>;
  /** The name of the product category the item belongs to */
  productCategoryName?: Maybe<Scalars['String']>;
  /** The ID of the product associated with the item */
  productId?: Maybe<Scalars['Int']>;
  /** The notes associated with the product */
  productNotes?: Maybe<Array<ItemNote>>;
  /** The quantity of the item */
  quantity?: Maybe<Scalars['Int']>;
  /** The ID of the rental associated with the item */
  rentalId?: Maybe<Scalars['Int']>;
  /** The ID of the rental item associated with the item */
  rentalItemId?: Maybe<Scalars['Int']>;
  /** The rental items associated with the item */
  rentalItems?: Maybe<Array<RentalItem>>;
  /** The ID of the rental section associated with the item */
  rentalSectionId?: Maybe<Scalars['Int']>;
  /** The selected price of the item */
  selectedPrice?: Maybe<Scalars['Float']>;
  /** The selected price of the item before any discounts */
  selectedPriceBeforeDiscount?: Maybe<Scalars['Float']>;
  /** The serial numbers associated with the item */
  serialNumbers?: Maybe<Array<Scalars['String']>>;
  /** Whether the item is serialized */
  serialized?: Maybe<Scalars['Boolean']>;
  /** The serialized pick list items associated with the item */
  serializedPickListItems?: Maybe<Array<SerializedPickListItem>>;
  /** Whether the item was set manually */
  setManually?: Maybe<Scalars['Boolean']>;
  /** Whether the missing item has been solved */
  solvedMissing?: Maybe<Scalars['Boolean']>;
  /** The status of the item */
  status?: Maybe<Scalars['String']>;
  /** The sub-rentals associated with the item */
  subRentals?: Maybe<Array<SubRental>>;
  /** The name of the item's supplier */
  supplierName?: Maybe<Scalars['String']>;
  /** Whether the item is tax exempt */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The type of the item */
  type?: Maybe<Scalars['String']>;
  /** The date and time the item was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The weekly price of the item */
  weeklyPrice?: Maybe<Scalars['Float']>;
};

/** Union type for PickList output */
export type PickListUnion = PickListAccessory | PickListAddOn | PickListItem;

/** A type representing a picture */
export type Picture = {
  __typename?: 'Picture';
  /** The AWS URL of the image */
  awsImageUrl?: Maybe<Scalars['String']>;
  /** The date and time the picture was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the picture */
  id: Scalars['ID'];
  /** The content type of the image */
  imageContentType?: Maybe<Scalars['String']>;
  /** The file name of the image */
  imageFileName?: Maybe<Scalars['String']>;
  /** The file size of the image */
  imageFileSize?: Maybe<Scalars['Int']>;
  /** The type of the image */
  imageType?: Maybe<Scalars['String']>;
  /** The date and time the image was last updated */
  imageUpdatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the imageable object */
  imageableId?: Maybe<Scalars['Int']>;
  /** The type of the imageable object */
  imageableType?: Maybe<Scalars['String']>;
  /** The URL of the image */
  imgUrl?: Maybe<Scalars['String']>;
  /** The Imgix URL of the image */
  imgixUrl?: Maybe<Scalars['String']>;
  /** The position of the image in the list */
  position?: Maybe<Scalars['Int']>;
  /** The ID of the product associated with the picture */
  productId?: Maybe<Scalars['Int']>;
  /** The date and time the picture was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The URL of the image */
  url?: Maybe<Scalars['String']>;
};

/** A type representing a pricing preview */
export type PricingPreview = {
  __typename?: 'PricingPreview';
  /** The amount for the pricing preview */
  amount?: Maybe<Scalars['Float']>;
  /** The billing cycle for the pricing preview */
  billingCycle?: Maybe<Scalars['ISO8601DateTime']>;
  /** The new subscription amount for the pricing preview */
  newSubscriptionAmount?: Maybe<Scalars['Float']>;
};

/** A product available for rent or sale */
export type Product = {
  __typename?: 'Product';
  /** Whether the product is active or not */
  active?: Maybe<Scalars['Boolean']>;
  /** List of add-on product relationships associated with the product */
  addOnProductRelationships?: Maybe<Array<AddOnProductRelationship>>;
  /** Whether to allow overbooking of the product or not */
  allowOverbooking?: Maybe<Scalars['Boolean']>;
  /** Whether to automatically send maintenance emails for the product or not */
  automaticallyMaintenanceEmail?: Maybe<Scalars['Boolean']>;
  /** Buffer of the product */
  buffer?: Maybe<Scalars['Float']>;
  /**
   * ID of the category the product belongs to
   * @deprecated Use sf_categories instead
   */
  categoryId?: Maybe<Scalars['Int']>;
  /** Collection name of the product */
  collectionName?: Maybe<Scalars['String']>;
  /** List of commodity product relationships associated with the product */
  commodityProductRelationships: Array<CommodityProductRelationship>;
  /** Creation timestamp of the product */
  createdAt: Scalars['ISO8601DateTime'];
  /** Custom shared quantity of the product */
  customSharedQuantity?: Maybe<Scalars['Int']>;
  /** Daily price of the product */
  dailyPrice?: Maybe<Scalars['Float']>;
  /** Whether the product is damage waiver exempt or not */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** Default pricing of the product */
  defaultPricing?: Maybe<Scalars['String']>;
  /** Deletion timestamp of the product */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Comma-separated department names associated with the product */
  departmentNames?: Maybe<Scalars['String']>;
  /** Description of the product */
  description?: Maybe<Scalars['String']>;
  /** Whether the product is eligible for discounts or not */
  discountEligible?: Maybe<Scalars['Boolean']>;
  /** Flat price of the product */
  flatPrice?: Maybe<Scalars['Float']>;
  /** List of flat prices associated with the product */
  flatPrices: Array<FlatPrice>;
  /** Google Analytics description of the product */
  gaDescription?: Maybe<Scalars['String']>;
  /** Google Analytics keywords of the product */
  gaKeywords?: Maybe<Scalars['String']>;
  /** Group shared quantity of the product */
  groupSharedQuantity?: Maybe<Scalars['Int']>;
  /** Half-day price of the product */
  halfDayPrice?: Maybe<Scalars['Float']>;
  /** Height of the product */
  height?: Maybe<Scalars['Float']>;
  /** Height in feet of the product */
  heightFt?: Maybe<Scalars['Float']>;
  /** Holiday hourly price of the product */
  holidayHourlyPrice?: Maybe<Scalars['Float']>;
  /** Hourly price of the product */
  hourlyPrice?: Maybe<Scalars['Float']>;
  /** ID of the product */
  id: Scalars['ID'];
  /** ID of the import history associated with the product */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** Product group the product belongs to */
  inventoryGroup?: Maybe<ProductGroup>;
  /** Inventory notes of the product */
  inventoryNotes?: Maybe<Scalars['String']>;
  /** Whether the product is multilocation or not */
  isMultilocation: Scalars['Boolean'];
  /** Length of the product */
  length?: Maybe<Scalars['Float']>;
  /** Length in feet of the product */
  lengthFt?: Maybe<Scalars['Float']>;
  /** Lifespan time of the product */
  lifespanTime?: Maybe<Scalars['Int']>;
  /** Lifespan unit of the product */
  lifespanUnit?: Maybe<Scalars['String']>;
  /** Location the product belongs to */
  location: Location;
  /** ID of the location the product belongs to */
  locationId?: Maybe<Scalars['Int']>;
  /** Maintenance quantity of the product */
  maintenanceQuantity: Scalars['Int'];
  /** Whether the product is shared on the marketplace or not */
  marketplaceShared?: Maybe<Scalars['Boolean']>;
  /** Material of the product */
  material?: Maybe<Scalars['String']>;
  /** Monthly price of the product */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** Marketplace custom shared quantity of the product */
  mpCustomSharedQuantity?: Maybe<Scalars['Int']>;
  /** Marketplace shared quantity type of the product */
  mpSharedQuantityType?: Maybe<Scalars['String']>;
  /** Whether the product is shared across multiple locations or not */
  multilocationShared?: Maybe<Scalars['Boolean']>;
  /** Name of the product */
  name?: Maybe<Scalars['String']>;
  /** Notes of the product */
  notes?: Maybe<Scalars['String']>;
  /** Permission type of the product */
  permissionType?: Maybe<Scalars['String']>;
  /** List of picture URLs associated with the product */
  pictureUrls?: Maybe<Array<Scalars['String']>>;
  /** List of pictures associated with the product */
  pictures: Array<Picture>;
  /** ID of the product group the product belongs to */
  productGroupId?: Maybe<Scalars['Int']>;
  /** Type of the product */
  productType: Scalars['String'];
  /** List of purchase order inventories associated with the product */
  purchaseOrderInventories?: Maybe<Array<PurchaseOrderInventory>>;
  /** Purchase price of the product */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** Quantity of the product */
  quantity?: Maybe<Scalars['Int']>;
  /** Serialization status of the product */
  serializationStatus?: Maybe<Scalars['String']>;
  /** List of storefront categories associated with the product */
  sfCategories: Array<StorefrontCategory>;
  /** Storefront custom shared quantity of the product */
  sfCustomSharedQuantity?: Maybe<Scalars['Int']>;
  /** Storefront shared quantity type of the product */
  sfSharedQuantityType?: Maybe<Scalars['String']>;
  /** List of storefront sub-categories associated with the product. */
  sfSubCategories: Array<StorefrontCategory>;
  /** List of storefront tags associated with the product */
  sfTags: Array<StorefrontTag>;
  /** Shared quantity type of the product */
  sharedQuantityType?: Maybe<Scalars['String']>;
  /** Whether to include notes in rentals or not */
  shouldIncludeNotesInRentals?: Maybe<Scalars['Boolean']>;
  /** Whether to show price on the storefront or not */
  showPriceStorefront?: Maybe<Scalars['Boolean']>;
  /** Slug of the product */
  slug?: Maybe<Scalars['String']>;
  /** Whether the product is shared on the storefront or not */
  storefrontShared?: Maybe<Scalars['Boolean']>;
  /** Whether the product is tax exempt or not */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Token of the product */
  token?: Maybe<Scalars['String']>;
  /** Turnover time of the product */
  turnoverTime?: Maybe<Scalars['Int']>;
  /** Turnover unit of the product */
  turnoverUnit?: Maybe<Scalars['String']>;
  /** Last update timestamp of the product */
  updatedAt: Scalars['ISO8601DateTime'];
  /** List of usage units associated with the product */
  usageUnits?: Maybe<Array<UsageUnit>>;
  /** Warehouse location of the product */
  warehouseLocation?: Maybe<Scalars['String']>;
  /** Weekly price of the product */
  weeklyPrice?: Maybe<Scalars['Float']>;
  /** Weight of the product */
  weight?: Maybe<Scalars['Float']>;
  /** Width of the product */
  width?: Maybe<Scalars['Float']>;
  /** Width in feet of the product */
  widthFt?: Maybe<Scalars['Float']>;
};


/** A product available for rent or sale */
export type ProductSfSubCategoriesArgs = {
  maxDepth?: InputMaybe<Scalars['Int']>;
};

/** A type representing the relationship between a product and a bundle */
export type ProductBundleRelationship = {
  __typename?: 'ProductBundleRelationship';
  /** The ID of the bundle in the relationship */
  bundleId?: Maybe<Scalars['Int']>;
  /** The date and time the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the relationship */
  id: Scalars['ID'];
  /** The position of the product in the bundle */
  position?: Maybe<Scalars['Int']>;
  /** The product associated with the relationship */
  product?: Maybe<Product>;
  /** The ID of the product in the relationship */
  productId?: Maybe<Scalars['Int']>;
  /** The quantity of the product in the bundle */
  quantity?: Maybe<Scalars['Int']>;
  /** The date and time the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A type representing a product group */
export type ProductGroup = {
  __typename?: 'ProductGroup';
  /** ID of the business the product group belongs to */
  businessId?: Maybe<Scalars['Int']>;
  /** Creation timestamp of the product group */
  createdAt: Scalars['ISO8601DateTime'];
  /** ID of the product group */
  id: Scalars['ID'];
  /** List of products associated with the product group */
  inventoryObjects: Array<Product>;
  /** Name of the product group */
  name?: Maybe<Scalars['String']>;
  /** Last update timestamp of the product group */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Product */
export type ProductInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Hourly Price */
  hourlyPrice?: InputMaybe<Scalars['Float']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Location's ID */
  locationId?: InputMaybe<Scalars['String']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['String']>;
};

/** A proposal setting document template */
export type ProposalSetting = {
  __typename?: 'ProposalSetting';
  /** Name of the author of the proposal setting */
  authorName: Scalars['String'];
  /** Creation timestamp of the proposal setting */
  createdAt: Scalars['ISO8601DateTime'];
  /** Whether the proposal setting was created from a template */
  createdFromTemplate: Scalars['Boolean'];
  /** URL of the document template */
  documentUrl: Scalars['String'];
  /** ID of the proposal setting */
  id: Scalars['ID'];
};

/** Represents a purchase order */
export type PurchaseOrder = {
  __typename?: 'PurchaseOrder';
  /** Billing address for the Purchase Order */
  billingAddress?: Maybe<PhysicalAddress>;
  /** Billing phone number for the Purchase Order */
  billingPhoneNumber?: Maybe<PhoneNumber>;
  /** Indicates if billing address is the same as delivery address */
  billingSameAsDelivery?: Maybe<Scalars['Boolean']>;
  /** Change history entries for the Purchase Order */
  changeHistoryEntries?: Maybe<Array<ChangeHistoryEntry>>;
  /** Estimated completion date for the Purchase Order */
  completionEstimate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Creation date of the Purchase Order */
  createdAt: Scalars['ISO8601DateTime'];
  /** Date needed for the Purchase Order */
  dateNeeded?: Maybe<Scalars['ISO8601DateTime']>;
  /** Delivery address for the Purchase Order */
  deliveryAddress?: Maybe<PhysicalAddress>;
  /** Delivery cost for the Purchase Order */
  deliveryCost?: Maybe<Scalars['Float']>;
  /** Indicates if delivery fee is tax exempt */
  deliveryFeeTaxExempt?: Maybe<Scalars['Boolean']>;
  /** Delivery phone number for the Purchase Order */
  deliveryPhoneNumber?: Maybe<PhoneNumber>;
  /** Description of the Purchase Order */
  description?: Maybe<Scalars['String']>;
  /** Documents associated with the Purchase Order */
  documents?: Maybe<Array<Document>>;
  /** ID of the Purchase Order */
  id: Scalars['ID'];
  /** Inventory status of the Purchase Order */
  inventoryStatus?: Maybe<Scalars['String']>;
  /** Location associated with the Purchase Order */
  location?: Maybe<Location>;
  /** Location ID associated with the Purchase Order */
  locationId?: Maybe<Scalars['Int']>;
  /** Name of the Purchase Order */
  name?: Maybe<Scalars['String']>;
  /** Note for the Purchase Order */
  note?: Maybe<Scalars['String']>;
  /** Number of the Purchase Order */
  number?: Maybe<Scalars['Int']>;
  /** Payment status of the Purchase Order */
  paymentStatus?: Maybe<Scalars['String']>;
  /** Priority of the Purchase Order */
  priority?: Maybe<Scalars['String']>;
  /** Delivery fees for the Purchase Order */
  purchaseOrderDeliveryFees?: Maybe<Array<PurchaseOrderDeliveryFee>>;
  /** List of inventory items for the Purchase Order */
  purchaseOrderInventories?: Maybe<Array<PurchaseOrderInventory>>;
  /** Total calculation details for the Purchase Order */
  purchaseOrderTotalCalculation: PurchaseOrderTotalCalculation;
  /** Vendor relationship for the Purchase Order */
  purchaseOrderVendorRelationship?: Maybe<PurchaseOrderVendorRelationship>;
  /** Rental ID associated with the Purchase Order */
  rentalId?: Maybe<Scalars['Int']>;
  /** Status of the Purchase Order */
  status?: Maybe<Scalars['String']>;
  /** Tax percentage for the Purchase Order */
  taxPercentage?: Maybe<Scalars['Float']>;
  /** Tax type for the Purchase Order */
  taxType?: Maybe<Scalars['String']>;
  /** Total amount for the Purchase Order */
  total?: Maybe<Scalars['Float']>;
  /** Last update date of the Purchase Order */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type PurchaseOrderCollection = {
  __typename?: 'PurchaseOrderCollection';
  collection: Array<PurchaseOrder>;
  metadata: CollectionMetadata;
};

/** A type representing the delivery fee for a purchase order */
export type PurchaseOrderDeliveryFee = {
  __typename?: 'PurchaseOrderDeliveryFee';
  /** The amount of the delivery fee */
  amount?: Maybe<Scalars['Float']>;
  /** The date and time the delivery fee was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the delivery fee */
  id: Scalars['ID'];
  /** The name of the delivery fee */
  name?: Maybe<Scalars['String']>;
  /** The date and time the delivery fee was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** A type representing the delivery fee for a purchase order */
export type PurchaseOrderDeliveryFeeInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The amount of the delivery fee */
  amount?: InputMaybe<Scalars['String']>;
  /** The unique identifier of the delivery fee */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the delivery fee */
  name?: InputMaybe<Scalars['String']>;
};

/** Arguments for creating or updating a PurchaseOrder */
export type PurchaseOrderInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Billing Address */
  billingAddressAttributes?: InputMaybe<PhysicalAddressInput>;
  /** Billing phone number */
  billingPhoneNumberAttributes?: InputMaybe<PhoneNumberInput>;
  /** Billing Same As Delivery */
  billingSameAsDelivery?: InputMaybe<Scalars['Boolean']>;
  /** Completion Estimate */
  completionEstimate?: InputMaybe<Scalars['String']>;
  /** Date Needed */
  dateNeeded?: InputMaybe<Scalars['String']>;
  /** Delivery Address */
  deliveryAddressAttributes?: InputMaybe<PhysicalAddressInput>;
  /** Delivery Cost */
  deliveryCost?: InputMaybe<Scalars['String']>;
  /** Delivery Fee Tax Exempt */
  deliveryFeeTaxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Delivery phone number */
  deliveryPhoneNumberAttributes?: InputMaybe<PhoneNumberInput>;
  /** Description */
  description?: InputMaybe<Scalars['String']>;
  /** Documents */
  documentsAttributes?: InputMaybe<Array<DocumentInput>>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Inventory Status */
  inventoryStatus?: InputMaybe<Scalars['String']>;
  /** Name */
  name?: InputMaybe<Scalars['String']>;
  /** Note */
  note?: InputMaybe<Scalars['String']>;
  /** Number */
  number?: InputMaybe<Scalars['Int']>;
  /** Payment Status */
  paymentStatus?: InputMaybe<PurchaseOrderPaymentStatus>;
  /** Priority */
  priority?: InputMaybe<Scalars['String']>;
  /** Purchase Order Delivery Fee */
  purchaseOrderDeliveryFeesAttributes?: InputMaybe<Array<PurchaseOrderDeliveryFeeInput>>;
  /** PurchaseOrderInventories */
  purchaseOrderInventoriesAttributes?: InputMaybe<Array<PurchaseOrderInventoryInput>>;
  /** PurchaseOrderVendorRelationship Attributes */
  purchaseOrderVendorRelationshipAttributes?: InputMaybe<PurchaseOrderVendorRelationshipInput>;
  /** Status */
  status?: InputMaybe<PurchaseOrderStatus>;
  /** Tax Percentage */
  taxPercentage?: InputMaybe<Scalars['String']>;
  /** Tax Type */
  taxType?: InputMaybe<Scalars['String']>;
};

/** A type representing the inventory of a purchase order */
export type PurchaseOrderInventory = {
  __typename?: 'PurchaseOrderInventory';
  /** The date and time the inventory item was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The quantity of the inventory item that is damaged */
  damagedQuantity?: Maybe<Scalars['Int']>;
  /** The quantity of the inventory item that has been fulfilled */
  fulfilledQuantity?: Maybe<Scalars['Int']>;
  /** The unique identifier of the inventory item */
  id: Scalars['ID'];
  /** The type of inventory item */
  inventoryType?: Maybe<Scalars['String']>;
  /** The item notes associated with the inventory item */
  itemNotes?: Maybe<Array<ItemNote>>;
  /** The manufacturer part number of the inventory item */
  manufacturerPartNumber?: Maybe<Scalars['String']>;
  /** The quantity of the inventory item that is missing */
  missingQuantity?: Maybe<Scalars['Int']>;
  /** The name of the inventory item */
  name?: Maybe<Scalars['String']>;
  /** Any additional notes about the inventory item */
  note?: Maybe<Scalars['String']>;
  /** The original inventory item */
  originalInventory?: Maybe<OriginalInventoryUnion>;
  /** The original inventory ID of the inventory item */
  originalInventoryId?: Maybe<Scalars['String']>;
  /** The original inventory type of the inventory item */
  originalInventoryType?: Maybe<Scalars['String']>;
  /** The purchase order ID associated with the inventory item */
  purchaseOrderId?: Maybe<Scalars['Int']>;
  /** The purchase order price of the inventory item */
  purchaseOrderPrice?: Maybe<Scalars['Float']>;
  /** The quantity of the inventory item */
  quantity?: Maybe<Scalars['Int']>;
  /** The rental price of the inventory item */
  rentalPrice?: Maybe<Scalars['Float']>;
  /** The serialized products associated with the inventory item */
  serializedProducts?: Maybe<Array<SerializedProduct>>;
  /** The date and time the inventory item was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a PurchaseOrderInventory */
export type PurchaseOrderInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The quantity of the inventory item that is damaged */
  damagedQuantity?: InputMaybe<Scalars['Int']>;
  /** The quantity of the inventory item that has been fulfilled */
  fulfilledQuantity?: InputMaybe<Scalars['Int']>;
  /** The unique identifier of the inventory item */
  id?: InputMaybe<Scalars['ID']>;
  /** The type of inventory item */
  inventoryType?: InputMaybe<Scalars['String']>;
  /** Attributes for the item notes */
  itemNotesAttributes?: InputMaybe<Array<ItemNoteInput>>;
  /** The manufacturer part number of the inventory item */
  manufacturerPartNumber?: InputMaybe<Scalars['String']>;
  /** The quantity of the inventory item that is missing */
  missingQuantity?: InputMaybe<Scalars['Int']>;
  /** The name of the inventory item */
  name?: InputMaybe<Scalars['String']>;
  /** Any additional notes about the inventory item */
  note?: InputMaybe<Scalars['String']>;
  /** The original inventory item */
  originalInventory?: InputMaybe<OriginalInventoryInput>;
  /** Attributes for the original inventory item */
  originalInventoryAttributes?: InputMaybe<OriginalInventoryInput>;
  /** The original inventory ID of the inventory item */
  originalInventoryId?: InputMaybe<Scalars['String']>;
  /** The original inventory type of the inventory item */
  originalInventoryType?: InputMaybe<Scalars['String']>;
  /** The purchase order ID associated with the inventory item */
  purchaseOrderId?: InputMaybe<Scalars['Int']>;
  /** The purchase order price of the inventory item */
  purchaseOrderPrice?: InputMaybe<Scalars['String']>;
  /** The quantity of the inventory item */
  quantity?: InputMaybe<Scalars['Int']>;
  /** The rental price of the inventory item */
  rentalPrice?: InputMaybe<Scalars['Float']>;
  /** Attributes for the serialized products */
  serializedProductsAttributes?: InputMaybe<Array<SerializedProductInput>>;
};

export enum PurchaseOrderPaymentStatus {
  /** Fully paid status */
  FullyPaid = 'fully_paid',
  /** No payment status */
  NotPaid = 'not_paid',
  /** Partially paid status */
  PartiallyPaid = 'partially_paid'
}

export enum PurchaseOrderStatus {
  /** Billed status */
  Billed = 'billed',
  /** Cancelled status */
  Cancelled = 'cancelled',
  /** Closed status */
  Closed = 'closed',
  /** Confirmed status */
  Confirmed = 'confirmed',
  /** Open status */
  Open = 'open',
  /** Paid status */
  Paid = 'paid',
  /** Partially Received status */
  PartiallyReceived = 'partially_received',
  /** Pending status */
  Pending = 'pending',
  /** Received status */
  Received = 'received'
}

/** A type representing the total calculation for a purchase order */
export type PurchaseOrderTotalCalculation = {
  __typename?: 'PurchaseOrderTotalCalculation';
  /** The delivery fee for the purchase order */
  delivery: Scalars['Float'];
  /** The subtotal amount of the purchase order */
  subtotal: Scalars['Float'];
  /** The tax amount applied to the purchase order */
  tax: Scalars['Float'];
  /** The taxable amount of the purchase order */
  taxableAmount: Scalars['Float'];
  /** The total amount of the purchase order */
  total: Scalars['Float'];
};

/** A type representing the relationship between a purchase order and a vendor */
export type PurchaseOrderVendorRelationship = {
  __typename?: 'PurchaseOrderVendorRelationship';
  /** The date and time the relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The email address of the vendor */
  emailAddress?: Maybe<EmailAddress>;
  /** The unique identifier of the relationship */
  id: Scalars['String'];
  /** The name of the vendor */
  name?: Maybe<Scalars['String']>;
  /** The phone number of the vendor */
  phoneNumber?: Maybe<PhoneNumber>;
  /** The physical address of the vendor */
  physicalAddress?: Maybe<PhysicalAddress>;
  /** The unique identifier of the purchase order */
  purchaseOrderId?: Maybe<Scalars['String']>;
  /** The date and time the relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The unique identifier of the vendor */
  vendorId?: Maybe<Scalars['String']>;
};

/** Arguments for creating or updating a PurchaseOrderVendorRelationship */
export type PurchaseOrderVendorRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Email Address */
  emailAddressAttributes?: InputMaybe<EmailAddressInput>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The relationship's vendor name */
  name?: InputMaybe<Scalars['String']>;
  /** Phone NUmber */
  phoneNumberAttributes?: InputMaybe<PhoneNumberInput>;
  /** Physical Address */
  physicalAddressAttributes?: InputMaybe<PhysicalAddressInput>;
  /** The vendor's id */
  vendorId?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Returns a paginated list of rental accessories with alerting information.
   *
   */
  accessoryPaginatedAlerting: RentalAccessoryAlerting;
  /**
   * Returns a paginated list of rental add-ons with alerting information.
   *
   */
  addOnPaginatedAlerting: RentalAddOnAlerting;
  /** Assigns a secondary order address from a venue to a rental */
  assignSecondaryOrderAddressFromVenue?: Maybe<Rental>;
  /**
   * Validates a bearer token and retrieves the associated business ID and location IDs.
   *
   */
  bearerTokenValidator: BearerTokenValidator;
  /**
   * Returns a list of available accessories for the current location.
   * Can be filtered using the 'search' argument.
   *
   */
  getAccessories: Array<Accessory>;
  /**
   * Returns a specific accessory by its ID or token.
   *
   */
  getAccessory: Accessory;
  /** Retrieve a single add-on by its unique token and location ID */
  getAddOn: AddOn;
  /** Paginated inventory ledger history for a purchase (add-on) */
  getAddOnInventoryLedgerEntries: InventoryLedgerEntryCollection;
  /** Returns orders with reserved add-on quantity pending checkout */
  getAddOnReservedOrders: Array<AddOnReservedOrder>;
  /** Retrieve a list of add-ons based on search criteria */
  getAddOns: Array<AddOn>;
  /** List of ApiKeys for a business */
  getApiKeys: Array<ApiKey>;
  /** Get availability of products, add-ons, and bundles within a specified period */
  getAvailabilityInPeriod: Availability;
  /** Retrieve a single bundle by its unique token and location ID */
  getBundle: Bundle;
  /** Retrieve a list of bundles based on search criteria */
  getBundles: Array<Bundle>;
  /** Retrieve change history entries based on search criteria */
  getChangeHistoryEntries?: Maybe<ChangeHistoryEntryCollection>;
  /** Retrieve the last 20 client success history entries */
  getClientSuccessHistoryEntries: Array<ClientSuccessHistoryEntry>;
  /** Retrieve a column filter by rental status */
  getColumnFilter?: Maybe<ColumnFilter>;
  /**
   * Returns a list of commissioned customers for the specified company-location relationship.
   * Each record includes the customer's name, commission rate, and audit timestamps.
   *
   */
  getCommissionedCustomers: Array<CommissionedCustomer>;
  /** List of companies matching the search criteria */
  getCompanies: Array<Company>;
  /**
   * Returns a specific company-location relationship for the current location by its ID.
   * Used when retrieving detailed information about a company during order creation.
   *
   */
  getCompanyLocationRelationship?: Maybe<CompanyLocationRelationship>;
  /**
   * Returns a paginated collection of active company-location relationships for the current location.
   *
   * Supports:
   * - Searching by company name or email address
   * - Pagination controls (page, per_page)
   * - Filtering by company name
   * - Sorting by company name (ascending)
   *
   * Only returns relationships where the associated company is active.
   *
   */
  getCompanyLocationRelationships: CompanyLocationRelationshipCollection;
  /** Retrieve a specific customer location relationship by its unique ID */
  getCustomerLocationRelationship?: Maybe<CustomerLocationRelationship>;
  /**
   * Used in the customer selection modal when clicking “Add Customer” during order creation
   * (Orders > New Order > Order Details). Returns the available customers.
   *
   */
  getCustomerLocationRelationships: CustomerLocationRelationshipCollection;
  /** List of customers matching the search criteria */
  getCustomers: Array<Customer>;
  /**
   * Retrieves a single disclaimer by its ID.
   *
   * Use this query when you need to display or edit a specific disclaimer.
   * The disclaimer must belong to the current location.
   *
   */
  getDisclaimer: Disclaimer;
  /**
   * Returns a list of disclaimers available for the current location.
   *
   * Features:
   * - Full-text search on title and description (word start matching)
   * - Automatic filtering by current location
   * - Results ordered by creation date (newest first)
   *
   * Common use cases:
   * - Displaying disclaimers on order forms
   * - Managing legal or policy-related content
   * - Associating disclaimers with rentals, products, or other inventory items
   *
   */
  getDisclaimers: Array<Disclaimer>;
  /** Retrieves a list of discounts, with optional search and filtering capabilities */
  getDiscounts: Array<Discount>;
  /** Duplicates a rental and returns the new rental object */
  getDuplicatedRental: Rental;
  /** List of email settings for a location */
  getEmailSettings?: Maybe<Array<EmailSetting>>;
  /** List of emails associated with a rental */
  getEmails?: Maybe<Array<Email>>;
  /**
   * Returns a list of employees for the current location.
   * Supports filtering by keyword or specific employee IDs.
   *
   */
  getEmployees: Array<Employee>;
  /**
   * Returns a specific event record by its ID.
   * Used when fetching the details of a single event, including related rentals, documents, team members, and totals.
   *
   */
  getEvent: Event;
  /** Retrieve the billing summary for a specific event */
  getEventBillingSummary: EventBillingSummary;
  /** Fetch rentals for a specific inventory item within an event. */
  getEventInventoryItemRentals: Array<RentalInventory>;
  /**
   * Returns a paginated collection of events for the current location.
   * Supports filters such as status, dates, venues, companies, and customers.
   *
   */
  getEvents: EventCollection;
  /**
   * Returns a list of fees based on the provided search criteria.
   *
   */
  getFees: Array<Fee>;
  /** Fetches bank accounts associated with a specific owner (user or business) that use the Grailpay payment processor. */
  getGrailpayOwnerBankAccounts: Array<BankAccount>;
  /** Fetches a paginated list of inventories (products, bundles, add-ons) for a specific location with various filtering options. */
  getInventories: Inventories;
  /** Retrieves a paginated and searchable list of labor staff roles, ordered by name */
  getLabors: Array<StaffRole>;
  /** Fetch detailed information about a specific location. If no ID is provided, fetches the location from the context. External requests should use the ID argument. */
  getLocationDetails: Location;
  /**
   * Returns a list of employees assigned to the current location, with their details.
   *
   */
  getLocationEmployees: Array<EmployeeLocationRelationship>;
  /** Get locations with available inventory based off ReventalsId, quantity, location and date range */
  getLocationWithAvailableInventory: Array<LocationWithAvailableInventory>;
  /** Get parent rentals by event ID and optional status filter */
  getParentRentals: Array<Rental>;
  /** Get pricing preview with billing cicle from new pricing tier */
  getPricingPreview?: Maybe<PricingPreview>;
  /** Retrieve a single active product by its token and location ID */
  getProduct: Product;
  /** Retrieve a single product group by its ID and associated location IDs */
  getProductGroup: ProductGroup;
  /** Retrieve a list of product groups, with optional search and filtering */
  getProductGroups: Array<ProductGroup>;
  /** Retrieve a list of products, with optional search and filtering */
  getProducts: Array<Product>;
  /** Retrieve a list of proposal settings, with optional search and filtering */
  getProposalSettings?: Maybe<Array<ProposalSetting>>;
  /** Fetch a specific purchase order by ID */
  getPurchaseOrder: PurchaseOrder;
  /** List of purchase orders */
  getPurchaseOrders: PurchaseOrderCollection;
  /**
   * Returns the location's current Quick View template (if any) and the full list of available templates for that location.
   *
   */
  getQuickViewTemplates: QuickViewTemplates;
  /** Lists all website redirects configured for your business location */
  getRedirectHosts: Array<RedirectHost>;
  /** Fetches rental agreements for the current location, with optional title search */
  getRentalAgreements: Array<RentalAgreement>;
  /** Get a rental by its ID or token */
  getRentalById: Rental;
  /** List of emails associated with the rental */
  getRentalEmails?: Maybe<Array<RentalEmails>>;
  /** Fetches and filters rental inventories based on various criteria */
  getRentalInventories: RentalInventories;
  getRentalInventory: Array<RentalInventory>;
  getRentalInventoryShortages: RentalInventoryShortages;
  getRentalTransports: Array<RentalTransport>;
  /** Retrieve a list of rentals based on various filters and pagination */
  getRentals: Array<Rental>;
  /** Get rentals by date and various filters */
  getRentalsByDate: Array<Rental>;
  /** Get rentals by date with various filters and pagination */
  getRentalsByDateVertical: RentalCollection;
  /** Get rentals by transport details */
  getRentalsByTransports: Array<Rental>;
  /** Retrieve rentals for the orders overview gantt chart using schedule overlap filters */
  getRentalsGantt: Array<Rental>;
  /**
   * Returns a list of roles available in the business.
   *
   * Roles define the permissions and responsibilities of employees (e.g., office manager, delivery driver).
   *
   * Features:
   * - Search by role name using the 'search' parameter
   * - Filter by role type using 'role_type' parameter
   * - Returns only active roles for the current location
   * - Supports pagination
   *
   * Global roles (Permission Roles) are included by default.
   *
   */
  getRoles: Array<Role>;
  /**
   * Generates a sales-tax report for the given locations and date range, using the selected accounting basis.
   * Returns aggregated summary, totals, and per-order details.
   *
   */
  getSalesTaxCashBasisReport: SalesTaxCashBasisReport;
  /** Retrieves a single serialized product by its ID. The product must belong to the specified location. */
  getSerializedProduct: SerializedProduct;
  /** Searches for serialized products based on the provided criteria. Results can be filtered by search term and are ordered by serial number. */
  getSerializedProducts: Array<SerializedProduct>;
  /** Get rentals by date with various filters and pagination */
  getSimplifiedPaginatedRentals: RentalCollection;
  /** Retrieves a single staff role by its ID */
  getStaffRole?: Maybe<StaffRole>;
  /** Retrieves a list of storefront categories for a specific location, optionally filtered by search criteria. */
  getStorefrontCagetories: Array<StorefrontCategory>;
  /** Retrieves a list of storefront categories for a specific location, optionally filtered by search criteria. */
  getStorefrontCategories: Array<StorefrontCategory>;
  getStorefrontTags?: Maybe<Array<StorefrontTag>>;
  /** Retrieves all active trucks for the current location */
  getTrucks: Array<Truck>;
  /**
   * Returns a non-duplicated list of employees (ID and email) that belong to the same business but are not assigned to the given location.
   *
   */
  getUniqueLocationEmployeeEmails: Array<EmployeeLocationRelationship>;
  /** Retrieves a list of vendors, optionally filtered by search criteria. */
  getVendors: Array<Vendor>;
  /**
   * Returns the details of a specific venue by its ID.
   * Includes related addresses, documents, phone numbers, and rental relationships.
   *
   */
  getVenue: Venue;
  /**
   * Returns a paginated collection of venues available for the current business location.
   * Supports filtering by name and pagination.
   *
   */
  getVenues: Array<Venue>;
  /**
   * Returns delivery fees for a specific ZIP code or all available fees if no ZIP code is provided.
   *
   * This query supports:
   * - Filtering by ZIP code to find specific delivery fees
   * - Full-text search across fee names and ZIP codes
   * - Pagination of results
   *
   * If no ZIP code is provided, returns all delivery fees for the current location.
   *
   */
  getZipCodeDeliveryFee: Array<ZipCodeDeliveryFee>;
  /**
   * Returns all delivery fees configured for the current location.
   *
   * Useful for:
   * - Displaying all available delivery zones and their associated fees
   * - Calculating delivery costs based on customer address
   * - Managing delivery fee rules in the admin interface
   *
   * Results can be filtered using the search parameter.
   *
   */
  getZipCodeDeliveryFees: Array<ZipCodeDeliveryFee>;
  /** Fetches paginated alerting information for rental items with filtering options */
  productPaginatedAlerting: RentalItemAlerting;
  /** Returns the flat list of rental_inventories for the rental, used to drive the Section grouping in the Pick List tab. */
  rentalPickList: Array<RentalInventory>;
  /** Returns ZPL content for rental slips as plain text (for direct-to-printer workflows) */
  rentalSlipsZpl: Scalars['String'];
  searchStorefrontTags?: Maybe<Array<StorefrontTag>>;
};


export type QueryAccessoryPaginatedAlertingArgs = {
  accessoryId?: InputMaybe<Scalars['String']>;
  combineLikeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  rentalId?: InputMaybe<Scalars['ID']>;
  selectedDate?: InputMaybe<Scalars['String']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
};


export type QueryAddOnPaginatedAlertingArgs = {
  addOnId?: InputMaybe<Scalars['String']>;
  combineLikeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  rentalId?: InputMaybe<Scalars['ID']>;
  selectedDate?: InputMaybe<Scalars['String']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
};


export type QueryAssignSecondaryOrderAddressFromVenueArgs = {
  rental: SoRentalInput;
  venueId: Scalars['ID'];
};


export type QueryBearerTokenValidatorArgs = {
  bearerToken: Scalars['String'];
};


export type QueryGetAccessoriesArgs = {
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetAccessoryArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetAddOnArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetAddOnInventoryLedgerEntriesArgs = {
  addOnToken: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};


export type QueryGetAddOnsArgs = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetAvailabilityInPeriodArgs = {
  addOns?: InputMaybe<Array<Scalars['Int']>>;
  bundles?: InputMaybe<Array<Scalars['Int']>>;
  endDate: Scalars['String'];
  products?: InputMaybe<Array<Scalars['Int']>>;
  startDate: Scalars['String'];
};


export type QueryGetBundleArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetBundlesArgs = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetChangeHistoryEntriesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  rentalToken: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetColumnFilterArgs = {
  rentalStatus: Scalars['String'];
};


export type QueryGetCommissionedCustomersArgs = {
  companyLocationRelationshipId: Scalars['ID'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetCompaniesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetCompanyLocationRelationshipArgs = {
  id: Scalars['String'];
};


export type QueryGetCompanyLocationRelationshipsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetCustomerLocationRelationshipArgs = {
  id: Scalars['String'];
};


export type QueryGetCustomerLocationRelationshipsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetCustomersArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetDisclaimerArgs = {
  id: Scalars['String'];
};


export type QueryGetDisclaimersArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetDiscountsArgs = {
  discountTargetType?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetDuplicatedRentalArgs = {
  rental: SoRentalInput;
};


export type QueryGetEmailSettingsArgs = {
  emailSettingType?: InputMaybe<Scalars['String']>;
};


export type QueryGetEmailsArgs = {
  rentalToken: Scalars['String'];
};


export type QueryGetEmployeesArgs = {
  id?: InputMaybe<Array<Scalars['String']>>;
  isDriver?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetEventArgs = {
  id: Scalars['String'];
};


export type QueryGetEventBillingSummaryArgs = {
  eventToken: Scalars['String'];
  threshold?: InputMaybe<Scalars['Int']>;
};


export type QueryGetEventInventoryItemRentalsArgs = {
  eventToken: Scalars['String'];
  inventoryItemId: Scalars['ID'];
  inventoryItemType: RentalInventoryTypeEnum;
};


export type QueryGetEventsArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  salesperson?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  venueId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetFeesArgs = {
  feeTargetType?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetGrailpayOwnerBankAccountsArgs = {
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
};


export type QueryGetInventoriesArgs = {
  categoryIds?: InputMaybe<Array<Scalars['Int']>>;
  colorIds?: InputMaybe<Array<Scalars['Int']>>;
  deletedAtGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  deletedAtLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Array<Scalars['Int']>>;
  locationId: Scalars['Int'];
  maxQuantityStorefrontGte?: InputMaybe<Scalars['Int']>;
  maxQuantityStorefrontLte?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  preview?: InputMaybe<Scalars['Boolean']>;
  search?: InputMaybe<Scalars['String']>;
  selectedSfCategoriesData?: InputMaybe<Scalars['JSON']>;
  sfCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  sfSubCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  subCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  updatedAtGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  updatedAtLte?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryGetLaborsArgs = {
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};


export type QueryGetLocationDetailsArgs = {
  id?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetLocationEmployeesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetLocationWithAvailableInventoryArgs = {
  endDate: Scalars['ISO8601DateTime'];
  inventoryList: Array<ReventalsSearchInventoryInput>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  radius: Scalars['Float'];
  startDate: Scalars['ISO8601DateTime'];
};


export type QueryGetParentRentalsArgs = {
  eventId: Scalars['ID'];
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetPricingPreviewArgs = {
  pricingTier: Scalars['String'];
};


export type QueryGetProductArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetProductGroupArgs = {
  id: Scalars['String'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetProductGroupsArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProductsArgs = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetProposalSettingsArgs = {
  rentalToken: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetPurchaseOrderArgs = {
  id: Scalars['ID'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetPurchaseOrdersArgs = {
  amountGte?: InputMaybe<Scalars['Float']>;
  amountLte?: InputMaybe<Scalars['Float']>;
  completionEstimateGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  completionEstimateLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  dateNeededGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  dateNeededLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  employeeIds?: InputMaybe<Array<Scalars['String']>>;
  inventoryStatus?: InputMaybe<Array<Scalars['String']>>;
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  numberPer?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  paymentStatus?: InputMaybe<Array<Scalars['String']>>;
  priority?: InputMaybe<Array<Scalars['String']>>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  vendorIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetQuickViewTemplatesArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryGetRentalAgreementsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetRentalByIdArgs = {
  ID: Scalars['String'];
};


export type QueryGetRentalEmailsArgs = {
  rentalToken: Scalars['String'];
};


export type QueryGetRentalInventoriesArgs = {
  deliveryTime?: InputMaybe<Array<Scalars['String']>>;
  deliveryType?: InputMaybe<Array<Scalars['String']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']>>;
  endDateGte?: InputMaybe<Scalars['String']>;
  endDateLte?: InputMaybe<Scalars['String']>;
  endWindowBeginningGte?: InputMaybe<Scalars['String']>;
  endWindowBeginningLte?: InputMaybe<Scalars['String']>;
  inventoryId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['Int'];
  numberPer?: InputMaybe<Scalars['Int']>;
  page: Scalars['Int'];
  pickListStatus?: InputMaybe<Array<Scalars['String']>>;
  pickedStatus?: InputMaybe<Array<Scalars['String']>>;
  productType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  startDateGte?: InputMaybe<Scalars['String']>;
  startDateLte?: InputMaybe<Scalars['String']>;
  startWindowFinishGte?: InputMaybe<Scalars['String']>;
  startWindowFinishLte?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  truckIds?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetRentalInventoryArgs = {
  includeBundleInventory?: InputMaybe<Scalars['Boolean']>;
  rentalId: Scalars['Int'];
};


export type QueryGetRentalInventoryShortagesArgs = {
  deliveryTypes?: InputMaybe<Array<Scalars['String']>>;
  departmentIds?: InputMaybe<Array<Scalars['String']>>;
  endDate: Scalars['String'];
  locationId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  startDate: Scalars['String'];
  timeZoneOffset?: InputMaybe<Scalars['String']>;
};


export type QueryGetRentalTransportsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  rentalSource?: InputMaybe<Array<Scalars['String']>>;
  rentalStatus?: InputMaybe<Array<Scalars['String']>>;
  startDateTimeGte?: InputMaybe<Scalars['String']>;
  startDateTimeLte?: InputMaybe<Scalars['String']>;
  transportType?: InputMaybe<Array<Scalars['String']>>;
  truckIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetRentalsArgs = {
  alerting?: InputMaybe<Scalars['Boolean']>;
  amountRemaining?: InputMaybe<Scalars['Float']>;
  approvalStatus?: InputMaybe<Scalars['String']>;
  availabilityAlert?: InputMaybe<Scalars['Boolean']>;
  beingDelivered?: InputMaybe<Scalars['Boolean']>;
  billingStatus?: InputMaybe<Scalars['String']>;
  businessId?: InputMaybe<Scalars['Int']>;
  changeRequestStatus?: InputMaybe<Scalars['String']>;
  checkedInAlerting?: InputMaybe<Scalars['Boolean']>;
  checkedOutAlerting?: InputMaybe<Scalars['Boolean']>;
  closedDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  clrIds?: InputMaybe<Array<Scalars['Int']>>;
  companyId?: InputMaybe<Scalars['Int']>;
  companyName?: InputMaybe<Scalars['String']>;
  connectHold?: InputMaybe<Scalars['Boolean']>;
  contactCategoriesNames?: InputMaybe<Scalars['String']>;
  customerIds?: InputMaybe<Array<Scalars['Int']>>;
  customerNames?: InputMaybe<Scalars['String']>;
  deliveryType?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<Scalars['Int']>>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']>>;
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  employeesWithAlert?: InputMaybe<Scalars['Boolean']>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endWindowBeginning?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventEndDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventEndSetting?: InputMaybe<Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
  eventStartDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventStartSetting?: InputMaybe<Scalars['String']>;
  expireDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  expired?: InputMaybe<Scalars['Boolean']>;
  finalPaymentDueDateType?: InputMaybe<Scalars['String']>;
  hasAutobookNotification?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  name?: InputMaybe<Scalars['String']>;
  offShelfAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  onShelfAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  page?: InputMaybe<Scalars['Int']>;
  parentToken?: InputMaybe<Scalars['String']>;
  paymentBalance?: InputMaybe<Scalars['Float']>;
  perPage?: InputMaybe<Scalars['Int']>;
  pickListStatus?: InputMaybe<Scalars['String']>;
  pickedStatus?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  quoteDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  readyForReservation?: InputMaybe<Scalars['Boolean']>;
  reservationDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  search?: InputMaybe<Scalars['String']>;
  serializedInventorySerialNumbers?: InputMaybe<Scalars['String']>;
  setByTimeDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  shortageAlert?: InputMaybe<Scalars['Boolean']>;
  signatureRequired?: InputMaybe<Scalars['Boolean']>;
  signatureRequiredAndSignatureExists?: InputMaybe<Scalars['Boolean']>;
  signerName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  startWindowFinish?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  strikeDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  subRentalStatus?: InputMaybe<Scalars['String']>;
  teamMembersNames?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  truckIds?: InputMaybe<Array<Scalars['Int']>>;
  truckNeeded?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAtGte?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryGetRentalsByDateArgs = {
  deliveryDateGte?: InputMaybe<Scalars['String']>;
  deliveryDateLte?: InputMaybe<Scalars['String']>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']>>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  eventEndDateTimeGte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeLte?: InputMaybe<Scalars['String']>;
  pickUpDateGte?: InputMaybe<Scalars['String']>;
  pickUpDateLte?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeGte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeLte?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  strikeDateTimeGte?: InputMaybe<Scalars['String']>;
  strikeDateTimeLte?: InputMaybe<Scalars['String']>;
  teamMembersNames?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  venueName?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetRentalsByDateVerticalArgs = {
  deliveryDateGte?: InputMaybe<Scalars['String']>;
  deliveryDateLte?: InputMaybe<Scalars['String']>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']>>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  eventEndDateTimeGte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeLte?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  parentToken?: InputMaybe<Scalars['String']>;
  perPage?: InputMaybe<Scalars['Int']>;
  pickUpDateGte?: InputMaybe<Scalars['String']>;
  pickUpDateLte?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeGte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeLte?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  strikeDateTimeGte?: InputMaybe<Scalars['String']>;
  strikeDateTimeLte?: InputMaybe<Scalars['String']>;
  teamMembersNames?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  venueName?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetRentalsByTransportsArgs = {
  employeeIds?: InputMaybe<Array<Scalars['Int']>>;
  rentalSource?: InputMaybe<Array<Scalars['String']>>;
  rentalStatus?: InputMaybe<Array<Scalars['String']>>;
  startDateTimeGte?: InputMaybe<Scalars['String']>;
  startDateTimeLte?: InputMaybe<Scalars['String']>;
  transportType?: InputMaybe<Array<Scalars['String']>>;
  truckIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetRentalsGanttArgs = {
  contactIds?: InputMaybe<Array<Scalars['String']>>;
  deliveryTypes?: InputMaybe<Array<Scalars['String']>>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  sortBy?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  teamMemberNames?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetRolesArgs = {
  roleType?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetSalesTaxCashBasisReportArgs = {
  accountingMethod: Scalars['String'];
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  locationIds: Array<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
};


export type QueryGetSerializedProductArgs = {
  id: Scalars['String'];
  locationId?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetSerializedProductsArgs = {
  locationId?: InputMaybe<Array<Scalars['Int']>>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetSimplifiedPaginatedRentalsArgs = {
  deliveryDateGte?: InputMaybe<Scalars['String']>;
  deliveryDateLte?: InputMaybe<Scalars['String']>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']>>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']>>;
  eventEndDateTimeGte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeLte?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  parentToken?: InputMaybe<Scalars['String']>;
  perPage?: InputMaybe<Scalars['Int']>;
  pickUpDateGte?: InputMaybe<Scalars['String']>;
  pickUpDateLte?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeGte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeLte?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']>>;
  strikeDateTimeGte?: InputMaybe<Scalars['String']>;
  strikeDateTimeLte?: InputMaybe<Scalars['String']>;
  teamMembersNames?: InputMaybe<Array<Scalars['String']>>;
  type?: InputMaybe<Array<Scalars['String']>>;
  venueName?: InputMaybe<Array<Scalars['String']>>;
};


export type QueryGetStaffRoleArgs = {
  id: Scalars['ID'];
};


export type QueryGetStorefrontCagetoriesArgs = {
  direction?: InputMaybe<StorefrontCategoryDirectionEnum>;
  locationId: Scalars['Int'];
  order?: InputMaybe<StorefrontCategoryOrderEnum>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetStorefrontCategoriesArgs = {
  direction?: InputMaybe<StorefrontCategoryDirectionEnum>;
  locationId: Scalars['Int'];
  order?: InputMaybe<StorefrontCategoryOrderEnum>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetStorefrontTagsArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetUniqueLocationEmployeeEmailsArgs = {
  locationId: Scalars['String'];
};


export type QueryGetVendorsArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetVenueArgs = {
  id: Scalars['String'];
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryGetVenuesArgs = {
  locationIds?: InputMaybe<Array<Scalars['Int']>>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetZipCodeDeliveryFeeArgs = {
  search?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryGetZipCodeDeliveryFeesArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QueryProductPaginatedAlertingArgs = {
  combineLikeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  productId?: InputMaybe<Scalars['String']>;
  rentalId?: InputMaybe<Scalars['ID']>;
  selectedDate?: InputMaybe<Scalars['String']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
};


export type QueryRentalPickListArgs = {
  rentalId: Scalars['String'];
};


export type QueryRentalSlipsZplArgs = {
  dpi?: InputMaybe<Scalars['Int']>;
  rentalToken: Scalars['String'];
  slipCount: Scalars['Int'];
};


export type QuerySearchStorefrontTagsArgs = {
  locationId: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
};

export type QuickViewTemplates = {
  __typename?: 'QuickViewTemplates';
  /** The current Quick View template for the location, if set. */
  quickViewTemplate?: Maybe<RentalTemplate>;
  /** List of all available Quick View templates for the location. */
  templates: Array<RentalTemplate>;
};

/** Autogenerated input type of ReactivateSerializedProducts */
export type ReactivateSerializedProductsInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  ids: Array<Scalars['ID']>;
};

/** Autogenerated return type of ReactivateSerializedProducts. */
export type ReactivateSerializedProductsPayload = {
  __typename?: 'ReactivateSerializedProductsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ReassignDrivers */
export type ReassignDriversInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  drivers: Array<DriverInput>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  truckRouteId: Scalars['Int'];
};

/** Autogenerated return type of ReassignDrivers. */
export type ReassignDriversPayload = {
  __typename?: 'ReassignDriversPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  drivers: Array<Driver>;
  errors: Array<Scalars['String']>;
};

/** Represents a mapping between a hostname and a business for redirect purposes */
export type RedirectHost = {
  __typename?: 'RedirectHost';
  /** The ID of the TapGoods business this redirect host is associated with */
  businessId?: Maybe<Scalars['Int']>;
  /** The fully qualified domain name (FQDN) used for redirection. Must be unique per business. */
  hostname: Scalars['String'];
  /** The unique database identifier for the redirect host */
  id: Scalars['ID'];
};

/** Input type for managing redirect host configurations */
export type RedirectHostInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the business this redirect host is associated with */
  businessId?: InputMaybe<Scalars['Int']>;
  /** The fully qualified domain name (FQDN) to redirect from. Must be a valid URL or domain name */
  hostname?: InputMaybe<Scalars['String']>;
  /** Unique identifier for the redirect host */
  id?: InputMaybe<Scalars['ID']>;
};

/** Arguments for creating or updating a Refund */
export type RefundInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Amount to refund */
  amount: Scalars['String'];
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Transaction ID */
  transactionId?: InputMaybe<Scalars['Int']>;
  /** Refund type */
  type: Scalars['String'];
};

export type RefundLine = {
  __typename?: 'RefundLine';
  amount: Scalars['Float'];
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  refundGroupId?: Maybe<Scalars['String']>;
  refundType: Scalars['String'];
};

/** Arguments for deleting a Refund Line */
export type RefundLineInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The amount to be refunded */
  amount?: InputMaybe<Scalars['Float']>;
  /** Created at datetime */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The refund line id */
  id: Scalars['Int'];
  /** The refund group id */
  refundGroupId?: InputMaybe<Scalars['Int']>;
  /** The type of refund line */
  refundType?: InputMaybe<Scalars['String']>;
};

/** Represents a rental object. */
export type Rental = {
  __typename?: 'Rental';
  /** List of accessories associated with the rental. */
  accessories?: Maybe<Array<Accessory>>;
  /** Indicates if the rental is currently active. */
  active?: Maybe<Scalars['Boolean']>;
  /** Cycles of activity settings for the rental, if applicable. */
  activitySettingCycles?: Maybe<Array<Array<Scalars['Int']>>>;
  /** List of add-ons associated with the rental. */
  addOns?: Maybe<Array<AddOn>>;
  /** Additional cost for delivery, if applicable. */
  additionalDeliveryCost?: Maybe<Scalars['Float']>;
  /** Additional information about the delivery of the rental. */
  additionalDeliveryInfo?: Maybe<Scalars['String']>;
  /** Additional information about the rental order. */
  additionalOrderInfo?: Maybe<Scalars['String']>;
  /** Indicates if alerting is enabled for the rental. */
  alerting?: Maybe<Scalars['Boolean']>;
  /** Status of the approval for the rental. */
  approvalStatus?: Maybe<Scalars['String']>;
  /** Card ID for auto-billing, if applicable. */
  autoBillCard?: Maybe<Scalars['String']>;
  /** Customer ID for auto-billing, if applicable. */
  autoBillCustomer?: Maybe<Scalars['String']>;
  /** Type of customer for auto-billing, such as "individual" or "business". */
  autoBillCustomerType?: Maybe<Scalars['String']>;
  /** Indicates if auto-billing is enabled for the rental. */
  autoBillEnabled?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental was automatically booked. */
  autoBooked?: Maybe<Scalars['Boolean']>;
  /** List of billing notes associated with the rental. */
  billingNotes: Array<BillingNote>;
  /** Billing status of the rental, indicating payment status. */
  billingStatus?: Maybe<RentalBillingStatusesEnum>;
  /** List of bundles associated with the rental. */
  bundles?: Maybe<Array<Bundle>>;
  /** Business associated with the rental. */
  business: Business;
  /** Signature captured at business check-in for the rental. */
  businessCheckinSignature?: Maybe<Scalars['String']>;
  /** Company of the business representative who signed at check-in for the rental. */
  businessCheckinSignerCompany?: Maybe<Scalars['String']>;
  /** Name of the person who signed at business check-in for the rental. */
  businessCheckinSignerName?: Maybe<Scalars['String']>;
  /** Title of the business representative who signed at check-in for the rental. */
  businessCheckinSignerTitle?: Maybe<Scalars['String']>;
  /** Signature captured at business checkout for the rental. */
  businessCheckoutSignature?: Maybe<Scalars['String']>;
  /** Company of the business representative who signed at checkout for the rental. */
  businessCheckoutSignerCompany?: Maybe<Scalars['String']>;
  /** Name of the person who signed at business checkout for the rental. */
  businessCheckoutSignerName?: Maybe<Scalars['String']>;
  /** Title of the business representative who signed at checkout for the rental. */
  businessCheckoutSignerTitle?: Maybe<Scalars['String']>;
  /** Signature of the business representative for the rental. */
  businessSignature?: Maybe<Scalars['String']>;
  /** Company of the business representative who signed the rental agreement. */
  businessSignerCompany?: Maybe<Scalars['String']>;
  /** Name of the business representative who signed the rental agreement. */
  businessSignerName?: Maybe<Scalars['String']>;
  /** Title of the business representative who signed the rental agreement. */
  businessSignerTitle?: Maybe<Scalars['String']>;
  /** Version of the calculator used for pricing the rental. */
  calculatorVersion?: Maybe<Scalars['Int']>;
  /** Indicates if a cancellation has been requested for the rental. */
  cancelRequested?: Maybe<Scalars['Boolean']>;
  /** Status of the cancellation for the rental. */
  cancellationStatus?: Maybe<Scalars['String']>;
  /** Type of carrier used for the rental delivery, if applicable. */
  carrierType?: Maybe<Scalars['String']>;
  /** Status indicating if the rental has been checked in. */
  checkedInStatus?: Maybe<Scalars['String']>;
  /** Signature captured at check-in for the rental. */
  checkinSignature?: Maybe<Scalars['String']>;
  /** Company of the person who signed at check-in for the rental. */
  checkinSignerCompany?: Maybe<Scalars['String']>;
  /** Name of the person who signed at check-in for the rental. */
  checkinSignerName?: Maybe<Scalars['String']>;
  /** Title of the person who signed at check-in for the rental. */
  checkinSignerTitle?: Maybe<Scalars['String']>;
  /** Signature captured at checkout for the rental. */
  checkoutSignature?: Maybe<Scalars['String']>;
  /** Company of the person who signed at checkout for the rental. */
  checkoutSignerCompany?: Maybe<Scalars['String']>;
  /** Name of the person who signed at checkout for the rental. */
  checkoutSignerName?: Maybe<Scalars['String']>;
  /** Title of the person who signed at checkout for the rental. */
  checkoutSignerTitle?: Maybe<Scalars['String']>;
  /** Date when the rental was closed. */
  closedDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Company associated with the rental. */
  company?: Maybe<Company>;
  /** Relationship between the rental and the company. */
  companyRentalRelationship?: Maybe<CompanyRentalRelationship>;
  /** Status of the connection for the rental, if applicable. */
  connectStatus?: Maybe<Scalars['String']>;
  /** List of conversations associated with the rental. */
  conversations?: Maybe<Array<Conversation>>;
  /** ID of the form associated with conversion errors for the rental. */
  conversionErrorFormId?: Maybe<Scalars['Int']>;
  /** Details about the current conversion lock on the rental */
  conversionLock?: Maybe<RentalConversionLock>;
  /** Status of the conversion for the rental, indicating if it is in progress or completed. */
  conversionStatus: Scalars['String'];
  /** Timestamp when the rental was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Custom amount for the deposit required for the rental. */
  customDepositAmount?: Maybe<Scalars['Float']>;
  /** Custom date for the rental expiration, if applicable. */
  customExpireDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Custom identifier for the rental, used for tracking or integration purposes. */
  customId?: Maybe<Scalars['String']>;
  /** Phone number of the customer contact for the rental. */
  customerContactPhone?: Maybe<Scalars['String']>;
  /** List of customer location relationships associated with the rental. */
  customerLocationRelationships: Array<CustomerLocationRelationship>;
  /** List of customer relationships associated with the rental. */
  customerRentalRelationships: Array<CustomerRentalRelationship>;
  /** List of customers associated with the rental. */
  customers: Array<Customer>;
  /** List of daily rentals associated with the rental. */
  dailyRentals?: Maybe<Array<Rental>>;
  /** Total fee for the damage waiver applied to the rental. */
  damageWaiverFeeTotal?: Maybe<Scalars['Float']>;
  /** Fixed fee for the damage waiver applied to the rental. */
  damageWaiverFixedFee?: Maybe<Scalars['Float']>;
  /** Percentage of the rental amount that constitutes the damage waiver. */
  damageWaiverPercent?: Maybe<Scalars['Float']>;
  /** Indicates if the damage waiver is tax exempt for the rental. */
  damageWaiverTaxExempt?: Maybe<Scalars['Boolean']>;
  /** City for the delivery address. */
  deliveryAddressCity?: Maybe<Scalars['String']>;
  /** Country for the delivery address. */
  deliveryAddressCountry?: Maybe<Scalars['String']>;
  /** Locale for the delivery address, typically a state or province. */
  deliveryAddressLocale?: Maybe<Scalars['String']>;
  /** Name of the location for the delivery address. */
  deliveryAddressLocationName?: Maybe<Scalars['String']>;
  /** Postal code for the delivery address. */
  deliveryAddressPostalCode?: Maybe<Scalars['String']>;
  /** Street address for the delivery location. */
  deliveryAddressStreetAddress1?: Maybe<Scalars['String']>;
  /** Additional street address information for the delivery location. */
  deliveryAddressStreetAddress2?: Maybe<Scalars['String']>;
  /** Cost associated with the delivery of the rental. */
  deliveryCost?: Maybe<Scalars['Float']>;
  /** Delivery drop-off date and time of the rental (alias for start_date_time). */
  deliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if delivery tax is enabled for the rental. */
  deliveryTaxEnabled?: Maybe<Scalars['Boolean']>;
  /** Number of delivery tickets associated with the rental. */
  deliveryTicketsCount?: Maybe<Scalars['Int']>;
  /** Tracking number for the delivery of the rental. */
  deliveryTrackingNumber?: Maybe<Scalars['String']>;
  /** Type of delivery for the rental (e.g., "pickup", "delivery"). */
  deliveryType?: Maybe<Scalars['String']>;
  /** Fixed fee for the deposit required for the rental. */
  depositFixedFee?: Maybe<Scalars['Float']>;
  /** Percentage of the rental amount that constitutes the deposit. */
  depositPercent?: Maybe<Scalars['Float']>;
  /** Indicates if a deposit is required for the rental. */
  depositRequired?: Maybe<Scalars['Boolean']>;
  /** Type of deposit required for the rental (e.g., "fixed", "percent"). */
  depositType?: Maybe<Scalars['String']>;
  /** List of disclaimers associated with the rental. */
  disclaimerRentalRelationships?: Maybe<Array<DisclaimerRentalRelationship>>;
  /** List of discounts applied to the rental. */
  discountRentalRelationships?: Maybe<Array<DiscountRentalRelationship>>;
  /** List of document relationships associated with the rental. */
  documentRentalRelationships: Array<DocumentRentalRelationship>;
  /** Earliest status of the pick list for the rental. */
  earliestPickListStatus?: Maybe<Scalars['String']>;
  /** List of emails associated with the rental. */
  emails?: Maybe<Array<RentalEmails>>;
  /** List of employee relationships associated with the rental. */
  employeeRentalRelationships: Array<EmployeeRentalRelationship>;
  /** List of employees associated with the rental. */
  employees: Array<Employee>;
  /** End date and time of the rental. */
  endDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Event associated with the rental. */
  event?: Maybe<Event>;
  /** Setting for the end of the event associated with the rental. */
  eventEndSetting?: Maybe<Scalars['String']>;
  /** ID of the event associated with the rental, if applicable. */
  eventId?: Maybe<Scalars['Int']>;
  /** Setting for the start of the event associated with the rental. */
  eventStartSetting?: Maybe<Scalars['String']>;
  /** List of expenses associated with the rental. */
  expenses: Array<Expense>;
  /** Type of expiration for the rental (e.g., "soft", "hard"). */
  expireType?: Maybe<Scalars['String']>;
  /** List of fees associated with the rental. */
  feeRentalRelationships?: Maybe<Array<FeeRentalRelationship>>;
  /** Number of days until the final payment is due for the rental. */
  finalPaymentDueDateDaysNum?: Maybe<Scalars['Int']>;
  /** Option for the final payment due date, such as "days", "weeks", or "months". */
  finalPaymentDueDateDaysOption?: Maybe<Scalars['String']>;
  /** Type of final payment due date, such as "fixed" or "relative". */
  finalPaymentDueDateType?: Maybe<Scalars['String']>;
  /** Date and time when the rental was flipped. */
  flipDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notes associated with the flip of the rental. */
  flipNotes?: Maybe<Scalars['String']>;
  /** Indicates if the rental is exempt from GST (Goods and Services Tax). */
  gstTaxExempt?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has an agreement. */
  hasAgreement?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has an auto-book notification set. */
  hasAutobookNotification?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has associated documents. */
  hasDocuments?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has been flipped. */
  hasFlip?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has a proposal setting. */
  hasProposalSettings?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has a set-by time. */
  hasSetByTime?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental has a strike time. */
  hasStrikeTime?: Maybe<Scalars['Boolean']>;
  /** ID */
  id: Scalars['ID'];
  /** Indicates if expired documents should be ignored for the rental. */
  ignoreExpiredDocuments?: Maybe<Scalars['Boolean']>;
  /** ID of the invoice associated with the rental. */
  invoiceId?: Maybe<Scalars['Int']>;
  /** Indicates if the rental is part of a recurring payment schedule. */
  isRecurringPayment?: Maybe<Scalars['Boolean']>;
  /** Sub-option for the job associated with the rental. */
  jobSubOption?: Maybe<Scalars['String']>;
  /** Type of job associated with the rental. */
  jobType?: Maybe<Scalars['String']>;
  /** Timestamp of the last payment made for the rental. */
  lastPaymentTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Type of the last payment made for the rental (e.g., "credit_card", "cash"). */
  lastPaymentType?: Maybe<Scalars['String']>;
  /** Value of the last payment made for the rental. */
  lastPaymentValue?: Maybe<Scalars['Float']>;
  /** Token of the last service associated with the rental. */
  lastServiceToken?: Maybe<Scalars['Int']>;
  /** Last status that was undone for the rental. */
  lastUndidStatus?: Maybe<Scalars['String']>;
  /** Location where the rental is associated. */
  location: Location;
  /** ID of the location where the rental is associated. */
  locationId?: Maybe<Scalars['Int']>;
  /** Indicates if a manual damage waiver is applied to the rental. */
  manualDamageWaiver?: Maybe<Scalars['Boolean']>;
  /** Name of the manual sales tax applied to the rental. */
  manualSalesTaxName?: Maybe<Scalars['String']>;
  /** Percentage of the manual sales tax applied to the rental. */
  manualSalesTaxPercent?: Maybe<Scalars['Float']>;
  /** Percentage of the rental amount that goes to the marketplace business. */
  marketplaceBusinessPercent?: Maybe<Scalars['Float']>;
  /** Percentage of the rental amount that goes to the marketplace customer. */
  marketplaceCustomerPercent?: Maybe<Scalars['Float']>;
  /** Expiration date for the marketplace rental, if applicable. */
  marketplaceExpirationDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Name of the rental. */
  name?: Maybe<Scalars['String']>;
  /** Indicates if the rental allows for no-cost subrental transfers. */
  noCostSubrentalTransfer?: Maybe<Scalars['Boolean']>;
  /** List of notes associated with the rental. */
  notes: Array<Note>;
  /** Indicates if an NPS (Net Promoter Score) survey is required for the rental. */
  npsRequired?: Maybe<Scalars['Boolean']>;
  /** Token of the parent rental, if applicable. */
  parentRentalToken?: Maybe<Scalars['String']>;
  /** Indicates if the first payment notification is enabled. */
  paymentNotification1Enabled?: Maybe<Scalars['Boolean']>;
  /** Number of days for the first payment notification. */
  paymentNotification1Num?: Maybe<Scalars['Int']>;
  /** Indicates if the second payment notification is enabled. */
  paymentNotification2Enabled?: Maybe<Scalars['Boolean']>;
  /** Number of days for the second payment notification. */
  paymentNotification2Num?: Maybe<Scalars['Int']>;
  /** Indicates if the third payment notification is enabled. */
  paymentNotification3Enabled?: Maybe<Scalars['Boolean']>;
  /** Number of days for the third payment notification. */
  paymentNotification3Num?: Maybe<Scalars['Int']>;
  /** Option for the payment notification days, such as "before" or "after". */
  paymentNotificationDaysOption?: Maybe<Scalars['String']>;
  /** Type of payment notification, such as "email" or "SMS". */
  paymentNotificationType?: Maybe<Scalars['String']>;
  /** Payment processor used for the rental transactions. */
  paymentProcessor?: Maybe<Scalars['String']>;
  /** Number of days before the payment reminder is sent. */
  paymentReminderDaysBefore?: Maybe<Scalars['String']>;
  /** Options for payment reminders, such as frequency and method. */
  paymentReminderOptions?: Maybe<Scalars['String']>;
  /** Payment term for the rental, such as "net 30" or "due on receipt". */
  paymentTerm?: Maybe<Scalars['String']>;
  /** List of accessories in the pick list for the rental. */
  pickListAccessories: Array<PickListAccessory>;
  /** List of add-ons in the pick list for the rental. */
  pickListAddOns: Array<PickListAddOn>;
  /** List of items in the pick list for the rental. */
  pickListItems: Array<PickListItem>;
  /** Pick-up (return) date and time of the rental — start of the pickup arrival window. */
  pickUpDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** City for the pickup address. */
  pickupAddressCity?: Maybe<Scalars['String']>;
  /** Country for the pickup address. */
  pickupAddressCountry?: Maybe<Scalars['String']>;
  /** Locale for the pickup address, typically a state or province. */
  pickupAddressLocale?: Maybe<Scalars['String']>;
  /** Name of the location for the pickup address. */
  pickupAddressLocationName?: Maybe<Scalars['String']>;
  /** Postal code for the pickup address. */
  pickupAddressPostalCode?: Maybe<Scalars['String']>;
  /** Street address for the pickup location. */
  pickupAddressStreetAddress1?: Maybe<Scalars['String']>;
  /** Additional street address information for the pickup location. */
  pickupAddressStreetAddress2?: Maybe<Scalars['String']>;
  /** Indicates if the pickup address is the same as the delivery address. */
  pickupSameAsDelivery?: Maybe<Scalars['Boolean']>;
  /** List of picture URLs associated with the rental. */
  pictures: Array<Scalars['String']>;
  /** Preferred delivery window for the rental. */
  preferredDeliveryWindow?: Maybe<Scalars['String']>;
  /** Preferred pickup window for the rental. */
  preferredPickupWindow?: Maybe<Scalars['String']>;
  /** ID of the pricing logic used for the rental. */
  pricingLogicId?: Maybe<Scalars['Int']>;
  /** ID of the primary contact associated with the rental. */
  primaryContactId?: Maybe<Scalars['Int']>;
  /** List of products associated with the rental. */
  products?: Maybe<Array<Product>>;
  /** Indicates if the rental is exempt from PST (Provincial Sales Tax). */
  pstTaxExempt?: Maybe<Scalars['Boolean']>;
  /** QuickBooks ID associated with the rental, if applicable. */
  qbId?: Maybe<Scalars['String']>;
  /** Indicates if there is an error related to QuickBooks period closure for the rental. */
  qbPeriodClosedError?: Maybe<Scalars['Boolean']>;
  /** Date when the rental was quoted. */
  quoteDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Indicates if the rental is part of a recurring schedule. */
  recurring?: Maybe<Scalars['Boolean']>;
  /** Source of the referral for the rental, if applicable. */
  referralSource?: Maybe<Scalars['String']>;
  /** List of refund lines associated with the rental. */
  refundLines?: Maybe<Array<RefundLine>>;
  /** Details of the rental agreement associated with the rental. */
  rentalAgreement?: Maybe<RentalAgreement>;
  /** ID of the rental agreement associated with the rental. */
  rentalAgreementId?: Maybe<Scalars['Int']>;
  /** List of labor staff associated with the rental. */
  rentalLabors?: Maybe<Array<RentalStaff>>;
  /** List of sections associated with the rental. */
  rentalSections: Array<RentalSection>;
  /** Settings associated with the rental. */
  rentalSetting?: Maybe<RentalSetting>;
  /** List of staff members associated with the rental. */
  rentalStaffs: Array<RentalStaff>;
  /** Email settings for the rental team. */
  rentalTeamEmailSetting?: Maybe<RentalTeamEmailSetting>;
  /** Total cost of the rental, including all fees and taxes. */
  rentalTotal: RentalTotal;
  /** List of Assigned Stops (rttr) associated with the rental. */
  rentalTransportTruckRelationships: Array<RentalTransportTruckRelationship>;
  /** List of transports associated with the rental. */
  rentalTransports: Array<RentalTransport>;
  /** Date when the rental was reserved. */
  reservationDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Tracking number for the return of the rental. */
  returnTrackingNumber?: Maybe<Scalars['String']>;
  /** Activity setting for the room associated with the rental. */
  roomActivitySetting?: Maybe<RoomActivitySettingEnum>;
  /** List of sales tax relationships associated with the rental. */
  salesTaxRentalRelationships?: Maybe<Array<SalesTaxRentalRelationship>>;
  /** Sales tax setting for the rental, such as "inclusive" or "exclusive". */
  salesTaxSetting?: Maybe<Scalars['String']>;
  /** Schedule associated with the rental. */
  schedule?: Maybe<Schedule>;
  /** Secondary order associated with the rental, if applicable. */
  secondaryOrder?: Maybe<Rental>;
  /** List of secondary orders associated with the rental. */
  secondaryOrders?: Maybe<Array<Rental>>;
  /** Count of secondary orders associated with the rental. */
  secondaryOrdersCount?: Maybe<Scalars['Int']>;
  /** List of service tickets associated with the rental. */
  serviceTickets: Array<ServiceTicket>;
  /** Date and time when the set-by time was established. */
  setByTimeDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notes associated with the set-by time for the rental. */
  setByTimeNotes?: Maybe<Scalars['String']>;
  /** Indicates if the deposit should cover one full payment of the rental. */
  shouldDepositOneFullPayment?: Maybe<Scalars['Boolean']>;
  /** Indicates if the rental should be synchronized to QuickBooks. */
  shouldSyncToQb?: Maybe<Scalars['Boolean']>;
  /** Signature associated with the rental. */
  signature?: Maybe<Scalars['String']>;
  /** Indicates if a signature is required for the rental. */
  signatureRequired?: Maybe<Scalars['Boolean']>;
  /** Status of the signature for the rental, indicating if it is required or completed. */
  signatureStatus?: Maybe<RentalSignatureStatusEnum>;
  /** Company of the person who signed the rental agreement. */
  signerCompany?: Maybe<Scalars['String']>;
  /** Name of the person who signed the rental agreement. */
  signerName?: Maybe<Scalars['String']>;
  /** Title of the person who signed the rental agreement. */
  signerTitle?: Maybe<Scalars['String']>;
  /** Indicates if smart pricing is active for the rental. */
  smartPricingActive?: Maybe<Scalars['Boolean']>;
  /** Source from which the rental originated (e.g., "web", "app"). */
  source?: Maybe<Scalars['String']>;
  /** Start date and time of the rental. */
  startDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Current status of the rental. */
  status?: Maybe<Scalars['String']>;
  /** A grouping of all possible statuses a rental can be in */
  statusWithFunnel?: Maybe<RentalStatusWithFunnelEnum>;
  /** Percentage of the rental amount that goes to the storefront business. */
  storefrontBusinessPercent?: Maybe<Scalars['Float']>;
  /** Percentage of the rental amount that goes to the storefront. */
  storefrontPercent?: Maybe<Scalars['Float']>;
  /** Date and time when the rental was struck. */
  strikeDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Notes associated with the strike time for the rental. */
  strikeTimeNotes?: Maybe<Scalars['String']>;
  /** Indicates if the rental is tax exempt. */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Tax rate applied to the rental. */
  taxRate?: Maybe<Scalars['Float']>;
  /** List of team members associated with the rental. */
  teamMembers: Array<Employee>;
  /** Unique token for the rental, used for identification. */
  token?: Maybe<Scalars['String']>;
  /** Total count of inventory items associated with the rental. */
  totalInventoryCount: Scalars['Int'];
  /** List of transactions associated with the rental. */
  transactions?: Maybe<Array<Transaction>>;
  /** Type of the rental, such as "PrimaryOrder" or "SecondaryOrder". */
  type?: Maybe<Scalars['String']>;
  /** Timestamp when the rental was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Venue associated with the rental. */
  venue?: Maybe<Venue>;
  /** Relationship between the rental and the venue. */
  venueRentalRelationship?: Maybe<VenueRentalRelationship>;
  /** Version number of the rental, used for tracking changes. */
  version?: Maybe<Scalars['Int']>;
};

export type RentalAccessory = {
  __typename?: 'RentalAccessory';
  /** ID of the accessory being rented. */
  accessoryId?: Maybe<Scalars['Int']>;
  /** Indicates if the accessory is currently active. */
  active?: Maybe<Scalars['Boolean']>;
  /** Quantity of the accessory that has been checked in after rental. */
  checkedInQuantity?: Maybe<Scalars['Int']>;
  /** Timestamp when the rental accessory was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Comma-separated customer contact names from the parent rental. */
  customerContactName?: Maybe<Scalars['String']>;
  /** Indicates if the rental accessory is exempt from damage waiver fees. */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** Quantity of the accessory that has been reported as damaged. */
  damagedQuantity?: Maybe<Scalars['Int']>;
  /** Delivery type of the parent rental. */
  deliveryType?: Maybe<Scalars['String']>;
  /** Name of the department associated with the rental accessory. */
  departmentName?: Maybe<Scalars['String']>;
  /** Description of the rental accessory. */
  description?: Maybe<Scalars['String']>;
  /** Multilocation group info for the parent inventory accessory */
  groupInfo?: Maybe<Scalars['JSON']>;
  /** Indicates if there is a shortage of this accessory. */
  hasShortage?: Maybe<Scalars['Boolean']>;
  /** Indicates if there is a soft hold on this accessory. */
  hasSoftHold?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the rental accessory. */
  id: Scalars['ID'];
  /** ID of the inventory item associated with this rental accessory. */
  inventoryId?: Maybe<Scalars['Int']>;
  /** Name of the parent inventory accessory */
  inventoryName?: Maybe<Scalars['String']>;
  /** The inventory item associated with this rental accessory. */
  inventoryObject?: Maybe<Accessory>;
  /** Token of the parent inventory accessory. */
  inventoryToken?: Maybe<Scalars['String']>;
  /** List of item notes associated with the rental accessory. */
  itemNotes?: Maybe<Array<ItemNote>>;
  /** Categorized inventory type: item, temp, accessory, or purchase. */
  itemType?: Maybe<Scalars['String']>;
  /** Notes regarding any lack or shortage of the accessory. */
  lackNotes?: Maybe<Scalars['String']>;
  /** Last recorded quantity of the accessory that was missing. */
  lastMissingQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the parent inventory accessory currently under maintenance. */
  maintenanceQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the accessory that is missing or unaccounted for. */
  missingQuantity?: Maybe<Scalars['Int']>;
  /** Name of the rental accessory. */
  name?: Maybe<Scalars['String']>;
  /** Additional notes about the rental accessory. */
  notes?: Maybe<Scalars['String']>;
  /** Number of this accessory available for rental. */
  numberAvailable?: Maybe<Scalars['Int']>;
  /** Number of this accessory available for soft hold. */
  numberAvailableForSoftHold?: Maybe<Scalars['Int']>;
  /** Parent rental associated with this accessory, if applicable. */
  parentRental?: Maybe<Rental>;
  /** Details of the pick list accessory associated with this rental accessory. */
  pickListAccessory?: Maybe<PickListAccessory>;
  /** ID of the pick list accessory associated with this rental accessory. */
  pickListAccessoryId?: Maybe<Scalars['Int']>;
  /** Quantity of the accessory that is missing from the pick list. */
  pickListMissingQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the accessory that has been picked from the pick list. */
  pickListPickedQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the accessory in the pick list. */
  pickListQuantity?: Maybe<Scalars['Int']>;
  /** Status of the pick list for this accessory. */
  pickListStatus?: Maybe<Scalars['String']>;
  /** Quantity of the accessory that has been picked for the rental. */
  pickedQuantity?: Maybe<Scalars['Int']>;
  /** Pictures associated with the rental accessory. */
  pictures?: Maybe<Scalars['String']>;
  /** Position of the accessory in the rental order or bundle. */
  position?: Maybe<Scalars['Int']>;
  /** Position of the accessory within its section. */
  positionInSection?: Maybe<Scalars['Int']>;
  /** Indicates if the pricing for this accessory was picked by the user. */
  pricingPickedByUser?: Maybe<Scalars['Boolean']>;
  /** STI type identifier (items, accessories, addons). */
  productType?: Maybe<Scalars['String']>;
  /** Total quantity of the accessory available for rental. */
  quantity?: Maybe<Scalars['Int']>;
  /** ID of the rental bundle this accessory belongs to, if applicable. */
  rentalBundleId?: Maybe<Scalars['Int']>;
  /** ID of the rental associated with this accessory. */
  rentalId?: Maybe<Scalars['Int']>;
  /** Name of the rental associated with this accessory. */
  rentalName?: Maybe<Scalars['String']>;
  /** Schedule for the rental accessory. */
  rentalSchedule?: Maybe<Schedule>;
  /** Rental section this accessory belongs to (used by the section-grouped Pick List view). */
  rentalSection?: Maybe<RentalSection>;
  /** Name of the rental section this accessory belongs to. */
  rentalSectionName?: Maybe<Scalars['String']>;
  /** Current status of the rental associated with this accessory. */
  rentalStatus?: Maybe<Scalars['String']>;
  /** Token for the rental associated with this accessory. */
  rentalToken?: Maybe<Scalars['String']>;
  /** JSON data containing section memberships for the accessory. */
  sectionMembershipsData?: Maybe<Scalars['JSON']>;
  /** Indicates if the accessory was set manually in the rental order. */
  setManually?: Maybe<Scalars['Boolean']>;
  /** Quantity short for this accessory. */
  shortageQuantity?: Maybe<Scalars['Int']>;
  /** Quantity under soft hold for this accessory. */
  softHoldQuantity?: Maybe<Scalars['Int']>;
  /** Current status of the rental accessory. */
  status?: Maybe<Scalars['String']>;
  /** List of sub-rentals associated with this accessory. */
  subRentals?: Maybe<Array<SubRental>>;
  /** Quantity of the accessory that has been sub-rented. */
  subRentedQuantity: Scalars['Int'];
  /** Indicates if the rental accessory is tax exempt. */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Reason for unavailability of the accessory, if applicable. */
  unavailabilityReason?: Maybe<Scalars['String']>;
  /** Timestamp when the rental accessory was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Location of the accessory in the warehouse. */
  warehouseLocation?: Maybe<Scalars['String']>;
  /** Total quantity of the parent inventory accessory in warehouse. */
  warehouseQuantity?: Maybe<Scalars['Int']>;
};

/** Type for reporting alerting information about rental accessories */
export type RentalAccessoryAlerting = {
  __typename?: 'RentalAccessoryAlerting';
  /** Error message if there was an issue retrieving alerting information */
  error?: Maybe<Scalars['String']>;
  /** Additional metadata about the alerting information */
  meta?: Maybe<Scalars['JSON']>;
  /** List of rental accessories that have alerting information */
  rentalAccessories?: Maybe<Array<RentalAccessory>>;
};

/** Input type for managing accessories associated with a rental or rental bundle */
export type RentalAccessoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the associated accessory master record */
  accessoryId?: InputMaybe<Scalars['Int']>;
  /** Whether the accessory is currently active in the rental */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Number of units that have been checked in */
  checkedInQuantity?: InputMaybe<Scalars['Int']>;
  /** Timestamp when the rental accessory was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Whether the damage waiver applies to this accessory */
  damageWaiverExempt?: InputMaybe<Scalars['Boolean']>;
  /** Number of units reported as damaged */
  damagedQuantity?: InputMaybe<Scalars['Int']>;
  /** Detailed description of the accessory */
  description?: InputMaybe<Scalars['String']>;
  /** When the accessory was fulfilled/picked */
  fulfilledDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the rental accessory */
  id?: InputMaybe<Scalars['ID']>;
  /** Nested attributes for notes associated with this accessory item */
  itemNotesAttributes?: InputMaybe<Array<ItemNoteInput>>;
  /** Notes about any shortages or missing items */
  lackNotes?: InputMaybe<Scalars['String']>;
  /** Previous count of missing units before the last update */
  lastMissingQuantity?: InputMaybe<Scalars['Int']>;
  /** Number of units reported as missing */
  missingQuantity?: InputMaybe<Scalars['Int']>;
  /** Name of the accessory as it appears in the rental */
  name?: InputMaybe<Scalars['String']>;
  /** General notes about this accessory in the rental */
  notes?: InputMaybe<Scalars['String']>;
  /** Number of units currently available in inventory */
  numberAvailable?: InputMaybe<Scalars['Int']>;
  /** Number of units available for soft hold */
  numberAvailableForSoftHold?: InputMaybe<Scalars['Int']>;
  /** ID of the associated pick list accessory */
  pickListAccessoryId?: InputMaybe<Scalars['Int']>;
  /** Number of units that have been picked for this accessory */
  pickedQuantity?: InputMaybe<Scalars['Int']>;
  /** Display position/order of the accessory in the rental */
  position?: InputMaybe<Scalars['Int']>;
  /** Position within the rental section */
  positionInSection?: InputMaybe<Scalars['Int']>;
  /** Whether the pricing was manually selected by the user */
  pricingPickedByUser?: InputMaybe<Scalars['Boolean']>;
  /** Total quantity of this accessory in the rental */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether the quantity was manually changed by the user for this accessory */
  quantityManuallyChanged?: InputMaybe<Scalars['Boolean']>;
  /** ID of the associated rental bundle if part of a bundle */
  rentalBundleId?: InputMaybe<Scalars['Int']>;
  /** ID of the associated rental */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** Whether this accessory was manually added to the rental */
  setManually?: InputMaybe<Scalars['Boolean']>;
  /** Current status of the accessory in the rental workflow */
  status?: InputMaybe<Scalars['String']>;
  /** Whether this accessory is exempt from taxes */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when the rental accessory was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type RentalAddOn = {
  __typename?: 'RentalAddOn';
  /** Indicates if the add-on is currently active. */
  active?: Maybe<Scalars['Boolean']>;
  /** ID of the add-on being rented. */
  addOnId?: Maybe<Scalars['Int']>;
  /** Timestamp when the rental add-on was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Comma-separated customer contact names from the parent rental. */
  customerContactName?: Maybe<Scalars['String']>;
  /** Indicates if the rental add-on is exempt from damage waiver fees. */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** Delivery type of the parent rental. */
  deliveryType?: Maybe<Scalars['String']>;
  /** Name of the department associated with the rental add-on. */
  departmentName?: Maybe<Scalars['String']>;
  /** Description of the rental add-on. */
  description?: Maybe<Scalars['String']>;
  /** Multilocation group info for the parent inventory add-on */
  groupInfo?: Maybe<Scalars['JSON']>;
  /** Indicates if there is a shortage of this add-on. */
  hasShortage?: Maybe<Scalars['Boolean']>;
  /** Indicates if there is a soft hold on this add-on. */
  hasSoftHold?: Maybe<Scalars['Boolean']>;
  /** Unique identifier for the rental add-on. */
  id: Scalars['ID'];
  /** ID of the inventory item associated with this rental add-on. */
  inventoryId?: Maybe<Scalars['Int']>;
  /** Name of the parent inventory add-on */
  inventoryName?: Maybe<Scalars['String']>;
  /** Inventory item associated with this rental add-on. */
  inventoryObject?: Maybe<AddOn>;
  /** Token of the parent inventory add-on. */
  inventoryToken?: Maybe<Scalars['String']>;
  /** List of item notes associated with the rental add-on. */
  itemNotes?: Maybe<Array<ItemNote>>;
  /** Categorized inventory type: item, temp, accessory, or purchase. */
  itemType?: Maybe<Scalars['String']>;
  /** Notes regarding any lack or shortage of the add-on. */
  lackNotes?: Maybe<Scalars['String']>;
  /** Quantity of the parent inventory add-on currently under maintenance. */
  maintenanceQuantity?: Maybe<Scalars['Int']>;
  /** Name of the rental add-on. */
  name?: Maybe<Scalars['String']>;
  /** Additional notes about the rental add-on. */
  notes?: Maybe<Scalars['String']>;
  /** Number of this add-on available for rental. */
  numberAvailable?: Maybe<Scalars['Int']>;
  /** Number of this add-on available for soft hold. */
  numberAvailableForSoftHold?: Maybe<Scalars['Int']>;
  /** Parent rental associated with this add-on, if applicable. */
  parentRental?: Maybe<Rental>;
  /** Details of the pick list add-on associated with this rental add-on. */
  pickListAddOn?: Maybe<PickListAddOn>;
  /** ID of the pick list add-on associated with this rental add-on. */
  pickListAddOnId?: Maybe<Scalars['Int']>;
  /** Quantity of the add-on that is missing from the pick list. */
  pickListMissingQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the add-on that has been picked from the pick list. */
  pickListPickedQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the add-on in the pick list. */
  pickListQuantity?: Maybe<Scalars['Int']>;
  /** Status of the pick list for this add-on. */
  pickListStatus?: Maybe<Scalars['String']>;
  /** Quantity of the add-on that has been picked for the rental. */
  pickedQuantity?: Maybe<Scalars['Int']>;
  /** Pictures associated with the rental add-on. */
  pictures?: Maybe<Scalars['String']>;
  /** Position of the add-on in the rental order or bundle. */
  position?: Maybe<Scalars['Int']>;
  /** Position of the add-on within its section. */
  positionInSection?: Maybe<Scalars['Int']>;
  /** Price per unit for the rental add-on. */
  pricePerUnit?: Maybe<Scalars['Float']>;
  /** Indicates if the pricing for this add-on was picked by the user. */
  pricingPickedByUser?: Maybe<Scalars['Boolean']>;
  /** STI type identifier (items, accessories, addons). */
  productType?: Maybe<Scalars['String']>;
  /** Total quantity of the add-on available for rental. */
  quantity?: Maybe<Scalars['Int']>;
  /** ID of the rental bundle this add-on belongs to, if applicable. */
  rentalBundleId?: Maybe<Scalars['Int']>;
  /** ID of the rental associated with this add-on. */
  rentalId?: Maybe<Scalars['Int']>;
  /** Name of the rental associated with this add-on. */
  rentalName?: Maybe<Scalars['String']>;
  /** Schedule for the rental add-on. */
  rentalSchedule?: Maybe<Schedule>;
  /** Rental section this add-on belongs to (used by the section-grouped Pick List view). */
  rentalSection?: Maybe<RentalSection>;
  /** ID of the rental section this add-on belongs to, if applicable. */
  rentalSectionId?: Maybe<Scalars['Int']>;
  /** Name of the rental section this add-on belongs to. */
  rentalSectionName?: Maybe<Scalars['String']>;
  /** Current status of the rental associated with this add-on. */
  rentalStatus?: Maybe<Scalars['String']>;
  /** Token for the rental associated with this add-on. */
  rentalToken?: Maybe<Scalars['String']>;
  /** Quantity of the add-on that has been returned. */
  returnedQuantity?: Maybe<Scalars['Int']>;
  /** JSON data containing section memberships for the add-on. */
  sectionMembershipsData?: Maybe<Scalars['JSON']>;
  /** Price selected for the rental add-on. */
  selectedPrice?: Maybe<Scalars['Float']>;
  /** Raw price selected for the rental add-on, without any formatting. */
  selectedPriceRaw?: Maybe<Scalars['Float']>;
  /** Indicates if the add-on was set manually in the rental order. */
  setManually?: Maybe<Scalars['Boolean']>;
  /** Quantity short for this add-on. */
  shortageQuantity?: Maybe<Scalars['Int']>;
  /** Quantity under soft hold for this add-on. */
  softHoldQuantity?: Maybe<Scalars['Int']>;
  /** Current status of the rental add-on. */
  status?: Maybe<Scalars['String']>;
  /** List of sub-rentals associated with this add-on. */
  subRentals?: Maybe<Array<SubRental>>;
  /** Quantity of the add-on that has been sub-rented. */
  subRentedQuantity: Scalars['Int'];
  /** Indicates if the rental add-on is tax exempt. */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Reason for unavailability of the add-on, if applicable. */
  unavailabilityReason?: Maybe<Scalars['String']>;
  /** Timestamp when the rental add-on was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Location of the add-on in the warehouse. */
  warehouseLocation?: Maybe<Scalars['String']>;
  /** Total quantity of the parent inventory add-on in warehouse. */
  warehouseQuantity?: Maybe<Scalars['Int']>;
};

/** Type for reporting alerting information about rental add-ons */
export type RentalAddOnAlerting = {
  __typename?: 'RentalAddOnAlerting';
  /** Error message if there was an issue retrieving alerting information */
  error?: Maybe<Scalars['String']>;
  /** Additional metadata about the alerting information */
  meta?: Maybe<Scalars['JSON']>;
  /** List of rental add-ons that have alerting information */
  rentalAddOns?: Maybe<Array<RentalAddOn>>;
};

/** Input type for managing add-ons associated with a rental or rental bundle */
export type RentalAddOnInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Indicates whether the add-on is currently active in the rental */
  active?: InputMaybe<Scalars['Boolean']>;
  /** ID of the associated add-on master record */
  addOnId?: InputMaybe<Scalars['Int']>;
  /** Timestamp when the rental add-on was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Whether the damage waiver applies to this add-on */
  damageWaiverExempt?: InputMaybe<Scalars['Boolean']>;
  /** Detailed description of the add-on */
  description?: InputMaybe<Scalars['String']>;
  /** Date when the add-on was fulfilled */
  fulfilledDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Unique identifier for the rental add-on */
  id?: InputMaybe<Scalars['ID']>;
  /** Nested attributes for notes associated with this add-on item */
  itemNotesAttributes?: InputMaybe<Array<ItemNoteInput>>;
  /** Notes about any shortages or missing items */
  lackNotes?: InputMaybe<Scalars['String']>;
  /** Name of the add-on as it appears in the rental */
  name?: InputMaybe<Scalars['String']>;
  /** General notes about this add-on in the rental */
  notes?: InputMaybe<Scalars['String']>;
  /** Number of units of this add-on currently available */
  numberAvailable?: InputMaybe<Scalars['Int']>;
  /** Number of units of this add-on available for soft hold */
  numberAvailableForSoftHold?: InputMaybe<Scalars['Int']>;
  /** ID of the pick list add-on associated with this rental add-on */
  pickListAddOnId?: InputMaybe<Scalars['Int']>;
  /** Quantity of units of this add-on that have been picked */
  pickedQuantity?: InputMaybe<Scalars['Int']>;
  /** Display position of the add-on in the rental */
  position?: InputMaybe<Scalars['Int']>;
  /** Display position of the add-on within its rental section */
  positionInSection?: InputMaybe<Scalars['Int']>;
  /** Price per unit of this add-on */
  pricePerUnit?: InputMaybe<Scalars['Float']>;
  /** Whether the price per unit was manually selected by the user */
  pricingPickedByUser?: InputMaybe<Scalars['Boolean']>;
  /** Quantity of units of this add-on that are currently in the rental */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether the quantity was manually changed by the user for this add-on */
  quantityManuallyChanged?: InputMaybe<Scalars['Boolean']>;
  /** ID of the associated rental bundle if part of a bundle */
  rentalBundleId?: InputMaybe<Scalars['Int']>;
  /** ID of the rental to which this add-on is associated */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** ID of the rental section to which this add-on belongs */
  rentalSectionId?: InputMaybe<Scalars['Int']>;
  /** Quantity of units of this add-on that have been returned */
  returnedQuantity?: InputMaybe<Scalars['Int']>;
  /** Final price per unit after any adjustments or discounts */
  selectedPrice?: InputMaybe<Scalars['Float']>;
  /** Base price per unit before any adjustments or discounts */
  selectedPriceRaw?: InputMaybe<Scalars['Float']>;
  /** Indicates if the add-on was manually set in the rental */
  setManually?: InputMaybe<Scalars['Boolean']>;
  /** Current status of the add-on in the rental workflow */
  status?: InputMaybe<Scalars['String']>;
  /** Indicates if the add-on is exempt from taxes */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when the rental add-on was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** A rental agreement defining terms and conditions for rentals between the business and customers */
export type RentalAgreement = {
  __typename?: 'RentalAgreement';
  /** ID of the business that owns this rental agreement */
  businessId?: Maybe<Scalars['Int']>;
  /** Timestamp when the rental agreement was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Detailed terms and conditions of the rental agreement */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the rental agreement */
  id: Scalars['ID'];
  /** ID of the location this rental agreement is associated with */
  locationId?: Maybe<Scalars['Int']>;
  /** Name of the rental agreement (alias for title) */
  name?: Maybe<Scalars['String']>;
  /** Title of the rental agreement */
  title?: Maybe<Scalars['String']>;
  /** Timestamp when the rental agreement was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating a rental agreement with terms and conditions */
export type RentalAgreementInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the business that owns this rental agreement */
  businessId?: InputMaybe<Scalars['Int']>;
  /** Timestamp when the rental agreement was created (read-only, ignored on create/update) */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Detailed terms and conditions of the rental agreement */
  description?: InputMaybe<Scalars['String']>;
  /** ID of the rental agreement (required for updates) */
  id?: InputMaybe<Scalars['ID']>;
  /** ID of the location this rental agreement is associated with */
  locationId?: InputMaybe<Scalars['Int']>;
  /** Alias for title. When set, it will update the title field. */
  name?: InputMaybe<Scalars['String']>;
  /** Title of the rental agreement (required when creating a new agreement) */
  title?: InputMaybe<Scalars['String']>;
  /** Timestamp when the rental agreement was last updated (for optimistic locking) */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export enum RentalBillingStatusesEnum {
  /** Order fully paid */
  Full = 'FULL',
  /** No payment received */
  None = 'NONE',
  /** Partial fulfilment */
  Partial = 'PARTIAL'
}

/** Represents a bundle of items in a rental, with pricing and configuration options */
export type RentalBundle = {
  __typename?: 'RentalBundle';
  /** Whether this bundle is currently active in the rental */
  active?: Maybe<Scalars['Boolean']>;
  /** Multiplier for the primary rate in advanced pricing */
  advancedPricingPrimaryMultiplier?: Maybe<Scalars['Int']>;
  /** Primary rate type for advanced pricing (e.g., daily, weekly) */
  advancedPricingPrimaryRate?: Maybe<Scalars['String']>;
  /** Multiplier for the secondary rate in advanced pricing */
  advancedPricingSecondaryMultiplier?: Maybe<Scalars['Int']>;
  /** Secondary rate type for advanced pricing (e.g., monthly) */
  advancedPricingSecondaryRate?: Maybe<Scalars['String']>;
  /** ID of the bundle template this rental bundle is based on */
  bundleId?: Maybe<Scalars['Int']>;
  /** Timestamp when the bundle was added to the rental */
  createdAt: Scalars['ISO8601DateTime'];
  /** Price per day for daily rentals */
  dailyPrice?: Maybe<Scalars['Float']>;
  /** Whether this bundle is exempt from damage waiver fees */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** Detailed description of the bundle contents and features */
  description?: Maybe<Scalars['String']>;
  /** Whether this bundle is eligible for discounts */
  discountEligible?: Maybe<Scalars['Boolean']>;
  /** Percentage discount applied to this bundle */
  discountPercent?: Maybe<Scalars['Float']>;
  /** Calculated price after applying all discounts */
  discountedPrice?: Maybe<Scalars['Float']>;
  /** Manually edited flat price for the entire bundle */
  editedFlatPrice?: Maybe<Scalars['Float']>;
  /** Manually edited flat price per unit */
  editedFlatUnitPrice?: Maybe<Scalars['Float']>;
  /** Array of flat price options available for this bundle */
  flatPrices?: Maybe<Array<FlatPrice>>;
  /** Price for a half-day rental period */
  halfDayPrice?: Maybe<Scalars['Float']>;
  /** Price per hour for hourly rentals */
  hourlyPrice?: Maybe<Scalars['Float']>;
  /** Unique identifier for the rental bundle */
  id: Scalars['ID'];
  /** ID of the inventory item this bundle is associated with */
  inventoryId?: Maybe<Scalars['Int']>;
  /** The inventory item this bundle is associated with */
  inventoryObject?: Maybe<Bundle>;
  /** Array of notes associated with this bundle */
  itemNotes?: Maybe<Array<ItemNote>>;
  /** Price per month for monthly rentals */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** Display name of the bundle */
  name?: Maybe<Scalars['String']>;
  /** Additional notes or special instructions for this bundle */
  notes?: Maybe<Scalars['String']>;
  /** Rental period for this bundle (e.g., daily, weekly, monthly) */
  period?: Maybe<Scalars['String']>;
  /** Sort order position of the bundle within the rental */
  position?: Maybe<Scalars['Int']>;
  /** Sort order position within its rental section */
  positionInSection?: Maybe<Scalars['Int']>;
  /** Whether the price is locked and should not be automatically updated */
  priceLocked?: Maybe<Scalars['Boolean']>;
  /** Whether the pricing was manually selected by a user */
  pricingPickedByUser?: Maybe<Scalars['Boolean']>;
  /** Optional purchase price if the bundle is being sold */
  purchasePrice?: Maybe<Scalars['Float']>;
  /** Number of units of this bundle in the rental */
  quantity?: Maybe<Scalars['Int']>;
  /** Array of accessories included with this bundle */
  rentalAccessories?: Maybe<Array<RentalAccessory>>;
  /** Array of add-ons included with this bundle */
  rentalAddOns?: Maybe<Array<RentalAddOn>>;
  /** Discount relationships associated with this bundle */
  rentalBundleDiscountRelationships?: Maybe<Array<RentalBundleDiscountRelationship>>;
  /** Fee relationships associated with this bundle */
  rentalBundleFeeRelationships?: Maybe<Array<RentalBundleFeeRelationship>>;
  /** ID of the rental this bundle belongs to */
  rentalId?: Maybe<Scalars['Int']>;
  /** Array of rental items included in this bundle */
  rentalItems?: Maybe<Array<RentalItem>>;
  /** Name of the rental this bundle is part of */
  rentalName?: Maybe<Scalars['String']>;
  /** Scheduling information for the rental this bundle is part of */
  rentalSchedule?: Maybe<Schedule>;
  /** ID of the rental section this bundle belongs to */
  rentalSectionId?: Maybe<Scalars['Int']>;
  /** Current status of the rental this bundle belongs to */
  rentalStatus?: Maybe<Scalars['String']>;
  /** Unique token identifier for the rental */
  rentalToken?: Maybe<Scalars['String']>;
  /** The final price of the bundle after all calculations and adjustments */
  selectedPrice?: Maybe<Scalars['Float']>;
  /** The base price of the bundle before any discounts or adjustments */
  selectedPriceRaw?: Maybe<Scalars['Float']>;
  /** Whether this bundle was manually added to the rental (vs. from a template) */
  setManually?: Maybe<Scalars['Boolean']>;
  /** Tax exemption status (no_items_tax_exempt, all_items_tax_exempt, or defer_tax_exempt_status_to_children) */
  taxExemptionSetting?: Maybe<Scalars['String']>;
  /** Timestamp when the bundle was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Price per week for weekly rentals */
  weeklyPrice?: Maybe<Scalars['Float']>;
};

/** Represents the relationship between a rental bundle and a discount with specific attributes */
export type RentalBundleDiscountRelationship = {
  __typename?: 'RentalBundleDiscountRelationship';
  /** Numeric value of the discount (must be greater than 0) */
  amount?: Maybe<Scalars['Float']>;
  /** Timestamp when the relationship was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the associated discount */
  discountId?: Maybe<Scalars['Int']>;
  /** Unique identifier for the relationship */
  id: Scalars['ID'];
  /** Name of the discount as it appears in this relationship */
  name?: Maybe<Scalars['String']>;
  /** ID of the associated rental bundle */
  rentalBundleId?: Maybe<Scalars['Int']>;
  /** Timestamp when the relationship was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Type of value for the discount (e.g., amount or percentage) */
  valueType?: Maybe<Scalars['String']>;
};

/** Input type for creating or updating a relationship between a rental bundle and a discount */
export type RentalBundleDiscountRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Numeric value of the discount */
  amount?: InputMaybe<Scalars['Float']>;
  /** Timestamp when the relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** ID of the associated discount */
  discountId?: InputMaybe<Scalars['Int']>;
  /** Unique identifier for the relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the discount as it appears in this relationship */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the associated rental bundle */
  rentalBundleId?: InputMaybe<Scalars['Int']>;
  /** The type of target this discount applies to */
  targetType?: InputMaybe<Scalars['String']>;
  /** Timestamp when the relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Type of value for the discount (e.g., amount or percentage) */
  valueType?: InputMaybe<Scalars['String']>;
};

/** Represents the relationship between a rental bundle and an associated fee */
export type RentalBundleFeeRelationship = {
  __typename?: 'RentalBundleFeeRelationship';
  /** The monetary amount or percentage value of the fee */
  amount?: Maybe<Scalars['Float']>;
  /** Timestamp when this fee relationship was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ID of the fee being applied to the rental bundle */
  feeId?: Maybe<Scalars['Int']>;
  /** Unique identifier for the fee relationship */
  id: Scalars['ID'];
  /** The display name of the fee */
  name?: Maybe<Scalars['String']>;
  /** ID of the rental bundle this fee is associated with */
  rentalBundleId?: Maybe<Scalars['Int']>;
  /** Tax exemption status for this fee relationship */
  taxExempt?: Maybe<Scalars['String']>;
  /** Timestamp when this fee relationship was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The type of value for the amount (e.g., fixed, percentage) */
  valueType?: Maybe<Scalars['String']>;
};

/** Represents the relationship between a rental bundle and a fee with specific attributes */
export type RentalBundleFeeRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Numeric value of the fee (must be greater than 0) */
  amount?: InputMaybe<Scalars['Float']>;
  /** Timestamp when the relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** ID of the associated fee */
  feeId?: InputMaybe<Scalars['Int']>;
  /** Unique identifier for the relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** Name of the fee as it appears in this relationship (max 255 characters) */
  name?: InputMaybe<Scalars['String']>;
  /** ID of the associated rental bundle */
  rentalBundleId?: InputMaybe<Scalars['Int']>;
  /** The type of target this fee applies to (e.g., global or item) */
  targetType?: InputMaybe<Scalars['String']>;
  /** Whether the fee is exempt from taxes */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp when the relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Type of value for the fee (e.g., percentage or amount) */
  valueType?: InputMaybe<Scalars['String']>;
};

export type RentalCollection = {
  __typename?: 'RentalCollection';
  collection: Array<Rental>;
  metadata: CollectionMetadata;
};

export type RentalConversionLock = {
  __typename?: 'RentalConversionLock';
  /** ID of the employee who holds the lock */
  employeeId?: Maybe<Scalars['Int']>;
  /** Timestamp when the lock was acquired */
  lockedAt: Scalars['ISO8601DateTime'];
  /** ID of the rental associated with the lock */
  rentalId?: Maybe<Scalars['Int']>;
  /** ID of the rental version being converted */
  rvId?: Maybe<Scalars['Int']>;
  /** Type of lock for rental conversion */
  type: RentalConversionLockTypeEnum;
};

export enum RentalConversionLockTypeEnum {
  /** Lock for cancelling a rental */
  Cancel = 'cancel',
  /** Lock for checking in a rental */
  CheckIn = 'check_in',
  /** Lock for checking out a rental */
  CheckOut = 'check_out',
  /** Lock for closing a rental */
  Close = 'close',
  /** Lock for creating a rental */
  Create = 'create',
  /** Lock for reserving a rental */
  Reserve = 'reserve',
  /** Lock for updating a rental */
  Update = 'update'
}

/** Represents an email sent within the system, including details about the sender, recipient, and associated documents */
export type RentalEmails = {
  __typename?: 'RentalEmails';
  /** Content body of the email */
  content?: Maybe<Scalars['String']>;
  /** Documents attached to the email */
  documents?: Maybe<Array<Document>>;
  /** Unique identifier for the email */
  id: Scalars['ID'];
  /** Action of the mailer that sent the email */
  mailerAction?: Maybe<Scalars['String']>;
  /** Class of the mailer that sent the email */
  mailerKlass?: Maybe<Scalars['String']>;
  /** Email address of the recipient who opened the email */
  openedRecipient?: Maybe<Scalars['String']>;
  /** Email address of the recipient */
  recipient?: Maybe<Scalars['String']>;
  /** Name of the sender of the email */
  senderName?: Maybe<Scalars['String']>;
  /** Timestamp when the email was sent */
  sentAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/**
 * **Arguments for updating the status, picked quantity and checked in quantity of standard pick list items, pick list accessories and pick list add ons**
 *
 * ⚙️ **Usage example:**
 * ```graphql
 * mutation SetRental($input: SetRentalInput!) {
 *   setRental(input: $input) {
 *     rental {
 *       id
 *       status
 *       pickListItems { id pickedQuantity checkedInQuantity status }
 *       pickListAccessories { id pickedQuantity checkedInQuantity status }
 *     }
 *     errors {
 *       fullMessages
 *     }
 *   }
 * }
 * ```
 *
 * **Variables:**
 * ```json
 * {
 *   "input": {
 *     "rental": {
 *       "id": "360",
 *       "pickListAccessoriesAttributes": [
 *         {
 *           "id": 432,
 *           "pickedQuantity": 2,
 *           "checkedInQuantity": 2,
 *           "status": "in_use"
 *         }
 *       ],
 *       "pickListItemsAttributes": [
 *         {
 *           "id": 603,
 *           "pickedQuantity": 2,
 *           "checkedInQuantity": 2,
 *           "status": "in_use"
 *         }
 *       ],
 *       "pickListAddOnsAttributes": [
 *         {
 *           "id": 79,
 *           "pickedQuantity": 1,
 *           "status": "in_use"
 *         }
 *       ]
 *     }
 *   }
 * }
 * ```
 *
 */
export type RentalInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  pickListAccessoriesAttributes?: InputMaybe<Array<PickListInputWrapper>>;
  pickListAddOnsAttributes?: InputMaybe<Array<PickListInputWrapper>>;
  pickListItemsAttributes?: InputMaybe<Array<PickListInputWrapper>>;
};

/** Represents a collection of rental inventory items with pagination support */
export type RentalInventories = {
  __typename?: 'RentalInventories';
  /** Pagination metadata including total count, current page, and items per page */
  pagination?: Maybe<Scalars['JSON']>;
  /** List of rental items matching your search criteria, including equipment, add-ons, and bundles. */
  rentalInventories?: Maybe<Array<RentalInventory>>;
};

export type RentalInventory = RentalAccessory | RentalAddOn | RentalBundle | RentalItem | RentalStaff;

/** References a rental inventory by its ID and type, with optional _destroy flag */
export type RentalInventoryIdInput = {
  /** Indicates if the load list entry should be destroyed */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Rental Inventory ID */
  inventoryId: Scalars['ID'];
  /** Rental Inventory Type */
  inventoryType: RentalInventoryTypeEnum;
};

/** Arguments for creating or updating a Rental */
export type RentalInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Accessory ID */
  accessoryId?: InputMaybe<Scalars['Int']>;
  /** Id of the AddOn for the purchase */
  addOnId?: InputMaybe<Scalars['Int']>;
  /** Bundle ID */
  bundleId?: InputMaybe<Scalars['Int']>;
  /** Daily Price */
  dailyPrice?: InputMaybe<Scalars['Float']>;
  /** Damage Waiver Exempt */
  damageWaiverExempt?: InputMaybe<Scalars['Boolean']>;
  /** Discount Eligible */
  discountEligible?: InputMaybe<Scalars['Boolean']>;
  /** Discount Percent */
  discountPercent?: InputMaybe<Scalars['Float']>;
  /** Edited Flat Price */
  editedFlatPrice?: InputMaybe<Scalars['JSON']>;
  /** Edited Flat Unit Price */
  editedFlatUnitPrice?: InputMaybe<Scalars['JSON']>;
  /** Flat Prices */
  flatPricesAttributes?: InputMaybe<Array<FlatPriceInput>>;
  /** Half Day Price */
  halfDayPrice?: InputMaybe<Scalars['Float']>;
  /** Hourly Price */
  hourlyPrice?: InputMaybe<Scalars['Float']>;
  /** Rental Inventory ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Item Notes */
  itemNotesAttributes?: InputMaybe<Array<ItemNoteInput>>;
  /** Monthly Price */
  monthlyPrice?: InputMaybe<Scalars['Float']>;
  /** Name */
  name: Scalars['String'];
  /** Notes */
  notes?: InputMaybe<Scalars['String']>;
  /** Period */
  period?: InputMaybe<Scalars['String']>;
  /** Price Locked */
  priceLocked?: InputMaybe<Scalars['Boolean']>;
  /** Price Per Unit */
  pricePerUnit?: InputMaybe<Scalars['Float']>;
  /** Pricing Picked By User */
  pricingPickedByUser?: InputMaybe<Scalars['Boolean']>;
  /** Pricing Settings */
  pricingSettings?: InputMaybe<Scalars['JSON']>;
  /** Product ID */
  productId?: InputMaybe<Scalars['Int']>;
  /** Purchase Price */
  purchasePrice?: InputMaybe<Scalars['Float']>;
  /** Quantity */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Quantity Manually Changed */
  quantityManuallyChanged?: InputMaybe<Scalars['Boolean']>;
  /** Rental Accessories */
  rentalAccessoriesAttributes?: InputMaybe<Array<RentalAccessoryInput>>;
  /** Rental Add Ons */
  rentalAddOnsAttributes?: InputMaybe<Array<RentalAddOnInput>>;
  /** Rental Bundle Discount Relationship */
  rentalBundleDiscountRelationshipsAttributes?: InputMaybe<Array<RentalBundleDiscountRelationshipInput>>;
  /** Rental Bundle Fee Relationship */
  rentalBundleFeeRelationshipsAttributes?: InputMaybe<Array<RentalBundleFeeRelationshipInput>>;
  /** Rental Item Discount Relationship */
  rentalItemDiscountRelationshipsAttributes?: InputMaybe<Array<RentalItemDiscountRelationshipInput>>;
  /** Rental Item Fee Relationship */
  rentalItemFeeRelationshipsAttributes?: InputMaybe<Array<RentalItemFeeRelationshipInput>>;
  /** Rental Items */
  rentalItemsAttributes?: InputMaybe<Array<RentalItemInput>>;
  /** Selected Price */
  selectedPrice?: InputMaybe<Scalars['Float']>;
  /** Selected Price */
  selectedPriceRaw?: InputMaybe<Scalars['Float']>;
  /** Service quantity */
  size?: InputMaybe<Scalars['Int']>;
  /** Staff Pricing ID */
  staffPricingId?: InputMaybe<Scalars['Int']>;
  /** Staff Role */
  staffRoleAttributes?: InputMaybe<StaffRoleInput>;
  /** Staff Role ID */
  staffRoleId?: InputMaybe<Scalars['Int']>;
  /** Staff Schedule */
  staffScheduleAttributes?: InputMaybe<StaffScheduleInput>;
  /** Tax Exempt */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Tax Exemption Setting */
  taxExemptionSetting?: InputMaybe<Scalars['String']>;
  /** User Input Pricing */
  userInputPricing?: InputMaybe<Scalars['Float']>;
  /** Weekly Price */
  weeklyPrice?: InputMaybe<Scalars['Float']>;
};

export type RentalInventoryShortages = {
  __typename?: 'RentalInventoryShortages';
  rentalInventories: Array<RentalInventory>;
};

export enum RentalInventoryTypeEnum {
  RentalAccessory = 'RentalAccessory',
  RentalAddOn = 'RentalAddOn',
  RentalBundle = 'RentalBundle',
  RentalItem = 'RentalItem',
  RentalStaff = 'RentalStaff'
}

/** A rental item represents a product or service being rented as part of a rental order */
export type RentalItem = {
  __typename?: 'RentalItem';
  /** Internal field used for marking items for destruction */
  _destroy?: Maybe<Scalars['JSON']>;
  /** Whether this rental item is currently active */
  active?: Maybe<Scalars['Boolean']>;
  /** Multiplier for the primary rate in advanced pricing */
  advancedPricingPrimaryMultiplier?: Maybe<Scalars['Int']>;
  /** Primary rate type for advanced pricing calculations */
  advancedPricingPrimaryRate?: Maybe<Scalars['String']>;
  /** Multiplier for the secondary rate in advanced pricing */
  advancedPricingSecondaryMultiplier?: Maybe<Scalars['Int']>;
  /** Secondary rate type for advanced pricing calculations */
  advancedPricingSecondaryRate?: Maybe<Scalars['String']>;
  /** Number of items that have been checked in */
  checkedInQuantity?: Maybe<Scalars['Int']>;
  /** Number of items that have been checked out */
  checkedQuantity?: Maybe<Scalars['Int']>;
  /** Timestamp when the rental item was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Custom tax amount applied to this rental item */
  customTaxAmount?: Maybe<Scalars['Float']>;
  /** Comma-separated customer contact names from the parent rental */
  customerContactName?: Maybe<Scalars['String']>;
  /** Price per day for this rental item */
  dailyPrice?: Maybe<Scalars['Float']>;
  /** Whether this item is exempt from damage waiver fees */
  damageWaiverExempt?: Maybe<Scalars['Boolean']>;
  /** Number of items reported as damaged */
  damagedQuantity?: Maybe<Scalars['Int']>;
  /** Delivery type of the parent rental */
  deliveryType?: Maybe<Scalars['String']>;
  /** Name of the department responsible for this item */
  departmentName?: Maybe<Scalars['String']>;
  /** Description of the rental item */
  description?: Maybe<Scalars['String']>;
  /** Whether this item is eligible for discounts */
  discountEligible?: Maybe<Scalars['Boolean']>;
  /** Comma-separated list of discount IDs applied to this item */
  discountIds?: Maybe<Scalars['String']>;
  /** Temporarily edited flat price before saving */
  editedFlatPrice?: Maybe<Scalars['JSON']>;
  /** Temporarily edited unit price before saving */
  editedFlatUnitPrice?: Maybe<Scalars['JSON']>;
  /** Additional expenses associated with this rental item */
  expense?: Maybe<Scalars['Float']>;
  /** Flat price for this rental item, regardless of rental period */
  flatPrice?: Maybe<Scalars['Float']>;
  /** List of available flat prices for this rental item */
  flatPrices?: Maybe<Array<FlatPrice>>;
  /** Unit price details for flat rate pricing in JSON format */
  flatUnitPrice?: Maybe<Scalars['JSON']>;
  /** Multilocation group info for the parent inventory item */
  groupInfo?: Maybe<Scalars['JSON']>;
  /** Price for a half-day rental period */
  halfDayPrice?: Maybe<Scalars['Float']>;
  /** Whether there is a shortage of this item */
  hasShortage?: Maybe<Scalars['Boolean']>;
  /** Whether there is a soft hold on this item */
  hasSoftHold?: Maybe<Scalars['Boolean']>;
  /** Special hourly price during holidays */
  holidayHourlyPrice?: Maybe<Scalars['Float']>;
  /** Price per hour for this rental item */
  hourlyPrice?: Maybe<Scalars['Float']>;
  /** Unique identifier for the rental item */
  id: Scalars['ID'];
  /** ID of the inventory item */
  inventoryId?: Maybe<Scalars['Int']>;
  /** Name of the parent inventory item (product) */
  inventoryName?: Maybe<Scalars['String']>;
  /** The inventory item */
  inventoryObject?: Maybe<Product>;
  /** Token of the parent inventory item (product) */
  inventoryToken?: Maybe<Scalars['String']>;
  /** Additional notes and comments attached to this rental item */
  itemNotes?: Maybe<Array<ItemNote>>;
  /** Categorized inventory type: item, temp, accessory, or purchase */
  itemType?: Maybe<Scalars['String']>;
  /** Notes about any missing or insufficient items */
  lackNotes?: Maybe<Scalars['String']>;
  /** Previous count of missing items */
  lastMissingQuantity?: Maybe<Scalars['Int']>;
  /** Quantity of the parent inventory item currently under maintenance */
  maintenanceQuantity?: Maybe<Scalars['Int']>;
  /** Number of items reported as missing */
  missingQuantity?: Maybe<Scalars['Int']>;
  /** Price per month for this rental item */
  monthlyPrice?: Maybe<Scalars['Float']>;
  /** Name of the rental item */
  name?: Maybe<Scalars['String']>;
  /** Additional notes related to this rental item */
  notes?: Maybe<Array<Note>>;
  /** Number of this item currently available for rent */
  numberAvailable?: Maybe<Scalars['Int']>;
  /** Number available for soft hold reservations */
  numberAvailableForSoftHold?: Maybe<Scalars['Int']>;
  /** Reference to the parent rental record */
  parentRental?: Maybe<Rental>;
  /** Current status of the parent rental */
  parentRentalStatus?: Maybe<Scalars['String']>;
  /** Rental period (e.g., hourly, daily, weekly, monthly) */
  period?: Maybe<Scalars['String']>;
  /** Whether the rental period was manually overridden */
  periodIsManuallyChanged?: Maybe<Scalars['Boolean']>;
  /** Reference to the pick list item */
  pickListItem?: Maybe<PickListItem>;
  /** ID of the associated pick list item */
  pickListItemId?: Maybe<Scalars['Int']>;
  /** Number of items missing from the pick list */
  pickListMissingQuantity?: Maybe<Scalars['Int']>;
  /** Number of items that have been picked from the pick list */
  pickListPickedQuantity?: Maybe<Scalars['Int']>;
  /** Total quantity of this item in the pick list */
  pickListQuantity?: Maybe<Scalars['Int']>;
  /** Current status in the pick list workflow */
  pickListStatus?: Maybe<Scalars['String']>;
  /** Number of items that have been picked for this rental */
  pickedQuantity?: Maybe<Scalars['Int']>;
  /** URLs or paths to pictures of this rental item */
  pictures?: Maybe<Scalars['String']>;
  /** Display position of this item in the rental */
  position?: Maybe<Scalars['Int']>;
  /** Position of this item within its section */
  positionInSection?: Maybe<Scalars['Int']>;
  /** Pre-discount line subtotal including fees and custom tax — the summary_only / subtotal_strike pre-discount value */
  preDiscountSubtotal?: Maybe<Scalars['Float']>;
  /** Whether the pricing was manually selected by the user */
  pricingPickedByUser?: Maybe<Scalars['Boolean']>;
  /** ID of the product being rented */
  productId?: Maybe<Scalars['Int']>;
  /** STI type identifier (items, accessories, addons) */
  productType?: Maybe<Scalars['String']>;
  /** Number of units being rented */
  quantity?: Maybe<Scalars['Int']>;
  /** Whether the quantity was manually adjusted */
  quantityManuallyChanged?: Maybe<Scalars['Boolean']>;
  /** ID of the rental bundle this item belongs to */
  rentalBundleId?: Maybe<Scalars['Int']>;
  /** ID of the parent rental this item belongs to */
  rentalId?: Maybe<Scalars['Int']>;
  /** Custom tax relationship for this rental item */
  rentalItemCustomTaxRelationship?: Maybe<RentalItemCustomTaxRelationship>;
  /** Discount relationships associated with this rental item */
  rentalItemDiscountRelationships?: Maybe<Array<RentalItemDiscountRelationship>>;
  /** Fee relationships associated with this rental item */
  rentalItemFeeRelationships?: Maybe<Array<RentalItemFeeRelationship>>;
  /** Name or identifier of the rental */
  rentalName?: Maybe<Scalars['String']>;
  /** Scheduling information for this rental item */
  rentalSchedule?: Maybe<Schedule>;
  /** Rental section this item belongs to (used by the section-grouped Pick List view). */
  rentalSection?: Maybe<RentalSection>;
  /** ID of the rental section this item belongs to */
  rentalSectionId?: Maybe<Scalars['Int']>;
  /** Name of the rental section this item belongs to */
  rentalSectionName?: Maybe<Scalars['String']>;
  /** Current status of the rental */
  rentalStatus?: Maybe<Scalars['String']>;
  /** Unique token identifying the rental */
  rentalToken?: Maybe<Scalars['String']>;
  /** JSON data about section memberships for this item */
  sectionMembershipsData?: Maybe<Scalars['JSON']>;
  /** Currently selected flat price details in JSON format */
  selectedFlatPrice?: Maybe<Scalars['JSON']>;
  /** The currently selected price based on rental period */
  selectedPrice?: Maybe<Scalars['Float']>;
  /** Price before any discounts were applied */
  selectedPriceBeforeDiscount?: Maybe<Scalars['Float']>;
  /** The raw selected price before any formatting */
  selectedPriceRaw?: Maybe<Scalars['Float']>;
  /** Serial numbers assigned to this rental item, when the product is serialized. */
  serialNumbers: Array<Scalars['String']>;
  /** Serialized data for rental items */
  serializedRentalItemsData?: Maybe<Scalars['JSON']>;
  /** Whether this item was manually added to the rental */
  setManually?: Maybe<Scalars['Boolean']>;
  /** Quantity short for this item */
  shortageQuantity?: Maybe<Scalars['Int']>;
  /** Quantity under soft hold for this item */
  softHoldQuantity?: Maybe<Scalars['Int']>;
  /** Current status of the rental item in inventory */
  status?: Maybe<Scalars['String']>;
  /** Sub-rentals associated with this rental item */
  subRentals?: Maybe<Array<SubRental>>;
  /** Quantity of this item that is sub-rented from other sources */
  subRentedQuantity: Scalars['Int'];
  /** Name of the supplier providing this item */
  supplierName?: Maybe<Scalars['String']>;
  /** Whether this item is exempt from taxes */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** Total discounts applied to this rental item */
  totalDiscounts?: Maybe<Scalars['Float']>;
  /** Total fees applied to this rental item */
  totalFees?: Maybe<Scalars['Float']>;
  /** Reason why this item is unavailable for rental */
  unavailabilityReason?: Maybe<Scalars['String']>;
  /** Timestamp when the rental item was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Location of this item in the warehouse */
  warehouseLocation?: Maybe<Scalars['String']>;
  /** Total quantity of the parent inventory item in warehouse */
  warehouseQuantity?: Maybe<Scalars['Int']>;
  /** Price per week for this rental item */
  weeklyPrice?: Maybe<Scalars['Float']>;
};

/** Represents alerting information for rental items, including pagination support and error handling */
export type RentalItemAlerting = {
  __typename?: 'RentalItemAlerting';
  /** Error message if the alerting query failed, null otherwise */
  error?: Maybe<Scalars['String']>;
  /** Pagination metadata including total count, current page, and items per page */
  meta?: Maybe<Scalars['JSON']>;
  /** Array of rental items with their alerting information */
  rentalItems?: Maybe<Array<RentalItem>>;
};

/** Represents the relationship between a rental item and a custom tax */
export type RentalItemCustomTaxRelationship = {
  __typename?: 'RentalItemCustomTaxRelationship';
  /** Amount of the tax to be applied */
  amount?: Maybe<Scalars['Float']>;
  /** Type of amount (e.g., "percent" or "fixed") */
  amountType?: Maybe<Scalars['String']>;
  /** When this relationship was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** The custom tax being applied */
  customTax?: Maybe<CustomTax>;
  /** ID of the associated custom tax */
  customTaxId: Scalars['Int'];
  /** Unique identifier for the relationship */
  id: Scalars['ID'];
  /** Name of the tax relationship */
  name?: Maybe<Scalars['String']>;
  /** The rental item this tax is applied to */
  rentalItem?: Maybe<RentalItem>;
  /** ID of the associated rental item */
  rentalItemId: Scalars['Int'];
  /** When this relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents the relationship between a rental item and an associated discount */
export type RentalItemDiscountRelationship = {
  __typename?: 'RentalItemDiscountRelationship';
  /** The monetary amount or percentage value of the discount */
  amount?: Maybe<Scalars['Float']>;
  /** The computed monetary value (positive magnitude) this discount removes from the rental item, in the rental currency */
  computedAmount?: Maybe<Scalars['Float']>;
  /** The timestamp when this relationship was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the discount associated with the rental item */
  discountId?: Maybe<Scalars['Int']>;
  /** The unique identifier for the discount relationship */
  id?: Maybe<Scalars['ID']>;
  /** The display name of the discount */
  name?: Maybe<Scalars['String']>;
  /** The ID of the rental item this discount is associated with */
  rentalItemId?: Maybe<Scalars['Int']>;
  /** The timestamp when this relationship was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The type of discount (e.g., 'fixed', 'percentage') */
  valueType?: Maybe<Scalars['String']>;
};

/** Input type for creating or updating a relationship between a rental item and a discount */
export type RentalItemDiscountRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The monetary amount or percentage value of the discount */
  amount?: InputMaybe<Scalars['Float']>;
  /** The timestamp when this relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the discount to associate with the rental item */
  discountId?: InputMaybe<Scalars['Int']>;
  /** The unique identifier for an existing discount relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** The display name of the discount */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the rental item to associate with the discount */
  rentalItemId?: InputMaybe<Scalars['Int']>;
  /** The type of target this discount applies to */
  targetType?: InputMaybe<Scalars['String']>;
  /** The timestamp when this relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The type of discount (e.g., 'fixed', 'percentage') */
  valueType?: InputMaybe<Scalars['String']>;
};

/** Represents the relationship between a rental item and an associated fee */
export type RentalItemFeeRelationship = {
  __typename?: 'RentalItemFeeRelationship';
  /** The monetary amount or percentage value of the fee */
  amount?: Maybe<Scalars['Float']>;
  /** The computed monetary value this fee contributes to the rental item, in the rental currency */
  computedAmount?: Maybe<Scalars['Float']>;
  /** The timestamp when this relationship was created */
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the fee associated with the rental item */
  feeId?: Maybe<Scalars['Int']>;
  /** The unique identifier for the fee relationship */
  id: Scalars['ID'];
  /** The display name of the fee */
  name?: Maybe<Scalars['String']>;
  /** The ID of the rental item this fee is associated with */
  rentalItemId?: Maybe<Scalars['Int']>;
  /** Indicates if this fee is exempt from taxes */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The timestamp when this relationship was last updated */
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The type of value for the amount (e.g., 'fixed', 'percentage') */
  valueType?: Maybe<Scalars['String']>;
};

/** Input type for creating or updating a relationship between a rental item and a fee */
export type RentalItemFeeRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The monetary amount or percentage value of the fee */
  amount?: InputMaybe<Scalars['Float']>;
  /** The timestamp when this relationship was created */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the fee to associate with the rental item */
  feeId?: InputMaybe<Scalars['Int']>;
  /** The unique identifier for an existing fee relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** The display name of the fee */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the rental item this fee is associated with */
  rentalItemId?: InputMaybe<Scalars['Int']>;
  /** The type of target this fee applies to */
  targetType?: InputMaybe<Scalars['String']>;
  /** Whether this fee is exempt from taxes */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** The timestamp when this relationship was last updated */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The type of value for the amount (e.g., 'fixed', 'percentage') */
  valueType?: InputMaybe<Scalars['String']>;
};

/** Input type for creating or updating a rental item, representing a product in a rental. */
export type RentalItemInput = {
  /** Destroy */
  _destroy?: InputMaybe<Scalars['JSON']>;
  /** Whether this rental item is currently active. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Multiplier for the primary rate in advanced pricing calculations. */
  advancedPricingPrimaryMultiplier?: InputMaybe<Scalars['Int']>;
  /** The primary rate used in advanced pricing calculations. */
  advancedPricingPrimaryRate?: InputMaybe<Scalars['String']>;
  /** Multiplier for the secondary rate in advanced pricing. */
  advancedPricingSecondaryMultiplier?: InputMaybe<Scalars['Int']>;
  /** Secondary rate used in advanced pricing, if applicable. */
  advancedPricingSecondaryRate?: InputMaybe<Scalars['String']>;
  /** The quantity of items that have been checked in. */
  checkedInQuantity?: InputMaybe<Scalars['Int']>;
  /** The timestamp when this item was created. */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The daily rental price for this item. */
  dailyPrice?: InputMaybe<Scalars['Float']>;
  /** Whether this item is exempt from damage waiver fees. */
  damageWaiverExempt?: InputMaybe<Scalars['Boolean']>;
  /** The quantity of items reported as damaged. */
  damagedQuantity?: InputMaybe<Scalars['Int']>;
  /** A detailed description of the rental item. */
  description?: InputMaybe<Scalars['String']>;
  /** Whether this item is eligible for discounts. */
  discountEligible?: InputMaybe<Scalars['Boolean']>;
  /** Comma-separated list of discount IDs applied to this item. */
  discountIds?: InputMaybe<Scalars['String']>;
  /** Custom flat price overrides in JSON format. */
  editedFlatPrice?: InputMaybe<Scalars['JSON']>;
  /** Custom flat unit price overrides in JSON format. */
  editedFlatUnitPrice?: InputMaybe<Scalars['JSON']>;
  /** The cost associated with this rental item. */
  expense?: InputMaybe<Scalars['Float']>;
  /** A fixed price for this item that overrides calculated pricing. */
  flatPrice?: InputMaybe<Scalars['Float']>;
  /** Custom flat price configurations for this rental item. */
  flatPricesAttributes?: InputMaybe<Array<FlatPriceInput>>;
  /** The date when this item was fulfilled or completed. */
  fulfilledDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Special price for half-day rentals, if applicable. */
  halfDayPrice?: InputMaybe<Scalars['Float']>;
  /** Special hourly price during holidays. */
  holidayHourlyPrice?: InputMaybe<Scalars['Float']>;
  /** The hourly rental price for this item. */
  hourlyPrice?: InputMaybe<Scalars['Float']>;
  /** The unique identifier for an existing rental item. */
  id?: InputMaybe<Scalars['ID']>;
  /** Additional notes associated with this rental item. */
  itemNotesAttributes?: InputMaybe<Array<ItemNoteInput>>;
  /** Notes about any missing or lacking aspects of this item. */
  lackNotes?: InputMaybe<Scalars['String']>;
  /** The quantity of items that were missing in the previous check. */
  lastMissingQuantity?: InputMaybe<Scalars['Int']>;
  /** The quantity of items reported as missing. */
  missingQuantity?: InputMaybe<Scalars['Int']>;
  /** The monthly rental price for this item. */
  monthlyPrice?: InputMaybe<Scalars['Float']>;
  /** The display name of the rental item. */
  name?: InputMaybe<Scalars['String']>;
  /** Additional notes or special instructions for this rental item. */
  notes?: InputMaybe<Scalars['String']>;
  /** The current quantity of this item available for rental. */
  numberAvailable?: InputMaybe<Scalars['Int']>;
  /** The quantity available for soft holds (temporary reservations). */
  numberAvailableForSoftHold?: InputMaybe<Scalars['Int']>;
  /** The rental period type (e.g., 'hourly', 'daily', 'weekly', 'monthly'). */
  period?: InputMaybe<Scalars['String']>;
  /** Whether the rental period was manually changed from the default. */
  periodIsManuallyChanged?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the associated pick list item, if applicable. */
  pickListItemId?: InputMaybe<Scalars['Int']>;
  /** The quantity of items that have been picked for this rental. */
  pickedQuantity?: InputMaybe<Scalars['Int']>;
  /** The display position of this item in the rental. */
  position?: InputMaybe<Scalars['Int']>;
  /** The display position of this item within its section. */
  positionInSection?: InputMaybe<Scalars['Int']>;
  /** Whether the pricing was explicitly selected by the user. */
  pricingPickedByUser?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the product being rented. */
  productId?: InputMaybe<Scalars['Int']>;
  /** The quantity of this item being rented. */
  quantity?: InputMaybe<Scalars['Int']>;
  /** Whether the quantity was manually changed by the user. */
  quantityManuallyChanged?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the rental bundle this item belongs to, if any. */
  rentalBundleId?: InputMaybe<Scalars['Int']>;
  /** The ID of the rental this item belongs to. */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** Associated discount relationships for this rental item. */
  rentalItemDiscountRelationshipsAttributes?: InputMaybe<Array<RentalItemDiscountRelationshipInput>>;
  /** Associated fee relationships for this rental item. */
  rentalItemFeeRelationshipsAttributes?: InputMaybe<Array<RentalItemFeeRelationshipInput>>;
  /** The ID of the rental section this item belongs to, if any. */
  rentalSectionId?: InputMaybe<Scalars['Int']>;
  /** The final selected price after any adjustments. */
  selectedPrice?: InputMaybe<Scalars['Float']>;
  /** The price of this item before any discounts were applied. */
  selectedPriceBeforeDiscount?: InputMaybe<Scalars['Float']>;
  /** The unformatted selected price before any display formatting. */
  selectedPriceRaw?: InputMaybe<Scalars['Float']>;
  /** Whether the price for this item was set manually (true) or calculated (false). */
  setManually?: InputMaybe<Scalars['Boolean']>;
  /** The current status of this rental item. */
  status?: InputMaybe<Scalars['String']>;
  /** The name of the supplier providing this item. */
  supplierName?: InputMaybe<Scalars['String']>;
  /** Whether this item is exempt from taxes. */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** The type of rental item (e.g., 'RentalItemStandard', 'RentalItemTemporary'). */
  type?: InputMaybe<Scalars['String']>;
  /** The timestamp when this item was last updated. */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The weekly rental price for this item. */
  weeklyPrice?: InputMaybe<Scalars['Float']>;
};

/** Represents a section within a rental that groups related inventory items together. */
export type RentalSection = {
  __typename?: 'RentalSection';
  /** The timestamp when this section was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for this rental section, always returned as a string. */
  id: Scalars['ID'];
  /** The display name of this section. */
  name?: Maybe<Scalars['String']>;
  /** The position of this section for display ordering. */
  position?: Maybe<Scalars['Int']>;
  /** Temporary identifier used by the frontend for React component state management. */
  reactTemporaryIdentifier?: Maybe<Scalars['String']>;
  /** The ID of the rental this section belongs to. */
  rentalId?: Maybe<Scalars['Int']>;
  /** The collection of inventory items that belong to this section. */
  sectionMemberships?: Maybe<Array<SectionMembership>>;
  /** The type of this section. One of: 'default', 'addon', 'staff', 'custom', 'department', or 'category'. */
  sectionType?: Maybe<Scalars['String']>;
  /** The timestamp when this section was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating a rental section that groups related inventory items. */
export type RentalSectionInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The timestamp when this section was created. */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier for an existing rental section. */
  id?: InputMaybe<Scalars['ID']>;
  /** The display name for this section. */
  name?: InputMaybe<Scalars['String']>;
  /** The position of this section for display ordering. */
  position?: InputMaybe<Scalars['Int']>;
  /** Temporary ID used during section creation in the UI before it's saved to the database. */
  reactTemporaryIdentifier?: InputMaybe<Scalars['String']>;
  /** The ID of the rental this section belongs to. */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** Section Memberships */
  sectionMembershipsAttributes?: InputMaybe<Array<SectionMembershipInput>>;
  /** The type of this section. One of: 'default', 'addon', 'staff', 'custom', 'department', or 'category'. */
  sectionType?: InputMaybe<Scalars['String']>;
  /** The timestamp when this section was last updated. */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Configuration settings that control the display and behavior of rental-related features in the UI. */
export type RentalSetting = {
  __typename?: 'RentalSetting';
  /** When true, a credit card fee is applied to transactions. */
  applyCcFee?: Maybe<Scalars['Boolean']>;
  /** The display name for the credit card fee shown to customers. */
  ccFeeName?: Maybe<Scalars['String']>;
  /** The timestamp when these settings were created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Discount display mode for rental item tables. One of: 'summary_only', 'subtotal_strike', 'column'. */
  discountDisplay?: Maybe<Scalars['String']>;
  /** Controls how discounts are displayed. One of: 'strikeThrough', 'discountedOnly', or 'hideDiscounts'. */
  discountSetting?: Maybe<Scalars['String']>;
  /** When true, aggregated inventory prices are displayed in billing views. */
  displayAggregatedInventoryPrices?: Maybe<Scalars['Boolean']>;
  /** When true, a customer survey is included in the rental. */
  hasCustomerSurvey?: Maybe<Scalars['Boolean']>;
  /** When true, delivery information is hidden from the customer view. */
  hideDeliveryInfo?: Maybe<Scalars['Boolean']>;
  /** When true, delivery times are hidden from the customer view. */
  hideDeliveryTimes?: Maybe<Scalars['Boolean']>;
  /** When true, event dates are hidden from the customer view. */
  hideEventDates?: Maybe<Scalars['Boolean']>;
  /** When true, event times are hidden from the customer view. */
  hideEventTimes?: Maybe<Scalars['Boolean']>;
  /** The unique identifier for these rental settings, always returned as a string. */
  id: Scalars['ID'];
  /** When true, multiple delivery tickets are allowed. */
  multipleDeliveryTickets: Scalars['Boolean'];
  /** The ID of the rental these settings belong to. */
  rentalId?: Maybe<Scalars['Int']>;
  /** When true, delivery preferred time is shown to the customer. */
  showDeliveryPreferredTime?: Maybe<Scalars['Boolean']>;
  /** When true, discounted unit pricing is shown to the customer. */
  showDiscountedUnitPricingToCustomers?: Maybe<Scalars['Boolean']>;
  /** When true, discounts are displayed in the pricing breakdown. */
  showDiscountsOnPricing?: Maybe<Scalars['Boolean']>;
  /** When true, item images are shown to the customer. */
  showItemImages?: Maybe<Scalars['Boolean']>;
  /** When true, item notes are shown to the customer. */
  showItemNotes?: Maybe<Scalars['Boolean']>;
  /** When true, pickup preferred time is shown to the customer. */
  showPickupPreferredTime?: Maybe<Scalars['Boolean']>;
  /** When true, serial numbers are shown to the customer. */
  showSerialNumbers?: Maybe<Scalars['Boolean']>;
  /** When true, time-specific notes are displayed to customers. */
  showSetByTimeNotes?: Maybe<Scalars['Boolean']>;
  /** When true, subtotals are shown for each section. */
  showSubtotalsInSections?: Maybe<Scalars['Boolean']>;
  /** When true, tax breakdown is shown to the customer. */
  showTaxBreakdown?: Maybe<Scalars['Boolean']>;
  /** When true, unit pricing is shown to the customer. */
  showUnitPricingToCustomers?: Maybe<Scalars['Boolean']>;
  /** The timestamp when these settings were last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating rental settings that control UI display and behavior. */
export type RentalSettingInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** When true, applies a credit card processing fee. */
  applyCcFee?: InputMaybe<Scalars['Boolean']>;
  /** The display name for the credit card fee. */
  ccFeeName?: InputMaybe<Scalars['String']>;
  /** The timestamp when these settings were created. */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Discount display mode for rental item tables. One of: 'summary_only', 'subtotal_strike', 'column'. */
  discountDisplay?: InputMaybe<Scalars['String']>;
  /** Controls how discounts are displayed: 'strikeThrough', 'discountedOnly', or 'hideDiscounts'. */
  discountSetting?: InputMaybe<Scalars['String']>;
  /** When true, displays aggregated inventory prices in billing views. */
  displayAggregatedInventoryPrices?: InputMaybe<Scalars['Boolean']>;
  /** When true, enables a customer survey functionality. */
  hasCustomerSurvey?: InputMaybe<Scalars['Boolean']>;
  /** When true, hides delivery information from customer view. */
  hideDeliveryInfo?: InputMaybe<Scalars['Boolean']>;
  /** When true, hides delivery times from customer view. */
  hideDeliveryTimes?: InputMaybe<Scalars['Boolean']>;
  /** When true, hides event dates from customer view. */
  hideEventDates?: InputMaybe<Scalars['Boolean']>;
  /** When true, hides event times from customer view. */
  hideEventTimes?: InputMaybe<Scalars['Boolean']>;
  /** The unique identifier for an existing rental setting. */
  id?: InputMaybe<Scalars['ID']>;
  /** When true, allows creating multiple delivery tickets. */
  multipleDeliveryTickets?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the rental these settings belong to. */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** When true, shows preferred delivery time options. */
  showDeliveryPreferredTime?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows discounted unit pricing to customers. */
  showDiscountedUnitPricingToCustomers?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows discounts in the pricing breakdown. */
  showDiscountsOnPricing?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows item images to customers. */
  showItemImages?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows item notes to customers. */
  showItemNotes?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows preferred pickup time options. */
  showPickupPreferredTime?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows serial numbers to customers. */
  showSerialNumbers?: InputMaybe<Scalars['Boolean']>;
  /** When true, displays time-specific notes to customers. */
  showSetByTimeNotes?: InputMaybe<Scalars['Boolean']>;
  /** When true, displays subtotals for each section. */
  showSubtotalsInSections?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows detailed tax breakdown to customers. */
  showTaxBreakdown?: InputMaybe<Scalars['Boolean']>;
  /** When true, shows unit pricing to customers. */
  showUnitPricingToCustomers?: InputMaybe<Scalars['Boolean']>;
  /** The timestamp when these settings were last updated. */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export enum RentalSignatureStatusEnum {
  /** Signature required and received */
  Completed = 'COMPLETED',
  /** Signature not required */
  NotRequired = 'NOT_REQUIRED',
  /** Signature required and pending */
  Pending = 'PENDING'
}

/** Represents staff members assigned to a rental, including their roles, schedules, and associated costs. */
export type RentalStaff = {
  __typename?: 'RentalStaff';
  /** The calculated cost for this staff assignment based on role and duration. */
  cost?: Maybe<Scalars['Float']>;
  /** The unique identifier for this rental staff assignment, always returned as a string. */
  id: Scalars['ID'];
  /** The scheduled start time for this staff assignment. */
  inTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the inventory item this staff is associated with, if any. */
  inventoryId?: Maybe<Scalars['Int']>;
  /** The display name of the staff member or role for this assignment. */
  name?: Maybe<Scalars['String']>;
  /** The scheduled end time for this staff assignment. */
  outTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the rental this staff is assigned to. */
  rentalId?: Maybe<Scalars['Int']>;
  /** The name of the rental this staff is assigned to. */
  rentalName?: Maybe<Scalars['String']>;
  /** The schedule details of the associated rental. */
  rentalSchedule?: Maybe<Schedule>;
  /** The staff members assigned to this rental staff. */
  rentalStaffMembers?: Maybe<Array<RentalStaffMember>>;
  /** The current status of the rental this staff is assigned to. */
  rentalStatus?: Maybe<Scalars['String']>;
  /** A unique token identifier for the associated rental. */
  rentalToken?: Maybe<Scalars['String']>;
  /** The quantity of staff members assigned. Must be a non-negative number. */
  size?: Maybe<Scalars['Int']>;
  /** The pricing details for this staff assignment. */
  staffPricing?: Maybe<StaffPricing>;
  /** The ID of the associated staff pricing record. */
  staffPricingId?: Maybe<Scalars['Int']>;
  /** The staff role details for this assignment. */
  staffRole?: Maybe<StaffRole>;
  /** The ID of the staff role for this assignment. */
  staffRoleId?: Maybe<Scalars['Int']>;
  /** The schedule details for this staff assignment. */
  staffSchedule?: Maybe<StaffSchedule>;
  /** The ID of the schedule for this staff assignment. */
  staffScheduleId?: Maybe<Scalars['Int']>;
  /** Custom pricing input by the user, if applicable. */
  userInputPricing?: Maybe<Scalars['Float']>;
};

/** Arguments for creating or updating a rental staff */
export type RentalStaffInput = {
  /** Delete the rental staff */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The ID of the rental staff */
  id?: InputMaybe<Scalars['ID']>;
  /** The rental id */
  rentalId?: InputMaybe<Scalars['ID']>;
  /** The rental staff size */
  size?: InputMaybe<Scalars['Int']>;
  /** The attributes for the staff role */
  staffRole?: InputMaybe<StaffRoleInput>;
};

/** Represents a staff member assigned to a rental */
export type RentalStaffMember = {
  __typename?: 'RentalStaffMember';
  /** The employee details for this rental staff member */
  employee?: Maybe<Employee>;
  /** The ID of the associated employee */
  employeeId?: Maybe<Scalars['Int']>;
  /** The unique identifier of the rental staff member */
  id?: Maybe<Scalars['ID']>;
  /** The name of the rental staff member */
  name?: Maybe<Scalars['String']>;
  /** The ID of the associated rental staff */
  rentalStaffId?: Maybe<Scalars['Int']>;
};

export enum RentalStatusWithFunnelEnum {
  /** Rental is cancelled */
  Cancelled = 'CANCELLED',
  /** Rental is checked in */
  CheckedIn = 'CHECKED_IN',
  /** Rental is closed */
  Closed = 'CLOSED',
  /** Rental is a draft */
  Draft = 'DRAFT',
  /** Rental is in use */
  InUse = 'IN_USE',
  /** Rental is pending approval */
  Pending = 'PENDING',
  /** Rental is a quote */
  Quote = 'QUOTE',
  /** Rental is in reservation */
  Reservation = 'RESERVATION',
  /** Rental is a template */
  Template = 'TEMPLATE'
}

/** Configuration for managing how email notifications are handled for rental team members. */
export type RentalTeamEmailSetting = {
  __typename?: 'RentalTeamEmailSetting';
  /** Comma-separated list of team member emails who should be BCC (blind carbon copied) on notifications. */
  bccTeamMembers?: Maybe<Scalars['String']>;
  /** The date and time when these settings were created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for this email setting, always returned as a string. */
  id: Scalars['ID'];
  /** Comma-separated list of team member emails who should receive redirected emails. */
  redirectEmailToTeamMembers?: Maybe<Scalars['String']>;
  /** The ID of the rental these email settings are associated with. */
  rentalId?: Maybe<Scalars['Int']>;
  /** Determines if the default order email recipients should be modified for team notifications. */
  shouldChangeOrderEmailRecipients?: Maybe<Scalars['String']>;
  /** The date and time when these settings were last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Team Email Settings on a Rental */
export type RentalTeamEmailSettingInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Should the emails BCC team members? True or False. */
  bccTeamMembers?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Should the emails be redirected to the team members? True or False. */
  redirectEmailToTeamMembers?: InputMaybe<Scalars['String']>;
  /** Should it change the behavior from the default? True or False. If true other two options are relevant */
  shouldChangeOrderEmailRecipients?: InputMaybe<Scalars['String']>;
};

/** Represents a template that can be used to create or configure rentals with predefined settings. */
export type RentalTemplate = {
  __typename?: 'RentalTemplate';
  /** The unique identifier for this rental template. */
  id: Scalars['ID'];
  /** Indicates whether this template is designed for quick view/selection in the UI. */
  isQuickView: Scalars['Boolean'];
  /** The display name of the rental template. */
  name: Scalars['String'];
};

/** Represents the complete financial breakdown and calculations for a rental, including subtotals, taxes, fees, and discounts. */
export type RentalTotal = {
  __typename?: 'RentalTotal';
  /** The remaining balance to be paid after all payments and refunds. */
  amountRemaining?: Maybe<Scalars['Float']>;
  /** Detailed breakdown of all billing line items. */
  billingLines?: Maybe<Array<RentalTotalBillingLine>>;
  /** Version identifier for the pricing calculator used. */
  calculatorVersion?: Maybe<Scalars['String']>;
  /** Total fees associated with credit card processing. */
  creditCardFeeTotal?: Maybe<Scalars['Float']>;
  /** Taxable portion of damage waiver fees. */
  damageWaiverTotalForTax?: Maybe<Scalars['Float']>;
  /** Total amount of discounts applied to the rental. */
  discountTotal?: Maybe<Scalars['Float']>;
  /** Total cost of damage waivers for inventory items. */
  dmgWaiverInventoryTotal?: Maybe<Scalars['Float']>;
  /** Total of all expenses associated with the rental. */
  expenseTotal?: Maybe<Scalars['Float']>;
  /** The sum of all fees applied to the rental. */
  feeTotal?: Maybe<Scalars['Float']>;
  /** Total fees excluding damage waiver charges. */
  feeTotalExcludingDamageWaiver?: Maybe<Scalars['Float']>;
  /** The unique identifier for this rental total record. */
  id?: Maybe<Scalars['Int']>;
  /** Total cost of all inventory items in the rental. */
  inventoryTotal?: Maybe<Scalars['Float']>;
  /** Total value of inventory items considered for damage assessment. */
  inventoryTotalForDamage?: Maybe<Scalars['Float']>;
  /** Portion of inventory total that is taxable. */
  inventoryTotalForTax?: Maybe<Scalars['Float']>;
  /** Total of all damage-related fees. */
  overallDamageFeeTotal?: Maybe<Scalars['Float']>;
  /** The grand total amount for the rental after all calculations. */
  overallTotal?: Maybe<Scalars['Float']>;
  /** Remaining balance to be paid for the rental. */
  paymentBalance?: Maybe<Scalars['Float']>;
  /** Sum of all fees applied before tax calculations. */
  pretaxFeeTotal?: Maybe<Scalars['Float']>;
  /** Amount of processing fees that have been refunded. */
  processingFeeRefunded?: Maybe<Scalars['Float']>;
  /** Total amount of processing fees applied to the rental. */
  processingFeeTotal?: Maybe<Scalars['Float']>;
  /** Damage fees specific to rental accessories. */
  rentalAccessoryDamageTotal?: Maybe<Scalars['Float']>;
  /** Total cost of all add-ons included in the rental. */
  rentalAddOnTotal?: Maybe<Scalars['Float']>;
  /** Taxable portion of rental add-on costs. */
  rentalAddOnTotalForTax?: Maybe<Scalars['Float']>;
  /** Total cost of all rental bundles. */
  rentalBundleTotal?: Maybe<Scalars['Float']>;
  /** Taxable portion of rental bundle costs. */
  rentalBundleTotalForTax?: Maybe<Scalars['Float']>;
  /** The ID of the rental associated with these totals. */
  rentalId?: Maybe<Scalars['Int']>;
  /** Damage fees specific to rental items. */
  rentalItemDamageTotal?: Maybe<Scalars['Float']>;
  /** Total cost of all individual rental items. */
  rentalItemTotal?: Maybe<Scalars['Float']>;
  /** Total value of rental items considered for damage assessment. */
  rentalItemTotalForDamage?: Maybe<Scalars['Float']>;
  /** Taxable portion of rental item costs. */
  rentalItemTotalForTax?: Maybe<Scalars['Float']>;
  /** Total cost of staffing for the rental. */
  staffingTotal?: Maybe<Scalars['Float']>;
  /** Taxable portion of staffing costs. */
  staffingTotalForTax?: Maybe<Scalars['Float']>;
  /** Total of standard, non-damage related fees. */
  standardFeeTotal?: Maybe<Scalars['Float']>;
  /** The subtotal before taxes and after discounts. */
  subTotal?: Maybe<Scalars['Float']>;
  /** The subtotal amount that is subject to taxation. */
  subTotalForTax?: Maybe<Scalars['Float']>;
  /** Total fees collected by TapGoods platform. */
  tapgoodsFeeTotal?: Maybe<Scalars['Float']>;
  /** Total tax amount collected by TapGoods platform. */
  tapgoodsTaxTotal?: Maybe<Scalars['Float']>;
  /** The total amount of taxes applied to the rental. */
  taxTotal?: Maybe<Scalars['Float']>;
  /** Fee charged by TapGoods for business services. */
  tgBusinessFee?: Maybe<Scalars['Float']>;
  /** Total amount before applying transaction-related charges. */
  totalBeforeTransactionCharges?: Maybe<Scalars['Float']>;
  /** Total cost associated with delivery services. */
  totalDeliveryCost?: Maybe<Scalars['Float']>;
  /** Taxable portion of delivery costs. */
  totalDeliveryCostForTax?: Maybe<Scalars['Float']>;
  /** Total amount that has been paid towards the rental. */
  totalPaid?: Maybe<Scalars['Float']>;
  /** Total amount that has been refunded for the rental. */
  totalRefunded?: Maybe<Scalars['Float']>;
};

/** Represents a line item in the rental's billing breakdown, detailing specific charges and calculations. */
export type RentalTotalBillingLine = {
  __typename?: 'RentalTotalBillingLine';
  /** Indicates if this line is an aggregate of multiple items. */
  aggregate?: Maybe<Scalars['Boolean']>;
  /** The original value before any discounts or fees are applied. */
  baseValue?: Maybe<Scalars['Float']>;
  /** The value to which damage waiver can be applied. */
  damageWaiverAppliableValue?: Maybe<Scalars['Float']>;
  /** The amount of discount applied to this line item. */
  discountValue?: Maybe<Scalars['Float']>;
  /** Additional fees associated with this line item. */
  feeValue?: Maybe<Scalars['Float']>;
  /** The final calculated value after all adjustments. */
  finalValue?: Maybe<Scalars['Float']>;
  /** The type of charge or calculation this line represents. */
  kind?: Maybe<Scalars['String']>;
  /** The display name of this billing line item. */
  name?: Maybe<Scalars['String']>;
  /** A unique identifier for this billing line item. */
  tag?: Maybe<Scalars['String']>;
  /** The portion of the value that is subject to taxation. */
  taxableValue?: Maybe<Scalars['Float']>;
};

export type RentalTransport = {
  __typename?: 'RentalTransport';
  active?: Maybe<Scalars['Boolean']>;
  /** End date and time of the rental transport */
  cachedEndTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Start date and time of the rental transport */
  cachedStartTime?: Maybe<Scalars['ISO8601DateTime']>;
  createdAt: Scalars['ISO8601DateTime'];
  deliveryTicket?: Maybe<DeliveryTicket>;
  deliveryTicketId?: Maybe<Scalars['Int']>;
  drivers?: Maybe<Array<Driver>>;
  endDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  id: Scalars['ID'];
  rental?: Maybe<Rental>;
  rentalId?: Maybe<Scalars['Int']>;
  rentalStaffId?: Maybe<Scalars['Int']>;
  rentalTransportTruckRelationships?: Maybe<Array<RentalTransportTruckRelationship>>;
  serviceTicketId?: Maybe<Scalars['Int']>;
  startDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  transportType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Represents a relationship between a rental transport and a truck, also known as a 'Truck Stop'. */
export type RentalTransportTruckRelationship = {
  __typename?: 'RentalTransportTruckRelationship';
  /** Whether this truck stop is currently active. */
  active?: Maybe<Scalars['Boolean']>;
  /** The date and time when this truck stop was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The scheduled or actual delivery time for this stop. */
  deliveryTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier for this truck stop relationship. */
  id: Scalars['ID'];
  /** The load list for this stop. */
  loadList?: Maybe<LoadList>;
  /** The order/sequence of this stop within the route. */
  position?: Maybe<Scalars['Int']>;
  /** The ID of the rental transport associated with this stop. */
  rentalTransportId?: Maybe<Scalars['Int']>;
  /** The time required to set up at this stop. */
  setupTime?: Maybe<Scalars['Int']>;
  /** A descriptive name for this stop location. */
  stopName?: Maybe<Scalars['String']>;
  /** The type of stop (e.g., 'pickup', 'delivery', 'service'). */
  stopType?: Maybe<Scalars['String']>;
  /** The ID of the truck assigned to this stop. */
  truckId?: Maybe<Scalars['Int']>;
  /** The truck route that includes this stop. */
  truckRoute?: Maybe<TruckRoute>;
  /** The ID of the truck route this stop belongs to. */
  truckRouteId?: Maybe<Scalars['Int']>;
  /** The date and time when this truck stop was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Autogenerated input type of ResolveMissingSubrentedInventory */
export type ResolveMissingSubrentedInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /**
   * A JSON hash of the form: { <item-id>: {
   *                                                         <location_id> => <removal per location>,
   *                                                         <MANUAL-subrental_id> => <removal>
   *                                                         } }
   */
  itemsToRemove: Scalars['JSON'];
  rentalId: Scalars['ID'];
};

/** Autogenerated return type of ResolveMissingSubrentedInventory. */
export type ResolveMissingSubrentedInventoryPayload = {
  __typename?: 'ResolveMissingSubrentedInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Scalars['JSON']>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of ReturnPickedSerializedInventory */
export type ReturnPickedSerializedInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['ID'];
};

/** Autogenerated return type of ReturnPickedSerializedInventory. */
export type ReturnPickedSerializedInventoryPayload = {
  __typename?: 'ReturnPickedSerializedInventoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

/** Arguments for creating or updating a PhysicalAddress */
export type ReventalsSearchInventoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The quantity of the inventory */
  quantity: Scalars['Int'];
  /** The reventals ID for the inventory */
  reventalsInventoryId: Scalars['Int'];
};

/** Autogenerated input type of RevertChangeHistoryEntry */
export type RevertChangeHistoryEntryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  changeHistoryEntryId: Scalars['ID'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of RevertChangeHistoryEntry. */
export type RevertChangeHistoryEntryPayload = {
  __typename?: 'RevertChangeHistoryEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Role = {
  __typename?: 'Role';
  /** Whether the role is currently active. Inactive roles are considered deleted. */
  active?: Maybe<Scalars['Boolean']>;
  /** The timestamp when this role was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for the role. */
  id: Scalars['ID'];
  /** The ID of the location this role belongs to. Null for global roles. */
  locationId?: Maybe<Scalars['Int']>;
  /** The name of the role. Must be unique within the location. */
  name?: Maybe<Scalars['String']>;
  /** Unique role identifier. For global roles: 'salesperson', 'manager', 'owner', 'devops', 'warehouse_manager', or 'admin'. */
  roleKey?: Maybe<Scalars['String']>;
  /** The type of role. 0: Global (Permission Role), 1: Location, 2: Rental */
  roleType?: Maybe<Scalars['Int']>;
  /** Returns the string representation of the role_type enum value. */
  roleTypeString?: Maybe<Scalars['String']>;
  /** The timestamp when this role was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Role */
export type RoleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the role */
  name: Scalars['String'];
  /** The type of the role */
  roleType?: InputMaybe<Scalars['String']>;
  /** The type of the role */
  roleTypeString?: InputMaybe<Scalars['String']>;
};

export enum RoomActivitySettingEnum {
  /** Room activity is currently active */
  Active = 'active',
  /** Dark mode for the room activity */
  Dark = 'dark',
  /** Set up the room activity */
  SetUp = 'set_up'
}

/** Represents a sales tax configuration with rates and application rules. */
export type SalesTax = {
  __typename?: 'SalesTax';
  /** Whether this tax applies to purchased items. */
  appliesToPurchases?: Maybe<Scalars['Boolean']>;
  /** Whether this tax applies to rentable items. */
  appliesToRentables?: Maybe<Scalars['Boolean']>;
  /** Whether this tax applies to services. */
  appliesToServices?: Maybe<Scalars['Boolean']>;
  /** When this tax configuration was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Indicates if this tax was created from a tax override rule. */
  createdFromOverride?: Maybe<Scalars['Boolean']>;
  /** The unique identifier for this sales tax configuration. */
  id: Scalars['ID'];
  /** The ID of the location this tax is associated with. */
  locationId: Scalars['Int'];
  /** The name or description of this tax. */
  name: Scalars['String'];
  /** The U.S. state this tax applies to, if applicable. */
  state?: Maybe<Scalars['String']>;
  /** The tax rate expressed as a percentage (e.g., 8.25 for 8.25%). */
  taxPercent: Scalars['Float'];
  /** The type of tax (e.g., state, county, city, special). */
  taxType: Scalars['String'];
  /** When this tax configuration was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type SalesTaxCashBasisReport = {
  __typename?: 'SalesTaxCashBasisReport';
  /** Detailed sales tax information per order. */
  details?: Maybe<Array<Details>>;
  /** Summary of sales tax by location and date range. */
  summary?: Maybe<Array<Summary>>;
  /** Summary of sales tax by location and date range. */
  summaryByCounty?: Maybe<Array<Summary>>;
  /** Summary of sales tax by location and date range. */
  summaryByState?: Maybe<Array<Summary>>;
  /** Aggregated totals for the report. */
  totals?: Maybe<Totals>;
};

/** Input type for creating or updating a sales tax configuration. */
export type SalesTaxInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether this tax should apply to purchased items. */
  appliesToPurchases?: InputMaybe<Scalars['Boolean']>;
  /** Whether this tax should apply to rentable items. */
  appliesToRentables?: InputMaybe<Scalars['Boolean']>;
  /** Whether this tax should apply to services. */
  appliesToServices?: InputMaybe<Scalars['Boolean']>;
  /** The unique identifier for an existing sales tax (for updates). */
  id?: InputMaybe<Scalars['ID']>;
  /** The ID of the location this tax should be associated with. */
  locationId?: InputMaybe<Scalars['Int']>;
  /** A descriptive name for this tax configuration. */
  name?: InputMaybe<Scalars['String']>;
  /** The U.S. state this tax applies to, if applicable. */
  state?: InputMaybe<Scalars['String']>;
  /** The tax rate as a percentage (e.g., 8.25 for 8.25%). */
  taxPercent?: InputMaybe<Scalars['Float']>;
  /** The type of tax (e.g., state, county, city, special). */
  taxType?: InputMaybe<Scalars['String']>;
};

/** Represents the many-to-many relationship between sales taxes and rentals. */
export type SalesTaxRentalRelationship = {
  __typename?: 'SalesTaxRentalRelationship';
  /** When this relationship was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for this relationship. */
  id: Scalars['ID'];
  /** The ID of the rental associated with this tax relationship. */
  rentalId: Scalars['String'];
  /** The detailed sales tax information associated with this relationship. */
  salesTax?: Maybe<SalesTax>;
  /** The ID of the sales tax associated with this rental. */
  salesTaxId?: Maybe<Scalars['Int']>;
  /** When this relationship was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating a relationship between a rental and a sales tax. */
export type SalesTaxRentalRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The unique identifier for an existing relationship (for updates). */
  id?: InputMaybe<Scalars['ID']>;
  /** The ID of the rental to associate with the sales tax. */
  rentalId?: InputMaybe<Scalars['String']>;
  /** Nested attributes for creating or updating the associated sales tax. */
  salesTaxAttributes?: InputMaybe<SalesTaxInput>;
  /** The ID of an existing sales tax to associate with the rental. */
  salesTaxId?: InputMaybe<Scalars['Int']>;
};

/** Represents the scheduling details for a rental, including delivery, event, and return time windows. */
export type Schedule = {
  __typename?: 'Schedule';
  /** Indicates whether this schedule is currently active. */
  active?: Maybe<Scalars['Boolean']>;
  /** The date and time when this schedule was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The scheduled date and time when the rental items are due to be returned. */
  endDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The beginning of the return time window for the rental items. */
  endWindowBeginning?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time when the actual event being supported by this rental ends. */
  eventEndDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Preference for event end time (morning/evening/clock/no_preference/afternoon/no_delivery). */
  eventEndSetting?: Maybe<Scalars['String']>;
  /** The date and time when the actual event being supported by this rental begins. */
  eventStartDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** Preference for event start time (morning/evening/clock/no_preference/afternoon/no_delivery). */
  eventStartSetting?: Maybe<Scalars['String']>;
  /** The unique identifier for the schedule. */
  id: Scalars['ID'];
  /** The date and time when items are taken off the shelf for this rental. */
  offShelfAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The date and time when items are expected to be returned to the shelf. */
  onShelfAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** The ID of the rental this schedule belongs to. */
  rentalId?: Maybe<Scalars['Int']>;
  /** Indicates if the rental period should match the event dates. */
  sameAsEventDate?: Maybe<Scalars['Boolean']>;
  /** Indicates if shelf management is enabled for this rental. */
  shelfEnabled?: Maybe<Scalars['Boolean']>;
  /** The scheduled date and time when the rental items will be checked out. */
  startDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The end of the delivery time window for the rental items. */
  startWindowFinish?: Maybe<Scalars['ISO8601DateTime']>;
  /** The time zone in which the rental and event times are specified. */
  timeZone?: Maybe<Scalars['String']>;
  /** The date and time when this schedule was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating a rental schedule, including delivery, event, and return time windows. */
export type ScheduleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether this schedule should be marked as active. */
  active?: InputMaybe<Scalars['Boolean']>;
  /** The date and time when this schedule was created. */
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The scheduled date and time when the rental items are due to be returned. */
  endDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The beginning of the return time window for the rental items. */
  endWindowBeginning?: InputMaybe<Scalars['ISO8601DateTime']>;
  /**
   * The date and time when the actual event
   *                                                                     being supported by this rental ends.
   */
  eventEndDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Preference for event end time (morning/evening/clock/no_preference/afternoon/no_delivery). */
  eventEndSetting?: InputMaybe<Scalars['String']>;
  /**
   * The date and time when the actual event
   *                                                                                     being supported by this rental begins.
   */
  eventStartDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Preference for event start time (morning/evening/clock/no_preference/afternoon/no_delivery). */
  eventStartSetting?: InputMaybe<Scalars['String']>;
  /** The unique identifier for an existing schedule (for updates). */
  id?: InputMaybe<Scalars['ID']>;
  /**
   * The date and time when items should be
   *                                                              taken off the shelf for this rental.
   */
  offShelfAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The date and time when items are expected to be returned to the shelf. */
  onShelfAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The ID of the rental this schedule belongs to. */
  rentalId?: InputMaybe<Scalars['Int']>;
  /** When true, the rental period will match the event dates. */
  sameAsEventDate?: InputMaybe<Scalars['Boolean']>;
  /** Whether shelf management is enabled for this rental. */
  shelfEnabled?: InputMaybe<Scalars['Boolean']>;
  /** The scheduled date and time when the rental items will be checked out. */
  startDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The end of the delivery time window for the rental items. */
  startWindowFinish?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** The time zone in which the rental and event times should be interpreted. */
  timeZone?: InputMaybe<Scalars['String']>;
  /** The date and time when this schedule was last updated. */
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** Represents the membership of a rental inventory item within a rental section, including positioning and relationships. */
export type SectionMembership = {
  __typename?: 'SectionMembership';
  /** Additional inventory data stored as JSON string. */
  associatedInventoryData?: Maybe<Scalars['String']>;
  /** The timestamp when the section membership was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for the section membership. */
  id: Scalars['ID'];
  /** The type of relationship with the parent (e.g., 'duplicate'). */
  parentConnectionType?: Maybe<Scalars['String']>;
  /** The ID of the parent membership, used for duplications. */
  parentMembershipId?: Maybe<Scalars['Int']>;
  /** The position of this item within the section's ordering. */
  position?: Maybe<Scalars['Int']>;
  /** The quantity of this item in the section, overriding the inventory's default quantity. */
  quantity?: Maybe<Scalars['Int']>;
  /** The associated rental inventory item. */
  rentalInventory?: Maybe<RentalInventory>;
  /** The ID of the associated rental inventory item. */
  rentalInventoryId?: Maybe<Scalars['Int']>;
  /** The type of rental inventory (e.g., 'RentalItem', 'RentalBundle'). */
  rentalInventoryType?: Maybe<RentalInventoryTypeEnum>;
  /** The ID of the rental section this membership belongs to. */
  rentalSectionId?: Maybe<Scalars['Int']>;
  /** The React View ID for frontend reference. */
  rvId?: Maybe<Scalars['String']>;
  /** The timestamp when the section membership was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating a section membership, which connects rental inventory to rental sections. */
export type SectionMembershipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The date and time when this section membership was last updated. */
  _updatedAt?: InputMaybe<Scalars['BigInt']>;
  /** The unique identifier for an existing section membership (for updates). */
  id?: InputMaybe<Scalars['ID']>;
  /** The type of relationship with the parent (e.g., 'duplicate'). */
  parentConnectionType?: InputMaybe<Scalars['String']>;
  /** The ID of the parent membership, used when duplicating items. */
  parentMembershipId?: InputMaybe<Scalars['Int']>;
  /** The position of this item within the section's ordering. */
  position?: InputMaybe<Scalars['Int']>;
  /** Nested attributes for creating orupdating the associated rental inventory. */
  rentalInventoryAttributes?: InputMaybe<RentalInventoryInput>;
  /** The ID of the rental inventory item to associate with the section. */
  rentalInventoryId?: InputMaybe<Scalars['Int']>;
  /** The type of rental inventory (e.g., 'RentalItem', 'RentalBundle'). */
  rentalInventoryType: RentalInventoryTypeEnum;
  /** The ID of the rental section to add the inventory to. */
  rentalSectionId?: InputMaybe<Scalars['Int']>;
};

/** Represents either a Customer or an Employee */
export type Sender = Customer | Employee;

/** Represents a specific serialized product assigned to a pick list item, tracking its status and quantity. */
export type SerializedPickListItem = {
  __typename?: 'SerializedPickListItem';
  /** The unique identifier for the serialized pick list item record. */
  id: Scalars['ID'];
  /** The ID of the associated pick list item. */
  pickListItemId?: Maybe<Scalars['Int']>;
  /** The quantity of this specific serialized product to be picked. */
  quantity?: Maybe<Scalars['Int']>;
  /** The serialized product associated with this pick list item. */
  serializedProduct?: Maybe<SerializedProduct>;
  /** The current status of the item in the picking process. */
  status?: Maybe<Scalars['String']>;
};

/** Represents an individual, trackable unit of inventory with a unique identifier (serial number). */
export type SerializedProduct = {
  __typename?: 'SerializedProduct';
  /** Used for nested form submissions to mark this record for destruction. */
  _destroy?: Maybe<Scalars['String']>;
  /** Indicates whether this serialized product is currently active and available for use. */
  active?: Maybe<Scalars['Boolean']>;
  /** Indicates whether this serialized product has been archived. */
  archived?: Maybe<Scalars['Boolean']>;
  /** The date and time when this serialized product was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** An alternative identifier that can be used to track this item. */
  customId?: Maybe<Scalars['String']>;
  /** The unique identifier for the serialized product record. */
  id: Scalars['ID'];
  /** The ID of the associated product. This field is being deprecated in favor of the polymorphic inventory relationship. */
  productId?: Maybe<Scalars['Int']>;
  /** Reference to the purchase order inventory record that this serialized product was received from. */
  purchaseOrderInventoryId?: Maybe<Scalars['Int']>;
  /** The quantity of this serialized product, typically 1 for standard serialized items. */
  quantity?: Maybe<Scalars['Int']>;
  /** A unique identifier assigned to this specific inventory item. Required for serialized products. */
  serialNumber?: Maybe<Scalars['String']>;
  /** A unique token used for secure identification and API access. */
  token?: Maybe<Scalars['String']>;
  /** The date and time when this serialized product was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Input type for creating or updating a serialized product, representing a unique physical item with a serial number. */
export type SerializedProductInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The unique identifier for an existing serialized product (for updates). */
  id?: InputMaybe<Scalars['ID']>;
  /** The ID of the product this serialized item represents. Only one of product_id, accessory_id, or add_on_id should be provided. */
  productId?: InputMaybe<Scalars['ID']>;
  /** The ID of the purchase order inventory this serialized product is associated with. */
  purchaseOrderInventoryId?: InputMaybe<Scalars['ID']>;
  /** The unique serial number identifying this specific product instance. */
  serialNumber?: InputMaybe<Scalars['String']>;
};

/** Represents a service ticket for rental staff, tracking service appointments and routing information. */
export type ServiceTicket = {
  __typename?: 'ServiceTicket';
  /** The actual end time when the service was completed. */
  endDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The unique identifier for the service ticket. */
  id: Scalars['ID'];
  /** The ID of the associated rental staff record. */
  rentalStaffId?: Maybe<Scalars['Int']>;
  /** The scheduled end time for routing from the service location. */
  routingEndDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The scheduled start time for routing to the service location. */
  routingStartDateTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The actual start time when the service began. */
  startDateTime?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Autogenerated input type of SetAccessory */
export type SetAccessoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  accessory: AccessoryInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetAccessory. */
export type SetAccessoryPayload = {
  __typename?: 'SetAccessoryPayload';
  accessory?: Maybe<Accessory>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
};

/** Autogenerated input type of SetAddOn */
export type SetAddOnInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  addOn: AddOnInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetAddOn. */
export type SetAddOnPayload = {
  __typename?: 'SetAddOnPayload';
  addOn?: Maybe<AddOn>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
};

/** Autogenerated input type of SetCompanyLocationRelationship */
export type SetCompanyLocationRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  relationship: CompanyLocationRelationshipInput;
};

/** Autogenerated return type of SetCompanyLocationRelationship. */
export type SetCompanyLocationRelationshipPayload = {
  __typename?: 'SetCompanyLocationRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  company?: Maybe<CompanyLocationRelationship>;
  errors: ValidationErrors;
};

/** Autogenerated input type of SetCustomerLocationRelationship */
export type SetCustomerLocationRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  customer: CustomerLocationRelationshipInput;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetCustomerLocationRelationship. */
export type SetCustomerLocationRelationshipPayload = {
  __typename?: 'SetCustomerLocationRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  customer?: Maybe<CustomerLocationRelationship>;
  errors: ValidationErrors;
};

/** Autogenerated input type of SetEmployeeRentalRelationships */
export type SetEmployeeRentalRelationshipsInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  relationships: Array<EmployeeRentalRelationshipInput>;
};

/** Autogenerated return type of SetEmployeeRentalRelationships. */
export type SetEmployeeRentalRelationshipsPayload = {
  __typename?: 'SetEmployeeRentalRelationshipsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  employeeRentalRelationships: Array<EmployeeRentalRelationship>;
  error: Scalars['String'];
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SetEvent */
export type SetEventInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  event: EventInput;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetEvent. */
export type SetEventPayload = {
  __typename?: 'SetEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  event?: Maybe<Event>;
};

/** Autogenerated input type of SetPickList */
export type SetPickListInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  pickListAccessoriesInput?: InputMaybe<Array<PickListInputWrapper>>;
  pickListAddOnsInput?: InputMaybe<Array<PickListInputWrapper>>;
  pickListItemsInput?: InputMaybe<Array<PickListInputWrapper>>;
  rentalId: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetPickList. */
export type SetPickListPayload = {
  __typename?: 'SetPickListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  pickLists?: Maybe<Array<PickListUnion>>;
  rental?: Maybe<Rental>;
};

/** Autogenerated input type of SetProduct */
export type SetProductInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  product: ProductInput;
};

/** Autogenerated return type of SetProduct. */
export type SetProductPayload = {
  __typename?: 'SetProductPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  product?: Maybe<Product>;
};

/** Autogenerated input type of SetPurchaseOrder */
export type SetPurchaseOrderInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  purchaseOrder: PurchaseOrderInput;
  submitFromEdit?: InputMaybe<Scalars['Boolean']>;
};

/** Autogenerated return type of SetPurchaseOrder. */
export type SetPurchaseOrderPayload = {
  __typename?: 'SetPurchaseOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  purchaseOrder?: Maybe<PurchaseOrder>;
};

/** Autogenerated input type of SetRedirectHost */
export type SetRedirectHostInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  redirectHost: RedirectHostInput;
};

/** Autogenerated return type of SetRedirectHost. */
export type SetRedirectHostPayload = {
  __typename?: 'SetRedirectHostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  redirectHost?: Maybe<RedirectHost>;
};

/** Autogenerated input type of SetRefund */
export type SetRefundInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  note: NoteInput;
  refund: RefundInput;
  rentalId: Scalars['Int'];
};

/** Autogenerated return type of SetRefund. */
export type SetRefundPayload = {
  __typename?: 'SetRefundPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of SetRental */
export type SetRentalInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetRental. */
export type SetRentalPayload = {
  __typename?: 'SetRentalPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation and Exception errors */
  errors: ValidationErrors;
  /** @deprecated Pick list entities are deprecated and it will be removed and a new field will be added in a future version. */
  rental?: Maybe<Rental>;
};

/** Autogenerated input type of SetRentalStaffs */
export type SetRentalStaffsInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalStaffsArgument: Array<RentalStaffInput>;
  rentalToken: Scalars['String'];
};

/** Autogenerated return type of SetRentalStaffs. */
export type SetRentalStaffsPayload = {
  __typename?: 'SetRentalStaffsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error: Scalars['String'];
  rentalStaffs: Array<RentalStaff>;
  success: Scalars['Boolean'];
};

/** Autogenerated input type of SetRole */
export type SetRoleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  role: RoleInput;
};

/** Autogenerated return type of SetRole. */
export type SetRolePayload = {
  __typename?: 'SetRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  role?: Maybe<Role>;
};

/** Autogenerated input type of SetSecondaryOrder */
export type SetSecondaryOrderInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Rental Input Information for a given Secondary Order */
  rental: SoRentalInput;
};

/** Autogenerated return type of SetSecondaryOrder. */
export type SetSecondaryOrderPayload = {
  __typename?: 'SetSecondaryOrderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Validation errors (must be specified in payload) */
  errors: ValidationErrors;
  /** Rental Information for a given Secondary Order */
  rental?: Maybe<Rental>;
};

/** Autogenerated input type of SetStorefrontCategory */
export type SetStorefrontCategoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  sfCategory: StorefrontCategoryInput;
};

/** Autogenerated return type of SetStorefrontCategory. */
export type SetStorefrontCategoryPayload = {
  __typename?: 'SetStorefrontCategoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  sfCategory?: Maybe<StorefrontCategory>;
};

/** Autogenerated input type of SetStorefrontTag */
export type SetStorefrontTagInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  sfTag: StorefrontTagInput;
};

/** Autogenerated input type of SetStorefrontTagItemRelationship */
export type SetStorefrontTagItemRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  sfTagItemRelationship: StorefrontTagItemRelationshipInput;
};

/** Autogenerated return type of SetStorefrontTagItemRelationship. */
export type SetStorefrontTagItemRelationshipPayload = {
  __typename?: 'SetStorefrontTagItemRelationshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sfTagItemRelationship?: Maybe<StorefrontTagItemRelationship>;
};

/** Autogenerated return type of SetStorefrontTag. */
export type SetStorefrontTagPayload = {
  __typename?: 'SetStorefrontTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors?: Maybe<ValidationErrors>;
  sfTag?: Maybe<StorefrontTag>;
};

/** Autogenerated input type of SetTruckRoute */
export type SetTruckRouteInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  truckRoute: TruckRouteInput;
};

/** Autogenerated return type of SetTruckRoute. */
export type SetTruckRoutePayload = {
  __typename?: 'SetTruckRoutePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  truckRoute?: Maybe<TruckRoute>;
};

/** Autogenerated input type of SetVendor */
export type SetVendorInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  vendor: VendorInput;
};

/** Autogenerated return type of SetVendor. */
export type SetVendorPayload = {
  __typename?: 'SetVendorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  vendor?: Maybe<Vendor>;
};

/** Autogenerated input type of SetVenue */
export type SetVenueInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  venue: VenueInput;
};

/** Autogenerated return type of SetVenue. */
export type SetVenuePayload = {
  __typename?: 'SetVenuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
  venue?: Maybe<Venue>;
};

/** Autogenerated input type of SetWebhookSettings */
export type SetWebhookSettingsInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  businessId: Scalars['Int'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  webhookLive?: InputMaybe<Scalars['String']>;
  webhookMode?: InputMaybe<Scalars['String']>;
  webhookSigningKey?: InputMaybe<Scalars['String']>;
  webhookTest?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of SetWebhookSettings. */
export type SetWebhookSettingsPayload = {
  __typename?: 'SetWebhookSettingsPayload';
  business?: Maybe<Business>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: ValidationErrors;
};

/** Arguments for creating or updating a Rental */
export type SoRentalInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Extra delivery cost applied on top of the daily order's delivery cost. This value should already be reflected in delivery_cost. Secondary orders only. */
  additionalDeliveryCost?: InputMaybe<Scalars['Float']>;
  /** List of commissioned customer relationships to attach to this rental. */
  commissionedCustomerRentalRelationshipsAttributes?: InputMaybe<Array<CommissionedCustomerRentalRelationshipInput>>;
  /** Company relationship attributes for this rental. */
  companyRentalRelationshipAttributes?: InputMaybe<CompanyRentalRelationshipInput>;
  /** Overrides calculated deposit with a fixed custom amount. */
  customDepositAmount?: InputMaybe<Scalars['Float']>;
  /** External or business-defined identifier for this rental. */
  customId?: InputMaybe<Scalars['String']>;
  /** Customer relationships (primary/secondary contacts, roles, etc.). */
  customerRentalRelationshipsAttributes?: InputMaybe<Array<CustomerRentalRelationshipInput>>;
  /** Child “Daily Orders” that belong to this rental. */
  dailyRentalsAttributes?: InputMaybe<Array<SoRentalInput>>;
  /** Total damage waiver amount to charge for this rental. */
  damageWaiverFeeTotal?: InputMaybe<Scalars['Float']>;
  /** If true, exempts the damage waiver from tax. */
  damageWaiverTaxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Delivery address city. */
  deliveryAddressCity?: InputMaybe<Scalars['String']>;
  /** Delivery address country (ISO name or code). */
  deliveryAddressCountry?: InputMaybe<Scalars['String']>;
  /** Delivery address state/region/province. */
  deliveryAddressLocale?: InputMaybe<Scalars['String']>;
  /** Named delivery location (venue/site name). */
  deliveryAddressLocationName?: InputMaybe<Scalars['String']>;
  /** Delivery address postal/ZIP code. */
  deliveryAddressPostalCode?: InputMaybe<Scalars['String']>;
  /** Delivery address line 1 (street). */
  deliveryAddressStreetAddress1?: InputMaybe<Scalars['String']>;
  /** Delivery address line 2 (apt/suite/etc.). */
  deliveryAddressStreetAddress2?: InputMaybe<Scalars['String']>;
  /** Total delivery cost for this rental (includes additional_delivery_cost when applicable). */
  deliveryCost?: InputMaybe<Scalars['Float']>;
  /** If true, applies sales tax to delivery charges. */
  deliveryTaxEnabled?: InputMaybe<Scalars['Boolean']>;
  /** Delivery method (e.g., 'delivery', 'pickup', 'will_call'). */
  deliveryType?: InputMaybe<Scalars['String']>;
  /** Deposit fixed fee component (used when deposit_type is mixed/fixed). */
  depositFixedFee?: InputMaybe<Scalars['Float']>;
  /** Deposit percent (0–100) used when deposit_type is percentage or mixed. */
  depositPercent?: InputMaybe<Scalars['Float']>;
  /** If true, requires a deposit for this rental. */
  depositRequired?: InputMaybe<Scalars['Boolean']>;
  /** Deposit calculation mode (e.g., 'percentage', 'fixed', 'mixed'). */
  depositType?: InputMaybe<Scalars['String']>;
  /** List of disclaimers to attach to this rental. */
  disclaimerRentalRelationshipsAttributes?: InputMaybe<Array<DisclaimerRentalRelationshipInput>>;
  /** Line-level or order-level discounts for this rental. */
  discountRentalRelationshipsAttributes?: InputMaybe<Array<DiscountRentalRelationshipInput>>;
  /** Documents that must be collected/acknowledged for this rental. */
  documentRentalRelationshipsAttributes?: InputMaybe<Array<DocumentRentalRelationshipInput>>;
  /** Team members/staff assigned to this rental (roles, shifts, etc.). */
  employeeRentalRelationshipsAttributes?: InputMaybe<Array<EmployeeRentalRelationshipInput>>;
  /** Associated event ID (if linked to an event record). */
  eventId?: InputMaybe<Scalars['Int']>;
  /** Internal expenses/costs associated with fulfilling this rental. */
  expensesAttributes?: InputMaybe<Array<ExpenseInput>>;
  /** Additional fees (fuel, cleaning, after-hours, etc.). */
  feeRentalRelationshipsAttributes?: InputMaybe<Array<FeeRentalRelationshipInput>>;
  /** Offset in days used to compute the final payment due date. */
  finalPaymentDueDateDaysNum?: InputMaybe<Scalars['Int']>;
  /** Offset direction for final payment date (e.g., 'before', 'after'). */
  finalPaymentDueDateDaysOption?: InputMaybe<Scalars['String']>;
  /** Anchor for final payment date: 'event_start', 'event_creation', 'event_end', or 'off'. */
  finalPaymentDueDateType?: InputMaybe<Scalars['String']>;
  /** Flip (turnover) start date/time. */
  flipDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Operational notes for the flip (turnover). */
  flipNotes?: InputMaybe<Scalars['String']>;
  /** If true, exempts GST for this rental (Canada/AUS regions). */
  gstTaxExempt?: InputMaybe<Scalars['Boolean']>;
  /** If true, this rental includes a flip (turnover) window. */
  hasFlip?: InputMaybe<Scalars['Boolean']>;
  /** If true, enables a set-by time requirement. */
  hasSetByTime?: InputMaybe<Scalars['Boolean']>;
  /** If true, enables a strike (teardown) time requirement. */
  hasStrikeTime?: InputMaybe<Scalars['Boolean']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Sub-option for the job type (business-specific value). */
  jobSubOption?: InputMaybe<Scalars['String']>;
  /** Job type classification (business-specific value). */
  jobType?: InputMaybe<Scalars['String']>;
  /** If true, uses manual damage waiver values instead of automatic calculation. */
  manualDamageWaiver?: InputMaybe<Scalars['Boolean']>;
  /** Custom sales tax name/label when overriding default tax. */
  manualSalesTaxName?: InputMaybe<Scalars['String']>;
  /** Custom sales tax percent when overriding default tax. */
  manualSalesTaxPercent?: InputMaybe<Scalars['Float']>;
  /** Human-readable name/title for this rental. */
  name?: InputMaybe<Scalars['String']>;
  /** Marks subrental transfers as no-cost (for accounting/ops only). */
  noCostSubrentalTransfer?: InputMaybe<Scalars['Boolean']>;
  /** Free-form notes attached to the rental (internal or customer-visible). */
  notesAttributes?: InputMaybe<Array<NoteInput>>;
  /** Enable payment reminder #1. */
  paymentNotification1Enabled?: InputMaybe<Scalars['Boolean']>;
  /** Days offset for payment reminder #1. */
  paymentNotification1Num?: InputMaybe<Scalars['Int']>;
  /** Enable payment reminder #2. */
  paymentNotification2Enabled?: InputMaybe<Scalars['Boolean']>;
  /** Days offset for payment reminder #2. */
  paymentNotification2Num?: InputMaybe<Scalars['Int']>;
  /** Enable payment reminder #3. */
  paymentNotification3Enabled?: InputMaybe<Scalars['Boolean']>;
  /** Days offset for payment reminder #3. */
  paymentNotification3Num?: InputMaybe<Scalars['Int']>;
  /** Offset direction for payment reminders (e.g., 'before', 'after'). */
  paymentNotificationDaysOption?: InputMaybe<Scalars['String']>;
  /** What the reminder is relative to (e.g., 'event_start', 'due_date'). */
  paymentNotificationType?: InputMaybe<Scalars['String']>;
  /** Payment term code/label (e.g., 'net_30', custom terms). */
  paymentTerm?: InputMaybe<Scalars['String']>;
  /** If true, exempts PST for this rental (regional). */
  pstTaxExempt?: InputMaybe<Scalars['Boolean']>;
  /** How the customer heard about this rental (referral/channel). */
  referralSource?: InputMaybe<Scalars['String']>;
  /** Rental agreement details and acceptance options. */
  rentalAgreementAttributes?: InputMaybe<RentalAgreementInput>;
  /** Existing rental agreement ID to associate. */
  rentalAgreementId?: InputMaybe<Scalars['Int']>;
  /** Logical sections/groups within the rental (e.g., rooms/phases). */
  rentalSectionsAttributes?: InputMaybe<Array<RentalSectionInput>>;
  /** Rental display/behavior settings (hide prices/notes from customers, etc.). */
  rentalSettingAttributes?: InputMaybe<RentalSettingInput>;
  /** Notification settings for team member emails on this rental. */
  rentalTeamEmailSettingAttributes?: InputMaybe<RentalTeamEmailSettingInput>;
  /** Room activity level setting used for planning/scheduling. */
  roomActivitySetting?: InputMaybe<RoomActivitySettingEnum>;
  /** Sales tax rules/relationships applied to this rental. */
  salesTaxRentalRelationshipsAttributes?: InputMaybe<Array<SalesTaxRentalRelationshipInput>>;
  /** Sales tax strategy (e.g., 'auto', 'manual', custom logic key). */
  salesTaxSetting?: InputMaybe<Scalars['String']>;
  /** Event schedule (start/end/setup/strike windows). */
  scheduleAttributes?: InputMaybe<ScheduleInput>;
  /** Nested secondary orders to create/update with this rental. */
  secondaryOrdersAttributes?: InputMaybe<Array<SoRentalInput>>;
  /** Required “set by” date/time for completion of setup. */
  setByTimeDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Notes/instructions related to the set-by time. */
  setByTimeNotes?: InputMaybe<Scalars['String']>;
  /** If true, deposit charges are collected as a single full payment. */
  shouldDepositOneFullPayment?: InputMaybe<Scalars['Boolean']>;
  /** If true, customer signature is required. */
  signatureRequired?: InputMaybe<Scalars['Boolean']>;
  /** Enables smart pricing/optimization for this rental. */
  smartPricingActive?: InputMaybe<Scalars['Boolean']>;
  /** Workflow status of the rental (e.g., 'quote', 'reserved', 'confirmed', 'completed'). */
  status?: InputMaybe<Scalars['String']>;
  /** Strike (teardown) start date/time. */
  strikeDateTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Notes/instructions related to the strike (teardown) time. */
  strikeTimeNotes?: InputMaybe<Scalars['String']>;
  /** If true, exempts this rental from sales tax. */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
  /** Auth token or client-side correlation token for this operation. */
  token?: InputMaybe<Scalars['String']>;
  /** Rental type/class (e.g., 'ParentRental', 'SecondaryOrder', 'DailyRental'). */
  type?: InputMaybe<Scalars['String']>;
  /** Venue relationship and address/contact details for the rental. */
  venueRentalRelationshipAttributes?: InputMaybe<VenueRentalRelationshipInput>;
};

export type StaffPricing = {
  __typename?: 'StaffPricing';
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  customTitle?: Maybe<Scalars['String']>;
  /** ID */
  id: Scalars['ID'];
  locationId?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['Float']>;
  pricingType?: Maybe<Scalars['String']>;
  staffRoleId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type StaffPricingInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  active?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  customTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['Float']>;
  pricingType?: InputMaybe<Scalars['String']>;
  staffRoleId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

/** A role that can be assigned to staff members, defining their permissions and access levels */
export type StaffRole = {
  __typename?: 'StaffRole';
  /** Whether this role is currently active and available for assignment */
  active?: Maybe<Scalars['Boolean']>;
  /** Timestamp when the role was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the staff role */
  id: Scalars['ID'];
  /** ID of the location this role belongs to */
  locationId?: Maybe<Scalars['Int']>;
  /** The display name of the staff role */
  name?: Maybe<Scalars['String']>;
  /** ID of the associated recurrence rule for this role */
  recurrenceId?: Maybe<Scalars['Int']>;
  /** List of pricing rules associated with this staff role */
  staffPricings?: Maybe<Array<StaffPricing>>;
  /** Whether this role is exempt from taxes */
  taxExempt?: Maybe<Scalars['Boolean']>;
  /** The type/category of the staff role */
  type?: Maybe<Scalars['String']>;
  /** Timestamp when the role was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Staff Role */
export type StaffRoleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Staff Role ID */
  id?: InputMaybe<Scalars['ID']>;
  /** Staff Role Name */
  name?: InputMaybe<Scalars['String']>;
  /** Staff Pricings */
  staffPricingsAttributes?: InputMaybe<Array<StaffPricingInput>>;
  /** Tax Exempt */
  taxExempt?: InputMaybe<Scalars['Boolean']>;
};

export type StaffSchedule = {
  __typename?: 'StaffSchedule';
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  /** ID */
  id: Scalars['ID'];
  inTime?: Maybe<Scalars['ISO8601DateTime']>;
  outTime?: Maybe<Scalars['ISO8601DateTime']>;
  scheduleOwnerId?: Maybe<Scalars['Int']>;
  scheduleOwnerType?: Maybe<Scalars['String']>;
  showTimeInOut?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Staff Role */
export type StaffScheduleInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Active */
  active?: InputMaybe<Scalars['Boolean']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Start date and time of the service */
  inTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** End date and time of the service */
  outTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** Schedule owner type */
  scheduleOwnerType?: InputMaybe<Scalars['String']>;
};

/** Represents a top-level category in the storefront that groups related subcategories and products. */
export type StorefrontCategory = {
  __typename?: 'StorefrontCategory';
  childrenCount: Scalars['Int'];
  depth: Scalars['Int'];
  /** The unique identifier for the storefront category. */
  id: Scalars['ID'];
  importHistoryId?: Maybe<Scalars['Int']>;
  /** The ID of the location this category belongs to. Categories are scoped to a specific location. */
  locationId: Scalars['Int'];
  /** The display name of the category. Used for presentation in the storefront. */
  name: Scalars['String'];
  parentId?: Maybe<Scalars['Int']>;
  path: Scalars['String'];
  sfCategories?: Maybe<Array<StorefrontCategory>>;
  /** The list of subcategories that belong to this category. Subcategories provide more specific grouping of products. */
  sfSubCategories?: Maybe<Array<StorefrontCategory>>;
  /** A URL-friendly version of the category name, used in storefront URLs. */
  slug: Scalars['String'];
  visibleOnSf: Scalars['Boolean'];
};

export enum StorefrontCategoryDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Arguments for creating or updating a Storefront Category */
export type StorefrontCategoryInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the Storefront Category */
  id?: InputMaybe<Scalars['Int']>;
  /** Name */
  name: Scalars['String'];
  /** Parent Category ID */
  parentId?: InputMaybe<Scalars['Int']>;
  /** Slug for URL navigation on Storefront */
  slug?: InputMaybe<Scalars['String']>;
  /** Whether the category is visible on Storefront */
  visibleOnSf?: InputMaybe<Scalars['Boolean']>;
};

export enum StorefrontCategoryOrderEnum {
  Name = 'NAME',
  Path = 'PATH',
  PathHierarchical = 'PATH_HIERARCHICAL'
}

export type StorefrontSetting = {
  __typename?: 'StorefrontSetting';
  aboutusHeroDescription?: Maybe<Scalars['String']>;
  aboutusHeroTitle?: Maybe<Scalars['String']>;
  aboutusShowTeam?: Maybe<Scalars['Boolean']>;
  aboutusShowTestimonials?: Maybe<Scalars['Boolean']>;
  aboutusTeamMembersCount?: Maybe<Scalars['Int']>;
  aboutusVisible?: Maybe<Scalars['Boolean']>;
  allowRentalChanges?: Maybe<Scalars['Boolean']>;
  businessId?: Maybe<Scalars['Int']>;
  buttonStyle?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactFax?: Maybe<Scalars['String']>;
  contactFormEmail?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactShowForm?: Maybe<Scalars['Boolean']>;
  contactShowSocial?: Maybe<Scalars['Boolean']>;
  contactVisible?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  darkFontColor?: Maybe<Scalars['String']>;
  darkSecondaryColor?: Maybe<Scalars['String']>;
  domains?: Maybe<Array<Domain>>;
  fbPixelId?: Maybe<Scalars['String']>;
  firstPage?: Maybe<Scalars['String']>;
  fontStyle?: Maybe<Scalars['String']>;
  footerAboutusCopy?: Maybe<Scalars['String']>;
  footerShowAboutus?: Maybe<Scalars['Boolean']>;
  footerShowContact?: Maybe<Scalars['Boolean']>;
  footerShowNavigation?: Maybe<Scalars['Boolean']>;
  footerShowRentalAgreement?: Maybe<Scalars['Boolean']>;
  gaCode?: Maybe<Scalars['String']>;
  gaDescription?: Maybe<Scalars['String']>;
  gaKeywords?: Maybe<Scalars['String']>;
  gtmId?: Maybe<Scalars['String']>;
  homeShowSidekicks?: Maybe<Scalars['Boolean']>;
  homeShowTestimonials?: Maybe<Scalars['Boolean']>;
  homeVisible?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  lightFontColor?: Maybe<Scalars['String']>;
  lightSecondaryColor?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['Int']>;
  primaryColor?: Maybe<Scalars['String']>;
  sfCustomerFeeChargeOption?: Maybe<Scalars['String']>;
  shopAllowAutobook?: Maybe<Scalars['Boolean']>;
  shopShowItemPricing?: Maybe<Scalars['Boolean']>;
  shopVisible?: Maybe<Scalars['Boolean']>;
  socialFacebookLink?: Maybe<Scalars['String']>;
  socialFacebookVisible?: Maybe<Scalars['Boolean']>;
  socialInstagramLink?: Maybe<Scalars['String']>;
  socialInstagramVisible?: Maybe<Scalars['Boolean']>;
  socialPinterestLink?: Maybe<Scalars['String']>;
  socialPinterestVisible?: Maybe<Scalars['Boolean']>;
  socialShowOnHeader?: Maybe<Scalars['Boolean']>;
  socialTwitterLink?: Maybe<Scalars['String']>;
  socialTwitterVisible?: Maybe<Scalars['Boolean']>;
  socialYoutubeLink?: Maybe<Scalars['String']>;
  socialYoutubeVisible?: Maybe<Scalars['Boolean']>;
  storefrontEnabled?: Maybe<Scalars['Boolean']>;
  theme?: Maybe<Scalars['String']>;
  updatedAt: Scalars['ISO8601DateTime'];
};

export type StorefrontShopSetting = {
  __typename?: 'StorefrontShopSetting';
  allowedFilters?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  seoTitle?: Maybe<Scalars['String']>;
  shopShowItemPricing?: Maybe<Scalars['Boolean']>;
  sortBy?: Maybe<Scalars['String']>;
};

export type StorefrontTag = {
  __typename?: 'StorefrontTag';
  id: Scalars['ID'];
  itemCount?: Maybe<Scalars['Int']>;
  locationId: Scalars['Int'];
  name: Scalars['String'];
  sfTagItemRelationships: Array<StorefrontTagItemRelationship>;
};

export type StorefrontTagInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
};

export type StorefrontTagItemRelationship = {
  __typename?: 'StorefrontTagItemRelationship';
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  itemId: Scalars['Int'];
  itemType: InventoryTypeEnum;
  sfTag: StorefrontTag;
  sfTagId: Scalars['Int'];
  updatedAt: Scalars['ISO8601DateTime'];
};

export type StorefrontTagItemRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['ISO8601DateTime']>;
  id?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['Int']>;
  itemType?: InputMaybe<Scalars['String']>;
  sfTagId?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['ISO8601DateTime']>;
};

export type SubRental = {
  __typename?: 'SubRental';
  contact?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']>;
  customerName?: Maybe<Scalars['String']>;
  expense?: Maybe<Scalars['Float']>;
  fulfilled?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  rentalAccessoryId?: Maybe<Scalars['ID']>;
  rentalItemId?: Maybe<Scalars['ID']>;
  subRentalOwnerId?: Maybe<Scalars['Int']>;
  subRentalOwnerType?: Maybe<Scalars['String']>;
  subRentalSupplierId?: Maybe<Scalars['ID']>;
  subRentalSupplierType?: Maybe<Scalars['String']>;
  supplierLocationCode?: Maybe<Scalars['String']>;
  supplierName?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['ISO8601DateTime']>;
};

export type Summary = {
  __typename?: 'Summary';
  nontaxableVolume?: Maybe<Scalars['Float']>;
  overallTotal?: Maybe<Scalars['Float']>;
  proportionalSubTotalForTax?: Maybe<Scalars['Float']>;
  taxName?: Maybe<Scalars['String']>;
  taxPercent?: Maybe<Scalars['Float']>;
  taxType?: Maybe<Scalars['String']>;
  taxablePercent?: Maybe<Scalars['String']>;
  totalTaxPayments?: Maybe<Scalars['Float']>;
  totalTransactionVolume?: Maybe<Scalars['Float']>;
};

/** A supplier or buyer record for add-on inventory purchases */
export type Supplier = {
  __typename?: 'Supplier';
  /** Name of the employee who created the record */
  authorName: Scalars['String'];
  /** On-hand quantity after this supplier adjustment */
  balanceAfter?: Maybe<Scalars['Int']>;
  /** When the transaction was completed */
  completedAt: Scalars['ISO8601DateTime'];
  /** Cost per unit */
  cost: Scalars['Float'];
  /** Unique identifier of the supplier record */
  id: Scalars['ID'];
  /** Supplier or buyer name */
  name?: Maybe<Scalars['String']>;
  /** Notes about the transaction */
  notes?: Maybe<Scalars['String']>;
  /** Purchase order number */
  po?: Maybe<Scalars['String']>;
  /** Quantity supplied or sold */
  quantity: Scalars['Int'];
  /** supplier or buyer */
  supplierType: Scalars['String'];
  /** When the record was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** Supplier website */
  website?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of SyncRentalManuallyToQB */
export type SyncRentalManuallyToQbInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['String'];
};

/** Autogenerated return type of SyncRentalManuallyToQB. */
export type SyncRentalManuallyToQbPayload = {
  __typename?: 'SyncRentalManuallyToQBPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error: Scalars['String'];
  export?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Autogenerated input type of SyncRentalToQB */
export type SyncRentalToQbInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalId: Scalars['String'];
};

/** Autogenerated return type of SyncRentalToQB. */
export type SyncRentalToQbPayload = {
  __typename?: 'SyncRentalToQBPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  error: Scalars['String'];
  success?: Maybe<Scalars['Boolean']>;
};

export type Totals = {
  __typename?: 'Totals';
  proportionalPercent?: Maybe<Scalars['Float']>;
  proportionalSubTotalForTax?: Maybe<Scalars['Float']>;
  subTotalForTaxVolume?: Maybe<Scalars['Float']>;
  totalNonTaxableOrderVolume?: Maybe<Scalars['Float']>;
  totalOrderVolume?: Maybe<Scalars['Float']>;
  totalTransactionVolume?: Maybe<Scalars['Float']>;
};

/** A payment/transaction record tied to a rental. */
export type Transaction = {
  __typename?: 'Transaction';
  /** Whether this transaction is active. */
  active?: Maybe<Scalars['Boolean']>;
  /** Gross amount of the transaction. */
  amount?: Maybe<Scalars['Float']>;
  /** Record creation timestamp. */
  createdAt: Scalars['ISO8601DateTime'];
  /** Amount applied to satisfy credit terms. */
  creditTermSatisfactionAmount?: Maybe<Scalars['Float']>;
  /** Customer associated with the transaction. */
  customer?: Maybe<Customer>;
  /** Soft-delete timestamp (if archived). */
  deletedAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** Primary ID of the transaction. */
  id: Scalars['ID'];
  /** Marketplace fee charged to the business. */
  marketplaceBusinessFee?: Maybe<Scalars['Float']>;
  /** Marketplace fee charged to the customer. */
  marketplaceCustomerFee?: Maybe<Scalars['Float']>;
  /** When the payment occurred. */
  paymentDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Type of payment (e.g., 'cash', 'card', 'check'). */
  paymentType?: Maybe<Scalars['String']>;
  /** Processor fee charged for this transaction. */
  processingFee?: Maybe<Scalars['Float']>;
  /** Total amount refunded so far. */
  refundedAmount?: Maybe<Scalars['Float']>;
  /** ID of the related rental. */
  rentalId?: Maybe<Scalars['Int']>;
  /** System status for this transaction (e.g., 'approved', 'refunded'). */
  status?: Maybe<Scalars['String']>;
  /** Storefront fee charged to the business. */
  storefrontBusinessFee?: Maybe<Scalars['Float']>;
  /** Storefront fee charged to the customer. */
  storefrontCustomerFee?: Maybe<Scalars['Float']>;
  /** Token for the transaction. */
  token?: Maybe<Scalars['String']>;
  /** Last update timestamp. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/**
 * A vehicle used for transportation of rental items between locations.
 * Trucks can be assigned to routes and have multiple drivers.
 *
 */
export type Truck = {
  __typename?: 'Truck';
  /** Indicates if the truck is active and available for use */
  active?: Maybe<Scalars['Boolean']>;
  /** Alphabetic identifier used for sorting and display */
  alphabetId?: Maybe<Scalars['String']>;
  /** Color code (in hex format) used for visual identification */
  color?: Maybe<Scalars['String']>;
  /** Date and time when the truck was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** A description of the truck, combining its identifier and name */
  description?: Maybe<Scalars['String']>;
  /** Drivers who are authorized to operate this truck */
  drivers?: Maybe<Array<Driver>>;
  /** Unique identifier for the truck */
  id: Scalars['ID'];
  /** ID of the location this truck is associated with */
  locationId: Scalars['Int'];
  /** Name or identifier of the truck */
  name?: Maybe<Scalars['String']>;
  /** Additional information or comments about the truck */
  notes?: Maybe<Scalars['String']>;
  /** Date and time when the truck was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

export type TruckRoute = {
  __typename?: 'TruckRoute';
  /** Timestamp when the route was created */
  createdAt: Scalars['ISO8601DateTime'];
  /** Scheduled date for the delivery or pickup */
  deliveryDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** Drivers assigned to this route */
  drivers?: Maybe<Array<Driver>>;
  /** Unique identifier for the truck route */
  id: Scalars['ID'];
  /** Planned start time for the route */
  startTime?: Maybe<Scalars['ISO8601DateTime']>;
  /** The truck assigned to this route */
  truck?: Maybe<Truck>;
  /** ID of the assigned truck */
  truckId?: Maybe<Scalars['ID']>;
  /** Timestamp when the route was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Truck Route */
export type TruckRouteInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Delivery date */
  deliveryDate?: InputMaybe<Scalars['ISO8601Date']>;
  /** ID of the truck route */
  id?: InputMaybe<Scalars['ID']>;
  /** Start time */
  startTime?: InputMaybe<Scalars['ISO8601DateTime']>;
  /** ID of the truck */
  truckId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UnassignTrucksFromRentalTransport */
export type UnassignTrucksFromRentalTransportInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The ID of the RentalTransport */
  rentalTransportId: Scalars['ID'];
  /** The IDs of the Trucks */
  truckIds: Array<Scalars['ID']>;
};

/** Autogenerated return type of UnassignTrucksFromRentalTransport. */
export type UnassignTrucksFromRentalTransportPayload = {
  __typename?: 'UnassignTrucksFromRentalTransportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Array of error messages */
  errors: Array<Scalars['String']>;
  /** The RentalTransport */
  rentalTransport?: Maybe<RentalTransport>;
};

/** Autogenerated input type of UpdateColumnFilter */
export type UpdateColumnFilterInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  rentalStatus: Scalars['String'];
  settings: Scalars['JSON'];
};

/** Autogenerated return type of UpdateColumnFilter. */
export type UpdateColumnFilterPayload = {
  __typename?: 'UpdateColumnFilterPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  columnFilter?: Maybe<ColumnFilter>;
  errors: Array<Scalars['String']>;
};

/** Autogenerated input type of UpdateQuickViewTemplate */
export type UpdateQuickViewTemplateInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  locationId: Scalars['ID'];
  templateId?: InputMaybe<Scalars['ID']>;
};

/** Autogenerated return type of UpdateQuickViewTemplate. */
export type UpdateQuickViewTemplatePayload = {
  __typename?: 'UpdateQuickViewTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  errors: Array<Scalars['String']>;
  location?: Maybe<Location>;
};

export type UsageUnit = {
  __typename?: 'UsageUnit';
  /** Unique identifier for the usage unit */
  id: Scalars['ID'];
  /** ID of the location this usage unit belongs to */
  locationId?: Maybe<Scalars['Int']>;
  /** The display name of the usage unit */
  name?: Maybe<Scalars['String']>;
  /** The type of unit measurement (additive, cumulative, or gauge) */
  unitType?: Maybe<Scalars['String']>;
};

export type ValidationErrors = {
  __typename?: 'ValidationErrors';
  details?: Maybe<Array<FieldError>>;
  fullMessages?: Maybe<Array<Scalars['String']>>;
};

/** Represents a vendor or supplier that provides products or services to the business. */
export type Vendor = {
  __typename?: 'Vendor';
  /** The date and time when the vendor was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The primary email address for the vendor. */
  emailAddress?: Maybe<EmailAddress>;
  /** The unique identifier for the vendor. */
  id: Scalars['ID'];
  /** The ID of the location this vendor is associated with. */
  locationId?: Maybe<Scalars['Int']>;
  /** The name of the vendor. Required and must be unique within the location. */
  name?: Maybe<Scalars['String']>;
  /** The primary contact phone number for the vendor. */
  phoneNumber?: Maybe<PhoneNumber>;
  /** The physical address information for the vendor. */
  physicalAddress?: Maybe<PhysicalAddress>;
  /** SMS contact number for the vendor. */
  sms?: Maybe<Scalars['String']>;
  /** The date and time when the vendor was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** Arguments for creating or updating a Vendor */
export type VendorInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Vendor's email */
  emailAddressAttributes?: InputMaybe<EmailAddressInput>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Vendor's name */
  name?: InputMaybe<Scalars['String']>;
  /** Vendor's phone number */
  phoneNumberAttributes?: InputMaybe<PhoneNumberInput>;
  /** Vendor's physical address */
  physicalAddressAttributes?: InputMaybe<PhysicalAddressInput>;
  /** Vendor's SMS */
  sms?: InputMaybe<Scalars['String']>;
};

/** Represents a venue location where events can take place, with associated contact information and relationships. */
export type Venue = {
  __typename?: 'Venue';
  /** Indicates if the venue is currently active in the system. Inactive venues are not available for new events or rentals. */
  active?: Maybe<Scalars['Boolean']>;
  /** The timestamp when the venue was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** A list of documents associated with this venue. */
  documents?: Maybe<Array<Document>>;
  /** A list of email addresses associated with this venue. */
  emailAddresses?: Maybe<Array<EmailAddress>>;
  /** The unique identifier for the venue. */
  id: Scalars['ID'];
  /** Reference to the import record if this venue was imported from an external source. */
  importHistoryId?: Maybe<Scalars['Int']>;
  /** The primary physical address for contacting this venue. */
  mainContactAddress?: Maybe<PhysicalAddress>;
  /** The name of the venue. Required and must be unique. Maximum 255 characters. */
  name?: Maybe<Scalars['String']>;
  /** A list of name variants or aliases for this venue. */
  names?: Maybe<Array<Name>>;
  /** Additional notes or details about the venue. Free-form text field. */
  notes?: Maybe<Scalars['String']>;
  /** A list of phone numbers associated with this venue. */
  phoneNumbers?: Maybe<Array<PhoneNumber>>;
  /** A list of physical addresses associated with this venue. */
  physicalAddresses?: Maybe<Array<PhysicalAddress>>;
  /** A unique token that can be used to reference this venue. */
  token?: Maybe<Scalars['String']>;
  /** The timestamp when the venue was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The ID of the user who created this venue record. */
  userId?: Maybe<Scalars['Int']>;
  /** The relationships between this venue and its associated business locations. */
  venueLocationRelationships?: Maybe<Array<VenueLocationRelationship>>;
  /** The relationships between this venue and its associated rentals. */
  venueRentalRelationships?: Maybe<Array<VenueRentalRelationship>>;
};

/** Arguments for creating or updating a Venue */
export type VenueInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** The attributes for venue emails */
  emailAddressesAttributes?: InputMaybe<Array<EmailAddressInput>>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The name of the venue */
  name?: InputMaybe<Scalars['String']>;
  /** The attributes for venue contact names */
  namesAttributes?: InputMaybe<Array<NameInput>>;
  /** The attributes for the phone numbers */
  phoneNumbersAttributes?: InputMaybe<Array<PhoneNumberInput>>;
  /** The attributes for venue physical adresses */
  physicalAddressesAttributes?: InputMaybe<Array<PhysicalAddressInput>>;
  /** The attributes for venue location relationships */
  venueLocationRelationshipsAttributes?: InputMaybe<Array<VenueLocationRelationshipInput>>;
};

/** Represents the relationship between a venue and a location */
export type VenueLocationRelationship = {
  __typename?: 'VenueLocationRelationship';
  /** Timestamp when the venue was associated with the location */
  createdAt: Scalars['ISO8601DateTime'];
  /** Unique identifier for the venue-location relationship */
  id: Scalars['ID'];
  /** The ID of the associated location */
  locationId?: Maybe<Scalars['Int']>;
  /** Timestamp when the venue-location relationship was last updated */
  updatedAt: Scalars['ISO8601DateTime'];
  /** The ID of the associated venue */
  venueId?: Maybe<Scalars['Int']>;
};

/** Arguments for creating or updating a VenueLocationRelationship */
export type VenueLocationRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** The id of the location */
  locationId?: InputMaybe<Scalars['Int']>;
  /** The id of the venue */
  venueId?: InputMaybe<Scalars['Int']>;
};

export type VenueRentalRelationship = {
  __typename?: 'VenueRentalRelationship';
  active?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['ISO8601DateTime'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  rentalId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['ISO8601DateTime'];
  venue?: Maybe<Venue>;
  venueId?: Maybe<Scalars['Int']>;
};

/** Input type for creating or updating a venue rental relationship */
export type VenueRentalRelationshipInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Whether the venue is currently active for this rental */
  active?: InputMaybe<Scalars['Boolean']>;
  /** Unique identifier for the venue rental relationship */
  id?: InputMaybe<Scalars['ID']>;
  /** The unique identifier of the associated rental */
  rentalId?: InputMaybe<Scalars['String']>;
  /** Attributes for the associated venue. When provided, will create or update the venue record. */
  venueAttributes?: InputMaybe<VenueInput>;
  /** The unique identifier of the associated venue */
  venueId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of WorldpayHostedPaymentSetup */
export type WorldpayHostedPaymentSetupInput = {
  /** Delete the relationship, '1' or '0', empty also does not destroy */
  _destroy?: InputMaybe<Scalars['String']>;
  /** Public origin of this API (scheme + host + optional non-default port), used for Worldpay return/cancel URLs */
  apiBaseUrl: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** ID of the object you're updating */
  id?: InputMaybe<Scalars['String']>;
  /** Optional URL and customer overrides */
  setupOptions?: InputMaybe<WorldpayHostedPaymentSetupOptionsInput>;
};

/** Optional URL and customer fields for Worldpay hosted payment setup */
export type WorldpayHostedPaymentSetupOptionsInput = {
  /** Optional override for the cancel URL */
  cancelUrl?: InputMaybe<Scalars['String']>;
  /** Optional customer ID for the return/cancel URL query params */
  customerId?: InputMaybe<Scalars['String']>;
  /** Optional customer type for the return/cancel URL query params */
  customerType?: InputMaybe<Scalars['String']>;
  /** Optional reference number (defaults to generated value) */
  referenceNumber?: InputMaybe<Scalars['String']>;
  /** Optional override for the return URL after payment */
  returnUrl?: InputMaybe<Scalars['String']>;
  /** Optional ticket number (defaults to generated value) */
  ticketNumber?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of WorldpayHostedPaymentSetup. */
export type WorldpayHostedPaymentSetupPayload = {
  __typename?: 'WorldpayHostedPaymentSetupPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Error message when setup failed */
  error?: Maybe<Scalars['String']>;
  /** URL to redirect the user to for card entry */
  redirectUrl?: Maybe<Scalars['String']>;
  /** Reference number for this setup */
  referenceNumber?: Maybe<Scalars['String']>;
  /** Ticket number for this setup */
  ticketNumber?: Maybe<Scalars['String']>;
  /** Worldpay transaction setup ID */
  transactionSetupId?: Maybe<Scalars['String']>;
  /** Validation code from Worldpay */
  validationCode?: Maybe<Scalars['String']>;
};

export type ZipCodeDeliveryFee = {
  __typename?: 'ZipCodeDeliveryFee';
  /** The delivery fee amount. Must be a positive number less than $99,999,999. */
  amount: Scalars['Float'];
  /** The timestamp when this delivery fee rule was created. */
  createdAt: Scalars['ISO8601DateTime'];
  /** The unique identifier for the delivery fee record. */
  id: Scalars['ID'];
  /** The ID of the location this delivery fee applies to. */
  locationId?: Maybe<Scalars['Int']>;
  /** A name for this delivery fee rule. Required, maximum 255 characters. */
  name: Scalars['String'];
  /** The timestamp when this delivery fee rule was last updated. */
  updatedAt: Scalars['ISO8601DateTime'];
  /**
   * Array of ZIP/postal codes this fee applies to.
   * US ZIP codes must be 5 digits (e.g., '90210').
   * Canadian postal codes must follow the format 'A1B 2C3'.
   * Each code must be unique within the location.
   *
   */
  zipCodes: Scalars['String'];
};

export type SetRentalStaffsMutationVariables = Exact<{
  input: SetRentalStaffsInput;
}>;


export type SetRentalStaffsMutation = { __typename?: 'Mutation', setRentalStaffs?: { __typename?: 'SetRentalStaffsPayload', success: boolean, error: string, rentalStaffs: Array<{ __typename?: 'RentalStaff', id: string, size?: number | null, rentalId?: number | null, staffRole?: { __typename?: 'StaffRole', id: string, name?: string | null } | null }> } | null };

export type SetEmployeeRentalRelationshipsMutationVariables = Exact<{
  input: SetEmployeeRentalRelationshipsInput;
}>;


export type SetEmployeeRentalRelationshipsMutation = { __typename?: 'Mutation', setEmployeeRentalRelationships?: { __typename?: 'SetEmployeeRentalRelationshipsPayload', success: boolean, error: string, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, rentalId?: number | null, employee: { __typename?: 'Employee', id: string, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null }, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, role: { __typename?: 'Role', id: string, name?: string | null, roleTypeString?: string | null } }> | null }> } | null };

export type GetRentalsByDateQueryVariables = Exact<{
  strikeDateTimeGte?: InputMaybe<Scalars['String']>;
  strikeDateTimeLte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeGte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeLte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeLte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeGte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['String']>;
  deliveryDateGte?: InputMaybe<Scalars['String']>;
  deliveryDateLte?: InputMaybe<Scalars['String']>;
  pickUpDateGte?: InputMaybe<Scalars['String']>;
  pickUpDateLte?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  venueName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetRentalsByDateQuery = { __typename?: 'Query', getRentalsByDate: Array<{ __typename?: 'Rental', id: string, name?: string | null, strikeDateTime?: string | Date | null, setByTimeDateTime?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, deliveryDate?: string | Date | null, pickUpDate?: string | Date | null, token?: string | null, status?: string | null, earliestPickListStatus?: string | null, deliveryType?: string | null, alerting?: boolean | null, type?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, primaryContactId?: number | null, parentRentalToken?: string | null, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, createdAt: string | Date, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employee?: { __typename?: 'Employee', id: string, name?: string | null } | null }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, rentalId?: number | null, employee: { __typename?: 'Employee', id: string, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null }, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, role: { __typename?: 'Role', id: string, name?: string | null, roleTypeString?: string | null } }> | null }>, employees: Array<{ __typename?: 'Employee', id: string, name?: string | null }>, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null, schedule?: { __typename?: 'Schedule', id: string, timeZone?: string | null } | null, customerLocationRelationships: Array<{ __typename?: 'CustomerLocationRelationship', id: string, email?: string | null, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null }>, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null, mainContactEmail?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null } | null, rentalLabors?: Array<{ __typename?: 'RentalStaff', id: string, size?: number | null, rentalId?: number | null, staffRole?: { __typename?: 'StaffRole', id: string, name?: string | null } | null }> | null, secondaryOrder?: { __typename?: 'Rental', id: string, name?: string | null, activitySettingCycles?: Array<Array<number>> | null, customerLocationRelationships: Array<{ __typename?: 'CustomerLocationRelationship', id: string, email?: string | null, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null }>, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null, mainContactEmail?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null } | null, rentalLabors?: Array<{ __typename?: 'RentalStaff', id: string, size?: number | null, rentalId?: number | null, staffRole?: { __typename?: 'StaffRole', id: string, name?: string | null } | null }> | null, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, rentalId?: number | null, employee: { __typename?: 'Employee', id: string, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null }, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, role: { __typename?: 'Role', id: string, name?: string | null, roleTypeString?: string | null } }> | null }> } | null }> };

export type GetRentalsByDateVerticalQueryVariables = Exact<{
  strikeDateTimeGte?: InputMaybe<Scalars['String']>;
  strikeDateTimeLte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeGte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeLte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeLte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeGte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['String']>;
  deliveryDateGte?: InputMaybe<Scalars['String']>;
  deliveryDateLte?: InputMaybe<Scalars['String']>;
  pickUpDateGte?: InputMaybe<Scalars['String']>;
  pickUpDateLte?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  venueName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  parentToken?: InputMaybe<Scalars['String']>;
  query?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetRentalsByDateVerticalQuery = { __typename?: 'Query', getRentalsByDateVertical: { __typename?: 'RentalCollection', collection: Array<{ __typename?: 'Rental', id: string, name?: string | null, strikeDateTime?: string | Date | null, setByTimeDateTime?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, token?: string | null, status?: string | null, type?: string | null, earliestPickListStatus?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, primaryContactId?: number | null, parentRentalToken?: string | null, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, createdAt: string | Date, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employee?: { __typename?: 'Employee', id: string, name?: string | null } | null }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, rentalId?: number | null, employee: { __typename?: 'Employee', id: string, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null }, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, role: { __typename?: 'Role', id: string, name?: string | null, roleTypeString?: string | null } }> | null }>, employees: Array<{ __typename?: 'Employee', id: string, name?: string | null }>, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null, schedule?: { __typename?: 'Schedule', id: string, timeZone?: string | null } | null, customerLocationRelationships: Array<{ __typename?: 'CustomerLocationRelationship', id: string, email?: string | null, name?: string | null }>, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null, mainContactEmail?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null } | null, rentalLabors?: Array<{ __typename?: 'RentalStaff', id: string, size?: number | null, rentalId?: number | null, staffRole?: { __typename?: 'StaffRole', id: string, name?: string | null } | null }> | null, pickListItems: Array<{ __typename?: 'PickListItem', id: string, quantity?: number | null, name?: string | null }>, pickListAccessories: Array<{ __typename?: 'PickListAccessory', id: string, quantity?: number | null, name?: string | null }>, pickListAddOns: Array<{ __typename?: 'PickListAddOn', id: string, quantity?: number | null, name?: string | null }>, rentalStaffs: Array<{ __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRole?: { __typename?: 'StaffRole', type?: string | null } | null }>, secondaryOrder?: { __typename?: 'Rental', id: string, name?: string | null, activitySettingCycles?: Array<Array<number>> | null, customerLocationRelationships: Array<{ __typename?: 'CustomerLocationRelationship', id: string, email?: string | null, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null }>, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null, mainContactEmail?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null } | null, rentalLabors?: Array<{ __typename?: 'RentalStaff', id: string, size?: number | null, rentalId?: number | null, staffRole?: { __typename?: 'StaffRole', id: string, name?: string | null } | null }> | null, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, rentalId?: number | null, employee: { __typename?: 'Employee', id: string, name?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null }, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, role: { __typename?: 'Role', id: string, name?: string | null, roleTypeString?: string | null } }> | null }> } | null, rentalTransports: Array<{ __typename?: 'RentalTransport', id: string, transportType?: string | null }> }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type GetSimplifiedPaginatedRentalsQueryVariables = Exact<{
  strikeDateTimeGte?: InputMaybe<Scalars['String']>;
  strikeDateTimeLte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeGte?: InputMaybe<Scalars['String']>;
  setByTimeDateTimeLte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['String']>;
  eventStartDateTimeLte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeGte?: InputMaybe<Scalars['String']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  venueName?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  employeesWithRoleIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  earliestPickListStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetSimplifiedPaginatedRentalsQuery = { __typename?: 'Query', getSimplifiedPaginatedRentals: { __typename?: 'RentalCollection', collection: Array<{ __typename?: 'Rental', id: string, name?: string | null, strikeDateTime?: string | Date | null, setByTimeDateTime?: string | Date | null, token?: string | null, status?: string | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, earliestPickListStatus?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, createdAt: string | Date, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employee?: { __typename?: 'Employee', id: string, name?: string | null } | null }>, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null, schedule?: { __typename?: 'Schedule', id: string, timeZone?: string | null } | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type SetPickListMutationVariables = Exact<{
  rentalId: Scalars['Int'];
  status?: InputMaybe<Scalars['String']>;
  pickListAccessoriesInput?: InputMaybe<Array<PickListInputWrapper> | PickListInputWrapper>;
  pickListItemsInput?: InputMaybe<Array<PickListInputWrapper> | PickListInputWrapper>;
  pickListAddOnsInput?: InputMaybe<Array<PickListInputWrapper> | PickListInputWrapper>;
}>;


export type SetPickListMutation = { __typename?: 'Mutation', setPickList?: { __typename?: 'SetPickListPayload', errors?: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } | null, rental?: { __typename?: 'Rental', id: string, status?: string | null, earliestPickListStatus?: string | null } | null, pickLists?: Array<{ __typename: 'PickListAccessory', id: string, checkedInQuantity?: number | null, pickedQuantity?: number | null, status?: string | null } | { __typename: 'PickListAddOn', id: string, status?: string | null } | { __typename: 'PickListItem', id: string, type?: string | null, checkedInQuantity?: number | null, pickedQuantity?: number | null, status?: string | null }> | null } | null };

export type GetLaborsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
}>;


export type GetLaborsQuery = { __typename?: 'Query', getLabors: Array<{ __typename?: 'StaffRole', id: string, name?: string | null, locationId?: number | null, type?: string | null }> };

export type GetRentalByIdQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetRentalByIdQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', id: string, token?: string | null, customers: Array<{ __typename?: 'Customer', name?: string | null, email?: string | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', cell?: string | null }> | null }>, conversations?: Array<{ __typename?: 'Conversation', id: string, messages: Array<{ __typename?: 'Message', id: string, createdAt: string | Date, sender: { __typename?: 'Customer', name?: string | null } | { __typename?: 'Employee', name?: string | null } }> }> | null, company?: { __typename?: 'Company', name?: string | null, mainContactEmail?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null } | null, teamMembers: Array<{ __typename?: 'Employee', name?: string | null, role?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null }>, pickListItems: Array<{ __typename: 'PickListItem', id: string, quantity?: number | null, name?: string | null, pickedQuantity?: number | null, checkedInQuantity?: number | null, status?: string | null, productCategoryName?: string | null, serialized?: boolean | null, serializedPickListItems?: Array<{ __typename?: 'SerializedPickListItem', id: string, status?: string | null, quantity?: number | null, serializedProduct?: { __typename?: 'SerializedProduct', id: string, token?: string | null, quantity?: number | null } | null }> | null, product?: { __typename?: 'Product', id: string, active?: boolean | null, name?: string | null, serializationStatus?: string | null, usageUnits?: Array<{ __typename?: 'UsageUnit', id: string, name?: string | null, unitType?: string | null, locationId?: number | null }> | null } | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null }> | null }>, pickListAccessories: Array<{ __typename: 'PickListAccessory', id: string, quantity?: number | null, name?: string | null, pickedQuantity?: number | null, checkedInQuantity?: number | null, status?: string | null, productCategoryName?: string | null }>, pickListAddOns: Array<{ __typename: 'PickListAddOn', id: string, quantity?: number | null, name?: string | null, pickedQuantity?: number | null, status?: string | null }>, rentalStaffs: Array<{ __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, inTime?: string | Date | null, staffRole?: { __typename?: 'StaffRole', type?: string | null } | null }>, secondaryOrders?: Array<{ __typename?: 'Rental', id: string, token?: string | null, name?: string | null, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, subTotal?: number | null, discountTotal?: number | null, feeTotal?: number | null, overallTotal?: number | null, billingLines?: Array<{ __typename?: 'RentalTotalBillingLine', tag?: string | null, name?: string | null, kind?: string | null, aggregate?: boolean | null, baseValue?: number | null, discountValue?: number | null, feeValue?: number | null, finalValue?: number | null, taxableValue?: number | null }> | null } }> | null, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, subTotal?: number | null, discountTotal?: number | null, feeTotal?: number | null, overallTotal?: number | null }, rentalTransports: Array<{ __typename?: 'RentalTransport', id: string, transportType?: string | null, rentalTransportTruckRelationships?: Array<{ __typename?: 'RentalTransportTruckRelationship', id: string, truckRoute?: { __typename?: 'TruckRoute', id: string, truck?: { __typename?: 'Truck', alphabetId?: string | null, name?: string | null } | null } | null }> | null }> } };

export type GetPickListQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetPickListQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', id: string, token?: string | null, status?: string | null, checkoutSignature?: string | null, checkoutSignerName?: string | null, checkoutSignerTitle?: string | null, checkoutSignerCompany?: string | null, businessCheckoutSignature?: string | null, businessCheckoutSignerName?: string | null, businessCheckoutSignerTitle?: string | null, businessCheckoutSignerCompany?: string | null, checkinSignature?: string | null, checkinSignerName?: string | null, checkinSignerTitle?: string | null, checkinSignerCompany?: string | null, businessCheckinSignature?: string | null, businessCheckinSignerName?: string | null, businessCheckinSignerTitle?: string | null, businessCheckinSignerCompany?: string | null, hasFlip?: boolean | null, flipDateTime?: string | Date | null, deliveryType?: string | null, deliveryAddressLocationName?: string | null, deliveryAddressStreetAddress1?: string | null, deliveryAddressStreetAddress2?: string | null, deliveryAddressCity?: string | null, deliveryAddressLocale?: string | null, deliveryAddressPostalCode?: string | null, deliveryAddressCountry?: string | null, isRecurringPayment?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, pickListItems: Array<{ __typename: 'PickListItem', id: string, quantity?: number | null, name?: string | null, pickedQuantity?: number | null, checkedInQuantity?: number | null, missingQuantity?: number | null, damagedQuantity?: number | null, lastMissingQuantity?: number | null, status?: string | null, productCategoryName?: string | null, serialized?: boolean | null, serialNumbers?: Array<string> | null, inventoryType: string, imgixUrl?: string | null, productNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, name?: string | null, supplierName?: string | null, quantity?: number | null, supplierLocationCode?: string | null }> | null, serializedPickListItems?: Array<{ __typename?: 'SerializedPickListItem', id: string, status?: string | null, quantity?: number | null, serializedProduct?: { __typename?: 'SerializedProduct', id: string, token?: string | null, quantity?: number | null, serialNumber?: string | null } | null }> | null, product?: { __typename?: 'Product', quantity?: number | null, id: string, active?: boolean | null, name?: string | null, serializationStatus?: string | null, warehouseLocation?: string | null, weight?: number | null, lengthFt?: number | null, length?: number | null, widthFt?: number | null, width?: number | null, heightFt?: number | null, height?: number | null, departmentNames?: string | null, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string, slug: string }>, usageUnits?: Array<{ __typename?: 'UsageUnit', id: string, name?: string | null, unitType?: string | null, locationId?: number | null }> | null } | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, amount?: number | null } | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null }> | null }>, pickListAccessories: Array<{ __typename: 'PickListAccessory', id: string, quantity?: number | null, name?: string | null, pickedQuantity?: number | null, checkedInQuantity?: number | null, missingQuantity?: number | null, damagedQuantity?: number | null, lastMissingQuantity?: number | null, status?: string | null, productCategoryName?: string | null, inventoryType: string, imgixUrl?: string | null, fee?: { __typename?: 'Fee', id: string, name?: string | null, amount?: number | null } | null, productNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, name?: string | null, supplierName?: string | null, quantity?: number | null, supplierLocationCode?: string | null }> | null, accessory?: { __typename?: 'Accessory', id: string, active?: boolean | null, name?: string | null, warehouseLocation?: string | null, weight?: number | null, lengthFt?: number | null, length?: number | null, widthFt?: number | null, width?: number | null, heightFt?: number | null, height?: number | null, material?: string | null, departmentNames?: string | null, quantity?: number | null, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string, slug: string }> } | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string }> | null }>, pickListAddOns: Array<{ __typename: 'PickListAddOn', id: string, quantity?: number | null, name?: string | null, pickedQuantity?: number | null, returnedQuantity?: number | null, status?: string | null, inventoryType: string, imgixUrl?: string | null, productNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, name?: string | null, supplierName?: string | null, quantity?: number | null, supplierLocationCode?: string | null }> | null, addOn?: { __typename?: 'AddOn', id: string, active?: boolean | null, name?: string | null, warehouseLocation?: string | null, weight?: number | null, lengthFt?: number | null, length?: number | null, widthFt?: number | null, width?: number | null, heightFt?: number | null, height?: number | null, material?: string | null, departmentNames?: string | null, quantity?: number | null, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string, slug: string }> } | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string }> | null }>, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null }>, schedule?: { __typename?: 'Schedule', startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, shelfEnabled?: boolean | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, timeZone?: string | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null } };

export type GetLocationDetailsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationDetailsQuery = { __typename?: 'Query', getLocationDetails: { __typename?: 'Location', name?: string | null, damageWaiverFixedFee?: number | null, damageWaiverPercent?: number | null, defaultStart?: string | Date | null, defaultEnd?: string | Date | null } };

export type GetQuickViewTemplatesQueryVariables = Exact<{
  locationId: Scalars['ID'];
}>;


export type GetQuickViewTemplatesQuery = { __typename?: 'Query', getQuickViewTemplates: { __typename?: 'QuickViewTemplates', quickViewTemplate?: { __typename?: 'RentalTemplate', id: string, name: string } | null, templates: Array<{ __typename?: 'RentalTemplate', id: string, name: string }> } };

export type UpdateQuickViewTemplateMutationVariables = Exact<{
  input: UpdateQuickViewTemplateInput;
}>;


export type UpdateQuickViewTemplateMutation = { __typename?: 'Mutation', updateQuickViewTemplate?: { __typename?: 'UpdateQuickViewTemplatePayload', errors: Array<string>, location?: { __typename?: 'Location', id: string, quickViewTemplateId?: string | null } | null } | null };

export type SetSecondaryOrderMutationVariables = Exact<{
  input: SetSecondaryOrderInput;
}>;


export type SetSecondaryOrderMutation = { __typename?: 'Mutation', setSecondaryOrder?: { __typename?: 'SetSecondaryOrderPayload', rental?: { __typename: 'Rental', id: string, name?: string | null, token?: string | null, secondaryOrdersCount?: number | null, event?: { __typename: 'Event', id: string, rentalsCount?: number | null, secondaryOrdersCount?: number | null } | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetParentRentalQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetParentRentalQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', smartPricingActive?: boolean | null, id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, location: { __typename?: 'Location', damageWaiverFixedFee?: number | null, damageWaiverPercent?: number | null, defaultStart?: string | Date | null, defaultEnd?: string | Date | null }, secondaryOrders?: Array<{ __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, dailyRentals?: Array<{ __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> }> | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> }> | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> } };

export type AssignSecondaryOrderAddressFromVenueQueryVariables = Exact<{
  rental: SoRentalInput;
  venueId: Scalars['ID'];
}>;


export type AssignSecondaryOrderAddressFromVenueQuery = { __typename?: 'Query', assignSecondaryOrderAddressFromVenue?: { __typename: 'Rental', id: string, deliveryAddressStreetAddress1?: string | null, deliveryAddressStreetAddress2?: string | null, deliveryAddressPostalCode?: string | null, deliveryAddressLocationName?: string | null, deliveryAddressLocale?: string | null, deliveryAddressCity?: string | null, deliveryAddressCountry?: string | null, deliveryType?: string | null, dailyRentals?: Array<{ __typename: 'Rental', id: string, deliveryAddressStreetAddress1?: string | null, deliveryAddressStreetAddress2?: string | null, deliveryAddressPostalCode?: string | null, deliveryAddressLocationName?: string | null, deliveryAddressLocale?: string | null, deliveryAddressCity?: string | null, deliveryAddressCountry?: string | null, deliveryType?: string | null }> | null } | null };

export type RentalAddressFragment = { __typename?: 'Rental', deliveryAddressStreetAddress1?: string | null, deliveryAddressStreetAddress2?: string | null, deliveryAddressPostalCode?: string | null, deliveryAddressLocationName?: string | null, deliveryAddressLocale?: string | null, deliveryAddressCity?: string | null, deliveryAddressCountry?: string | null, deliveryType?: string | null };

export type GetDuplicatedRentalQueryVariables = Exact<{
  rental: SoRentalInput;
}>;


export type GetDuplicatedRentalQuery = { __typename?: 'Query', getDuplicatedRental: { __typename: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, dailyRentals?: Array<{ __typename: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> }> | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> } };

export type ReusableRentalFragment = { __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> };

export type ReusableDiscountRentalRelationshipFragment = { __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null };

export type ReusableFeeRentalRelationshipFragment = { __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null };

export type ReusableDisclaimerRentalRelationshipFragment = { __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null };

export type ReusableRentalAccessoryFragment = { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null };

export type ReusableRentalAddOnFragment = { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null };

export type ReusableRentalItemFragment = { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null };

export type ReusableRentalItemSimpleFragment = { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null };

export type ReusableRentalAccessorySimpleFragment = { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null };

export type ReusableRentalAddOnSimpleFragment = { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null };

export type ReusableRentalForInvoiceFragment = { __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, event?: { __typename?: 'Event', name?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, createdAt: string | Date, updatedAt: string | Date, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, rentalId?: number | null, subTotal?: number | null, overallTotal?: number | null }, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> };

export type GetParentRentalForInvoiceQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetParentRentalForInvoiceQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, secondaryOrders?: Array<{ __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, dailyRentals?: Array<{ __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, status?: string | null, referralSource?: string | null, type?: string | null, flipDateTime?: string | Date | null, finalPaymentDueDateDaysNum?: number | null, finalPaymentDueDateDaysOption?: string | null, manualDamageWaiver?: boolean | null, damageWaiverFeeTotal?: number | null, noCostSubrentalTransfer?: boolean | null, depositFixedFee?: number | null, depositPercent?: number | null, depositRequired?: boolean | null, depositType?: string | null, deliveryCost?: number | null, additionalDeliveryCost?: number | null, customDepositAmount?: number | null, paymentNotification1Enabled?: boolean | null, paymentNotification1Num?: number | null, paymentNotification2Enabled?: boolean | null, paymentNotification2Num?: number | null, paymentNotification3Enabled?: boolean | null, paymentNotification3Num?: number | null, paymentNotificationDaysOption?: string | null, paymentNotificationType?: string | null, salesTaxSetting?: string | null, manualSalesTaxName?: string | null, manualSalesTaxPercent?: number | null, damageWaiverTaxExempt?: boolean | null, deliveryTaxEnabled?: boolean | null, gstTaxExempt?: boolean | null, pstTaxExempt?: boolean | null, taxExempt?: boolean | null, paymentTerm?: string | null, signatureRequired?: boolean | null, eventId?: number | null, rentalAgreementId?: number | null, setByTimeDateTime?: string | Date | null, setByTimeNotes?: string | null, hasSetByTime?: boolean | null, flipNotes?: string | null, hasFlip?: boolean | null, hasStrikeTime?: boolean | null, strikeDateTime?: string | Date | null, strikeTimeNotes?: string | null, roomActivitySetting?: RoomActivitySettingEnum | null, jobType?: string | null, jobSubOption?: string | null, event?: { __typename?: 'Event', name?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, createdAt: string | Date, updatedAt: string | Date, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, rentalId?: number | null, subTotal?: number | null, overallTotal?: number | null }, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> }> | null, event?: { __typename?: 'Event', name?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, createdAt: string | Date, updatedAt: string | Date, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, rentalId?: number | null, subTotal?: number | null, overallTotal?: number | null }, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> }> | null, event?: { __typename?: 'Event', name?: string | null } | null, notes: Array<{ __typename?: 'Note', id: string, createdAt: string | Date, updatedAt: string | Date, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employeeId?: number | null }>, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, rentalId?: number | null, subTotal?: number | null, overallTotal?: number | null }, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null, disclaimerId?: number | null, signatureRequired?: boolean | null }> | null, discountRentalRelationships?: Array<{ __typename?: 'DiscountRentalRelationship', id?: string | null, active?: boolean | null, amount?: number | null, discountTargetType?: string | null, name?: string | null, valueType?: string | null, discountId?: number | null, discount?: { __typename?: 'Discount', id: string } | null }> | null, feeRentalRelationships?: Array<{ __typename?: 'FeeRentalRelationship', id: string, active?: boolean | null, amount?: number | null, feeType?: string | null, feeTargetType?: string | null, name?: string | null, valueType?: string | null, feeId?: number | null, taxExempt?: boolean | null, fee?: { __typename?: 'Fee', id: string } | null }> | null, rentalSetting?: { __typename?: 'RentalSetting', id: string, hideEventTimes?: boolean | null, hideEventDates?: boolean | null, hideDeliveryInfo?: boolean | null, hideDeliveryTimes?: boolean | null, hasCustomerSurvey?: boolean | null } | null, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', id: string, companyId: string, isPrimaryContact: boolean, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null } | null } | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, clientId: number, clientType: string, autosendEmails?: boolean | null, isPrimaryContact: boolean, client: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', mainContactNumber?: boolean | null, office?: string | null, cell?: string | null, extension?: string | null, type?: number | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null } | null, documents?: Array<{ __typename?: 'Document', id: string, fileFileName?: string | null }> | null } }>, documentRentalRelationships: Array<{ __typename?: 'DocumentRentalRelationship', id: string, active?: boolean | null, employeeId?: number | null, document: { __typename?: 'Document', id: string, documentType?: string | null, fileFileName?: string | null, fileFileSize?: number | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, name?: string | null, file?: string | null } }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, employeeId?: number | null, active?: boolean | null, commissionName?: string | null, commissionPercent?: number | null, employeeRentalRoles?: Array<{ __typename?: 'EmployeeRentalRole', id: string, roleId: string }> | null }>, rentalTeamEmailSetting?: { __typename?: 'RentalTeamEmailSetting', id: string, shouldChangeOrderEmailRecipients?: string | null, redirectEmailToTeamMembers?: string | null, bccTeamMembers?: string | null } | null, expenses: Array<{ __typename?: 'Expense', id?: string | null, name?: string | null, amount?: number | null, active?: boolean | null }>, salesTaxRentalRelationships?: Array<{ __typename?: 'SalesTaxRentalRelationship', id: string, rentalId: string, salesTaxId?: number | null, salesTax?: { __typename?: 'SalesTax', id: string, taxType: string, name: string, taxPercent: number, locationId: number, state?: string | null, appliesToRentables?: boolean | null, appliesToPurchases?: boolean | null, appliesToServices?: boolean | null } | null }> | null, venueRentalRelationship?: { __typename?: 'VenueRentalRelationship', id: string, venueId?: number | null, venue?: { __typename?: 'Venue', id: string, name?: string | null } | null } | null, rentalSections: Array<{ __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, position?: number | null, rentalInventory?: { __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename?: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, priceLocked?: boolean | null, discountPercent?: number | null, hourlyPrice?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, taxExemptionSetting?: string | null, purchasePrice?: number | null, period?: string | null, bundleId?: number | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, selectedPrice?: number | null, selectedPriceRaw?: number | null, notes?: string | null, taxExempt?: boolean | null, pricePerUnit?: number | null, pricingPickedByUser?: boolean | null, addOnId?: number | null, damageWaiverExempt?: boolean | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, notes?: string | null, accessoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalBundleDiscountRelationships?: Array<{ __typename?: 'RentalBundleDiscountRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null, rentalBundleFeeRelationships?: Array<{ __typename?: 'RentalBundleFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null }> | null } | { __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, period?: string | null, editedFlatPrice?: any | null, editedFlatUnitPrice?: any | null, productId?: number | null, hourlyPrice?: number | null, dailyPrice?: number | null, halfDayPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, discountEligible?: boolean | null, taxExempt?: boolean | null, damageWaiverExempt?: boolean | null, totalFees?: number | null, totalDiscounts?: number | null, customTaxAmount?: number | null, preDiscountSubtotal?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, flatPrices?: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }> | null, rentalItemDiscountRelationships?: Array<{ __typename?: 'RentalItemDiscountRelationship', id?: string | null, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemFeeRelationships?: Array<{ __typename?: 'RentalItemFeeRelationship', id: string, amount?: number | null, name?: string | null, valueType?: string | null, computedAmount?: number | null }> | null, rentalItemCustomTaxRelationship?: { __typename?: 'RentalItemCustomTaxRelationship', id: string, name?: string | null, amount?: number | null, amountType?: string | null } | null } | { __typename?: 'RentalStaff', id: string, name?: string | null, size?: number | null, staffRoleId?: number | null, staffPricingId?: number | null, userInputPricing?: number | null, staffSchedule?: { __typename?: 'StaffSchedule', id: string, inTime?: string | Date | null, outTime?: string | Date | null, active?: boolean | null, scheduleOwnerType?: string | null } | null, staffRole?: { __typename?: 'StaffRole', id: string, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null } | null }> | null }> } };

export type GetRentalByTokenQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetRentalByTokenQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', id: string, token?: string | null, name?: string | null, pricingLogicId?: number | null, rentalTotal: { __typename?: 'RentalTotal', billingLines?: Array<{ __typename?: 'RentalTotalBillingLine', tag?: string | null, name?: string | null, kind?: string | null, aggregate?: boolean | null, baseValue?: number | null, discountValue?: number | null, feeValue?: number | null, finalValue?: number | null, taxableValue?: number | null }> | null }, billingNotes: Array<{ __typename?: 'BillingNote', id: string, authorName?: string | null, message?: string | null, paymentDate?: string | Date | null, deletedAt?: string | Date | null, amount?: number | null, noteType?: string | null, paymentInfo?: string | null, employeeName?: string | null, isAuthorPrimary?: boolean | null, isCompanyPrimary?: boolean | null }>, business: { __typename?: 'Business', id: string, name?: string | null }, refundLines?: Array<{ __typename?: 'RefundLine', id: string, amount: number, createdAt: string | Date, refundGroupId?: string | null, refundType: string }> | null } };

export type DeleteRefundLineMutationVariables = Exact<{
  input: DeleteRefundLineInput;
}>;


export type DeleteRefundLineMutation = { __typename?: 'Mutation', deleteRefundLine?: { __typename?: 'DeleteRefundLinePayload', success?: boolean | null, error?: string | null } | null };

export type SyncRentalToQbMutationVariables = Exact<{
  input: SyncRentalToQbInput;
}>;


export type SyncRentalToQbMutation = { __typename?: 'Mutation', syncRentalToQb?: { __typename?: 'SyncRentalToQBPayload', success?: boolean | null, error: string } | null };

export type SyncRentalManuallyToQbMutationVariables = Exact<{
  input: SyncRentalManuallyToQbInput;
}>;


export type SyncRentalManuallyToQbMutation = { __typename?: 'Mutation', syncRentalManuallyToQb?: { __typename?: 'SyncRentalManuallyToQBPayload', success?: boolean | null, export?: string | null, error: string } | null };

export type GetClientSuccessHistoryEntriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientSuccessHistoryEntriesQuery = { __typename?: 'Query', getClientSuccessHistoryEntries: Array<{ __typename?: 'ClientSuccessHistoryEntry', id: string, entryType: string, refundName?: string | null, createdAt: string | Date, rental: { __typename?: 'Rental', id: string, token?: string | null }, admin: { __typename?: 'Admin', id: string, name: string }, billingNote?: { __typename?: 'BillingNote', id: string, message?: string | null, authorName?: string | null, paymentDate?: string | Date | null } | null }> };

export type ExportStorefrontInventoryMutationVariables = Exact<{
  input: ExportStorefrontInventoryInput;
}>;


export type ExportStorefrontInventoryMutation = { __typename?: 'Mutation', exportStorefrontInventory?: { __typename?: 'ExportStorefrontInventoryPayload', status: string, exportProgressId?: string | null, errors: Array<string> } | null };

export type WorldpayHostedPaymentSetupMutationVariables = Exact<{
  input: WorldpayHostedPaymentSetupInput;
}>;


export type WorldpayHostedPaymentSetupMutation = { __typename?: 'Mutation', worldpayHostedPaymentSetup?: { __typename?: 'WorldpayHostedPaymentSetupPayload', redirectUrl?: string | null, transactionSetupId?: string | null, referenceNumber?: string | null, ticketNumber?: string | null, validationCode?: string | null, error?: string | null } | null };

export type GetRentalsGanttQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  teamMemberNames?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  contactIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type GetRentalsGanttQuery = { __typename?: 'Query', getRentalsGantt: Array<{ __typename?: 'Rental', id: string, token?: string | null, name?: string | null, status?: string | null, deliveryType?: string | null, teamMembers: Array<{ __typename?: 'Employee', id: string, name?: string | null }>, employeeRentalRelationships: Array<{ __typename?: 'EmployeeRentalRelationship', id: string, rentalId?: number | null, employee: { __typename?: 'Employee', id: string, name?: string | null } }>, customers: Array<{ __typename?: 'Customer', id: string, name?: string | null }>, company?: { __typename?: 'Company', id: string, name?: string | null } | null, event?: { __typename?: 'Event', id: string, name?: string | null } | null, schedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null } | null }> };

export type GetParentRentalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  eventId: Scalars['ID'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetParentRentalsQuery = { __typename?: 'Query', getParentRentals: Array<{ __typename?: 'Rental', id: string, name?: string | null, token?: string | null, customId?: string | null, secondaryOrdersCount?: number | null, recurring?: boolean | null, status?: string | null, rentalTotal: { __typename?: 'RentalTotal', id?: number | null, subTotal?: number | null, discountTotal?: number | null, feeTotal?: number | null, overallTotal?: number | null }, schedule?: { __typename?: 'Schedule', id: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, sameAsEventDate?: boolean | null, shelfEnabled?: boolean | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null }> };

export type GetEventBillingSummaryQueryVariables = Exact<{
  eventToken: Scalars['String'];
  threshold?: InputMaybe<Scalars['Int']>;
}>;


export type GetEventBillingSummaryQuery = { __typename?: 'Query', getEventBillingSummary: { __typename?: 'EventBillingSummary', totalDays?: number | null, totalWeeks?: number | null, dateGroups?: Array<Array<string>> | null, rentalTypes?: { __typename?: 'EventBillingRentalTypes', Items?: Array<{ __typename?: 'EventBillingItem', name?: string | null, total?: number | null, quantityTotal?: number | null, inventoryId?: number | null, quantities?: Array<number> | null }> | null, Accessories?: Array<{ __typename?: 'EventBillingItem', name?: string | null, total?: number | null, quantityTotal?: number | null, inventoryId?: number | null, quantities?: Array<number> | null }> | null, Purchases?: Array<{ __typename?: 'EventBillingItem', name?: string | null, total?: number | null, quantityTotal?: number | null, inventoryId?: number | null, quantities?: Array<number> | null }> | null, Bundles?: Array<{ __typename?: 'EventBillingItem', name?: string | null, total?: number | null, quantityTotal?: number | null, inventoryId?: number | null, quantities?: Array<number> | null }> | null, Staff?: Array<{ __typename?: 'EventBillingItem', name?: string | null, total?: number | null, quantityTotal?: number | null, inventoryId?: number | null, quantities?: Array<number> | null }> | null, Labor?: Array<{ __typename?: 'EventBillingItem', name?: string | null, total?: number | null, quantityTotal?: number | null, inventoryId?: number | null, quantities?: Array<number> | null }> | null } | null } };

export type GetEventInventoryItemRentalsQueryVariables = Exact<{
  eventToken: Scalars['String'];
  inventoryItemId: Scalars['ID'];
  inventoryItemType: RentalInventoryTypeEnum;
}>;


export type GetEventInventoryItemRentalsQuery = { __typename?: 'Query', getEventInventoryItemRentals: Array<{ __typename: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, rentalId?: number | null, rentalName?: string | null, rentalToken?: string | null, rentalStatus?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null } | null } | { __typename: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, rentalId?: number | null, rentalName?: string | null, rentalToken?: string | null, rentalStatus?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null } | null } | { __typename: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, rentalId?: number | null, rentalName?: string | null, rentalToken?: string | null, rentalStatus?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null } | null } | { __typename: 'RentalItem', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, rentalId?: number | null, rentalName?: string | null, rentalToken?: string | null, rentalStatus?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null } | null } | { __typename: 'RentalStaff', id: string, name?: string | null, size?: number | null, inventoryId?: number | null, rentalId?: number | null, rentalName?: string | null, rentalToken?: string | null, rentalStatus?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, timeZone?: string | null } | null }> };

export type CloseEventMutationVariables = Exact<{
  input: SetEventInput;
}>;


export type CloseEventMutation = { __typename?: 'Mutation', setEvent?: { __typename?: 'SetEventPayload', event?: { __typename?: 'Event', id: string, status: string } | null } | null };

export type GetEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetEventQuery = { __typename?: 'Query', getEvent: { __typename?: 'Event', id: string, token: string, status: string, name?: string | null, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, recurring?: boolean | null, recurrencePeriodCount?: number | null, latestRecurrenceToken?: string | null, active?: boolean | null, createdAt?: string | Date | null, updatedAt?: string | Date | null, customerId?: string | null, locationId?: string | null, timeZone?: string | null, rentalsCount?: number | null, secondaryOrdersCount?: number | null, source?: string | null, referralSource?: string | null, type?: string | null, location?: { __typename?: 'Location', phoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null, country?: string | null, active?: boolean | null, mainContactAddress?: boolean | null, addressableId?: number | null, addressableType?: string | null, addressType?: string | null, name?: string | null } | null } | null, documents?: Array<{ __typename?: 'Document', id: string, name?: string | null, file?: string | null, fileUrl?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, createdAt: string | Date, fileFileSize?: number | null, fileFileName?: string | null, documentType?: string | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, visibleToCustomer?: boolean | null }> | null, notes?: Array<{ __typename?: 'Note', id: string, message?: string | null, createdAt: string | Date, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null, employee?: { __typename?: 'Employee', lastName?: string | null, firstName?: string | null } | null }> | null, teamMembers?: Array<{ __typename?: 'Employee', id: string, role?: string | null, email?: string | null, lastName?: string | null, firstName?: string | null }> | null, rentalTotal: { __typename?: 'RentalTotal', overallTotal?: number | null, taxTotal?: number | null, subTotal?: number | null, subTotalForTax?: number | null, inventoryTotal?: number | null, inventoryTotalForTax?: number | null, totalDeliveryCost?: number | null, pretaxFeeTotal?: number | null, feeTotalExcludingDamageWaiver?: number | null, tgBusinessFee?: number | null, tapgoodsFeeTotal?: number | null, feeTotal?: number | null, standardFeeTotal?: number | null, overallDamageFeeTotal?: number | null, rentalAccessoryDamageTotal?: number | null, rentalItemDamageTotal?: number | null, creditCardFeeTotal?: number | null, expenseTotal?: number | null, discountTotal?: number | null, rentalBundleTotalForTax?: number | null, rentalItemTotalForTax?: number | null, rentalAddOnTotalForTax?: number | null, totalDeliveryCostForTax?: number | null, staffingTotalForTax?: number | null, staffingTotal?: number | null, rentalBundleTotal?: number | null, rentalItemTotal?: number | null, rentalAddOnTotal?: number | null, dmgWaiverInventoryTotal?: number | null, processingFeeTotal?: number | null, tapgoodsTaxTotal?: number | null, totalBeforeTransactionCharges?: number | null, totalPaid?: number | null, paymentBalance?: number | null, totalRefunded?: number | null, processingFeeRefunded?: number | null, amountRemaining?: number | null, inventoryTotalForDamage?: number | null, rentalItemTotalForDamage?: number | null, damageWaiverTotalForTax?: number | null } } };

export type ExportEventInvoiceMutationVariables = Exact<{
  input: ExportEventInvoiceInput;
}>;


export type ExportEventInvoiceMutation = { __typename?: 'Mutation', exportEventInvoice?: { __typename?: 'ExportEventInvoicePayload', exportProgressId: string } | null };

export type ExportEventBillingSummaryMutationVariables = Exact<{
  input: ExportEventBillingSummaryInput;
}>;


export type ExportEventBillingSummaryMutation = { __typename?: 'Mutation', exportEventBillingSummary?: { __typename?: 'ExportEventBillingSummaryPayload', exportProgressId: string } | null };

export type EventFormGetEventQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type EventFormGetEventQuery = { __typename?: 'Query', getEvent: { __typename?: 'Event', id: string, name?: string | null, eventEndDateTime?: string | Date | null, eventStartDateTime?: string | Date | null, customerId?: string | null, recurring?: boolean | null, recurrencePeriodCount?: number | null, timeZone?: string | null, referralSource?: string | null, status: string, documentEventRelationships?: Array<{ __typename?: 'DocumentEventRelationship', id?: string | null, documentId?: number | null, expirable?: boolean | null, expiresAt?: string | Date | null, employeeId?: string | null, document?: { __typename?: 'Document', id: string, name?: string | null, file?: string | null, fileUrl?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, createdAt: string | Date, fileFileSize?: number | null, documentType?: string | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, visibleToCustomer?: boolean | null, documentableId?: number | null, documentableType?: string | null, fileFileName?: string | null } | null }> | null, notes?: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null }> | null, employeeEventRelationships?: Array<{ __typename?: 'EmployeeEventRelationship', id: string, employeeId?: number | null, name?: string | null, employeeEventRoles?: Array<{ __typename?: 'EmployeeEventRole', id: string, roleId: string, name: string }> | null }> | null } };

export type DeleteEventMutationVariables = Exact<{
  input: DeleteEventInput;
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent?: { __typename?: 'DeleteEventPayload', event?: { __typename?: 'Event', id: string, token: string, name?: string | null, status: string } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null } } | null };

export type SetEventMutationVariables = Exact<{
  input: SetEventInput;
}>;


export type SetEventMutation = { __typename?: 'Mutation', setEvent?: { __typename?: 'SetEventPayload', event?: { __typename?: 'Event', id: string, name?: string | null, token: string, eventEndDateTime?: string | Date | null, eventStartDateTime?: string | Date | null, recurring?: boolean | null, latestRecurrentRentalId?: string | null, documents?: Array<{ __typename?: 'Document', id: string, documentableId?: number | null, documentableType?: string | null, fileFileName?: string | null }> | null, notes?: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null }> | null, teamMembers?: Array<{ __typename?: 'Employee', id: string, email?: string | null, firstName?: string | null, lastName?: string | null }> | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetEventsQueryVariables = Exact<{
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetEventsQuery = { __typename?: 'Query', getEvents: { __typename?: 'EventCollection', collection: Array<{ __typename?: 'Event', id: string, token: string, status: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, rentalsCount?: number | null, secondaryOrdersCount?: number | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number } } };

export type GetEventsForFilterAutocompleteQueryVariables = Exact<{
  search: Scalars['String'];
}>;


export type GetEventsForFilterAutocompleteQuery = { __typename?: 'Query', getEvents: { __typename?: 'EventCollection', collection: Array<{ __typename: 'Event', id: string, name?: string | null, token: string }> } };

export type GetStaffRoleTypeQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetStaffRoleTypeQuery = { __typename?: 'Query', getStaffRole?: { __typename: 'StaffRole', id: string, type?: string | null } | null };

export type GetLocationEmployeesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationEmployeesQuery = { __typename?: 'Query', getLocationEmployees: Array<{ __typename?: 'EmployeeLocationRelationship', id: string, name?: string | null, employeeId?: string | null, employeeRoleRelationships: Array<{ __typename?: 'EmployeeRoleRelationship', name?: string | null, roleKey?: string | null, roleId?: string | null }> }> };

export type GetEventsListQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  eventStartDateTimeGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  eventEndDateTimeLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  venueId?: InputMaybe<Scalars['ID']>;
  companyId?: InputMaybe<Scalars['ID']>;
  customerId?: InputMaybe<Scalars['ID']>;
  salesperson?: InputMaybe<Scalars['ID']>;
  sortBy?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
}>;


export type GetEventsListQuery = { __typename?: 'Query', getEvents: { __typename?: 'EventCollection', collection: Array<{ __typename?: 'Event', id: string, token: string, name?: string | null, status: string, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, rentalsCount?: number | null, secondaryOrdersCount?: number | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number } } };

export type SearchSfTagsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  locationId: Scalars['Int'];
}>;


export type SearchSfTagsQuery = { __typename?: 'Query', searchStorefrontTags?: Array<{ __typename: 'StorefrontTag', id: string, name: string }> | null };

export type GetProductForCalendarQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetProductForCalendarQuery = { __typename?: 'Query', getProduct: { __typename: 'Product', id: string, token?: string | null, hourlyPrice?: number | null, groupSharedQuantity?: number | null, halfDayPrice?: number | null, dailyPrice?: number | null, weeklyPrice?: number | null, monthlyPrice?: number | null, name?: string | null, multilocationShared?: boolean | null, quantity?: number | null, maintenanceQuantity: number, collectionName?: string | null, isMultilocation: boolean, flatPrices: Array<{ __typename?: 'FlatPrice', id: string, name?: string | null, amount?: number | null }>, pictures: Array<{ __typename: 'Picture', id: string, url?: string | null, imgixUrl?: string | null, imageFileName?: string | null }>, inventoryGroup?: { __typename: 'ProductGroup', id: string, inventoryObjects: Array<{ __typename: 'Product', id: string, locationId?: number | null, token?: string | null }> } | null } };

export type GetAccessoryForCalendarQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAccessoryForCalendarQuery = { __typename?: 'Query', getAccessory: { __typename: 'Accessory', id: string, token?: string | null, groupSharedQuantity?: number | null, name?: string | null, multilocationShared?: boolean | null, quantity?: number | null, maintenanceQuantity: number, collectionName?: string | null, isMultilocation: boolean, pictures: Array<{ __typename: 'Picture', id: string, url?: string | null, imgixUrl?: string | null, imageFileName?: string | null }>, inventoryGroup?: { __typename: 'AccessoryGroup', id: string, inventoryObjects: Array<{ __typename: 'Accessory', id: string, locationId?: number | null, token?: string | null }> } | null } };

export type GetAddOnForCalendarQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetAddOnForCalendarQuery = { __typename?: 'Query', getAddOn: { __typename: 'AddOn', id: string, token?: string | null, groupSharedQuantity?: number | null, name?: string | null, multilocationShared?: boolean | null, quantity?: number | null, ownedQuantity?: number | null, initialQuantity?: number | null, reservedQuantity?: number | null, quantityInWarehouse?: number | null, maintenanceQuantity?: number | null, collectionName?: string | null, isMultilocation: boolean, pictures: Array<{ __typename: 'Picture', id: string, url?: string | null, imgixUrl?: string | null, imageFileName?: string | null }>, inventoryGroup?: { __typename: 'AddOnGroup', id: string, inventoryObjects: Array<{ __typename: 'AddOn', id: string, locationId?: number | null, token?: string | null }> } | null } };

export type GetBundleForCalendarQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetBundleForCalendarQuery = { __typename?: 'Query', getBundle: { __typename: 'Bundle', id: string, name?: string | null, token?: string | null, totalQuantity: number, collectionName?: string | null, isMultilocation: boolean, pictures: Array<{ __typename: 'Picture', id: string, url?: string | null, imgixUrl?: string | null, imageFileName?: string | null }>, productBundleRelationships: Array<{ __typename: 'ProductBundleRelationship', id: string, quantity?: number | null, productId?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null }>, accessoryBundleRelationships: Array<{ __typename: 'AccessoryBundleRelationship', id: string, quantity?: number | null, accessoryId?: number | null, accessory?: { __typename?: 'Accessory', id: string, name?: string | null } | null }>, addOnBundleRelationships: Array<{ __typename: 'AddOnBundleRelationship', id: string, quantity?: number | null, addOnId?: number | null, addOn?: { __typename?: 'AddOn', id: string, name?: string | null } | null }> } };

export type PictureFragment = { __typename: 'Picture', id: string, url?: string | null, imgixUrl?: string | null, imageFileName?: string | null };

export type ProductBundleRelationshipForCalendarFragment = { __typename: 'ProductBundleRelationship', id: string, quantity?: number | null, productId?: number | null, product?: { __typename?: 'Product', id: string, name?: string | null } | null };

export type AccessoryBundleRelationshipForCalendarFragment = { __typename: 'AccessoryBundleRelationship', id: string, quantity?: number | null, accessoryId?: number | null, accessory?: { __typename?: 'Accessory', id: string, name?: string | null } | null };

export type AddOnBundleRelationshipForCalendarFragment = { __typename: 'AddOnBundleRelationship', id: string, quantity?: number | null, addOnId?: number | null, addOn?: { __typename?: 'AddOn', id: string, name?: string | null } | null };

export type GetAddOnInventoryLedgerEntriesQueryVariables = Exact<{
  addOnToken: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetAddOnInventoryLedgerEntriesQuery = { __typename?: 'Query', getAddOnInventoryLedgerEntries: { __typename?: 'InventoryLedgerEntryCollection', collection: Array<{ __typename: 'InventoryLedgerEntry', id: string, date: string | Date, quantity: number, balanceAfter?: number | null, operation: string, rentalName?: string | null, rentalId?: number | null, rentalToken?: string | null, turnoverTimeInSeconds?: number | null, dateWithTurnoverTime?: string | Date | null, subRentedQuantity?: number | null, details?: any | null } | { __typename: 'Supplier', id: string, name?: string | null, website?: string | null, quantity: number, cost: number, notes?: string | null, completedAt: string | Date, po?: string | null, supplierType: string, updatedAt: string | Date, authorName: string, balanceAfter?: number | null }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number, totalPages: number, currentPage: number } } };

export type GetAddOnReservedOrdersQueryVariables = Exact<{
  addOnToken: Scalars['String'];
}>;


export type GetAddOnReservedOrdersQuery = { __typename?: 'Query', getAddOnReservedOrders: Array<{ __typename?: 'AddOnReservedOrder', token: string, name?: string | null, status: string, eventStartDateTime?: string | Date | null, quantity: number }> };

export type ReactivateSerializedProductsMutationVariables = Exact<{
  input: ReactivateSerializedProductsInput;
}>;


export type ReactivateSerializedProductsMutation = { __typename?: 'Mutation', reactivateSerializedProducts?: { __typename?: 'ReactivateSerializedProductsPayload', success: boolean, error?: string | null } | null };

export type GetPurchaseOrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPurchaseOrderQuery = { __typename?: 'Query', getPurchaseOrder: { __typename?: 'PurchaseOrder', id: string, name?: string | null, number?: number | null, status?: string | null, paymentStatus?: string | null, taxPercentage?: number | null, completionEstimate?: string | Date | null, dateNeeded?: string | Date | null, description?: string | null, note?: string | null, priority?: string | null, createdAt: string | Date, deliveryCost?: number | null, billingSameAsDelivery?: boolean | null, taxType?: string | null, deliveryFeeTaxExempt?: boolean | null, purchaseOrderDeliveryFees?: Array<{ __typename?: 'PurchaseOrderDeliveryFee', id: string, name?: string | null, amount?: number | null }> | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null, purchaseOrderTotalCalculation: { __typename?: 'PurchaseOrderTotalCalculation', subtotal: number, tax: number, total: number, delivery: number, taxableAmount: number }, purchaseOrderInventories?: Array<{ __typename?: 'PurchaseOrderInventory', id: string, name?: string | null, quantity?: number | null, fulfilledQuantity?: number | null, damagedQuantity?: number | null, missingQuantity?: number | null, purchaseOrderPrice?: number | null, rentalPrice?: number | null, inventoryType?: string | null, note?: string | null, manufacturerPartNumber?: string | null, purchaseOrderId?: number | null, originalInventoryId?: string | null, originalInventory?: { __typename?: 'Accessory' } | { __typename?: 'AddOn' } | { __typename?: 'Product', serializationStatus?: string | null } | null, serializedProducts?: Array<{ __typename?: 'SerializedProduct', id: string, serialNumber?: string | null, productId?: number | null, purchaseOrderInventoryId?: number | null }> | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, purchaseOrderVendorRelationship?: { __typename?: 'PurchaseOrderVendorRelationship', id: string, name?: string | null, emailAddress?: { __typename?: 'EmailAddress', id: string, emailAddress?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null } | null, location?: { __typename?: 'Location', name?: string | null, locale?: string | null, website?: string | null, physicalAddress?: { __typename?: 'PhysicalAddress', streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null } | null, deliveryAddress?: { __typename?: 'PhysicalAddress', id: string, name?: string | null, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, billingAddress?: { __typename?: 'PhysicalAddress', id: string, name?: string | null, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, deliveryPhoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null, billingPhoneNumber?: { __typename?: 'PhoneNumber', id: string, cell?: string | null } | null } };

export type CancelPurchaseOrderMutationVariables = Exact<{
  input: CancelPurchaseOrderInput;
}>;


export type CancelPurchaseOrderMutation = { __typename?: 'Mutation', cancelPurchaseOrder?: { __typename?: 'CancelPurchaseOrderPayload', success: boolean, errors: Array<string>, deletedInventories?: Array<string> | null } | null };

export type CheckInAllPurchaseOrderInventoryMutationVariables = Exact<{
  input: CheckInAllPurchaseOrderInventoryInput;
}>;


export type CheckInAllPurchaseOrderInventoryMutation = { __typename?: 'Mutation', checkInAllPurchaseOrderInventory?: { __typename?: 'CheckInAllPurchaseOrderInventoryPayload', success: boolean, errors: Array<string> } | null };

export type SetPurchaseOrderMutationVariables = Exact<{
  input: SetPurchaseOrderInput;
}>;


export type SetPurchaseOrderMutation = { __typename?: 'Mutation', setPurchaseOrder?: { __typename?: 'SetPurchaseOrderPayload', purchaseOrder?: { __typename?: 'PurchaseOrder', id: string, number?: number | null, dateNeeded?: string | Date | null, completionEstimate?: string | Date | null, priority?: string | null, status?: string | null, paymentStatus?: string | null, purchaseOrderVendorRelationship?: { __typename?: 'PurchaseOrderVendorRelationship', vendorId?: string | null, name?: string | null, physicalAddress?: { __typename?: 'PhysicalAddress', name?: string | null, streetAddress1?: string | null, locale?: string | null, city?: string | null, country?: string | null } | null, emailAddress?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null } | null, purchaseOrderInventories?: Array<{ __typename?: 'PurchaseOrderInventory', id: string, fulfilledQuantity?: number | null, missingQuantity?: number | null, damagedQuantity?: number | null, purchaseOrderId?: number | null, note?: string | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null }> | null, serializedProducts?: Array<{ __typename?: 'SerializedProduct', id: string, serialNumber?: string | null, productId?: number | null, purchaseOrderInventoryId?: number | null, _destroy?: string | null }> | null }> | null, deliveryAddress?: { __typename?: 'PhysicalAddress', name?: string | null, streetAddress1?: string | null, locale?: string | null, city?: string | null, country?: string | null } | null, deliveryPhoneNumber?: { __typename?: 'PhoneNumber', cell?: string | null } | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type ExportPurchaseOrderMutationVariables = Exact<{
  purchaseOrderId: Scalars['ID'];
  emails?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type ExportPurchaseOrderMutation = { __typename?: 'Mutation', exportPurchaseOrder?: { __typename?: 'ExportPurchaseOrderPayload', status: string, exportProgressId?: string | null, errors?: Array<string> | null } | null };

export type GetPurchaseOrderChangeHistoryEntriesQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPurchaseOrderChangeHistoryEntriesQuery = { __typename?: 'Query', getPurchaseOrder: { __typename?: 'PurchaseOrder', changeHistoryEntries?: Array<{ __typename?: 'ChangeHistoryEntry', id: string, message?: string | null, createdAt: string | Date, allowRevert?: boolean | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null } };

export type RevertChangeHistoryEntryMutationVariables = Exact<{
  input: RevertChangeHistoryEntryInput;
}>;


export type RevertChangeHistoryEntryMutation = { __typename?: 'Mutation', revertChangeHistoryEntry?: { __typename?: 'RevertChangeHistoryEntryPayload', success: boolean, errors: Array<string> } | null };

export type GetProductsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetProductsQuery = { __typename?: 'Query', getProducts: Array<{ __typename?: 'Product', id: string, name?: string | null }> };

export type GetAddOnsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAddOnsQuery = { __typename?: 'Query', getAddOns: Array<{ __typename?: 'AddOn', id: string, name?: string | null }> };

export type GetAccessoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetAccessoriesQuery = { __typename?: 'Query', getAccessories: Array<{ __typename?: 'Accessory', id: string, name?: string | null }> };

export type SetProductMutationVariables = Exact<{
  input: SetProductInput;
}>;


export type SetProductMutation = { __typename?: 'Mutation', setProduct?: { __typename?: 'SetProductPayload', product?: { __typename?: 'Product', id: string, name?: string | null, quantity?: number | null, hourlyPrice?: number | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type SetAddOnMutationVariables = Exact<{
  input: SetAddOnInput;
}>;


export type SetAddOnMutation = { __typename?: 'Mutation', setAddOn?: { __typename?: 'SetAddOnPayload', addOn?: { __typename?: 'AddOn', id: string, name?: string | null, quantity?: number | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type SetAccessoryMutationVariables = Exact<{
  input: SetAccessoryInput;
}>;


export type SetAccessoryMutation = { __typename?: 'Mutation', setAccessory?: { __typename?: 'SetAccessoryPayload', accessory?: { __typename?: 'Accessory', id: string, name?: string | null, quantity?: number | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetPurchaseOrdersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  numberPer?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  paymentStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  inventoryStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  priority?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  createdAtLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  dateNeededGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  dateNeededLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  completionEstimateGte?: InputMaybe<Scalars['ISO8601DateTime']>;
  completionEstimateLte?: InputMaybe<Scalars['ISO8601DateTime']>;
  amountGte?: InputMaybe<Scalars['Float']>;
  amountLte?: InputMaybe<Scalars['Float']>;
  vendorIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetPurchaseOrdersQuery = { __typename?: 'Query', getPurchaseOrders: { __typename?: 'PurchaseOrderCollection', collection: Array<{ __typename?: 'PurchaseOrder', id: string, name?: string | null, number?: number | null, status?: string | null, paymentStatus?: string | null, inventoryStatus?: string | null, taxPercentage?: number | null, completionEstimate?: string | Date | null, dateNeeded?: string | Date | null, description?: string | null, note?: string | null, priority?: string | null, createdAt: string | Date, total?: number | null, purchaseOrderVendorRelationship?: { __typename?: 'PurchaseOrderVendorRelationship', id: string, name?: string | null } | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type GetVendorsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetVendorsQuery = { __typename?: 'Query', getVendors: Array<{ __typename?: 'Vendor', id: string, name?: string | null, sms?: string | null, emailAddress?: { __typename?: 'EmailAddress', id: string, emailAddress?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null }> };

export type SetVendorMutationVariables = Exact<{
  input: SetVendorInput;
}>;


export type SetVendorMutation = { __typename?: 'Mutation', setVendor?: { __typename?: 'SetVendorPayload', vendor?: { __typename?: 'Vendor', id: string, name?: string | null, sms?: string | null, emailAddress?: { __typename?: 'EmailAddress', id: string, emailAddress?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetChangeHistoryEntriesQueryVariables = Exact<{
  rentalToken: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
  perPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type GetChangeHistoryEntriesQuery = { __typename?: 'Query', getChangeHistoryEntries?: { __typename?: 'ChangeHistoryEntryCollection', collection: Array<{ __typename?: 'ChangeHistoryEntry', id: string, message?: string | null, createdAt: string | Date, updatedAt: string | Date, employee?: { __typename?: 'Employee', id: string, name?: string | null, uid: string, updatedAt: string | Date, createdAt: string | Date, provider: string, signInCount: number } | null, rental?: { __typename?: 'Rental', id: string, name?: string | null, token?: string | null, pictures: Array<string> } | null }>, metadata: { __typename?: 'CollectionMetadata', totalCount: number, totalPages: number, currentPage: number } } | null };

export type GetRentalEmailsQueryVariables = Exact<{
  rentalToken: Scalars['String'];
}>;


export type GetRentalEmailsQuery = { __typename?: 'Query', getRentalEmails?: Array<{ __typename?: 'RentalEmails', id: string, mailerKlass?: string | null, mailerAction?: string | null, sentAt?: string | Date | null, senderName?: string | null, recipient?: string | null, openedRecipient?: string | null, body?: string | null, documents?: Array<{ __typename?: 'Document', id: string, url?: string | null, fileFileName?: string | null }> | null }> | null };

export type GetEmailSettingQueryVariables = Exact<{
  emailSettingType?: InputMaybe<Scalars['String']>;
}>;


export type GetEmailSettingQuery = { __typename?: 'Query', getEmailSettings?: Array<{ __typename?: 'EmailSetting', id: string, customName?: string | null, customEmailNote?: string | null }> | null };

export type GetRentalForEmailsQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetRentalForEmailsQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', id: string, token?: string | null, name?: string | null, type?: string | null, status?: string | null, hasProposalSettings?: boolean | null, hasDocuments?: boolean | null, hasAgreement?: boolean | null, finalPaymentDueDateType?: string | null, emails?: Array<{ __typename?: 'RentalEmails', id: string, mailerAction?: string | null, mailerKlass?: string | null, recipient?: string | null, openedRecipient?: string | null, senderName?: string | null, sentAt?: string | Date | null, body?: string | null, documents?: Array<{ __typename?: 'Document', id: string, name?: string | null, fileUrl?: string | null, fileFileName?: string | null, url?: string | null }> | null }> | null, secondaryOrders?: Array<{ __typename?: 'Rental', id: string, token?: string | null, name?: string | null }> | null, customerRentalRelationships: Array<{ __typename?: 'CustomerRentalRelationship', id: string, client: { __typename?: 'CustomerLocationRelationship', email?: string | null, name?: string | null } }>, companyRentalRelationship?: { __typename?: 'CompanyRentalRelationship', company?: { __typename?: 'Company', name?: string | null, mainContactEmail?: { __typename?: 'EmailAddress', emailAddress?: string | null } | null } | null } | null, rentalSetting?: { __typename?: 'RentalSetting', discountSetting?: string | null, discountDisplay?: string | null } | null, disclaimerRentalRelationships?: Array<{ __typename?: 'DisclaimerRentalRelationship', id?: string | null }> | null, rentalStaffs: Array<{ __typename?: 'RentalStaff', id: string, staffPricingId?: number | null, rentalStaffMembers?: Array<{ __typename?: 'RentalStaffMember', id?: string | null, name?: string | null }> | null, staffRole?: { __typename?: 'StaffRole', id: string, name?: string | null, taxExempt?: boolean | null, staffPricings?: Array<{ __typename?: 'StaffPricing', id: string, price?: number | null, pricingType?: string | null, customTitle?: string | null }> | null } | null }>, notes: Array<{ __typename?: 'Note', id: string, message?: string | null, visibleToCustomer?: boolean | null, visibleToOperations?: boolean | null }>, payments?: Array<{ __typename?: 'Transaction', id: string, amount?: number | null, paymentDate?: string | Date | null, paymentType?: string | null, token?: string | null, customer?: { __typename?: 'Customer', id: string, name?: string | null } | null }> | null } };

export type ReusableRentalTransportForLoadListFragment = { __typename: 'RentalTransport', id: string, deliveryTicketId?: number | null, rentalStaffId?: number | null, serviceTicketId?: number | null, transportType?: string | null, cachedStartTime?: string | Date | null, cachedEndTime?: string | Date | null, createdAt: string | Date, updatedAt: string | Date, rentalTransportTruckRelationships?: Array<{ __typename: 'RentalTransportTruckRelationship', id: string, active?: boolean | null, position?: number | null, setupTime?: number | null, stopName?: string | null, stopType?: string | null, truckRouteId?: number | null, rentalTransportId?: number | null, createdAt: string | Date, updatedAt: string | Date, truckRoute?: { __typename: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truckId?: string | null, drivers?: Array<{ __typename: 'Driver', id: string, employeeId?: number | null, role?: string | null, name: string }> | null } | null, loadList?: { __typename: 'LoadList', id: string, loadListEntries?: Array<{ __typename: 'LoadListEntry', id: string, rentalItemId?: number | null, rentalAccessoryId?: number | null, rentalAddOnId?: number | null, rentalBundleId?: number | null, rentalInventoryId?: number | null, rentalInventoryType?: string | null }> | null } | null }> | null };

export type GetLoadListInfoQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetLoadListInfoQuery = { __typename?: 'Query', getRentalById: { __typename: 'Rental', id: string, token?: string | null, name?: string | null, status?: string | null, deliveryType?: string | null, deliveryAddressLocationName?: string | null, deliveryAddressStreetAddress1?: string | null, deliveryAddressStreetAddress2?: string | null, deliveryAddressCity?: string | null, deliveryAddressLocale?: string | null, deliveryAddressPostalCode?: string | null, deliveryAddressCountry?: string | null, rentalTransports: Array<{ __typename: 'RentalTransport', id: string, deliveryTicketId?: number | null, rentalStaffId?: number | null, serviceTicketId?: number | null, transportType?: string | null, cachedStartTime?: string | Date | null, cachedEndTime?: string | Date | null, createdAt: string | Date, updatedAt: string | Date, rentalTransportTruckRelationships?: Array<{ __typename: 'RentalTransportTruckRelationship', id: string, active?: boolean | null, position?: number | null, setupTime?: number | null, stopName?: string | null, stopType?: string | null, truckRouteId?: number | null, rentalTransportId?: number | null, createdAt: string | Date, updatedAt: string | Date, truckRoute?: { __typename: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truckId?: string | null, drivers?: Array<{ __typename: 'Driver', id: string, employeeId?: number | null, role?: string | null, name: string }> | null } | null, loadList?: { __typename: 'LoadList', id: string, loadListEntries?: Array<{ __typename: 'LoadListEntry', id: string, rentalItemId?: number | null, rentalAccessoryId?: number | null, rentalAddOnId?: number | null, rentalBundleId?: number | null, rentalInventoryId?: number | null, rentalInventoryType?: string | null }> | null } | null }> | null }>, rentalSections: Array<{ __typename: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null, sectionMemberships?: Array<{ __typename?: 'SectionMembership', id: string, position?: number | null, quantity?: number | null, rentalSectionId?: number | null, rentalInventoryId?: number | null, rentalInventoryType?: RentalInventoryTypeEnum | null, parentMembershipId?: number | null, parentConnectionType?: string | null, rentalInventory?: { __typename: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, bundleId?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null, rentalItems?: Array<{ __typename?: 'RentalItem', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null }> | null } | { __typename: 'RentalItem', serializedRentalItemsData?: any | null, id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null, shouldIncludeNotesInRentals?: boolean | null, visibleToOperations?: boolean | null }> | null } | { __typename: 'RentalStaff' } | null }> | null }>, schedule?: { __typename?: 'Schedule', startDateTime?: string | Date | null, endDateTime?: string | Date | null, startWindowFinish?: string | Date | null, endWindowBeginning?: string | Date | null, eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, shelfEnabled?: boolean | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, timeZone?: string | null, eventStartSetting?: string | null, eventEndSetting?: string | null } | null, products?: Array<{ __typename?: 'Product', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, lengthFt?: number | null, widthFt?: number | null, heightFt?: number | null, serializationStatus?: string | null, pictures: Array<{ __typename?: 'Picture', imgixUrl?: string | null, imgUrl?: string | null }> }> | null, accessories?: Array<{ __typename?: 'Accessory', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, lengthFt?: number | null, widthFt?: number | null, heightFt?: number | null, serializationStatus?: string | null, pictures: Array<{ __typename?: 'Picture', imgixUrl?: string | null, imgUrl?: string | null }> }> | null, addOns?: Array<{ __typename?: 'AddOn', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, lengthFt?: number | null, widthFt?: number | null, heightFt?: number | null, serializationStatus?: string | null, pictures: Array<{ __typename?: 'Picture', imgixUrl?: string | null, imgUrl?: string | null }> }> | null, bundles?: Array<{ __typename?: 'Bundle', id: string, name?: string | null, departmentNames?: string | null, pictures: Array<{ __typename?: 'Picture', imgixUrl?: string | null, imgUrl?: string | null }> }> | null }, getTrucks: Array<{ __typename: 'Truck', id: string, name?: string | null, active?: boolean | null, color?: string | null, alphabetId?: string | null, description?: string | null, notes?: string | null }> };

export type AssignTrucksToRentalTransportMutationVariables = Exact<{
  rentalTransportId: Scalars['ID'];
  truckIds: Array<Scalars['ID']> | Scalars['ID'];
  truckIdToAssignItems?: InputMaybe<Scalars['ID']>;
}>;


export type AssignTrucksToRentalTransportMutation = { __typename?: 'Mutation', assignTrucksToRentalTransport?: { __typename?: 'AssignTrucksToRentalTransportPayload', errors: Array<string>, rentalTransport?: { __typename: 'RentalTransport', id: string, deliveryTicketId?: number | null, rentalStaffId?: number | null, serviceTicketId?: number | null, transportType?: string | null, cachedStartTime?: string | Date | null, cachedEndTime?: string | Date | null, createdAt: string | Date, updatedAt: string | Date, rentalTransportTruckRelationships?: Array<{ __typename: 'RentalTransportTruckRelationship', id: string, active?: boolean | null, position?: number | null, setupTime?: number | null, stopName?: string | null, stopType?: string | null, truckRouteId?: number | null, rentalTransportId?: number | null, createdAt: string | Date, updatedAt: string | Date, truckRoute?: { __typename: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truckId?: string | null, drivers?: Array<{ __typename: 'Driver', id: string, employeeId?: number | null, role?: string | null, name: string }> | null } | null, loadList?: { __typename: 'LoadList', id: string, loadListEntries?: Array<{ __typename: 'LoadListEntry', id: string, rentalItemId?: number | null, rentalAccessoryId?: number | null, rentalAddOnId?: number | null, rentalBundleId?: number | null, rentalInventoryId?: number | null, rentalInventoryType?: string | null }> | null } | null }> | null } | null } | null };

export type UnassignTrucksFromRentalTransportMutationVariables = Exact<{
  rentalTransportId: Scalars['ID'];
  truckIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type UnassignTrucksFromRentalTransportMutation = { __typename?: 'Mutation', unassignTrucksFromRentalTransport?: { __typename?: 'UnassignTrucksFromRentalTransportPayload', errors: Array<string>, rentalTransport?: { __typename: 'RentalTransport', id: string, deliveryTicketId?: number | null, rentalStaffId?: number | null, serviceTicketId?: number | null, transportType?: string | null, cachedStartTime?: string | Date | null, cachedEndTime?: string | Date | null, createdAt: string | Date, updatedAt: string | Date, rentalTransportTruckRelationships?: Array<{ __typename: 'RentalTransportTruckRelationship', id: string, active?: boolean | null, position?: number | null, setupTime?: number | null, stopName?: string | null, stopType?: string | null, truckRouteId?: number | null, rentalTransportId?: number | null, createdAt: string | Date, updatedAt: string | Date, truckRoute?: { __typename: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truckId?: string | null, drivers?: Array<{ __typename: 'Driver', id: string, employeeId?: number | null, role?: string | null, name: string }> | null } | null, loadList?: { __typename: 'LoadList', id: string, loadListEntries?: Array<{ __typename: 'LoadListEntry', id: string, rentalItemId?: number | null, rentalAccessoryId?: number | null, rentalAddOnId?: number | null, rentalBundleId?: number | null, rentalInventoryId?: number | null, rentalInventoryType?: string | null }> | null } | null }> | null } | null } | null };

export type AssignItemsToLoadListMutationVariables = Exact<{
  rttrId: Scalars['ID'];
  rentalInventoryIds: Array<RentalInventoryIdInput> | RentalInventoryIdInput;
}>;


export type AssignItemsToLoadListMutation = { __typename?: 'Mutation', assignItemsToLoadList?: { __typename?: 'AssignItemsToLoadListPayload', errors: Array<string>, rentalTransport?: { __typename: 'RentalTransport', id: string, deliveryTicketId?: number | null, rentalStaffId?: number | null, serviceTicketId?: number | null, transportType?: string | null, cachedStartTime?: string | Date | null, cachedEndTime?: string | Date | null, createdAt: string | Date, updatedAt: string | Date, rentalTransportTruckRelationships?: Array<{ __typename: 'RentalTransportTruckRelationship', id: string, active?: boolean | null, position?: number | null, setupTime?: number | null, stopName?: string | null, stopType?: string | null, truckRouteId?: number | null, rentalTransportId?: number | null, createdAt: string | Date, updatedAt: string | Date, truckRoute?: { __typename: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truckId?: string | null, drivers?: Array<{ __typename: 'Driver', id: string, employeeId?: number | null, role?: string | null, name: string }> | null } | null, loadList?: { __typename: 'LoadList', id: string, loadListEntries?: Array<{ __typename: 'LoadListEntry', id: string, rentalItemId?: number | null, rentalAccessoryId?: number | null, rentalAddOnId?: number | null, rentalBundleId?: number | null, rentalInventoryId?: number | null, rentalInventoryType?: string | null }> | null } | null }> | null } | null } | null };

export type ExportRentalSlipsMutationVariables = Exact<{
  input: ExportRentalSlipsInput;
}>;


export type ExportRentalSlipsMutation = { __typename?: 'Mutation', exportRentalSlips?: { __typename?: 'ExportRentalSlipsPayload', exportProgressId: string } | null };

export type RentalSlipsZplQueryVariables = Exact<{
  rentalToken: Scalars['String'];
  slipCount: Scalars['Int'];
  dpi?: InputMaybe<Scalars['Int']>;
}>;


export type RentalSlipsZplQuery = { __typename?: 'Query', rentalSlipsZpl: string };

export type GetProposalSettingsQueryVariables = Exact<{
  rentalToken: Scalars['String'];
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetProposalSettingsQuery = { __typename?: 'Query', getProposalSettings?: Array<{ __typename?: 'ProposalSetting', id: string, documentUrl: string, authorName: string, createdAt: string | Date, createdFromTemplate: boolean }> | null };

export type ContactsGetCustomerLocationRelationshipsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ContactsGetCustomerLocationRelationshipsQuery = { __typename?: 'Query', getCustomerLocationRelationships: { __typename?: 'CustomerLocationRelationshipCollection', collection: Array<{ __typename?: 'CustomerLocationRelationship', id: string, name?: string | null, customerId?: number | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number } } };

export type ContactsGetCompanyLocationRelationshipsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type ContactsGetCompanyLocationRelationshipsQuery = { __typename?: 'Query', getCompanyLocationRelationships: { __typename?: 'CompanyLocationRelationshipCollection', collection: Array<{ __typename?: 'CompanyLocationRelationship', id: string, name?: string | null, companyId: number }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number } } };

export type ContactsGetCustomerLocationRelationshipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContactsGetCustomerLocationRelationshipQuery = { __typename?: 'Query', getCustomerLocationRelationship?: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, name?: string | null, title?: string | null, email?: string | null, driverLicenseNumber?: string | null, driverLicenseState?: string | null, notes?: string | null, shouldApplyDiscounts?: boolean | null, token?: string | null, depositType?: string | null, customDepositAmount?: number | null, shouldApplyDeposits?: boolean | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, file?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null, venues?: Array<{ __typename?: 'Venue', id: string, name?: string | null, notes?: string | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, file?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null }> | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, discounts?: Array<{ __typename?: 'Discount', id: string, name?: string | null, discountTargetType?: string | null, valueType?: string | null, amount?: number | null }> | null, companies?: Array<{ __typename?: 'Company', id: string, name?: string | null, taxExempt?: boolean | null, depositType?: string | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, customerLocationRelationships?: Array<{ __typename?: 'CustomerLocationRelationship', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, depositType?: string | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, file?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null }> | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, file?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null, companyLocationRelationships?: Array<{ __typename?: 'CompanyLocationRelationship', id: string, locationId: number, companyId: number }> | null, discounts?: Array<{ __typename?: 'Discount', id: string, name?: string | null, discountTargetType?: string | null, valueType?: string | null, amount?: number | null }> | null }> | null } | null };

export type ContactsGetCompanyLocationRelationshipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContactsGetCompanyLocationRelationshipQuery = { __typename?: 'Query', getCompanyLocationRelationship?: { __typename?: 'CompanyLocationRelationship', id: string, name?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, notes?: string | null, token?: string | null, depositType?: string | null, customDepositAmount?: number | null, shouldApplyDeposits?: boolean | null, taxExempt?: boolean | null, venues?: Array<{ __typename?: 'Venue', id: string, name?: string | null, notes?: string | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, file?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null }> | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, mainContactEmail?: { __typename?: 'EmailAddress', id: string, emailAddress?: string | null } | null, discounts?: Array<{ __typename?: 'Discount', id: string, name?: string | null, discountTargetType?: string | null, valueType?: string | null, amount?: number | null }> | null, customerLocationRelationships?: Array<{ __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, name?: string | null, depositType?: string | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, file?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null }> | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, fileUpdatedAt?: string | Date | null, id: string, createdAt: string | Date, documentType?: string | null, file?: string | null, visibleToCustomer?: boolean | null, fileContentType?: string | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null } | null } | null };

export type GetCompanyLocationRelationshipsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetCompanyLocationRelationshipsQuery = { __typename?: 'Query', getCompanyLocationRelationships: { __typename?: 'CompanyLocationRelationshipCollection', collection: Array<{ __typename?: 'CompanyLocationRelationship', id: string, name?: string | null, depositType?: string | null, companyId: number, company?: { __typename?: 'Company', accountOwner?: { __typename?: 'Employee', id: string, name?: string | null, role?: string | null } | null } | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type GetCustomerLocationRelationshipsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetCustomerLocationRelationshipsQuery = { __typename?: 'Query', getCustomerLocationRelationships: { __typename?: 'CustomerLocationRelationshipCollection', collection: Array<{ __typename?: 'CustomerLocationRelationship', id: string, name?: string | null, depositType?: string | null, customerId?: number | null }>, metadata: { __typename?: 'CollectionMetadata', totalPages: number, totalCount: number, currentPage: number, limitValue: number } } };

export type ContactsDrawerGetCustomerLocationRelationshipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContactsDrawerGetCustomerLocationRelationshipQuery = { __typename?: 'Query', getCustomerLocationRelationship?: { __typename?: 'CustomerLocationRelationship', id: string, firstName?: string | null, lastName?: string | null, title?: string | null, email?: string | null, driverLicenseNumber?: string | null, driverLicenseState?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null } | null };

export type ContactsDrawerGetCompanyLocationRelationshipQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ContactsDrawerGetCompanyLocationRelationshipQuery = { __typename?: 'Query', getCompanyLocationRelationship?: { __typename?: 'CompanyLocationRelationship', id: string, name?: string | null, company?: { __typename?: 'Company', id: string, name?: string | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, mainContactEmail?: { __typename?: 'EmailAddress', id: string, emailAddress?: string | null } | null } | null } | null };

export type SetCustomerLocationRelationshipMutationVariables = Exact<{
  input: SetCustomerLocationRelationshipInput;
}>;


export type SetCustomerLocationRelationshipMutation = { __typename?: 'Mutation', setCustomerLocationRelationship?: { __typename?: 'SetCustomerLocationRelationshipPayload', customer?: { __typename?: 'CustomerLocationRelationship', id: string, name?: string | null, title?: string | null, email?: string | null, driverLicenseNumber?: string | null, driverLicenseState?: string | null, phoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null, physicalAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type SetCompanyLocationRelationshipMutationVariables = Exact<{
  input: SetCompanyLocationRelationshipInput;
}>;


export type SetCompanyLocationRelationshipMutation = { __typename?: 'Mutation', setCompanyLocationRelationship?: { __typename?: 'SetCompanyLocationRelationshipPayload', company?: { __typename?: 'CompanyLocationRelationship', id: string, name?: string | null, companyId: number, company?: { __typename?: 'Company', id: string, mainContactEmail?: { __typename?: 'EmailAddress', id: string, emailAddress?: string | null } | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, mainPhoneNumber?: { __typename?: 'PhoneNumber', id: string, office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null } | null } | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetCommissionedCustomersQueryVariables = Exact<{
  companyLocationRelationshipId: Scalars['ID'];
}>;


export type GetCommissionedCustomersQuery = { __typename?: 'Query', getCommissionedCustomers: Array<{ __typename?: 'CommissionedCustomer', rate?: number | null, id: string, firstName?: string | null, lastName?: string | null }> };

export type GetZipCodeDeliveryFeesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetZipCodeDeliveryFeesQuery = { __typename?: 'Query', getZipCodeDeliveryFees: Array<{ __typename?: 'ZipCodeDeliveryFee', zipCodes: string, amount: number, name: string, id: string }> };

export type GetEmployeesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetEmployeesQuery = { __typename?: 'Query', getEmployees: Array<{ __typename?: 'Employee', id: string, name?: string | null, role?: string | null }> };

export type GetVenuesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
}>;


export type GetVenuesQuery = { __typename?: 'Query', getVenues: Array<{ __typename?: 'Venue', id: string, name?: string | null, notes?: string | null }> };

export type GetVenueQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetVenueQuery = { __typename?: 'Query', getVenue: { __typename?: 'Venue', id: string, name?: string | null, notes?: string | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, documents?: Array<{ __typename?: 'Document', fileFileName?: string | null, fileFileSize?: number | null, name?: string | null, fileUrl?: string | null, file?: string | null, fileUpdatedAt?: string | Date | null, fileContentType?: string | null, id: string, createdAt: string | Date, documentType?: string | null, visibleToCustomer?: boolean | null, expirable?: boolean | null, expiresAt?: string | Date | null, employee?: { __typename?: 'Employee', firstName?: string | null, lastName?: string | null } | null }> | null } };

export type SetVenueMutationVariables = Exact<{
  input: SetVenueInput;
}>;


export type SetVenueMutation = { __typename?: 'Mutation', setVenue?: { __typename?: 'SetVenuePayload', venue?: { __typename?: 'Venue', id: string, name?: string | null, notes?: string | null, phoneNumbers?: Array<{ __typename?: 'PhoneNumber', office?: string | null, extension?: string | null, cell?: string | null, fax?: string | null, mainContactNumber?: boolean | null }> | null, mainContactAddress?: { __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null } | null, physicalAddresses?: Array<{ __typename?: 'PhysicalAddress', id: string, country?: string | null, streetAddress1?: string | null, streetAddress2?: string | null, city?: string | null, locale?: string | null, postalCode?: string | null }> | null, names?: Array<{ __typename?: 'Name', id: string, firstName?: string | null, lastName?: string | null }> | null, emailAddresses?: Array<{ __typename?: 'EmailAddress', id: string, emailAddress?: string | null, primaryContactEmail?: boolean | null }> | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetRentalConversionStatusQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetRentalConversionStatusQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', conversionStatus: string, conversionErrorFormId?: number | null } };

export type GetDisclaimersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetDisclaimersQuery = { __typename?: 'Query', getDisclaimers: Array<{ __typename?: 'Disclaimer', id: string, name: string }> };

export type GetDisclaimerQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetDisclaimerQuery = { __typename?: 'Query', getDisclaimer: { __typename?: 'Disclaimer', id: string, title: string } };

export type GetDiscountsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  discountTargetType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDiscountsQuery = { __typename?: 'Query', getDiscounts: Array<{ __typename?: 'Discount', id: string, name?: string | null, valueType?: string | null, amount?: number | null, discountTargetType?: string | null }> };

export type GetFeesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  feeTargetType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetFeesQuery = { __typename?: 'Query', getFees: Array<{ __typename?: 'Fee', id: string, name?: string | null, valueType?: string | null, amount?: number | null, feeTargetType?: string | null, taxExempt?: boolean | null }> };

export type GetRentalAgreementsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetRentalAgreementsQuery = { __typename?: 'Query', getRentalAgreements: Array<{ __typename?: 'RentalAgreement', id: string, title?: string | null, name?: string | null }> };

export type FetchMissingSubrentedInventoryMutationVariables = Exact<{
  input: FetchMissingSubrentedInventoryInput;
}>;


export type FetchMissingSubrentedInventoryMutation = { __typename?: 'Mutation', fetchMissingSubrentedInventory?: { __typename?: 'FetchMissingSubrentedInventoryPayload', hasMismatch: boolean, inventories?: Array<{ __typename?: 'MissingSubrentedInventory', id: string, type: string, title: string, missingItems: number, subrentedLocations: Array<{ __typename?: 'MissingSubrentedLocation', id: string, name: string, amountSubrented?: number | null, isCurrentLocation: boolean }> }> | null } | null };

export type ResolveMissingSubrentedInventoryMutationVariables = Exact<{
  rentalId: Scalars['ID'];
  itemsToRemove: Scalars['JSON'];
}>;


export type ResolveMissingSubrentedInventoryMutation = { __typename?: 'Mutation', resolveMissingSubrentedInventory?: { __typename?: 'ResolveMissingSubrentedInventoryPayload', success: boolean, errors?: any | null } | null };

export type SectionPickListSectionFragment = { __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null };

export type SectionPickListNoteFragment = { __typename?: 'ItemNote', id: string, message?: string | null };

export type SectionPickListProductFragment = { __typename?: 'Product', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, serializationStatus?: string | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, lengthFt?: number | null, widthFt?: number | null, heightFt?: number | null, pictures: Array<{ __typename?: 'Picture', id: string, imgixUrl?: string | null }>, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string }> };

export type SectionPickListAccessoryInventoryFragment = { __typename?: 'Accessory', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, pictures: Array<{ __typename?: 'Picture', id: string, imgixUrl?: string | null }>, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string }> };

export type SectionPickListAddOnInventoryFragment = { __typename?: 'AddOn', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, pictures: Array<{ __typename?: 'Picture', id: string, imgixUrl?: string | null }>, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string }> };

export type SectionPickListSubRentalFragment = { __typename?: 'SubRental', id: string, name?: string | null, quantity?: number | null, supplierName?: string | null, supplierLocationCode?: string | null };

export type RentalPickListQueryVariables = Exact<{
  rentalId: Scalars['String'];
}>;


export type RentalPickListQuery = { __typename?: 'Query', rentalPickList: Array<{ __typename: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, pickedQuantity?: number | null, pickListPickedQuantity?: number | null, checkedInQuantity?: number | null, missingQuantity?: number | null, damagedQuantity?: number | null, lackNotes?: string | null, status?: string | null, pictures?: string | null, departmentName?: string | null, warehouseLocation?: string | null, pickListAccessoryId?: number | null, pickListStatus?: string | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null }> | null, rentalSection?: { __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null } | null, inventoryObject?: { __typename?: 'Accessory', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, pictures: Array<{ __typename?: 'Picture', id: string, imgixUrl?: string | null }>, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string }> } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, name?: string | null, quantity?: number | null, supplierName?: string | null, supplierLocationCode?: string | null }> | null } | { __typename: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, pickedQuantity?: number | null, pickListPickedQuantity?: number | null, returnedQuantity?: number | null, lackNotes?: string | null, status?: string | null, pictures?: string | null, departmentName?: string | null, warehouseLocation?: string | null, pickListAddOnId?: number | null, pickListStatus?: string | null, rentalSectionId?: number | null, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null }> | null, rentalSection?: { __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null } | null, inventoryObject?: { __typename?: 'AddOn', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, pictures: Array<{ __typename?: 'Picture', id: string, imgixUrl?: string | null }>, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string }> } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, name?: string | null, quantity?: number | null, supplierName?: string | null, supplierLocationCode?: string | null }> | null } | { __typename: 'RentalBundle' } | { __typename: 'RentalItem', id: string, name?: string | null, quantity?: number | null, pickedQuantity?: number | null, pickListPickedQuantity?: number | null, checkedInQuantity?: number | null, missingQuantity?: number | null, damagedQuantity?: number | null, lackNotes?: string | null, status?: string | null, pictures?: string | null, departmentName?: string | null, warehouseLocation?: string | null, pickListItemId?: number | null, pickListStatus?: string | null, rentalSectionId?: number | null, serialNumbers: Array<string>, itemNotes?: Array<{ __typename?: 'ItemNote', id: string, message?: string | null }> | null, rentalSection?: { __typename?: 'RentalSection', id: string, name?: string | null, position?: number | null, sectionType?: string | null } | null, inventoryObject?: { __typename?: 'Product', id: string, name?: string | null, departmentNames?: string | null, warehouseLocation?: string | null, serializationStatus?: string | null, weight?: number | null, length?: number | null, width?: number | null, height?: number | null, lengthFt?: number | null, widthFt?: number | null, heightFt?: number | null, pictures: Array<{ __typename?: 'Picture', id: string, imgixUrl?: string | null }>, sfCategories: Array<{ __typename?: 'StorefrontCategory', id: string, name: string }> } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, name?: string | null, quantity?: number | null, supplierName?: string | null, supplierLocationCode?: string | null }> | null } | { __typename: 'RentalStaff' }> };

export type ReturnPickedSerializedInventoryMutationVariables = Exact<{
  input: ReturnPickedSerializedInventoryInput;
}>;


export type ReturnPickedSerializedInventoryMutation = { __typename?: 'Mutation', returnPickedSerializedInventory?: { __typename?: 'ReturnPickedSerializedInventoryPayload', success: boolean, errors?: Array<string> | null } | null };

export type ArchivePickedSerializedInventoryMutationVariables = Exact<{
  input: ArchivePickedSerializedInventoryInput;
}>;


export type ArchivePickedSerializedInventoryMutation = { __typename?: 'Mutation', archivePickedSerializedInventory?: { __typename?: 'ArchivePickedSerializedInventoryPayload', success: boolean, errors?: Array<string> | null } | null };

export type ExportInvoicesMutationVariables = Exact<{
  input: ExportInvoicesInput;
}>;


export type ExportInvoicesMutation = { __typename?: 'Mutation', exportInvoices?: { __typename?: 'ExportInvoicesPayload', message: string } | null };

export type GetSalesTaxReportQueryVariables = Exact<{
  locationIds: Array<Scalars['Int']> | Scalars['Int'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']>;
  accountingMethod: Scalars['String'];
}>;


export type GetSalesTaxReportQuery = { __typename?: 'Query', getSalesTaxCashBasisReport: { __typename?: 'SalesTaxCashBasisReport', summaryByState?: Array<{ __typename?: 'Summary', taxName?: string | null, taxType?: string | null, taxablePercent?: string | null, totalTransactionVolume?: number | null, overallTotal?: number | null, nontaxableVolume?: number | null, taxPercent?: number | null, proportionalSubTotalForTax?: number | null, totalTaxPayments?: number | null }> | null, summaryByCounty?: Array<{ __typename?: 'Summary', taxName?: string | null, taxType?: string | null, taxablePercent?: string | null, totalTransactionVolume?: number | null, overallTotal?: number | null, nontaxableVolume?: number | null, taxPercent?: number | null, proportionalSubTotalForTax?: number | null, totalTaxPayments?: number | null }> | null, summary?: Array<{ __typename?: 'Summary', taxName?: string | null, taxType?: string | null, taxablePercent?: string | null, totalTransactionVolume?: number | null, overallTotal?: number | null, nontaxableVolume?: number | null, taxPercent?: number | null, proportionalSubTotalForTax?: number | null, totalTaxPayments?: number | null }> | null, totals?: { __typename?: 'Totals', totalTransactionVolume?: number | null, subTotalForTaxVolume?: number | null, totalOrderVolume?: number | null, totalNonTaxableOrderVolume?: number | null, proportionalSubTotalForTax?: number | null, proportionalPercent?: number | null } | null, details?: Array<{ __typename?: 'Details', token?: string | null, orderName?: string | null, payment?: number | null, taxPercent?: number | null, paymentDate?: string | Date | null, amount?: number | null, overallTotal?: number | null, taxAmountDue?: number | null, grandTaxTotal?: number | null, taxName?: string | null, taxType?: string | null, refundAmount?: number | null, taxPaymentsBasedOnTotal?: number | null, subTotalForTax?: number | null, displayOrder?: number | null, eventStartDate?: string | Date | null }> | null } };

export type SummaryFragmentFragment = { __typename?: 'Summary', taxName?: string | null, taxType?: string | null, taxablePercent?: string | null, totalTransactionVolume?: number | null, overallTotal?: number | null, nontaxableVolume?: number | null, taxPercent?: number | null, proportionalSubTotalForTax?: number | null, totalTaxPayments?: number | null };

export type EditTrucksForRentalTransportMutationVariables = Exact<{
  rentalTransportId: Scalars['ID'];
  truckIdsToAssign: Array<Scalars['ID']> | Scalars['ID'];
  truckIdsToUnassign: Array<Scalars['ID']> | Scalars['ID'];
  truckIdToAssignItems?: InputMaybe<Scalars['ID']>;
}>;


export type EditTrucksForRentalTransportMutation = { __typename?: 'Mutation', assignTrucksToRentalTransport?: { __typename?: 'AssignTrucksToRentalTransportPayload', errors: Array<string> } | null, unassignTrucksFromRentalTransport?: { __typename?: 'UnassignTrucksFromRentalTransportPayload', errors: Array<string> } | null };

export type ReassignDriversMutationVariables = Exact<{
  input: ReassignDriversInput;
}>;


export type ReassignDriversMutation = { __typename?: 'Mutation', reassignDrivers?: { __typename?: 'ReassignDriversPayload', errors: Array<string>, drivers: Array<{ __typename?: 'Driver', id: string, employeeId?: number | null, role?: string | null, truckRouteId?: number | null, createdAt: string | Date, updatedAt: string | Date, name: string }> } | null };

export type SetTruckRouteMutationVariables = Exact<{
  input: SetTruckRouteInput;
}>;


export type SetTruckRouteMutation = { __typename?: 'Mutation', setTruckRoute?: { __typename?: 'SetTruckRoutePayload', truckRoute?: { __typename?: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truck?: { __typename?: 'Truck', id: string, name?: string | null, color?: string | null } | null } | null } | null };

export type GetRentalsByTransportsQueryVariables = Exact<{
  startDateTimeGte?: InputMaybe<Scalars['String']>;
  startDateTimeLte?: InputMaybe<Scalars['String']>;
  employeeIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  rentalStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  transportType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  truckIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type GetRentalsByTransportsQuery = { __typename?: 'Query', getRentalsByTransports: Array<{ __typename?: 'Rental', token?: string | null, name?: string | null, hasDocuments?: boolean | null, totalInventoryCount: number, startDateTime?: string | Date | null, endDateTime?: string | Date | null, eventStartSetting?: string | null, eventEndSetting?: string | null, hasSetByTime?: boolean | null, setByTimeDateTime?: string | Date | null, customers: Array<{ __typename?: 'Customer', name?: string | null, email?: string | null }>, company?: { __typename?: 'Company', name?: string | null, primaryContactEmail?: string | null } | null, pickListItems: Array<{ __typename?: 'PickListItem', name?: string | null, quantity?: number | null }>, pickListAddOns: Array<{ __typename?: 'PickListAddOn', name?: string | null, quantity?: number | null }>, pickListAccessories: Array<{ __typename?: 'PickListAccessory', name?: string | null, quantity?: number | null }>, rentalTransports: Array<{ __typename?: 'RentalTransport', id: string, rentalStaffId?: number | null, transportType?: string | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, drivers?: Array<{ __typename?: 'Driver', name: string, role?: string | null, rentalTransportId?: number | null }> | null, rentalTransportTruckRelationships?: Array<{ __typename?: 'RentalTransportTruckRelationship', id: string, truckRouteId?: number | null, truckRoute?: { __typename?: 'TruckRoute', id: string, deliveryDate?: string | Date | null, startTime?: string | Date | null, truck?: { __typename?: 'Truck', name?: string | null, color?: string | null } | null, drivers?: Array<{ __typename?: 'Driver', name: string, role?: string | null, rentalTransportId?: number | null }> | null } | null }> | null }>, serviceTickets: Array<{ __typename?: 'ServiceTicket', routingStartDateTime?: string | Date | null, routingEndDateTime?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null, rentalStaffId?: number | null }>, rentalStaffs: Array<{ __typename?: 'RentalStaff', id: string, name?: string | null }>, event?: { __typename: 'Event', id: string, name?: string | null, token: string, eventEndDateTime?: string | Date | null, eventStartDateTime?: string | Date | null } | null }> };

export type GetTrucksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrucksQuery = { __typename?: 'Query', getTrucks: Array<{ __typename?: 'Truck', id: string, name?: string | null, color?: string | null, notes?: string | null, active?: boolean | null, alphabetId?: string | null, locationId: number, createdAt: string | Date, updatedAt: string | Date }> };

export type GetPricingPreviewQueryVariables = Exact<{
  pricingTier: Scalars['String'];
}>;


export type GetPricingPreviewQuery = { __typename?: 'Query', getPricingPreview?: { __typename?: 'PricingPreview', amount?: number | null, billingCycle?: string | Date | null, newSubscriptionAmount?: number | null } | null };

export type GetSfCategoriesForCategoryModalQueryVariables = Exact<{
  locationId: Scalars['Int'];
  order?: InputMaybe<StorefrontCategoryOrderEnum>;
  orderDirection?: InputMaybe<StorefrontCategoryDirectionEnum>;
}>;


export type GetSfCategoriesForCategoryModalQuery = { __typename?: 'Query', getStorefrontCategories: Array<{ __typename: 'StorefrontCategory', id: string, name: string, depth: number, path: string, visibleOnSf: boolean }> };

export type CreateCategoryMutationVariables = Exact<{
  input: SetStorefrontCategoryInput;
}>;


export type CreateCategoryMutation = { __typename?: 'Mutation', setStorefrontCategory?: { __typename?: 'SetStorefrontCategoryPayload', sfCategory?: { __typename: 'StorefrontCategory', id: string, name: string, slug: string, parentId?: number | null, visibleOnSf: boolean } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type BulkCreateTagsMutationVariables = Exact<{
  input: BulkSetStorefrontTagsInput;
}>;


export type BulkCreateTagsMutation = { __typename?: 'Mutation', bulkSetStorefrontTags?: { __typename?: 'BulkSetStorefrontTagsPayload', sfTags?: Array<{ __typename: 'StorefrontTag', id: string, locationId: number, name: string }> | null, errors?: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } | null } | null };

export type ListSfCategoriesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  locationId: Scalars['Int'];
  order?: InputMaybe<StorefrontCategoryOrderEnum>;
  orderDirection?: InputMaybe<StorefrontCategoryDirectionEnum>;
}>;


export type ListSfCategoriesQuery = { __typename?: 'Query', getStorefrontCategories: Array<{ __typename: 'StorefrontCategory', id: string, name: string, depth: number, path: string, slug: string, parentId?: number | null, visibleOnSf: boolean, childrenCount: number, locationId: number }> };

export type DeleteSfCategoryMutationVariables = Exact<{
  input: DeleteStorefrontCategoryInput;
}>;


export type DeleteSfCategoryMutation = { __typename?: 'Mutation', deleteStorefrontCategory?: { __typename?: 'DeleteStorefrontCategoryPayload', sfCategory?: { __typename: 'StorefrontCategory', id: string, name: string, depth: number, path: string, slug: string, parentId?: number | null, visibleOnSf: boolean } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null } } | null };

export type SetStorefrontTagMutationVariables = Exact<{
  input: SetStorefrontTagInput;
}>;


export type SetStorefrontTagMutation = { __typename?: 'Mutation', setStorefrontTag?: { __typename?: 'SetStorefrontTagPayload', sfTag?: { __typename: 'StorefrontTag', id: string, name: string, locationId: number, itemCount?: number | null } | null, errors?: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } | null } | null };

export type SetStorefrontTagItemRelationshipMutationVariables = Exact<{
  input: SetStorefrontTagItemRelationshipInput;
}>;


export type SetStorefrontTagItemRelationshipMutation = { __typename?: 'Mutation', setStorefrontTagItemRelationship?: { __typename?: 'SetStorefrontTagItemRelationshipPayload', sfTagItemRelationship?: { __typename: 'StorefrontTagItemRelationship', id: string, itemId: number, itemType: InventoryTypeEnum, sfTagId: number, sfTag: { __typename: 'StorefrontTag', id: string, name: string, locationId: number, itemCount?: number | null } } | null, errors?: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } | null } | null };

export type DeleteStorefrontTagMutationVariables = Exact<{
  input: DeleteStorefrontTagInput;
}>;


export type DeleteStorefrontTagMutation = { __typename?: 'Mutation', deleteStorefrontTag?: { __typename?: 'DeleteStorefrontTagPayload', sfTag?: { __typename: 'StorefrontTag', id: string, name: string, locationId: number, itemCount?: number | null } | null, errors?: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } | null } | null };

export type DeleteStorefrontTagItemRelationshipMutationVariables = Exact<{
  input: DeleteStorefrontTagItemRelationshipInput;
}>;


export type DeleteStorefrontTagItemRelationshipMutation = { __typename?: 'Mutation', deleteStorefrontTagItemRelationship?: { __typename?: 'DeleteStorefrontTagItemRelationshipPayload', sfTagItemRelationship?: { __typename: 'StorefrontTagItemRelationship', id: string, itemId: number, itemType: InventoryTypeEnum, sfTagId: number, sfTag: { __typename: 'StorefrontTag', id: string, name: string, locationId: number, itemCount?: number | null } } | null, errors?: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } | null } | null };

export type ListTagsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type ListTagsQuery = { __typename?: 'Query', getStorefrontTags?: Array<{ __typename: 'StorefrontTag', id: string, name: string, locationId: number, itemCount?: number | null, sfTagItemRelationships: Array<{ __typename: 'StorefrontTagItemRelationship', id: string, itemId: number, itemType: InventoryTypeEnum, sfTagId: number }> }> | null };

export type StorefrontTagItemRelationshipFragment = { __typename: 'StorefrontTagItemRelationship', id: string, itemId: number, itemType: InventoryTypeEnum, sfTagId: number };

export type StorefrontTagFragment = { __typename: 'StorefrontTag', id: string, name: string, locationId: number, itemCount?: number | null };

export type GenerateBearerTokenMutationVariables = Exact<{
  accessType?: InputMaybe<Scalars['String']>;
}>;


export type GenerateBearerTokenMutation = { __typename?: 'Mutation', generateBearerToken?: { __typename?: 'GenerateBearerTokenPayload', response: string, errors: Array<{ __typename?: 'ValidationErrors', fullMessages?: Array<string> | null }> } | null };

export type GetRedirectHostsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRedirectHostsQuery = { __typename?: 'Query', getRedirectHosts: Array<{ __typename: 'RedirectHost', id: string, hostname: string }> };

export type DeleteBearerTokenMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type DeleteBearerTokenMutation = { __typename?: 'Mutation', deleteBearerToken?: { __typename?: 'DeleteBearerTokenPayload', success: boolean, errors: Array<{ __typename?: 'ValidationErrors', fullMessages?: Array<string> | null }> } | null };

export type GetApiKeysQueryVariables = Exact<{ [key: string]: never; }>;


export type GetApiKeysQuery = { __typename?: 'Query', getApiKeys: Array<{ __typename?: 'ApiKey', id: string, businessId: string, createdAt: string | Date, tokenSuffix: string, accessType?: string | null }> };

export type SetRedirectHostMutationVariables = Exact<{
  input: SetRedirectHostInput;
}>;


export type SetRedirectHostMutation = { __typename?: 'Mutation', setRedirectHost?: { __typename?: 'SetRedirectHostPayload', redirectHost?: { __typename: 'RedirectHost', id: string, hostname: string } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type DeleteRedirectHostMutationVariables = Exact<{
  input: DeleteRedirectHostInput;
}>;


export type DeleteRedirectHostMutation = { __typename?: 'Mutation', deleteRedirectHost?: { __typename?: 'DeleteRedirectHostPayload', redirectHost?: { __typename: 'RedirectHost', id: string, hostname: string } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type SetWebhookSettingsMutationVariables = Exact<{
  input: SetWebhookSettingsInput;
}>;


export type SetWebhookSettingsMutation = { __typename?: 'Mutation', setWebhookSettings?: { __typename?: 'SetWebhookSettingsPayload', business?: { __typename?: 'Business', id: string, webhookMode: string, webhookLive?: string | null, webhookTest?: string | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type GetRolesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  roleType?: InputMaybe<Scalars['String']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', getRoles: Array<{ __typename?: 'Role', id: string, name?: string | null, roleType?: number | null, roleTypeString?: string | null, roleKey?: string | null }> };

export type SetRoleMutationVariables = Exact<{
  input: SetRoleInput;
}>;


export type SetRoleMutation = { __typename?: 'Mutation', setRole?: { __typename?: 'SetRolePayload', role?: { __typename?: 'Role', id: string, name?: string | null, roleType?: number | null } | null, errors: { __typename?: 'ValidationErrors', fullMessages?: Array<string> | null, details?: Array<{ __typename?: 'FieldError', field?: string | null, messages?: Array<string> | null }> | null } } | null };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;


export type DeleteRoleMutation = { __typename?: 'Mutation', deleteRole?: { __typename?: 'DeleteRolePayload', success: boolean, errors: Array<string>, deletedRole?: string | null } | null };

export type GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery = { __typename?: 'Query', getUniqueLocationEmployeeEmails: Array<{ __typename?: 'EmployeeLocationRelationship', employeeId?: string | null, employeeEmail?: string | null }> };

export type SetRefundMutationVariables = Exact<{
  input: SetRefundInput;
}>;


export type SetRefundMutation = { __typename?: 'Mutation', setRefund?: { __typename?: 'SetRefundPayload', success?: boolean | null, error: string } | null };

export type GetGrailpayOwnerBankAccountsQueryVariables = Exact<{
  ownerId: Scalars['ID'];
  ownerType: Scalars['String'];
}>;


export type GetGrailpayOwnerBankAccountsQuery = { __typename?: 'Query', getGrailpayOwnerBankAccounts: Array<{ __typename?: 'BankAccount', id: string, token: string, last4?: string | null, active?: boolean | null, bankName?: string | null, createdAt: string | Date, updatedAt: string | Date, paymentProcessor: string }> };

export type GetRentalInventoryForOverbookingModalQueryVariables = Exact<{
  rentalId: Scalars['Int'];
}>;


export type GetRentalInventoryForOverbookingModalQuery = { __typename?: 'Query', getRentalInventory: Array<{ __typename: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, subRentedQuantity: number } | { __typename: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, subRentedQuantity: number } | { __typename: 'RentalBundle', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null } | { __typename: 'RentalItem', id: string, name?: string | null, quantity?: number | null, inventoryId?: number | null, subRentedQuantity: number } | { __typename: 'RentalStaff', id: string, name?: string | null, size?: number | null, inventoryId?: number | null }> };

export type GetNestedSfCategoriesForLinkBuilderQueryVariables = Exact<{
  locationId: Scalars['Int'];
  order?: InputMaybe<StorefrontCategoryOrderEnum>;
  direction?: InputMaybe<StorefrontCategoryDirectionEnum>;
}>;


export type GetNestedSfCategoriesForLinkBuilderQuery = { __typename?: 'Query', getStorefrontCategories: Array<{ __typename: 'StorefrontCategory', id: string, name: string, path: string, parentId?: number | null, depth: number }> };

export type ProductPaginatedAlertingQueryVariables = Exact<{
  rentalId?: InputMaybe<Scalars['ID']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
  productId?: InputMaybe<Scalars['String']>;
  combineLikeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  selectedDate?: InputMaybe<Scalars['String']>;
}>;


export type ProductPaginatedAlertingQuery = { __typename?: 'Query', productPaginatedAlerting: { __typename?: 'RentalItemAlerting', meta?: any | null, error?: string | null, rentalItems?: Array<{ __typename?: 'RentalItem', quantity?: number | null, hasShortage?: boolean | null, rentalStatus?: string | null, rentalName?: string | null, rentalToken?: string | null, unavailabilityReason?: string | null, rentalSchedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, supplierName?: string | null, rentalItemId?: string | null, quantity?: number | null, expense?: number | null, createdAt?: string | Date | null, updatedAt?: string | Date | null, rentalAccessoryId?: string | null, subRentalOwnerId?: number | null, subRentalOwnerType?: string | null, fulfilled?: boolean | null, subRentalSupplierId?: string | null, subRentalSupplierType?: string | null, name?: string | null, customerName?: string | null, contact?: string | null }> | null }> | null } };

export type AddOnPaginatedAlertingQueryVariables = Exact<{
  rentalId?: InputMaybe<Scalars['ID']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
  addOnId?: InputMaybe<Scalars['String']>;
  combineLikeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  selectedDate?: InputMaybe<Scalars['String']>;
}>;


export type AddOnPaginatedAlertingQuery = { __typename?: 'Query', addOnPaginatedAlerting: { __typename?: 'RentalAddOnAlerting', meta?: any | null, error?: string | null, rentalAddOns?: Array<{ __typename?: 'RentalAddOn', quantity?: number | null, hasShortage?: boolean | null, rentalStatus?: string | null, rentalName?: string | null, rentalToken?: string | null, unavailabilityReason?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, endWindowBeginning?: string | Date | null, startDateTime?: string | Date | null } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, supplierName?: string | null, rentalItemId?: string | null, quantity?: number | null, expense?: number | null, createdAt?: string | Date | null, updatedAt?: string | Date | null, rentalAccessoryId?: string | null, subRentalOwnerId?: number | null, subRentalOwnerType?: string | null, fulfilled?: boolean | null, subRentalSupplierId?: string | null, subRentalSupplierType?: string | null, name?: string | null, customerName?: string | null, contact?: string | null }> | null }> | null } };

export type AccessoryPaginatedAlertingQueryVariables = Exact<{
  rentalId?: InputMaybe<Scalars['ID']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
  accessoryId?: InputMaybe<Scalars['String']>;
  combineLikeItems?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  selectedDate?: InputMaybe<Scalars['String']>;
}>;


export type AccessoryPaginatedAlertingQuery = { __typename?: 'Query', accessoryPaginatedAlerting: { __typename?: 'RentalAccessoryAlerting', meta?: any | null, error?: string | null, rentalAccessories?: Array<{ __typename?: 'RentalAccessory', quantity?: number | null, hasShortage?: boolean | null, rentalStatus?: string | null, rentalName?: string | null, rentalToken?: string | null, unavailabilityReason?: string | null, rentalSchedule?: { __typename?: 'Schedule', eventStartDateTime?: string | Date | null, eventEndDateTime?: string | Date | null, offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, endWindowBeginning?: string | Date | null, startDateTime?: string | Date | null } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, supplierName?: string | null, rentalItemId?: string | null, quantity?: number | null, expense?: number | null, createdAt?: string | Date | null, updatedAt?: string | Date | null, rentalAccessoryId?: string | null, subRentalOwnerId?: number | null, subRentalOwnerType?: string | null, fulfilled?: boolean | null, subRentalSupplierId?: string | null, subRentalSupplierType?: string | null, name?: string | null, customerName?: string | null, contact?: string | null }> | null }> | null } };

export type GetColumnFilterQueryVariables = Exact<{
  rentalStatus: Scalars['String'];
}>;


export type GetColumnFilterQuery = { __typename?: 'Query', getColumnFilter?: { __typename?: 'ColumnFilter', id: string, rentalStatus: string, settings: any } | null };

export type UpdateColumnFilterMutationVariables = Exact<{
  rentalStatus: Scalars['String'];
  settings: Scalars['JSON'];
}>;


export type UpdateColumnFilterMutation = { __typename?: 'Mutation', updateColumnFilter?: { __typename?: 'UpdateColumnFilterPayload', errors: Array<string>, columnFilter?: { __typename?: 'ColumnFilter', id: string, rentalStatus: string, settings: any } | null } | null };

export type GetRentalInventoryShortagesQueryVariables = Exact<{
  locationId: Scalars['Int'];
  startDate: Scalars['String'];
  endDate: Scalars['String'];
  departmentIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  timeZoneOffset?: InputMaybe<Scalars['String']>;
  deliveryTypes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetRentalInventoryShortagesQuery = { __typename?: 'Query', getRentalInventoryShortages: { __typename?: 'RentalInventoryShortages', rentalInventories: Array<{ __typename: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, hasShortage?: boolean | null, hasSoftHold?: boolean | null, shortageQuantity?: number | null, softHoldQuantity?: number | null, productType?: string | null, inventoryId?: number | null, inventoryToken?: string | null, warehouseQuantity?: number | null, maintenanceQuantity?: number | null, subRentedQuantity: number, deliveryType?: string | null, customerContactName?: string | null, itemType?: string | null, rentalSectionName?: string | null, groupInfo?: any | null, inventoryName?: string | null, parentRental?: { __typename?: 'Rental', id: string, locationId?: number | null, token?: string | null, name?: string | null, status?: string | null, source?: string | null, schedule?: { __typename?: 'Schedule', offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null } | null } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, quantity?: number | null }> | null } | { __typename: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, hasShortage?: boolean | null, hasSoftHold?: boolean | null, shortageQuantity?: number | null, softHoldQuantity?: number | null, productType?: string | null, inventoryId?: number | null, inventoryToken?: string | null, warehouseQuantity?: number | null, maintenanceQuantity?: number | null, subRentedQuantity: number, deliveryType?: string | null, customerContactName?: string | null, itemType?: string | null, rentalSectionName?: string | null, groupInfo?: any | null, inventoryName?: string | null, parentRental?: { __typename?: 'Rental', id: string, locationId?: number | null, token?: string | null, name?: string | null, status?: string | null, source?: string | null, schedule?: { __typename?: 'Schedule', offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null } | null } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, quantity?: number | null }> | null } | { __typename?: 'RentalBundle' } | { __typename: 'RentalItem', id: string, name?: string | null, quantity?: number | null, hasShortage?: boolean | null, hasSoftHold?: boolean | null, shortageQuantity?: number | null, softHoldQuantity?: number | null, productType?: string | null, inventoryId?: number | null, inventoryToken?: string | null, warehouseQuantity?: number | null, maintenanceQuantity?: number | null, subRentedQuantity: number, deliveryType?: string | null, customerContactName?: string | null, itemType?: string | null, rentalSectionName?: string | null, groupInfo?: any | null, inventoryName?: string | null, parentRental?: { __typename?: 'Rental', id: string, locationId?: number | null, token?: string | null, name?: string | null, status?: string | null, source?: string | null, schedule?: { __typename?: 'Schedule', offShelfAt?: string | Date | null, onShelfAt?: string | Date | null, startDateTime?: string | Date | null, endDateTime?: string | Date | null } | null } | null, subRentals?: Array<{ __typename?: 'SubRental', id: string, quantity?: number | null }> | null } | { __typename?: 'RentalStaff' }> } };

export type GetRentalInventoriesQueryVariables = Exact<{
  status: Scalars['String'];
  locationId: Scalars['Int'];
  page: Scalars['Int'];
  numberPer?: InputMaybe<Scalars['Int']>;
  startDateLte?: InputMaybe<Scalars['String']>;
  startDateGte?: InputMaybe<Scalars['String']>;
  endDateLte?: InputMaybe<Scalars['String']>;
  endDateGte?: InputMaybe<Scalars['String']>;
  startWindowFinishLte?: InputMaybe<Scalars['String']>;
  startWindowFinishGte?: InputMaybe<Scalars['String']>;
  endWindowBeginningLte?: InputMaybe<Scalars['String']>;
  endWindowBeginningGte?: InputMaybe<Scalars['String']>;
  departmentIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  pickedStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryType?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  deliveryTime?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  truckIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  inventoryId?: InputMaybe<Scalars['String']>;
  pickListStatus?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  productType?: InputMaybe<Scalars['String']>;
  sortField?: InputMaybe<Scalars['String']>;
  sortDirection?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetRentalInventoriesQuery = { __typename?: 'Query', getRentalInventories: { __typename?: 'RentalInventories', pagination?: any | null, rentalInventories?: Array<{ __typename: 'RentalAccessory', id: string, name?: string | null, quantity?: number | null, departmentName?: string | null, warehouseLocation?: string | null, hasShortage?: boolean | null, status?: string | null, pickListStatus?: string | null, pickListQuantity?: number | null, pickListPickedQuantity?: number | null, pickListMissingQuantity?: number | null, pictures?: string | null, rentalSchedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, startDateTime?: string | Date | null, eventEndSetting?: string | null, eventStartSetting?: string | null, endWindowBeginning?: string | Date | null } | null, parentRental?: { __typename?: 'Rental', locationId?: number | null, token?: string | null, name?: string | null, schedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, startDateTime?: string | Date | null, eventEndSetting?: string | null, eventStartSetting?: string | null } | null } | null } | { __typename: 'RentalAddOn', id: string, name?: string | null, quantity?: number | null, departmentName?: string | null, warehouseLocation?: string | null, hasShortage?: boolean | null, status?: string | null, pickListStatus?: string | null, pickListQuantity?: number | null, pickListPickedQuantity?: number | null, pickListMissingQuantity?: number | null, pictures?: string | null, rentalSchedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, startDateTime?: string | Date | null, eventEndSetting?: string | null, eventStartSetting?: string | null, endWindowBeginning?: string | Date | null } | null, parentRental?: { __typename?: 'Rental', locationId?: number | null, token?: string | null, name?: string | null, schedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, startDateTime?: string | Date | null, eventEndSetting?: string | null, eventStartSetting?: string | null } | null } | null } | { __typename?: 'RentalBundle' } | { __typename: 'RentalItem', id: string, name?: string | null, quantity?: number | null, departmentName?: string | null, warehouseLocation?: string | null, status?: string | null, hasShortage?: boolean | null, pickListStatus?: string | null, pickListQuantity?: number | null, pickListPickedQuantity?: number | null, pickListMissingQuantity?: number | null, pictures?: string | null, rentalSchedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, startDateTime?: string | Date | null, eventEndSetting?: string | null, eventStartSetting?: string | null, endWindowBeginning?: string | Date | null } | null, parentRental?: { __typename?: 'Rental', locationId?: number | null, token?: string | null, name?: string | null, status?: string | null, schedule?: { __typename?: 'Schedule', endDateTime?: string | Date | null, startDateTime?: string | Date | null, eventEndSetting?: string | null, eventStartSetting?: string | null } | null } | null } | { __typename?: 'RentalStaff' }> | null } };

export type GetRentalUpdatedAtQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetRentalUpdatedAtQuery = { __typename?: 'Query', getRentalById: { __typename?: 'Rental', id: string, updatedAt: string | Date } };

export type GetRentalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  eventId?: InputMaybe<Scalars['ID']>;
}>;


export type GetRentalsQuery = { __typename?: 'Query', getRentals: Array<{ __typename?: 'Rental', id: string, name?: string | null }> };

export const RentalAddressFragmentDoc = gql`
    fragment RentalAddress on Rental {
  deliveryAddressStreetAddress1
  deliveryAddressStreetAddress2
  deliveryAddressPostalCode
  deliveryAddressLocationName
  deliveryAddressLocale
  deliveryAddressCity
  deliveryAddressCountry
  deliveryType
}
    `;
export const ReusableRentalItemSimpleFragmentDoc = gql`
    fragment ReusableRentalItemSimple on RentalItem {
  id
  name
  quantity
  inventoryId
  itemNotes {
    id
    message
    shouldIncludeNotesInRentals
    visibleToOperations
  }
}
    `;
export const ReusableRentalAccessorySimpleFragmentDoc = gql`
    fragment ReusableRentalAccessorySimple on RentalAccessory {
  id
  name
  quantity
  inventoryId
  itemNotes {
    id
    message
    shouldIncludeNotesInRentals
    visibleToOperations
  }
}
    `;
export const ReusableRentalAddOnSimpleFragmentDoc = gql`
    fragment ReusableRentalAddOnSimple on RentalAddOn {
  id
  name
  quantity
  inventoryId
  itemNotes {
    id
    message
    shouldIncludeNotesInRentals
    visibleToOperations
  }
}
    `;
export const ReusableDisclaimerRentalRelationshipFragmentDoc = gql`
    fragment ReusableDisclaimerRentalRelationship on DisclaimerRentalRelationship {
  id
  disclaimerId
  signatureRequired
}
    `;
export const ReusableDiscountRentalRelationshipFragmentDoc = gql`
    fragment ReusableDiscountRentalRelationship on DiscountRentalRelationship {
  id
  active
  amount
  discountTargetType
  name
  valueType
  discountId
  discount {
    id
  }
}
    `;
export const ReusableFeeRentalRelationshipFragmentDoc = gql`
    fragment ReusableFeeRentalRelationship on FeeRentalRelationship {
  id
  active
  amount
  feeType
  feeTargetType
  name
  valueType
  feeId
  taxExempt
  fee {
    id
  }
}
    `;
export const ReusableRentalItemFragmentDoc = gql`
    fragment ReusableRentalItem on RentalItem {
  id
  name
  quantity
  period
  editedFlatPrice
  editedFlatUnitPrice
  productId
  hourlyPrice
  dailyPrice
  halfDayPrice
  weeklyPrice
  monthlyPrice
  discountEligible
  taxExempt
  damageWaiverExempt
  itemNotes {
    id
    message
    shouldIncludeNotesInRentals
    visibleToOperations
  }
  flatPrices {
    id
    name
    amount
  }
  rentalItemDiscountRelationships {
    id
    amount
    name
    valueType
    computedAmount
  }
  rentalItemFeeRelationships {
    id
    amount
    name
    valueType
    computedAmount
  }
  rentalItemCustomTaxRelationship {
    id
    name
    amount
    amountType
  }
  totalFees
  totalDiscounts
  customTaxAmount
  preDiscountSubtotal
}
    `;
export const ReusableRentalAccessoryFragmentDoc = gql`
    fragment ReusableRentalAccessory on RentalAccessory {
  id
  name
  quantity
  notes
  accessoryId
  itemNotes {
    id
    message
    shouldIncludeNotesInRentals
    visibleToOperations
  }
}
    `;
export const ReusableRentalAddOnFragmentDoc = gql`
    fragment ReusableRentalAddOn on RentalAddOn {
  id
  name
  quantity
  selectedPrice
  selectedPriceRaw
  notes
  taxExempt
  pricePerUnit
  pricingPickedByUser
  addOnId
  damageWaiverExempt
  itemNotes {
    id
    message
    shouldIncludeNotesInRentals
    visibleToOperations
  }
}
    `;
export const ReusableRentalFragmentDoc = gql`
    fragment ReusableRental on Rental {
  id
  name
  token
  customId
  status
  referralSource
  type
  flipDateTime
  finalPaymentDueDateDaysNum
  finalPaymentDueDateDaysOption
  manualDamageWaiver
  damageWaiverFeeTotal
  noCostSubrentalTransfer
  depositFixedFee
  depositPercent
  depositRequired
  depositType
  deliveryCost
  additionalDeliveryCost
  disclaimerRentalRelationships {
    ...ReusableDisclaimerRentalRelationship
  }
  customDepositAmount
  paymentNotification1Enabled
  paymentNotification1Num
  paymentNotification2Enabled
  paymentNotification2Num
  paymentNotification3Enabled
  paymentNotification3Num
  paymentNotificationDaysOption
  paymentNotificationType
  salesTaxSetting
  manualSalesTaxName
  manualSalesTaxPercent
  damageWaiverTaxExempt
  deliveryTaxEnabled
  gstTaxExempt
  pstTaxExempt
  taxExempt
  paymentTerm
  signatureRequired
  eventId
  rentalAgreementId
  setByTimeDateTime
  setByTimeNotes
  hasSetByTime
  flipNotes
  flipDateTime
  hasFlip
  hasStrikeTime
  strikeDateTime
  strikeTimeNotes
  roomActivitySetting
  jobType
  jobSubOption
  discountRentalRelationships {
    ...ReusableDiscountRentalRelationship
  }
  feeRentalRelationships {
    ...ReusableFeeRentalRelationship
  }
  rentalSetting {
    id
    hideEventTimes
    hideEventDates
    hideDeliveryInfo
    hideDeliveryTimes
    hasCustomerSurvey
  }
  schedule {
    id
    eventStartDateTime
    eventEndDateTime
    timeZone
    offShelfAt
    onShelfAt
    startDateTime
    endDateTime
    startWindowFinish
    endWindowBeginning
    sameAsEventDate
    shelfEnabled
    eventStartSetting
    eventEndSetting
  }
  companyRentalRelationship {
    id
    companyId
    isPrimaryContact
    company {
      id
      name
      mainPhoneNumber {
        mainContactNumber
        office
        cell
        extension
        type
      }
      mainContactAddress {
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
        country
      }
    }
  }
  customerRentalRelationships {
    id
    clientId
    clientType
    autosendEmails
    isPrimaryContact
    client {
      ... on CustomerLocationRelationship {
        id
        firstName
        lastName
        phoneNumber {
          mainContactNumber
          office
          cell
          extension
          type
        }
        physicalAddress {
          streetAddress1
          streetAddress2
          city
          locale
          postalCode
          country
        }
        documents {
          id
          fileFileName
        }
      }
    }
  }
  notes {
    id
    message
    visibleToCustomer
    visibleToOperations
    employeeId
  }
  documentRentalRelationships {
    id
    active
    employeeId
    document {
      id
      documentType
      fileFileName
      fileFileSize
      fileUpdatedAt
      fileContentType
      name
      file
    }
  }
  employeeRentalRelationships {
    id
    employeeId
    active
    commissionName
    commissionPercent
    employeeRentalRoles {
      id
      roleId
    }
  }
  rentalTeamEmailSetting {
    id
    shouldChangeOrderEmailRecipients
    redirectEmailToTeamMembers
    bccTeamMembers
  }
  expenses {
    id
    name
    amount
    active
  }
  salesTaxRentalRelationships {
    id
    rentalId
    salesTaxId
    salesTax {
      id
      taxType
      name
      taxPercent
      locationId
      state
      appliesToRentables
      appliesToPurchases
      appliesToServices
    }
  }
  venueRentalRelationship {
    id
    venueId
    venue {
      id
      name
    }
  }
  rentalSections {
    id
    name
    position
    sectionType
    sectionMemberships {
      id
      rentalInventoryId
      rentalInventoryType
      position
      rentalInventory {
        ... on RentalItem {
          ...ReusableRentalItem
        }
        ... on RentalAccessory {
          ...ReusableRentalAccessory
        }
        ... on RentalAddOn {
          ...ReusableRentalAddOn
        }
        ... on RentalStaff {
          id
          name
          size
          staffRoleId
          staffPricingId
          userInputPricing
          staffSchedule {
            id
            inTime
            outTime
            active
            scheduleOwnerType
          }
          staffRole {
            id
            taxExempt
            staffPricings {
              id
              price
              pricingType
              customTitle
            }
          }
        }
        ... on RentalBundle {
          id
          name
          quantity
          priceLocked
          discountPercent
          hourlyPrice
          halfDayPrice
          dailyPrice
          weeklyPrice
          monthlyPrice
          taxExemptionSetting
          flatPrices {
            id
            name
            amount
          }
          purchasePrice
          period
          bundleId
          itemNotes {
            id
            message
            shouldIncludeNotesInRentals
            visibleToOperations
          }
          rentalItems {
            ...ReusableRentalItem
          }
          rentalAddOns {
            ...ReusableRentalAddOn
          }
          rentalAccessories {
            ...ReusableRentalAccessory
          }
          rentalBundleDiscountRelationships {
            id
            amount
            name
            valueType
          }
          rentalBundleFeeRelationships {
            id
            amount
            name
            valueType
          }
        }
      }
    }
  }
}
    ${ReusableDisclaimerRentalRelationshipFragmentDoc}
${ReusableDiscountRentalRelationshipFragmentDoc}
${ReusableFeeRentalRelationshipFragmentDoc}
${ReusableRentalItemFragmentDoc}
${ReusableRentalAccessoryFragmentDoc}
${ReusableRentalAddOnFragmentDoc}`;
export const ReusableRentalForInvoiceFragmentDoc = gql`
    fragment ReusableRentalForInvoice on Rental {
  ...ReusableRental
  event {
    name
  }
  notes {
    id
    createdAt
    updatedAt
    message
    visibleToCustomer
    visibleToOperations
    employeeId
  }
  rentalTotal {
    id
    rentalId
    subTotal
    overallTotal
  }
}
    ${ReusableRentalFragmentDoc}`;
export const PictureFragmentDoc = gql`
    fragment Picture on Picture {
  id
  url
  imgixUrl
  imageFileName
  __typename
}
    `;
export const ProductBundleRelationshipForCalendarFragmentDoc = gql`
    fragment ProductBundleRelationshipForCalendar on ProductBundleRelationship {
  id
  quantity
  productId
  product {
    id
    name
  }
  __typename
}
    `;
export const AccessoryBundleRelationshipForCalendarFragmentDoc = gql`
    fragment AccessoryBundleRelationshipForCalendar on AccessoryBundleRelationship {
  id
  quantity
  accessoryId
  accessory {
    id
    name
  }
  __typename
}
    `;
export const AddOnBundleRelationshipForCalendarFragmentDoc = gql`
    fragment AddOnBundleRelationshipForCalendar on AddOnBundleRelationship {
  id
  quantity
  addOnId
  addOn {
    id
    name
  }
  __typename
}
    `;
export const ReusableRentalTransportForLoadListFragmentDoc = gql`
    fragment ReusableRentalTransportForLoadList on RentalTransport {
  __typename
  id
  deliveryTicketId
  rentalStaffId
  serviceTicketId
  transportType
  cachedStartTime
  cachedEndTime
  createdAt
  updatedAt
  rentalTransportTruckRelationships {
    __typename
    id
    active
    position
    setupTime
    stopName
    stopType
    truckRouteId
    rentalTransportId
    createdAt
    updatedAt
    truckRoute {
      __typename
      id
      deliveryDate
      startTime
      truckId
      drivers {
        __typename
        id
        employeeId
        role
        name
      }
    }
    loadList {
      __typename
      id
      loadListEntries {
        __typename
        id
        rentalItemId
        rentalAccessoryId
        rentalAddOnId
        rentalBundleId
        rentalInventoryId
        rentalInventoryType
      }
    }
  }
}
    `;
export const SectionPickListSectionFragmentDoc = gql`
    fragment SectionPickListSection on RentalSection {
  id
  name
  position
  sectionType
}
    `;
export const SectionPickListNoteFragmentDoc = gql`
    fragment SectionPickListNote on ItemNote {
  id
  message
}
    `;
export const SectionPickListProductFragmentDoc = gql`
    fragment SectionPickListProduct on Product {
  id
  name
  departmentNames
  warehouseLocation
  serializationStatus
  weight
  length
  width
  height
  lengthFt
  widthFt
  heightFt
  pictures {
    id
    imgixUrl
  }
  sfCategories {
    id
    name
  }
}
    `;
export const SectionPickListAccessoryInventoryFragmentDoc = gql`
    fragment SectionPickListAccessoryInventory on Accessory {
  id
  name
  departmentNames
  warehouseLocation
  pictures {
    id
    imgixUrl
  }
  sfCategories {
    id
    name
  }
}
    `;
export const SectionPickListAddOnInventoryFragmentDoc = gql`
    fragment SectionPickListAddOnInventory on AddOn {
  id
  name
  departmentNames
  warehouseLocation
  pictures {
    id
    imgixUrl
  }
  sfCategories {
    id
    name
  }
}
    `;
export const SectionPickListSubRentalFragmentDoc = gql`
    fragment SectionPickListSubRental on SubRental {
  id
  name
  quantity
  supplierName
  supplierLocationCode
}
    `;
export const SummaryFragmentFragmentDoc = gql`
    fragment SummaryFragment on Summary {
  taxName
  taxType
  taxablePercent
  totalTransactionVolume
  overallTotal
  nontaxableVolume
  taxPercent
  proportionalSubTotalForTax
  totalTaxPayments
}
    `;
export const StorefrontTagItemRelationshipFragmentDoc = gql`
    fragment StorefrontTagItemRelationship on StorefrontTagItemRelationship {
  id
  itemId
  itemType
  sfTagId
  __typename
}
    `;
export const StorefrontTagFragmentDoc = gql`
    fragment StorefrontTag on StorefrontTag {
  id
  name
  locationId
  itemCount
  __typename
}
    `;
export const SetRentalStaffsDocument = gql`
    mutation SetRentalStaffs($input: SetRentalStaffsInput!) {
  setRentalStaffs(input: $input) {
    rentalStaffs {
      id
      size
      staffRole {
        id
        name
      }
      rentalId
    }
    success
    error
  }
}
    `;
export type SetRentalStaffsMutationFn = Apollo.MutationFunction<SetRentalStaffsMutation, SetRentalStaffsMutationVariables>;

/**
 * __useSetRentalStaffsMutation__
 *
 * To run a mutation, you first call `useSetRentalStaffsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRentalStaffsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRentalStaffsMutation, { data, loading, error }] = useSetRentalStaffsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRentalStaffsMutation(baseOptions?: Apollo.MutationHookOptions<SetRentalStaffsMutation, SetRentalStaffsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRentalStaffsMutation, SetRentalStaffsMutationVariables>(SetRentalStaffsDocument, options);
      }
export type SetRentalStaffsMutationHookResult = ReturnType<typeof useSetRentalStaffsMutation>;
export type SetRentalStaffsMutationResult = Apollo.MutationResult<SetRentalStaffsMutation>;
export type SetRentalStaffsMutationOptions = Apollo.BaseMutationOptions<SetRentalStaffsMutation, SetRentalStaffsMutationVariables>;
export const SetEmployeeRentalRelationshipsDocument = gql`
    mutation SetEmployeeRentalRelationships($input: SetEmployeeRentalRelationshipsInput!) {
  setEmployeeRentalRelationships(input: $input) {
    employeeRentalRelationships {
      id
      rentalId
      employee {
        id
        name
        phoneNumber {
          id
          cell
        }
      }
      employeeRentalRoles {
        id
        role {
          id
          name
          roleTypeString
        }
      }
    }
    success
    error
  }
}
    `;
export type SetEmployeeRentalRelationshipsMutationFn = Apollo.MutationFunction<SetEmployeeRentalRelationshipsMutation, SetEmployeeRentalRelationshipsMutationVariables>;

/**
 * __useSetEmployeeRentalRelationshipsMutation__
 *
 * To run a mutation, you first call `useSetEmployeeRentalRelationshipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmployeeRentalRelationshipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmployeeRentalRelationshipsMutation, { data, loading, error }] = useSetEmployeeRentalRelationshipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEmployeeRentalRelationshipsMutation(baseOptions?: Apollo.MutationHookOptions<SetEmployeeRentalRelationshipsMutation, SetEmployeeRentalRelationshipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmployeeRentalRelationshipsMutation, SetEmployeeRentalRelationshipsMutationVariables>(SetEmployeeRentalRelationshipsDocument, options);
      }
export type SetEmployeeRentalRelationshipsMutationHookResult = ReturnType<typeof useSetEmployeeRentalRelationshipsMutation>;
export type SetEmployeeRentalRelationshipsMutationResult = Apollo.MutationResult<SetEmployeeRentalRelationshipsMutation>;
export type SetEmployeeRentalRelationshipsMutationOptions = Apollo.BaseMutationOptions<SetEmployeeRentalRelationshipsMutation, SetEmployeeRentalRelationshipsMutationVariables>;
export const GetRentalsByDateDocument = gql`
    query getRentalsByDate($strikeDateTimeGte: String, $strikeDateTimeLte: String, $setByTimeDateTimeGte: String, $setByTimeDateTimeLte: String, $eventStartDateTimeGte: String, $eventStartDateTimeLte: String, $eventEndDateTimeGte: String, $eventEndDateTimeLte: String, $deliveryDateGte: String, $deliveryDateLte: String, $pickUpDateGte: String, $pickUpDateLte: String, $status: [String!], $venueName: [String!], $employeesWithRoleIds: [Int!], $earliestPickListStatus: [String!], $type: [String!]) {
  getRentalsByDate(
    strikeDateTimeGte: $strikeDateTimeGte
    strikeDateTimeLte: $strikeDateTimeLte
    setByTimeDateTimeGte: $setByTimeDateTimeGte
    setByTimeDateTimeLte: $setByTimeDateTimeLte
    eventStartDateTimeGte: $eventStartDateTimeGte
    eventStartDateTimeLte: $eventStartDateTimeLte
    eventEndDateTimeGte: $eventEndDateTimeGte
    eventEndDateTimeLte: $eventEndDateTimeLte
    deliveryDateGte: $deliveryDateGte
    deliveryDateLte: $deliveryDateLte
    pickUpDateGte: $pickUpDateGte
    pickUpDateLte: $pickUpDateLte
    status: $status
    venueName: $venueName
    employeesWithRoleIds: $employeesWithRoleIds
    earliestPickListStatus: $earliestPickListStatus
    type: $type
  ) {
    id
    name
    strikeDateTime
    setByTimeDateTime
    startDateTime
    endDateTime
    deliveryDate
    pickUpDate
    token
    status
    earliestPickListStatus
    deliveryType
    alerting
    type
    roomActivitySetting
    notes {
      id
      message
      createdAt
      visibleToCustomer
      visibleToOperations
      employee {
        id
        name
      }
    }
    employeeRentalRelationships {
      id
      rentalId
      employee {
        id
        name
        phoneNumber {
          id
          cell
        }
      }
      employeeRentalRoles {
        id
        role {
          id
          name
          roleTypeString
        }
      }
    }
    employees {
      id
      name
    }
    venue {
      id
      name
    }
    schedule {
      id
      timeZone
    }
    customerLocationRelationships {
      id
      email
      name
      phoneNumber {
        cell
      }
    }
    company {
      id
      name
      mainPhoneNumber {
        cell
      }
      mainContactEmail {
        emailAddress
      }
    }
    rentalLabors {
      id
      size
      staffRole {
        id
        name
      }
      rentalId
    }
    primaryContactId
    secondaryOrder {
      id
      name
      activitySettingCycles
      customerLocationRelationships {
        id
        email
        name
        phoneNumber {
          cell
        }
      }
      company {
        id
        name
        mainPhoneNumber {
          cell
        }
        mainContactEmail {
          emailAddress
        }
      }
      rentalLabors {
        id
        size
        staffRole {
          id
          name
        }
        rentalId
      }
      employeeRentalRelationships {
        id
        rentalId
        employee {
          id
          name
          phoneNumber {
            id
            cell
          }
        }
        employeeRentalRoles {
          id
          role {
            id
            name
            roleTypeString
          }
        }
      }
    }
    parentRentalToken
  }
}
    `;

/**
 * __useGetRentalsByDateQuery__
 *
 * To run a query within a React component, call `useGetRentalsByDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalsByDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalsByDateQuery({
 *   variables: {
 *      strikeDateTimeGte: // value for 'strikeDateTimeGte'
 *      strikeDateTimeLte: // value for 'strikeDateTimeLte'
 *      setByTimeDateTimeGte: // value for 'setByTimeDateTimeGte'
 *      setByTimeDateTimeLte: // value for 'setByTimeDateTimeLte'
 *      eventStartDateTimeGte: // value for 'eventStartDateTimeGte'
 *      eventStartDateTimeLte: // value for 'eventStartDateTimeLte'
 *      eventEndDateTimeGte: // value for 'eventEndDateTimeGte'
 *      eventEndDateTimeLte: // value for 'eventEndDateTimeLte'
 *      deliveryDateGte: // value for 'deliveryDateGte'
 *      deliveryDateLte: // value for 'deliveryDateLte'
 *      pickUpDateGte: // value for 'pickUpDateGte'
 *      pickUpDateLte: // value for 'pickUpDateLte'
 *      status: // value for 'status'
 *      venueName: // value for 'venueName'
 *      employeesWithRoleIds: // value for 'employeesWithRoleIds'
 *      earliestPickListStatus: // value for 'earliestPickListStatus'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetRentalsByDateQuery(baseOptions?: Apollo.QueryHookOptions<GetRentalsByDateQuery, GetRentalsByDateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalsByDateQuery, GetRentalsByDateQueryVariables>(GetRentalsByDateDocument, options);
      }
export function useGetRentalsByDateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalsByDateQuery, GetRentalsByDateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalsByDateQuery, GetRentalsByDateQueryVariables>(GetRentalsByDateDocument, options);
        }
export type GetRentalsByDateQueryHookResult = ReturnType<typeof useGetRentalsByDateQuery>;
export type GetRentalsByDateLazyQueryHookResult = ReturnType<typeof useGetRentalsByDateLazyQuery>;
export type GetRentalsByDateQueryResult = Apollo.QueryResult<GetRentalsByDateQuery, GetRentalsByDateQueryVariables>;
export const GetRentalsByDateVerticalDocument = gql`
    query getRentalsByDateVertical($strikeDateTimeGte: String, $strikeDateTimeLte: String, $setByTimeDateTimeGte: String, $setByTimeDateTimeLte: String, $eventStartDateTimeGte: String, $eventStartDateTimeLte: String, $eventEndDateTimeGte: String, $eventEndDateTimeLte: String, $deliveryDateGte: String, $deliveryDateLte: String, $pickUpDateGte: String, $pickUpDateLte: String, $status: [String!], $venueName: [String!], $employeesWithRoleIds: [Int!], $earliestPickListStatus: [String!], $page: Int, $perPage: Int, $parentToken: String, $query: String, $type: [String!]) {
  getRentalsByDateVertical(
    strikeDateTimeGte: $strikeDateTimeGte
    strikeDateTimeLte: $strikeDateTimeLte
    setByTimeDateTimeGte: $setByTimeDateTimeGte
    setByTimeDateTimeLte: $setByTimeDateTimeLte
    eventStartDateTimeGte: $eventStartDateTimeGte
    eventStartDateTimeLte: $eventStartDateTimeLte
    eventEndDateTimeGte: $eventEndDateTimeGte
    eventEndDateTimeLte: $eventEndDateTimeLte
    deliveryDateGte: $deliveryDateGte
    deliveryDateLte: $deliveryDateLte
    pickUpDateGte: $pickUpDateGte
    pickUpDateLte: $pickUpDateLte
    status: $status
    venueName: $venueName
    employeesWithRoleIds: $employeesWithRoleIds
    earliestPickListStatus: $earliestPickListStatus
    page: $page
    perPage: $perPage
    parentToken: $parentToken
    query: $query
    type: $type
  ) {
    collection {
      id
      name
      strikeDateTime
      setByTimeDateTime
      startDateTime
      endDateTime
      token
      status
      type
      earliestPickListStatus
      roomActivitySetting
      notes {
        id
        message
        createdAt
        visibleToCustomer
        visibleToOperations
        employee {
          id
          name
        }
      }
      employeeRentalRelationships {
        id
        rentalId
        employee {
          id
          name
          phoneNumber {
            id
            cell
          }
        }
        employeeRentalRoles {
          id
          role {
            id
            name
            roleTypeString
          }
        }
      }
      employees {
        id
        name
      }
      venue {
        id
        name
      }
      schedule {
        id
        timeZone
      }
      customerLocationRelationships {
        id
        email
        name
      }
      company {
        id
        name
        mainPhoneNumber {
          cell
        }
        mainContactEmail {
          emailAddress
        }
      }
      rentalLabors {
        id
        size
        staffRole {
          id
          name
        }
        rentalId
      }
      pickListItems {
        id
        quantity
        name
      }
      pickListAccessories {
        id
        quantity
        name
      }
      pickListAddOns {
        id
        quantity
        name
      }
      rentalStaffs {
        id
        name
        size
        staffRole {
          type
        }
      }
      primaryContactId
      secondaryOrder {
        id
        name
        activitySettingCycles
        customerLocationRelationships {
          id
          email
          name
          phoneNumber {
            cell
          }
        }
        company {
          id
          name
          mainPhoneNumber {
            cell
          }
          mainContactEmail {
            emailAddress
          }
        }
        rentalLabors {
          id
          size
          staffRole {
            id
            name
          }
          rentalId
        }
        employeeRentalRelationships {
          id
          rentalId
          employee {
            id
            name
            phoneNumber {
              id
              cell
            }
          }
          employeeRentalRoles {
            id
            role {
              id
              name
              roleTypeString
            }
          }
        }
      }
      parentRentalToken
      rentalTransports {
        id
        transportType
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
    `;

/**
 * __useGetRentalsByDateVerticalQuery__
 *
 * To run a query within a React component, call `useGetRentalsByDateVerticalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalsByDateVerticalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalsByDateVerticalQuery({
 *   variables: {
 *      strikeDateTimeGte: // value for 'strikeDateTimeGte'
 *      strikeDateTimeLte: // value for 'strikeDateTimeLte'
 *      setByTimeDateTimeGte: // value for 'setByTimeDateTimeGte'
 *      setByTimeDateTimeLte: // value for 'setByTimeDateTimeLte'
 *      eventStartDateTimeGte: // value for 'eventStartDateTimeGte'
 *      eventStartDateTimeLte: // value for 'eventStartDateTimeLte'
 *      eventEndDateTimeGte: // value for 'eventEndDateTimeGte'
 *      eventEndDateTimeLte: // value for 'eventEndDateTimeLte'
 *      deliveryDateGte: // value for 'deliveryDateGte'
 *      deliveryDateLte: // value for 'deliveryDateLte'
 *      pickUpDateGte: // value for 'pickUpDateGte'
 *      pickUpDateLte: // value for 'pickUpDateLte'
 *      status: // value for 'status'
 *      venueName: // value for 'venueName'
 *      employeesWithRoleIds: // value for 'employeesWithRoleIds'
 *      earliestPickListStatus: // value for 'earliestPickListStatus'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      parentToken: // value for 'parentToken'
 *      query: // value for 'query'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetRentalsByDateVerticalQuery(baseOptions?: Apollo.QueryHookOptions<GetRentalsByDateVerticalQuery, GetRentalsByDateVerticalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalsByDateVerticalQuery, GetRentalsByDateVerticalQueryVariables>(GetRentalsByDateVerticalDocument, options);
      }
export function useGetRentalsByDateVerticalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalsByDateVerticalQuery, GetRentalsByDateVerticalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalsByDateVerticalQuery, GetRentalsByDateVerticalQueryVariables>(GetRentalsByDateVerticalDocument, options);
        }
export type GetRentalsByDateVerticalQueryHookResult = ReturnType<typeof useGetRentalsByDateVerticalQuery>;
export type GetRentalsByDateVerticalLazyQueryHookResult = ReturnType<typeof useGetRentalsByDateVerticalLazyQuery>;
export type GetRentalsByDateVerticalQueryResult = Apollo.QueryResult<GetRentalsByDateVerticalQuery, GetRentalsByDateVerticalQueryVariables>;
export const GetSimplifiedPaginatedRentalsDocument = gql`
    query getSimplifiedPaginatedRentals($strikeDateTimeGte: String, $strikeDateTimeLte: String, $setByTimeDateTimeGte: String, $setByTimeDateTimeLte: String, $eventStartDateTimeGte: String, $eventStartDateTimeLte: String, $eventEndDateTimeGte: String, $eventEndDateTimeLte: String, $status: [String!], $venueName: [String!], $employeesWithRoleIds: [Int!], $earliestPickListStatus: [String!], $page: Int, $perPage: Int, $type: [String!]) {
  getSimplifiedPaginatedRentals(
    strikeDateTimeGte: $strikeDateTimeGte
    strikeDateTimeLte: $strikeDateTimeLte
    setByTimeDateTimeGte: $setByTimeDateTimeGte
    setByTimeDateTimeLte: $setByTimeDateTimeLte
    eventStartDateTimeGte: $eventStartDateTimeGte
    eventStartDateTimeLte: $eventStartDateTimeLte
    eventEndDateTimeGte: $eventEndDateTimeGte
    eventEndDateTimeLte: $eventEndDateTimeLte
    status: $status
    venueName: $venueName
    employeesWithRoleIds: $employeesWithRoleIds
    earliestPickListStatus: $earliestPickListStatus
    page: $page
    perPage: $perPage
    type: $type
  ) {
    collection {
      id
      name
      strikeDateTime
      setByTimeDateTime
      token
      status
      startDateTime
      endDateTime
      earliestPickListStatus
      roomActivitySetting
      notes {
        id
        message
        createdAt
        visibleToCustomer
        visibleToOperations
        employee {
          id
          name
        }
      }
      venue {
        id
        name
      }
      schedule {
        id
        timeZone
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
    `;

/**
 * __useGetSimplifiedPaginatedRentalsQuery__
 *
 * To run a query within a React component, call `useGetSimplifiedPaginatedRentalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSimplifiedPaginatedRentalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSimplifiedPaginatedRentalsQuery({
 *   variables: {
 *      strikeDateTimeGte: // value for 'strikeDateTimeGte'
 *      strikeDateTimeLte: // value for 'strikeDateTimeLte'
 *      setByTimeDateTimeGte: // value for 'setByTimeDateTimeGte'
 *      setByTimeDateTimeLte: // value for 'setByTimeDateTimeLte'
 *      eventStartDateTimeGte: // value for 'eventStartDateTimeGte'
 *      eventStartDateTimeLte: // value for 'eventStartDateTimeLte'
 *      eventEndDateTimeGte: // value for 'eventEndDateTimeGte'
 *      eventEndDateTimeLte: // value for 'eventEndDateTimeLte'
 *      status: // value for 'status'
 *      venueName: // value for 'venueName'
 *      employeesWithRoleIds: // value for 'employeesWithRoleIds'
 *      earliestPickListStatus: // value for 'earliestPickListStatus'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetSimplifiedPaginatedRentalsQuery(baseOptions?: Apollo.QueryHookOptions<GetSimplifiedPaginatedRentalsQuery, GetSimplifiedPaginatedRentalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSimplifiedPaginatedRentalsQuery, GetSimplifiedPaginatedRentalsQueryVariables>(GetSimplifiedPaginatedRentalsDocument, options);
      }
export function useGetSimplifiedPaginatedRentalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSimplifiedPaginatedRentalsQuery, GetSimplifiedPaginatedRentalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSimplifiedPaginatedRentalsQuery, GetSimplifiedPaginatedRentalsQueryVariables>(GetSimplifiedPaginatedRentalsDocument, options);
        }
export type GetSimplifiedPaginatedRentalsQueryHookResult = ReturnType<typeof useGetSimplifiedPaginatedRentalsQuery>;
export type GetSimplifiedPaginatedRentalsLazyQueryHookResult = ReturnType<typeof useGetSimplifiedPaginatedRentalsLazyQuery>;
export type GetSimplifiedPaginatedRentalsQueryResult = Apollo.QueryResult<GetSimplifiedPaginatedRentalsQuery, GetSimplifiedPaginatedRentalsQueryVariables>;
export const SetPickListDocument = gql`
    mutation SetPickList($rentalId: Int!, $status: String, $pickListAccessoriesInput: [PickListInputWrapper!], $pickListItemsInput: [PickListInputWrapper!], $pickListAddOnsInput: [PickListInputWrapper!]) {
  setPickList(
    input: {rentalId: $rentalId, status: $status, pickListAccessoriesInput: $pickListAccessoriesInput, pickListItemsInput: $pickListItemsInput, pickListAddOnsInput: $pickListAddOnsInput}
  ) {
    errors {
      details {
        field
        messages
        __typename
      }
      fullMessages
    }
    rental {
      id
      status
      earliestPickListStatus
    }
    pickLists {
      ... on PickListItem {
        id
        type
        checkedInQuantity
        pickedQuantity
        status
        __typename
      }
      ... on PickListAccessory {
        id
        checkedInQuantity
        pickedQuantity
        status
        __typename
      }
      ... on PickListAddOn {
        id
        status
        __typename
      }
    }
  }
}
    `;
export type SetPickListMutationFn = Apollo.MutationFunction<SetPickListMutation, SetPickListMutationVariables>;

/**
 * __useSetPickListMutation__
 *
 * To run a mutation, you first call `useSetPickListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPickListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPickListMutation, { data, loading, error }] = useSetPickListMutation({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      status: // value for 'status'
 *      pickListAccessoriesInput: // value for 'pickListAccessoriesInput'
 *      pickListItemsInput: // value for 'pickListItemsInput'
 *      pickListAddOnsInput: // value for 'pickListAddOnsInput'
 *   },
 * });
 */
export function useSetPickListMutation(baseOptions?: Apollo.MutationHookOptions<SetPickListMutation, SetPickListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPickListMutation, SetPickListMutationVariables>(SetPickListDocument, options);
      }
export type SetPickListMutationHookResult = ReturnType<typeof useSetPickListMutation>;
export type SetPickListMutationResult = Apollo.MutationResult<SetPickListMutation>;
export type SetPickListMutationOptions = Apollo.BaseMutationOptions<SetPickListMutation, SetPickListMutationVariables>;
export const GetLaborsDocument = gql`
    query GetLabors($search: String, $type: String!) {
  getLabors(search: $search, type: $type) {
    id
    name
    locationId
    type
  }
}
    `;

/**
 * __useGetLaborsQuery__
 *
 * To run a query within a React component, call `useGetLaborsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLaborsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLaborsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useGetLaborsQuery(baseOptions: Apollo.QueryHookOptions<GetLaborsQuery, GetLaborsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLaborsQuery, GetLaborsQueryVariables>(GetLaborsDocument, options);
      }
export function useGetLaborsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLaborsQuery, GetLaborsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLaborsQuery, GetLaborsQueryVariables>(GetLaborsDocument, options);
        }
export type GetLaborsQueryHookResult = ReturnType<typeof useGetLaborsQuery>;
export type GetLaborsLazyQueryHookResult = ReturnType<typeof useGetLaborsLazyQuery>;
export type GetLaborsQueryResult = Apollo.QueryResult<GetLaborsQuery, GetLaborsQueryVariables>;
export const GetRentalByIdDocument = gql`
    query getRentalById($ID: String!) {
  getRentalById(ID: $ID) {
    id
    token
    customers {
      name
      email
      phoneNumbers {
        cell
      }
    }
    conversations {
      id
      messages {
        id
        createdAt
        sender {
          ... on Customer {
            name
          }
          ... on Employee {
            name
          }
        }
      }
    }
    company {
      name
      mainContactEmail {
        emailAddress
      }
      mainPhoneNumber {
        cell
      }
    }
    teamMembers {
      name
      phoneNumber {
        cell
      }
      role
    }
    pickListItems {
      id
      quantity
      name
      pickedQuantity
      checkedInQuantity
      status
      productCategoryName
      serialized
      serializedPickListItems {
        id
        status
        quantity
        serializedProduct {
          id
          token
          quantity
        }
      }
      product {
        id
        active
        name
        serializationStatus
        usageUnits {
          id
          name
          unitType
          locationId
        }
      }
      rentalItems {
        id
        name
      }
      __typename
    }
    pickListAccessories {
      id
      quantity
      name
      pickedQuantity
      checkedInQuantity
      status
      productCategoryName
      __typename
    }
    pickListAddOns {
      id
      quantity
      name
      pickedQuantity
      status
      __typename
    }
    rentalStaffs {
      id
      name
      size
      inTime
      staffRole {
        type
      }
    }
    secondaryOrders {
      id
      token
      name
      rentalTotal {
        id
        subTotal
        discountTotal
        feeTotal
        overallTotal
        billingLines {
          tag
          name
          kind
          aggregate
          baseValue
          discountValue
          feeValue
          finalValue
          taxableValue
        }
      }
    }
    rentalTotal {
      id
      subTotal
      discountTotal
      feeTotal
      overallTotal
    }
    rentalTransports {
      id
      transportType
      rentalTransportTruckRelationships {
        id
        truckRoute {
          id
          truck {
            alphabetId
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetRentalByIdQuery__
 *
 * To run a query within a React component, call `useGetRentalByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalByIdQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetRentalByIdQuery(baseOptions: Apollo.QueryHookOptions<GetRentalByIdQuery, GetRentalByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalByIdQuery, GetRentalByIdQueryVariables>(GetRentalByIdDocument, options);
      }
export function useGetRentalByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalByIdQuery, GetRentalByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalByIdQuery, GetRentalByIdQueryVariables>(GetRentalByIdDocument, options);
        }
export type GetRentalByIdQueryHookResult = ReturnType<typeof useGetRentalByIdQuery>;
export type GetRentalByIdLazyQueryHookResult = ReturnType<typeof useGetRentalByIdLazyQuery>;
export type GetRentalByIdQueryResult = Apollo.QueryResult<GetRentalByIdQuery, GetRentalByIdQueryVariables>;
export const GetPickListDocument = gql`
    query getPickList($ID: String!) {
  getRentalById(ID: $ID) {
    id
    token
    status
    checkoutSignature
    checkoutSignerName
    checkoutSignerTitle
    checkoutSignerCompany
    businessCheckoutSignature
    businessCheckoutSignerName
    businessCheckoutSignerTitle
    businessCheckoutSignerCompany
    checkinSignature
    checkinSignerName
    checkinSignerTitle
    checkinSignerCompany
    businessCheckinSignature
    businessCheckinSignerName
    businessCheckinSignerTitle
    businessCheckinSignerCompany
    hasFlip
    flipDateTime
    deliveryType
    deliveryAddressLocationName
    deliveryAddressStreetAddress1
    deliveryAddressStreetAddress2
    deliveryAddressCity
    deliveryAddressLocale
    deliveryAddressPostalCode
    deliveryAddressCountry
    isRecurringPayment
    gstTaxExempt
    pstTaxExempt
    pickListItems {
      id
      quantity
      name
      pickedQuantity
      checkedInQuantity
      missingQuantity
      damagedQuantity
      lastMissingQuantity
      status
      productCategoryName
      serialized
      serialNumbers
      inventoryType
      imgixUrl
      productNotes {
        id
        message
        shouldIncludeNotesInRentals
        visibleToOperations
      }
      subRentals {
        id
        name
        supplierName
        quantity
        supplierLocationCode
      }
      serializedPickListItems {
        id
        status
        quantity
        serializedProduct {
          id
          token
          quantity
          serialNumber
        }
      }
      product {
        quantity
        id
        active
        name
        serializationStatus
        warehouseLocation
        weight
        lengthFt
        length
        widthFt
        width
        heightFt
        height
        departmentNames
        sfCategories {
          id
          name
          slug
        }
        usageUnits {
          id
          name
          unitType
          locationId
        }
      }
      fee {
        id
        name
        amount
      }
      rentalItems {
        id
        name
      }
      __typename
    }
    pickListAccessories {
      id
      quantity
      name
      pickedQuantity
      checkedInQuantity
      missingQuantity
      damagedQuantity
      lastMissingQuantity
      checkedInQuantity
      status
      productCategoryName
      inventoryType
      imgixUrl
      fee {
        id
        name
        amount
      }
      productNotes {
        id
        message
        shouldIncludeNotesInRentals
        visibleToOperations
      }
      subRentals {
        id
        name
        supplierName
        quantity
        supplierLocationCode
      }
      accessory {
        id
        active
        name
        warehouseLocation
        weight
        lengthFt
        length
        widthFt
        width
        heightFt
        height
        material
        departmentNames
        quantity
        sfCategories {
          id
          name
          slug
        }
      }
      rentalAccessories {
        id
      }
      __typename
    }
    pickListAddOns {
      id
      quantity
      name
      pickedQuantity
      returnedQuantity
      status
      inventoryType
      imgixUrl
      productNotes {
        id
        message
        shouldIncludeNotesInRentals
        visibleToOperations
      }
      subRentals {
        id
        name
        supplierName
        quantity
        supplierLocationCode
      }
      addOn {
        id
        active
        name
        warehouseLocation
        weight
        lengthFt
        length
        widthFt
        width
        heightFt
        height
        material
        departmentNames
        quantity
        sfCategories {
          id
          name
          slug
        }
      }
      rentalAddOns {
        id
      }
      __typename
    }
    rentalSections {
      id
      name
    }
    schedule {
      startDateTime
      endDateTime
      startWindowFinish
      endWindowBeginning
      eventStartDateTime
      eventEndDateTime
      shelfEnabled
      offShelfAt
      onShelfAt
      timeZone
      eventStartSetting
      eventEndSetting
    }
  }
}
    `;

/**
 * __useGetPickListQuery__
 *
 * To run a query within a React component, call `useGetPickListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPickListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPickListQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetPickListQuery(baseOptions: Apollo.QueryHookOptions<GetPickListQuery, GetPickListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPickListQuery, GetPickListQueryVariables>(GetPickListDocument, options);
      }
export function useGetPickListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPickListQuery, GetPickListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPickListQuery, GetPickListQueryVariables>(GetPickListDocument, options);
        }
export type GetPickListQueryHookResult = ReturnType<typeof useGetPickListQuery>;
export type GetPickListLazyQueryHookResult = ReturnType<typeof useGetPickListLazyQuery>;
export type GetPickListQueryResult = Apollo.QueryResult<GetPickListQuery, GetPickListQueryVariables>;
export const GetLocationDetailsDocument = gql`
    query GetLocationDetails($search: String) {
  getLocationDetails(search: $search) {
    name
    damageWaiverFixedFee
    damageWaiverPercent
    defaultStart
    defaultEnd
  }
}
    `;

/**
 * __useGetLocationDetailsQuery__
 *
 * To run a query within a React component, call `useGetLocationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationDetailsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLocationDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationDetailsQuery, GetLocationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationDetailsQuery, GetLocationDetailsQueryVariables>(GetLocationDetailsDocument, options);
      }
export function useGetLocationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationDetailsQuery, GetLocationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationDetailsQuery, GetLocationDetailsQueryVariables>(GetLocationDetailsDocument, options);
        }
export type GetLocationDetailsQueryHookResult = ReturnType<typeof useGetLocationDetailsQuery>;
export type GetLocationDetailsLazyQueryHookResult = ReturnType<typeof useGetLocationDetailsLazyQuery>;
export type GetLocationDetailsQueryResult = Apollo.QueryResult<GetLocationDetailsQuery, GetLocationDetailsQueryVariables>;
export const GetQuickViewTemplatesDocument = gql`
    query GetQuickViewTemplates($locationId: ID!) {
  getQuickViewTemplates(id: $locationId) {
    quickViewTemplate {
      id
      name
    }
    templates {
      id
      name
    }
  }
}
    `;

/**
 * __useGetQuickViewTemplatesQuery__
 *
 * To run a query within a React component, call `useGetQuickViewTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickViewTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickViewTemplatesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetQuickViewTemplatesQuery(baseOptions: Apollo.QueryHookOptions<GetQuickViewTemplatesQuery, GetQuickViewTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuickViewTemplatesQuery, GetQuickViewTemplatesQueryVariables>(GetQuickViewTemplatesDocument, options);
      }
export function useGetQuickViewTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuickViewTemplatesQuery, GetQuickViewTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuickViewTemplatesQuery, GetQuickViewTemplatesQueryVariables>(GetQuickViewTemplatesDocument, options);
        }
export type GetQuickViewTemplatesQueryHookResult = ReturnType<typeof useGetQuickViewTemplatesQuery>;
export type GetQuickViewTemplatesLazyQueryHookResult = ReturnType<typeof useGetQuickViewTemplatesLazyQuery>;
export type GetQuickViewTemplatesQueryResult = Apollo.QueryResult<GetQuickViewTemplatesQuery, GetQuickViewTemplatesQueryVariables>;
export const UpdateQuickViewTemplateDocument = gql`
    mutation UpdateQuickViewTemplate($input: UpdateQuickViewTemplateInput!) {
  updateQuickViewTemplate(input: $input) {
    location {
      id
      quickViewTemplateId
    }
    errors
  }
}
    `;
export type UpdateQuickViewTemplateMutationFn = Apollo.MutationFunction<UpdateQuickViewTemplateMutation, UpdateQuickViewTemplateMutationVariables>;

/**
 * __useUpdateQuickViewTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateQuickViewTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateQuickViewTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateQuickViewTemplateMutation, { data, loading, error }] = useUpdateQuickViewTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateQuickViewTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateQuickViewTemplateMutation, UpdateQuickViewTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateQuickViewTemplateMutation, UpdateQuickViewTemplateMutationVariables>(UpdateQuickViewTemplateDocument, options);
      }
export type UpdateQuickViewTemplateMutationHookResult = ReturnType<typeof useUpdateQuickViewTemplateMutation>;
export type UpdateQuickViewTemplateMutationResult = Apollo.MutationResult<UpdateQuickViewTemplateMutation>;
export type UpdateQuickViewTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateQuickViewTemplateMutation, UpdateQuickViewTemplateMutationVariables>;
export const SetSecondaryOrderDocument = gql`
    mutation SetSecondaryOrder($input: SetSecondaryOrderInput!) {
  setSecondaryOrder(input: $input) {
    rental {
      id
      name
      token
      secondaryOrdersCount
      __typename
      event {
        id
        rentalsCount
        secondaryOrdersCount
        __typename
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetSecondaryOrderMutationFn = Apollo.MutationFunction<SetSecondaryOrderMutation, SetSecondaryOrderMutationVariables>;

/**
 * __useSetSecondaryOrderMutation__
 *
 * To run a mutation, you first call `useSetSecondaryOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSecondaryOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSecondaryOrderMutation, { data, loading, error }] = useSetSecondaryOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSecondaryOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetSecondaryOrderMutation, SetSecondaryOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSecondaryOrderMutation, SetSecondaryOrderMutationVariables>(SetSecondaryOrderDocument, options);
      }
export type SetSecondaryOrderMutationHookResult = ReturnType<typeof useSetSecondaryOrderMutation>;
export type SetSecondaryOrderMutationResult = Apollo.MutationResult<SetSecondaryOrderMutation>;
export type SetSecondaryOrderMutationOptions = Apollo.BaseMutationOptions<SetSecondaryOrderMutation, SetSecondaryOrderMutationVariables>;
export const GetParentRentalDocument = gql`
    query getParentRental($ID: String!) {
  getRentalById(ID: $ID) {
    ...ReusableRental
    location {
      damageWaiverFixedFee
      damageWaiverPercent
      defaultStart
      defaultEnd
    }
    smartPricingActive
    secondaryOrders {
      ...ReusableRental
      dailyRentals {
        ...ReusableRental
      }
    }
  }
}
    ${ReusableRentalFragmentDoc}`;

/**
 * __useGetParentRentalQuery__
 *
 * To run a query within a React component, call `useGetParentRentalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentRentalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentRentalQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetParentRentalQuery(baseOptions: Apollo.QueryHookOptions<GetParentRentalQuery, GetParentRentalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentRentalQuery, GetParentRentalQueryVariables>(GetParentRentalDocument, options);
      }
export function useGetParentRentalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParentRentalQuery, GetParentRentalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentRentalQuery, GetParentRentalQueryVariables>(GetParentRentalDocument, options);
        }
export type GetParentRentalQueryHookResult = ReturnType<typeof useGetParentRentalQuery>;
export type GetParentRentalLazyQueryHookResult = ReturnType<typeof useGetParentRentalLazyQuery>;
export type GetParentRentalQueryResult = Apollo.QueryResult<GetParentRentalQuery, GetParentRentalQueryVariables>;
export const AssignSecondaryOrderAddressFromVenueDocument = gql`
    query AssignSecondaryOrderAddressFromVenue($rental: SoRentalInput!, $venueId: ID!) {
  assignSecondaryOrderAddressFromVenue(rental: $rental, venueId: $venueId) {
    id
    ...RentalAddress
    dailyRentals {
      id
      ...RentalAddress
      __typename
    }
    __typename
  }
}
    ${RentalAddressFragmentDoc}`;

/**
 * __useAssignSecondaryOrderAddressFromVenueQuery__
 *
 * To run a query within a React component, call `useAssignSecondaryOrderAddressFromVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignSecondaryOrderAddressFromVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignSecondaryOrderAddressFromVenueQuery({
 *   variables: {
 *      rental: // value for 'rental'
 *      venueId: // value for 'venueId'
 *   },
 * });
 */
export function useAssignSecondaryOrderAddressFromVenueQuery(baseOptions: Apollo.QueryHookOptions<AssignSecondaryOrderAddressFromVenueQuery, AssignSecondaryOrderAddressFromVenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssignSecondaryOrderAddressFromVenueQuery, AssignSecondaryOrderAddressFromVenueQueryVariables>(AssignSecondaryOrderAddressFromVenueDocument, options);
      }
export function useAssignSecondaryOrderAddressFromVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssignSecondaryOrderAddressFromVenueQuery, AssignSecondaryOrderAddressFromVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssignSecondaryOrderAddressFromVenueQuery, AssignSecondaryOrderAddressFromVenueQueryVariables>(AssignSecondaryOrderAddressFromVenueDocument, options);
        }
export type AssignSecondaryOrderAddressFromVenueQueryHookResult = ReturnType<typeof useAssignSecondaryOrderAddressFromVenueQuery>;
export type AssignSecondaryOrderAddressFromVenueLazyQueryHookResult = ReturnType<typeof useAssignSecondaryOrderAddressFromVenueLazyQuery>;
export type AssignSecondaryOrderAddressFromVenueQueryResult = Apollo.QueryResult<AssignSecondaryOrderAddressFromVenueQuery, AssignSecondaryOrderAddressFromVenueQueryVariables>;
export const GetDuplicatedRentalDocument = gql`
    query GetDuplicatedRental($rental: SoRentalInput!) {
  getDuplicatedRental(rental: $rental) {
    ...ReusableRental
    dailyRentals {
      ...ReusableRental
      __typename
    }
    __typename
  }
}
    ${ReusableRentalFragmentDoc}`;

/**
 * __useGetDuplicatedRentalQuery__
 *
 * To run a query within a React component, call `useGetDuplicatedRentalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDuplicatedRentalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDuplicatedRentalQuery({
 *   variables: {
 *      rental: // value for 'rental'
 *   },
 * });
 */
export function useGetDuplicatedRentalQuery(baseOptions: Apollo.QueryHookOptions<GetDuplicatedRentalQuery, GetDuplicatedRentalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDuplicatedRentalQuery, GetDuplicatedRentalQueryVariables>(GetDuplicatedRentalDocument, options);
      }
export function useGetDuplicatedRentalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDuplicatedRentalQuery, GetDuplicatedRentalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDuplicatedRentalQuery, GetDuplicatedRentalQueryVariables>(GetDuplicatedRentalDocument, options);
        }
export type GetDuplicatedRentalQueryHookResult = ReturnType<typeof useGetDuplicatedRentalQuery>;
export type GetDuplicatedRentalLazyQueryHookResult = ReturnType<typeof useGetDuplicatedRentalLazyQuery>;
export type GetDuplicatedRentalQueryResult = Apollo.QueryResult<GetDuplicatedRentalQuery, GetDuplicatedRentalQueryVariables>;
export const GetParentRentalForInvoiceDocument = gql`
    query getParentRentalForInvoice($ID: String!) {
  getRentalById(ID: $ID) {
    ...ReusableRentalForInvoice
    secondaryOrders {
      ...ReusableRentalForInvoice
      dailyRentals {
        ...ReusableRentalForInvoice
      }
    }
  }
}
    ${ReusableRentalForInvoiceFragmentDoc}`;

/**
 * __useGetParentRentalForInvoiceQuery__
 *
 * To run a query within a React component, call `useGetParentRentalForInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentRentalForInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentRentalForInvoiceQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetParentRentalForInvoiceQuery(baseOptions: Apollo.QueryHookOptions<GetParentRentalForInvoiceQuery, GetParentRentalForInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentRentalForInvoiceQuery, GetParentRentalForInvoiceQueryVariables>(GetParentRentalForInvoiceDocument, options);
      }
export function useGetParentRentalForInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParentRentalForInvoiceQuery, GetParentRentalForInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentRentalForInvoiceQuery, GetParentRentalForInvoiceQueryVariables>(GetParentRentalForInvoiceDocument, options);
        }
export type GetParentRentalForInvoiceQueryHookResult = ReturnType<typeof useGetParentRentalForInvoiceQuery>;
export type GetParentRentalForInvoiceLazyQueryHookResult = ReturnType<typeof useGetParentRentalForInvoiceLazyQuery>;
export type GetParentRentalForInvoiceQueryResult = Apollo.QueryResult<GetParentRentalForInvoiceQuery, GetParentRentalForInvoiceQueryVariables>;
export const GetRentalByTokenDocument = gql`
    query getRentalByToken($ID: String!) {
  getRentalById(ID: $ID) {
    id
    token
    name
    pricingLogicId
    rentalTotal {
      billingLines {
        tag
        name
        kind
        aggregate
        baseValue
        discountValue
        feeValue
        finalValue
        taxableValue
      }
    }
    billingNotes {
      id
      authorName
      message
      paymentDate
      deletedAt
      amount
      noteType
      paymentInfo
      employeeName
      isAuthorPrimary
      isCompanyPrimary
    }
    business {
      id
      name
    }
    refundLines {
      id
      amount
      createdAt
      refundGroupId
      refundType
    }
  }
}
    `;

/**
 * __useGetRentalByTokenQuery__
 *
 * To run a query within a React component, call `useGetRentalByTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalByTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalByTokenQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetRentalByTokenQuery(baseOptions: Apollo.QueryHookOptions<GetRentalByTokenQuery, GetRentalByTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalByTokenQuery, GetRentalByTokenQueryVariables>(GetRentalByTokenDocument, options);
      }
export function useGetRentalByTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalByTokenQuery, GetRentalByTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalByTokenQuery, GetRentalByTokenQueryVariables>(GetRentalByTokenDocument, options);
        }
export type GetRentalByTokenQueryHookResult = ReturnType<typeof useGetRentalByTokenQuery>;
export type GetRentalByTokenLazyQueryHookResult = ReturnType<typeof useGetRentalByTokenLazyQuery>;
export type GetRentalByTokenQueryResult = Apollo.QueryResult<GetRentalByTokenQuery, GetRentalByTokenQueryVariables>;
export const DeleteRefundLineDocument = gql`
    mutation DeleteRefundLine($input: DeleteRefundLineInput!) {
  deleteRefundLine(input: $input) {
    success
    error
  }
}
    `;
export type DeleteRefundLineMutationFn = Apollo.MutationFunction<DeleteRefundLineMutation, DeleteRefundLineMutationVariables>;

/**
 * __useDeleteRefundLineMutation__
 *
 * To run a mutation, you first call `useDeleteRefundLineMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRefundLineMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRefundLineMutation, { data, loading, error }] = useDeleteRefundLineMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRefundLineMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRefundLineMutation, DeleteRefundLineMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRefundLineMutation, DeleteRefundLineMutationVariables>(DeleteRefundLineDocument, options);
      }
export type DeleteRefundLineMutationHookResult = ReturnType<typeof useDeleteRefundLineMutation>;
export type DeleteRefundLineMutationResult = Apollo.MutationResult<DeleteRefundLineMutation>;
export type DeleteRefundLineMutationOptions = Apollo.BaseMutationOptions<DeleteRefundLineMutation, DeleteRefundLineMutationVariables>;
export const SyncRentalToQbDocument = gql`
    mutation SyncRentalToQB($input: SyncRentalToQBInput!) {
  syncRentalToQb(input: $input) {
    success
    error
  }
}
    `;
export type SyncRentalToQbMutationFn = Apollo.MutationFunction<SyncRentalToQbMutation, SyncRentalToQbMutationVariables>;

/**
 * __useSyncRentalToQbMutation__
 *
 * To run a mutation, you first call `useSyncRentalToQbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncRentalToQbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncRentalToQbMutation, { data, loading, error }] = useSyncRentalToQbMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncRentalToQbMutation(baseOptions?: Apollo.MutationHookOptions<SyncRentalToQbMutation, SyncRentalToQbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncRentalToQbMutation, SyncRentalToQbMutationVariables>(SyncRentalToQbDocument, options);
      }
export type SyncRentalToQbMutationHookResult = ReturnType<typeof useSyncRentalToQbMutation>;
export type SyncRentalToQbMutationResult = Apollo.MutationResult<SyncRentalToQbMutation>;
export type SyncRentalToQbMutationOptions = Apollo.BaseMutationOptions<SyncRentalToQbMutation, SyncRentalToQbMutationVariables>;
export const SyncRentalManuallyToQbDocument = gql`
    mutation syncRentalManuallyToQb($input: SyncRentalManuallyToQBInput!) {
  syncRentalManuallyToQb(input: $input) {
    success
    export
    error
  }
}
    `;
export type SyncRentalManuallyToQbMutationFn = Apollo.MutationFunction<SyncRentalManuallyToQbMutation, SyncRentalManuallyToQbMutationVariables>;

/**
 * __useSyncRentalManuallyToQbMutation__
 *
 * To run a mutation, you first call `useSyncRentalManuallyToQbMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncRentalManuallyToQbMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncRentalManuallyToQbMutation, { data, loading, error }] = useSyncRentalManuallyToQbMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncRentalManuallyToQbMutation(baseOptions?: Apollo.MutationHookOptions<SyncRentalManuallyToQbMutation, SyncRentalManuallyToQbMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncRentalManuallyToQbMutation, SyncRentalManuallyToQbMutationVariables>(SyncRentalManuallyToQbDocument, options);
      }
export type SyncRentalManuallyToQbMutationHookResult = ReturnType<typeof useSyncRentalManuallyToQbMutation>;
export type SyncRentalManuallyToQbMutationResult = Apollo.MutationResult<SyncRentalManuallyToQbMutation>;
export type SyncRentalManuallyToQbMutationOptions = Apollo.BaseMutationOptions<SyncRentalManuallyToQbMutation, SyncRentalManuallyToQbMutationVariables>;
export const GetClientSuccessHistoryEntriesDocument = gql`
    query getClientSuccessHistoryEntries {
  getClientSuccessHistoryEntries {
    id
    entryType
    refundName
    createdAt
    rental {
      id
      token
    }
    admin {
      id
      name
    }
    billingNote {
      id
      message
      authorName
      paymentDate
    }
  }
}
    `;

/**
 * __useGetClientSuccessHistoryEntriesQuery__
 *
 * To run a query within a React component, call `useGetClientSuccessHistoryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientSuccessHistoryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientSuccessHistoryEntriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientSuccessHistoryEntriesQuery(baseOptions?: Apollo.QueryHookOptions<GetClientSuccessHistoryEntriesQuery, GetClientSuccessHistoryEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientSuccessHistoryEntriesQuery, GetClientSuccessHistoryEntriesQueryVariables>(GetClientSuccessHistoryEntriesDocument, options);
      }
export function useGetClientSuccessHistoryEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientSuccessHistoryEntriesQuery, GetClientSuccessHistoryEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientSuccessHistoryEntriesQuery, GetClientSuccessHistoryEntriesQueryVariables>(GetClientSuccessHistoryEntriesDocument, options);
        }
export type GetClientSuccessHistoryEntriesQueryHookResult = ReturnType<typeof useGetClientSuccessHistoryEntriesQuery>;
export type GetClientSuccessHistoryEntriesLazyQueryHookResult = ReturnType<typeof useGetClientSuccessHistoryEntriesLazyQuery>;
export type GetClientSuccessHistoryEntriesQueryResult = Apollo.QueryResult<GetClientSuccessHistoryEntriesQuery, GetClientSuccessHistoryEntriesQueryVariables>;
export const ExportStorefrontInventoryDocument = gql`
    mutation ExportStorefrontInventory($input: ExportStorefrontInventoryInput!) {
  exportStorefrontInventory(input: $input) {
    status
    exportProgressId
    errors
  }
}
    `;
export type ExportStorefrontInventoryMutationFn = Apollo.MutationFunction<ExportStorefrontInventoryMutation, ExportStorefrontInventoryMutationVariables>;

/**
 * __useExportStorefrontInventoryMutation__
 *
 * To run a mutation, you first call `useExportStorefrontInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportStorefrontInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportStorefrontInventoryMutation, { data, loading, error }] = useExportStorefrontInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportStorefrontInventoryMutation(baseOptions?: Apollo.MutationHookOptions<ExportStorefrontInventoryMutation, ExportStorefrontInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportStorefrontInventoryMutation, ExportStorefrontInventoryMutationVariables>(ExportStorefrontInventoryDocument, options);
      }
export type ExportStorefrontInventoryMutationHookResult = ReturnType<typeof useExportStorefrontInventoryMutation>;
export type ExportStorefrontInventoryMutationResult = Apollo.MutationResult<ExportStorefrontInventoryMutation>;
export type ExportStorefrontInventoryMutationOptions = Apollo.BaseMutationOptions<ExportStorefrontInventoryMutation, ExportStorefrontInventoryMutationVariables>;
export const WorldpayHostedPaymentSetupDocument = gql`
    mutation WorldpayHostedPaymentSetup($input: WorldpayHostedPaymentSetupInput!) {
  worldpayHostedPaymentSetup(input: $input) {
    redirectUrl
    transactionSetupId
    referenceNumber
    ticketNumber
    validationCode
    error
  }
}
    `;
export type WorldpayHostedPaymentSetupMutationFn = Apollo.MutationFunction<WorldpayHostedPaymentSetupMutation, WorldpayHostedPaymentSetupMutationVariables>;

/**
 * __useWorldpayHostedPaymentSetupMutation__
 *
 * To run a mutation, you first call `useWorldpayHostedPaymentSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWorldpayHostedPaymentSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [worldpayHostedPaymentSetupMutation, { data, loading, error }] = useWorldpayHostedPaymentSetupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useWorldpayHostedPaymentSetupMutation(baseOptions?: Apollo.MutationHookOptions<WorldpayHostedPaymentSetupMutation, WorldpayHostedPaymentSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WorldpayHostedPaymentSetupMutation, WorldpayHostedPaymentSetupMutationVariables>(WorldpayHostedPaymentSetupDocument, options);
      }
export type WorldpayHostedPaymentSetupMutationHookResult = ReturnType<typeof useWorldpayHostedPaymentSetupMutation>;
export type WorldpayHostedPaymentSetupMutationResult = Apollo.MutationResult<WorldpayHostedPaymentSetupMutation>;
export type WorldpayHostedPaymentSetupMutationOptions = Apollo.BaseMutationOptions<WorldpayHostedPaymentSetupMutation, WorldpayHostedPaymentSetupMutationVariables>;
export const GetRentalsGanttDocument = gql`
    query GetRentalsGantt($startDate: ISO8601DateTime, $endDate: ISO8601DateTime, $status: [String!], $teamMemberNames: [String!], $contactIds: [String!], $deliveryTypes: [String!], $sortBy: String) {
  getRentalsGantt(
    startDate: $startDate
    endDate: $endDate
    status: $status
    teamMemberNames: $teamMemberNames
    contactIds: $contactIds
    deliveryTypes: $deliveryTypes
    sortBy: $sortBy
  ) {
    id
    token
    name
    status
    deliveryType
    teamMembers {
      id
      name
    }
    employeeRentalRelationships {
      id
      rentalId
      employee {
        id
        name
      }
    }
    customers {
      id
      name
    }
    company {
      id
      name
    }
    event {
      id
      name
    }
    schedule {
      eventStartDateTime
      eventEndDateTime
      startDateTime
      endDateTime
      startWindowFinish
      endWindowBeginning
    }
  }
}
    `;

/**
 * __useGetRentalsGanttQuery__
 *
 * To run a query within a React component, call `useGetRentalsGanttQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalsGanttQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalsGanttQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      status: // value for 'status'
 *      teamMemberNames: // value for 'teamMemberNames'
 *      contactIds: // value for 'contactIds'
 *      deliveryTypes: // value for 'deliveryTypes'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetRentalsGanttQuery(baseOptions?: Apollo.QueryHookOptions<GetRentalsGanttQuery, GetRentalsGanttQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalsGanttQuery, GetRentalsGanttQueryVariables>(GetRentalsGanttDocument, options);
      }
export function useGetRentalsGanttLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalsGanttQuery, GetRentalsGanttQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalsGanttQuery, GetRentalsGanttQueryVariables>(GetRentalsGanttDocument, options);
        }
export type GetRentalsGanttQueryHookResult = ReturnType<typeof useGetRentalsGanttQuery>;
export type GetRentalsGanttLazyQueryHookResult = ReturnType<typeof useGetRentalsGanttLazyQuery>;
export type GetRentalsGanttQueryResult = Apollo.QueryResult<GetRentalsGanttQuery, GetRentalsGanttQueryVariables>;
export const GetParentRentalsDocument = gql`
    query GetParentRentals($search: String, $eventId: ID!, $page: Int, $perPage: Int, $status: [String!]) {
  getParentRentals(
    search: $search
    eventId: $eventId
    page: $page
    perPage: $perPage
    status: $status
  ) {
    id
    name
    token
    customId
    secondaryOrdersCount
    recurring
    status
    rentalTotal {
      id
      subTotal
      discountTotal
      feeTotal
      overallTotal
    }
    schedule {
      id
      eventStartDateTime
      eventEndDateTime
      timeZone
      offShelfAt
      onShelfAt
      startDateTime
      endDateTime
      startWindowFinish
      endWindowBeginning
      sameAsEventDate
      shelfEnabled
      eventStartSetting
      eventEndSetting
    }
  }
}
    `;

/**
 * __useGetParentRentalsQuery__
 *
 * To run a query within a React component, call `useGetParentRentalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetParentRentalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetParentRentalsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      eventId: // value for 'eventId'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetParentRentalsQuery(baseOptions: Apollo.QueryHookOptions<GetParentRentalsQuery, GetParentRentalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetParentRentalsQuery, GetParentRentalsQueryVariables>(GetParentRentalsDocument, options);
      }
export function useGetParentRentalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetParentRentalsQuery, GetParentRentalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetParentRentalsQuery, GetParentRentalsQueryVariables>(GetParentRentalsDocument, options);
        }
export type GetParentRentalsQueryHookResult = ReturnType<typeof useGetParentRentalsQuery>;
export type GetParentRentalsLazyQueryHookResult = ReturnType<typeof useGetParentRentalsLazyQuery>;
export type GetParentRentalsQueryResult = Apollo.QueryResult<GetParentRentalsQuery, GetParentRentalsQueryVariables>;
export const GetEventBillingSummaryDocument = gql`
    query GetEventBillingSummary($eventToken: String!, $threshold: Int) {
  getEventBillingSummary(eventToken: $eventToken, threshold: $threshold) {
    totalDays
    totalWeeks
    dateGroups
    rentalTypes {
      Items {
        name
        total
        quantityTotal
        inventoryId
        quantities
      }
      Accessories {
        name
        total
        quantityTotal
        inventoryId
        quantities
      }
      Purchases {
        name
        total
        quantityTotal
        inventoryId
        quantities
      }
      Bundles {
        name
        total
        quantityTotal
        inventoryId
        quantities
      }
      Staff {
        name
        total
        quantityTotal
        inventoryId
        quantities
      }
      Labor {
        name
        total
        quantityTotal
        inventoryId
        quantities
      }
    }
  }
}
    `;

/**
 * __useGetEventBillingSummaryQuery__
 *
 * To run a query within a React component, call `useGetEventBillingSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventBillingSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventBillingSummaryQuery({
 *   variables: {
 *      eventToken: // value for 'eventToken'
 *      threshold: // value for 'threshold'
 *   },
 * });
 */
export function useGetEventBillingSummaryQuery(baseOptions: Apollo.QueryHookOptions<GetEventBillingSummaryQuery, GetEventBillingSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventBillingSummaryQuery, GetEventBillingSummaryQueryVariables>(GetEventBillingSummaryDocument, options);
      }
export function useGetEventBillingSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventBillingSummaryQuery, GetEventBillingSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventBillingSummaryQuery, GetEventBillingSummaryQueryVariables>(GetEventBillingSummaryDocument, options);
        }
export type GetEventBillingSummaryQueryHookResult = ReturnType<typeof useGetEventBillingSummaryQuery>;
export type GetEventBillingSummaryLazyQueryHookResult = ReturnType<typeof useGetEventBillingSummaryLazyQuery>;
export type GetEventBillingSummaryQueryResult = Apollo.QueryResult<GetEventBillingSummaryQuery, GetEventBillingSummaryQueryVariables>;
export const GetEventInventoryItemRentalsDocument = gql`
    query GetEventInventoryItemRentals($eventToken: String!, $inventoryItemId: ID!, $inventoryItemType: RentalInventoryTypeEnum!) {
  getEventInventoryItemRentals(
    eventToken: $eventToken
    inventoryItemId: $inventoryItemId
    inventoryItemType: $inventoryItemType
  ) {
    ... on RentalItem {
      id
      name
      quantity
      inventoryId
      rentalId
      rentalName
      rentalToken
      rentalStatus
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        timeZone
      }
      __typename
    }
    ... on RentalAccessory {
      id
      name
      quantity
      inventoryId
      rentalId
      rentalName
      rentalToken
      rentalStatus
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        timeZone
      }
      __typename
    }
    ... on RentalBundle {
      id
      name
      quantity
      inventoryId
      rentalId
      rentalName
      rentalToken
      rentalStatus
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        timeZone
      }
      __typename
    }
    ... on RentalAddOn {
      id
      name
      quantity
      inventoryId
      rentalId
      rentalName
      rentalToken
      rentalStatus
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        timeZone
      }
      __typename
    }
    ... on RentalStaff {
      id
      name
      size
      inventoryId
      rentalId
      rentalName
      rentalToken
      rentalStatus
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        timeZone
      }
      __typename
    }
  }
}
    `;

/**
 * __useGetEventInventoryItemRentalsQuery__
 *
 * To run a query within a React component, call `useGetEventInventoryItemRentalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventInventoryItemRentalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventInventoryItemRentalsQuery({
 *   variables: {
 *      eventToken: // value for 'eventToken'
 *      inventoryItemId: // value for 'inventoryItemId'
 *      inventoryItemType: // value for 'inventoryItemType'
 *   },
 * });
 */
export function useGetEventInventoryItemRentalsQuery(baseOptions: Apollo.QueryHookOptions<GetEventInventoryItemRentalsQuery, GetEventInventoryItemRentalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventInventoryItemRentalsQuery, GetEventInventoryItemRentalsQueryVariables>(GetEventInventoryItemRentalsDocument, options);
      }
export function useGetEventInventoryItemRentalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventInventoryItemRentalsQuery, GetEventInventoryItemRentalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventInventoryItemRentalsQuery, GetEventInventoryItemRentalsQueryVariables>(GetEventInventoryItemRentalsDocument, options);
        }
export type GetEventInventoryItemRentalsQueryHookResult = ReturnType<typeof useGetEventInventoryItemRentalsQuery>;
export type GetEventInventoryItemRentalsLazyQueryHookResult = ReturnType<typeof useGetEventInventoryItemRentalsLazyQuery>;
export type GetEventInventoryItemRentalsQueryResult = Apollo.QueryResult<GetEventInventoryItemRentalsQuery, GetEventInventoryItemRentalsQueryVariables>;
export const CloseEventDocument = gql`
    mutation closeEvent($input: SetEventInput!) {
  setEvent(input: $input) {
    event {
      id
      status
    }
  }
}
    `;
export type CloseEventMutationFn = Apollo.MutationFunction<CloseEventMutation, CloseEventMutationVariables>;

/**
 * __useCloseEventMutation__
 *
 * To run a mutation, you first call `useCloseEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeEventMutation, { data, loading, error }] = useCloseEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseEventMutation(baseOptions?: Apollo.MutationHookOptions<CloseEventMutation, CloseEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseEventMutation, CloseEventMutationVariables>(CloseEventDocument, options);
      }
export type CloseEventMutationHookResult = ReturnType<typeof useCloseEventMutation>;
export type CloseEventMutationResult = Apollo.MutationResult<CloseEventMutation>;
export type CloseEventMutationOptions = Apollo.BaseMutationOptions<CloseEventMutation, CloseEventMutationVariables>;
export const GetEventDocument = gql`
    query GetEvent($id: String!) {
  getEvent(id: $id) {
    id
    token
    status
    name
    eventStartDateTime
    eventEndDateTime
    recurring
    recurrencePeriodCount
    latestRecurrenceToken
    active
    createdAt
    updatedAt
    customerId
    locationId
    timeZone
    rentalsCount
    secondaryOrdersCount
    source
    referralSource
    type
    location {
      phoneNumber {
        id
        cell
      }
      physicalAddress {
        id
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
        country
        active
        mainContactAddress
        addressableId
        addressableType
        addressType
        name
      }
    }
    documents {
      id
      name
      file
      fileUrl
      expirable
      expiresAt
      createdAt
      fileFileSize
      fileFileName
      documentType
      fileUpdatedAt
      fileContentType
      visibleToCustomer
    }
    notes {
      id
      message
      createdAt
      visibleToCustomer
      visibleToOperations
      employee {
        lastName
        firstName
      }
    }
    teamMembers {
      id
      role
      email
      lastName
      firstName
    }
    rentalTotal {
      overallTotal
      taxTotal
      subTotal
      subTotalForTax
      inventoryTotal
      inventoryTotalForTax
      totalDeliveryCost
      pretaxFeeTotal
      feeTotalExcludingDamageWaiver
      tgBusinessFee
      tapgoodsFeeTotal
      feeTotal
      standardFeeTotal
      overallDamageFeeTotal
      rentalAccessoryDamageTotal
      rentalItemDamageTotal
      creditCardFeeTotal
      expenseTotal
      discountTotal
      rentalBundleTotalForTax
      rentalItemTotalForTax
      rentalAddOnTotalForTax
      totalDeliveryCostForTax
      staffingTotalForTax
      staffingTotal
      rentalBundleTotal
      rentalItemTotal
      rentalAddOnTotal
      dmgWaiverInventoryTotal
      processingFeeTotal
      tapgoodsTaxTotal
      totalBeforeTransactionCharges
      totalPaid
      paymentBalance
      totalRefunded
      processingFeeRefunded
      amountRemaining
      inventoryTotalForDamage
      rentalItemTotalForDamage
      damageWaiverTotalForTax
    }
  }
}
    `;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
      }
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventQuery, GetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventQuery, GetEventQueryVariables>(GetEventDocument, options);
        }
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventQueryResult = Apollo.QueryResult<GetEventQuery, GetEventQueryVariables>;
export const ExportEventInvoiceDocument = gql`
    mutation ExportEventInvoice($input: ExportEventInvoiceInput!) {
  exportEventInvoice(input: $input) {
    exportProgressId
  }
}
    `;
export type ExportEventInvoiceMutationFn = Apollo.MutationFunction<ExportEventInvoiceMutation, ExportEventInvoiceMutationVariables>;

/**
 * __useExportEventInvoiceMutation__
 *
 * To run a mutation, you first call `useExportEventInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEventInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEventInvoiceMutation, { data, loading, error }] = useExportEventInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportEventInvoiceMutation(baseOptions?: Apollo.MutationHookOptions<ExportEventInvoiceMutation, ExportEventInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEventInvoiceMutation, ExportEventInvoiceMutationVariables>(ExportEventInvoiceDocument, options);
      }
export type ExportEventInvoiceMutationHookResult = ReturnType<typeof useExportEventInvoiceMutation>;
export type ExportEventInvoiceMutationResult = Apollo.MutationResult<ExportEventInvoiceMutation>;
export type ExportEventInvoiceMutationOptions = Apollo.BaseMutationOptions<ExportEventInvoiceMutation, ExportEventInvoiceMutationVariables>;
export const ExportEventBillingSummaryDocument = gql`
    mutation ExportEventBillingSummary($input: ExportEventBillingSummaryInput!) {
  exportEventBillingSummary(input: $input) {
    exportProgressId
  }
}
    `;
export type ExportEventBillingSummaryMutationFn = Apollo.MutationFunction<ExportEventBillingSummaryMutation, ExportEventBillingSummaryMutationVariables>;

/**
 * __useExportEventBillingSummaryMutation__
 *
 * To run a mutation, you first call `useExportEventBillingSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportEventBillingSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportEventBillingSummaryMutation, { data, loading, error }] = useExportEventBillingSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportEventBillingSummaryMutation(baseOptions?: Apollo.MutationHookOptions<ExportEventBillingSummaryMutation, ExportEventBillingSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportEventBillingSummaryMutation, ExportEventBillingSummaryMutationVariables>(ExportEventBillingSummaryDocument, options);
      }
export type ExportEventBillingSummaryMutationHookResult = ReturnType<typeof useExportEventBillingSummaryMutation>;
export type ExportEventBillingSummaryMutationResult = Apollo.MutationResult<ExportEventBillingSummaryMutation>;
export type ExportEventBillingSummaryMutationOptions = Apollo.BaseMutationOptions<ExportEventBillingSummaryMutation, ExportEventBillingSummaryMutationVariables>;
export const EventFormGetEventDocument = gql`
    query EventFormGetEvent($id: String!) {
  getEvent(id: $id) {
    id
    name
    eventEndDateTime
    eventStartDateTime
    customerId
    recurring
    recurrencePeriodCount
    timeZone
    referralSource
    status
    documentEventRelationships {
      id
      documentId
      expirable
      expiresAt
      employeeId
      document {
        id
        name
        file
        fileUrl
        expirable
        expiresAt
        createdAt
        fileFileSize
        documentType
        fileUpdatedAt
        fileContentType
        visibleToCustomer
        documentableId
        documentableType
        fileFileName
      }
    }
    notes {
      id
      message
      visibleToCustomer
      visibleToOperations
    }
    employeeEventRelationships {
      id
      employeeId
      name
      employeeEventRoles {
        id
        roleId
        name
      }
    }
  }
}
    `;

/**
 * __useEventFormGetEventQuery__
 *
 * To run a query within a React component, call `useEventFormGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventFormGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventFormGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEventFormGetEventQuery(baseOptions: Apollo.QueryHookOptions<EventFormGetEventQuery, EventFormGetEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventFormGetEventQuery, EventFormGetEventQueryVariables>(EventFormGetEventDocument, options);
      }
export function useEventFormGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventFormGetEventQuery, EventFormGetEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventFormGetEventQuery, EventFormGetEventQueryVariables>(EventFormGetEventDocument, options);
        }
export type EventFormGetEventQueryHookResult = ReturnType<typeof useEventFormGetEventQuery>;
export type EventFormGetEventLazyQueryHookResult = ReturnType<typeof useEventFormGetEventLazyQuery>;
export type EventFormGetEventQueryResult = Apollo.QueryResult<EventFormGetEventQuery, EventFormGetEventQueryVariables>;
export const DeleteEventDocument = gql`
    mutation DeleteEvent($input: DeleteEventInput!) {
  deleteEvent(input: $input) {
    event {
      id
      token
      name
      status
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type DeleteEventMutationFn = Apollo.MutationFunction<DeleteEventMutation, DeleteEventMutationVariables>;

/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEventMutation, DeleteEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEventMutation, DeleteEventMutationVariables>(DeleteEventDocument, options);
      }
export type DeleteEventMutationHookResult = ReturnType<typeof useDeleteEventMutation>;
export type DeleteEventMutationResult = Apollo.MutationResult<DeleteEventMutation>;
export type DeleteEventMutationOptions = Apollo.BaseMutationOptions<DeleteEventMutation, DeleteEventMutationVariables>;
export const SetEventDocument = gql`
    mutation SetEvent($input: SetEventInput!) {
  setEvent(input: $input) {
    event {
      id
      name
      token
      eventEndDateTime
      eventStartDateTime
      recurring
      latestRecurrentRentalId
      documents {
        id
        documentableId
        documentableType
        fileFileName
      }
      notes {
        id
        message
        visibleToCustomer
        visibleToOperations
      }
      teamMembers {
        id
        email
        firstName
        lastName
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetEventMutationFn = Apollo.MutationFunction<SetEventMutation, SetEventMutationVariables>;

/**
 * __useSetEventMutation__
 *
 * To run a mutation, you first call `useSetEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEventMutation, { data, loading, error }] = useSetEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetEventMutation(baseOptions?: Apollo.MutationHookOptions<SetEventMutation, SetEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEventMutation, SetEventMutationVariables>(SetEventDocument, options);
      }
export type SetEventMutationHookResult = ReturnType<typeof useSetEventMutation>;
export type SetEventMutationResult = Apollo.MutationResult<SetEventMutation>;
export type SetEventMutationOptions = Apollo.BaseMutationOptions<SetEventMutation, SetEventMutationVariables>;
export const GetEventsDocument = gql`
    query GetEvents($status: [String!]) {
  getEvents(status: $status) {
    collection {
      id
      token
      status
      eventStartDateTime
      eventEndDateTime
      rentalsCount
      secondaryOrdersCount
    }
    metadata {
      totalPages
    }
  }
}
    `;

/**
 * __useGetEventsQuery__
 *
 * To run a query within a React component, call `useGetEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsQuery({
 *   variables: {
 *      status: // value for 'status'
 *   },
 * });
 */
export function useGetEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
      }
export function useGetEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsQuery, GetEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsQuery, GetEventsQueryVariables>(GetEventsDocument, options);
        }
export type GetEventsQueryHookResult = ReturnType<typeof useGetEventsQuery>;
export type GetEventsLazyQueryHookResult = ReturnType<typeof useGetEventsLazyQuery>;
export type GetEventsQueryResult = Apollo.QueryResult<GetEventsQuery, GetEventsQueryVariables>;
export const GetEventsForFilterAutocompleteDocument = gql`
    query GetEventsForFilterAutocomplete($search: String!) {
  getEvents(search: $search) {
    collection {
      id
      name
      token
      __typename
    }
  }
}
    `;

/**
 * __useGetEventsForFilterAutocompleteQuery__
 *
 * To run a query within a React component, call `useGetEventsForFilterAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsForFilterAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsForFilterAutocompleteQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEventsForFilterAutocompleteQuery(baseOptions: Apollo.QueryHookOptions<GetEventsForFilterAutocompleteQuery, GetEventsForFilterAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsForFilterAutocompleteQuery, GetEventsForFilterAutocompleteQueryVariables>(GetEventsForFilterAutocompleteDocument, options);
      }
export function useGetEventsForFilterAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsForFilterAutocompleteQuery, GetEventsForFilterAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsForFilterAutocompleteQuery, GetEventsForFilterAutocompleteQueryVariables>(GetEventsForFilterAutocompleteDocument, options);
        }
export type GetEventsForFilterAutocompleteQueryHookResult = ReturnType<typeof useGetEventsForFilterAutocompleteQuery>;
export type GetEventsForFilterAutocompleteLazyQueryHookResult = ReturnType<typeof useGetEventsForFilterAutocompleteLazyQuery>;
export type GetEventsForFilterAutocompleteQueryResult = Apollo.QueryResult<GetEventsForFilterAutocompleteQuery, GetEventsForFilterAutocompleteQueryVariables>;
export const GetStaffRoleTypeDocument = gql`
    query GetStaffRoleType($id: ID!) {
  getStaffRole(id: $id) {
    id
    type
    __typename
  }
}
    `;

/**
 * __useGetStaffRoleTypeQuery__
 *
 * To run a query within a React component, call `useGetStaffRoleTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStaffRoleTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStaffRoleTypeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetStaffRoleTypeQuery(baseOptions: Apollo.QueryHookOptions<GetStaffRoleTypeQuery, GetStaffRoleTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetStaffRoleTypeQuery, GetStaffRoleTypeQueryVariables>(GetStaffRoleTypeDocument, options);
      }
export function useGetStaffRoleTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetStaffRoleTypeQuery, GetStaffRoleTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetStaffRoleTypeQuery, GetStaffRoleTypeQueryVariables>(GetStaffRoleTypeDocument, options);
        }
export type GetStaffRoleTypeQueryHookResult = ReturnType<typeof useGetStaffRoleTypeQuery>;
export type GetStaffRoleTypeLazyQueryHookResult = ReturnType<typeof useGetStaffRoleTypeLazyQuery>;
export type GetStaffRoleTypeQueryResult = Apollo.QueryResult<GetStaffRoleTypeQuery, GetStaffRoleTypeQueryVariables>;
export const GetLocationEmployeesDocument = gql`
    query GetLocationEmployees($search: String) {
  getLocationEmployees(search: $search) {
    id
    name
    employeeId
    employeeRoleRelationships {
      name
      roleKey
      roleId
    }
  }
}
    `;

/**
 * __useGetLocationEmployeesQuery__
 *
 * To run a query within a React component, call `useGetLocationEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationEmployeesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetLocationEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationEmployeesQuery, GetLocationEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationEmployeesQuery, GetLocationEmployeesQueryVariables>(GetLocationEmployeesDocument, options);
      }
export function useGetLocationEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationEmployeesQuery, GetLocationEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationEmployeesQuery, GetLocationEmployeesQueryVariables>(GetLocationEmployeesDocument, options);
        }
export type GetLocationEmployeesQueryHookResult = ReturnType<typeof useGetLocationEmployeesQuery>;
export type GetLocationEmployeesLazyQueryHookResult = ReturnType<typeof useGetLocationEmployeesLazyQuery>;
export type GetLocationEmployeesQueryResult = Apollo.QueryResult<GetLocationEmployeesQuery, GetLocationEmployeesQueryVariables>;
export const GetEventsListDocument = gql`
    query GetEventsList($search: String, $status: [String!], $page: Int, $perPage: Int, $eventStartDateTimeGte: ISO8601DateTime, $eventEndDateTimeLte: ISO8601DateTime, $venueId: ID, $companyId: ID, $customerId: ID, $salesperson: ID, $sortBy: String, $sortField: String) {
  getEvents(
    search: $search
    status: $status
    page: $page
    perPage: $perPage
    eventStartDateTimeGte: $eventStartDateTimeGte
    eventEndDateTimeLte: $eventEndDateTimeLte
    venueId: $venueId
    companyId: $companyId
    customerId: $customerId
    salesperson: $salesperson
    sortBy: $sortBy
    sortField: $sortField
  ) {
    collection {
      id
      token
      name
      status
      eventStartDateTime
      eventEndDateTime
      rentalsCount
      secondaryOrdersCount
    }
    metadata {
      totalPages
    }
  }
}
    `;

/**
 * __useGetEventsListQuery__
 *
 * To run a query within a React component, call `useGetEventsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventsListQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *      eventStartDateTimeGte: // value for 'eventStartDateTimeGte'
 *      eventEndDateTimeLte: // value for 'eventEndDateTimeLte'
 *      venueId: // value for 'venueId'
 *      companyId: // value for 'companyId'
 *      customerId: // value for 'customerId'
 *      salesperson: // value for 'salesperson'
 *      sortBy: // value for 'sortBy'
 *      sortField: // value for 'sortField'
 *   },
 * });
 */
export function useGetEventsListQuery(baseOptions?: Apollo.QueryHookOptions<GetEventsListQuery, GetEventsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEventsListQuery, GetEventsListQueryVariables>(GetEventsListDocument, options);
      }
export function useGetEventsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEventsListQuery, GetEventsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEventsListQuery, GetEventsListQueryVariables>(GetEventsListDocument, options);
        }
export type GetEventsListQueryHookResult = ReturnType<typeof useGetEventsListQuery>;
export type GetEventsListLazyQueryHookResult = ReturnType<typeof useGetEventsListLazyQuery>;
export type GetEventsListQueryResult = Apollo.QueryResult<GetEventsListQuery, GetEventsListQueryVariables>;
export const SearchSfTagsDocument = gql`
    query SearchSfTags($search: String, $locationId: Int!) {
  searchStorefrontTags(search: $search, locationId: $locationId) {
    id
    name
    __typename
  }
}
    `;

/**
 * __useSearchSfTagsQuery__
 *
 * To run a query within a React component, call `useSearchSfTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchSfTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchSfTagsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useSearchSfTagsQuery(baseOptions: Apollo.QueryHookOptions<SearchSfTagsQuery, SearchSfTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchSfTagsQuery, SearchSfTagsQueryVariables>(SearchSfTagsDocument, options);
      }
export function useSearchSfTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchSfTagsQuery, SearchSfTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchSfTagsQuery, SearchSfTagsQueryVariables>(SearchSfTagsDocument, options);
        }
export type SearchSfTagsQueryHookResult = ReturnType<typeof useSearchSfTagsQuery>;
export type SearchSfTagsLazyQueryHookResult = ReturnType<typeof useSearchSfTagsLazyQuery>;
export type SearchSfTagsQueryResult = Apollo.QueryResult<SearchSfTagsQuery, SearchSfTagsQueryVariables>;
export const GetProductForCalendarDocument = gql`
    query GetProductForCalendar($id: String!) {
  getProduct(id: $id) {
    id
    token
    hourlyPrice
    groupSharedQuantity
    halfDayPrice
    dailyPrice
    weeklyPrice
    monthlyPrice
    flatPrices {
      id
      name
      amount
    }
    name
    multilocationShared
    quantity
    maintenanceQuantity
    collectionName
    isMultilocation
    pictures {
      ...Picture
    }
    __typename
    inventoryGroup {
      id
      inventoryObjects {
        id
        locationId
        token
        __typename
      }
      __typename
    }
  }
}
    ${PictureFragmentDoc}`;

/**
 * __useGetProductForCalendarQuery__
 *
 * To run a query within a React component, call `useGetProductForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductForCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetProductForCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetProductForCalendarQuery, GetProductForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductForCalendarQuery, GetProductForCalendarQueryVariables>(GetProductForCalendarDocument, options);
      }
export function useGetProductForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductForCalendarQuery, GetProductForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductForCalendarQuery, GetProductForCalendarQueryVariables>(GetProductForCalendarDocument, options);
        }
export type GetProductForCalendarQueryHookResult = ReturnType<typeof useGetProductForCalendarQuery>;
export type GetProductForCalendarLazyQueryHookResult = ReturnType<typeof useGetProductForCalendarLazyQuery>;
export type GetProductForCalendarQueryResult = Apollo.QueryResult<GetProductForCalendarQuery, GetProductForCalendarQueryVariables>;
export const GetAccessoryForCalendarDocument = gql`
    query GetAccessoryForCalendar($id: String!) {
  getAccessory(id: $id) {
    id
    token
    groupSharedQuantity
    name
    multilocationShared
    quantity
    maintenanceQuantity
    collectionName
    isMultilocation
    pictures {
      ...Picture
    }
    __typename
    inventoryGroup {
      id
      inventoryObjects {
        id
        locationId
        token
        __typename
      }
      __typename
    }
  }
}
    ${PictureFragmentDoc}`;

/**
 * __useGetAccessoryForCalendarQuery__
 *
 * To run a query within a React component, call `useGetAccessoryForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessoryForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessoryForCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccessoryForCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetAccessoryForCalendarQuery, GetAccessoryForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessoryForCalendarQuery, GetAccessoryForCalendarQueryVariables>(GetAccessoryForCalendarDocument, options);
      }
export function useGetAccessoryForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessoryForCalendarQuery, GetAccessoryForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessoryForCalendarQuery, GetAccessoryForCalendarQueryVariables>(GetAccessoryForCalendarDocument, options);
        }
export type GetAccessoryForCalendarQueryHookResult = ReturnType<typeof useGetAccessoryForCalendarQuery>;
export type GetAccessoryForCalendarLazyQueryHookResult = ReturnType<typeof useGetAccessoryForCalendarLazyQuery>;
export type GetAccessoryForCalendarQueryResult = Apollo.QueryResult<GetAccessoryForCalendarQuery, GetAccessoryForCalendarQueryVariables>;
export const GetAddOnForCalendarDocument = gql`
    query GetAddOnForCalendar($id: String!) {
  getAddOn(id: $id) {
    id
    token
    groupSharedQuantity
    name
    multilocationShared
    quantity
    ownedQuantity
    initialQuantity
    reservedQuantity
    quantityInWarehouse
    maintenanceQuantity
    collectionName
    isMultilocation
    pictures {
      ...Picture
    }
    __typename
    inventoryGroup {
      id
      inventoryObjects {
        id
        locationId
        token
        __typename
      }
      __typename
    }
  }
}
    ${PictureFragmentDoc}`;

/**
 * __useGetAddOnForCalendarQuery__
 *
 * To run a query within a React component, call `useGetAddOnForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnForCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAddOnForCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetAddOnForCalendarQuery, GetAddOnForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnForCalendarQuery, GetAddOnForCalendarQueryVariables>(GetAddOnForCalendarDocument, options);
      }
export function useGetAddOnForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnForCalendarQuery, GetAddOnForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnForCalendarQuery, GetAddOnForCalendarQueryVariables>(GetAddOnForCalendarDocument, options);
        }
export type GetAddOnForCalendarQueryHookResult = ReturnType<typeof useGetAddOnForCalendarQuery>;
export type GetAddOnForCalendarLazyQueryHookResult = ReturnType<typeof useGetAddOnForCalendarLazyQuery>;
export type GetAddOnForCalendarQueryResult = Apollo.QueryResult<GetAddOnForCalendarQuery, GetAddOnForCalendarQueryVariables>;
export const GetBundleForCalendarDocument = gql`
    query GetBundleForCalendar($id: String!) {
  getBundle(id: $id) {
    id
    name
    token
    pictures {
      ...Picture
    }
    token
    totalQuantity
    collectionName
    isMultilocation
    productBundleRelationships {
      ...ProductBundleRelationshipForCalendar
    }
    accessoryBundleRelationships {
      ...AccessoryBundleRelationshipForCalendar
    }
    addOnBundleRelationships {
      ...AddOnBundleRelationshipForCalendar
    }
    __typename
  }
}
    ${PictureFragmentDoc}
${ProductBundleRelationshipForCalendarFragmentDoc}
${AccessoryBundleRelationshipForCalendarFragmentDoc}
${AddOnBundleRelationshipForCalendarFragmentDoc}`;

/**
 * __useGetBundleForCalendarQuery__
 *
 * To run a query within a React component, call `useGetBundleForCalendarQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBundleForCalendarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBundleForCalendarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBundleForCalendarQuery(baseOptions: Apollo.QueryHookOptions<GetBundleForCalendarQuery, GetBundleForCalendarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBundleForCalendarQuery, GetBundleForCalendarQueryVariables>(GetBundleForCalendarDocument, options);
      }
export function useGetBundleForCalendarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBundleForCalendarQuery, GetBundleForCalendarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBundleForCalendarQuery, GetBundleForCalendarQueryVariables>(GetBundleForCalendarDocument, options);
        }
export type GetBundleForCalendarQueryHookResult = ReturnType<typeof useGetBundleForCalendarQuery>;
export type GetBundleForCalendarLazyQueryHookResult = ReturnType<typeof useGetBundleForCalendarLazyQuery>;
export type GetBundleForCalendarQueryResult = Apollo.QueryResult<GetBundleForCalendarQuery, GetBundleForCalendarQueryVariables>;
export const GetAddOnReservedOrdersDocument = gql`
    query GetAddOnReservedOrders($addOnToken: String!) {
  getAddOnReservedOrders(addOnToken: $addOnToken) {
    token
    name
    status
    eventStartDateTime
    quantity
  }
}
    `;

/**
 * __useGetAddOnReservedOrdersQuery__
 *
 * To run a query within a React component, call `useGetAddOnReservedOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnReservedOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnReservedOrdersQuery({
 *   variables: {
 *      addOnToken: // value for 'addOnToken'
 *   },
 * });
 */
export function useGetAddOnReservedOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetAddOnReservedOrdersQuery, GetAddOnReservedOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnReservedOrdersQuery, GetAddOnReservedOrdersQueryVariables>(GetAddOnReservedOrdersDocument, options);
      }
export function useGetAddOnReservedOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnReservedOrdersQuery, GetAddOnReservedOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnReservedOrdersQuery, GetAddOnReservedOrdersQueryVariables>(GetAddOnReservedOrdersDocument, options);
        }
export type GetAddOnReservedOrdersQueryHookResult = ReturnType<typeof useGetAddOnReservedOrdersQuery>;
export type GetAddOnReservedOrdersLazyQueryHookResult = ReturnType<typeof useGetAddOnReservedOrdersLazyQuery>;
export type GetAddOnReservedOrdersQueryResult = Apollo.QueryResult<GetAddOnReservedOrdersQuery, GetAddOnReservedOrdersQueryVariables>;
export const GetAddOnInventoryLedgerEntriesDocument = gql`
    query GetAddOnInventoryLedgerEntries($addOnToken: String!, $page: Int, $perPage: Int) {
  getAddOnInventoryLedgerEntries(
    addOnToken: $addOnToken
    page: $page
    perPage: $perPage
  ) {
    collection {
      __typename
      ... on InventoryLedgerEntry {
        id
        date
        quantity
        balanceAfter
        operation
        rentalName
        rentalId
        rentalToken
        turnoverTimeInSeconds
        dateWithTurnoverTime
        subRentedQuantity
        details
      }
      ... on Supplier {
        id
        name
        website
        quantity
        cost
        notes
        completedAt
        po
        supplierType
        updatedAt
        authorName
        balanceAfter
      }
    }
    metadata {
      totalCount
      totalPages
      currentPage
    }
  }
}
    `;

/**
 * __useGetAddOnInventoryLedgerEntriesQuery__
 *
 * To run a query within a React component, call `useGetAddOnInventoryLedgerEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnInventoryLedgerEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnInventoryLedgerEntriesQuery({
 *   variables: {
 *      addOnToken: // value for 'addOnToken'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetAddOnInventoryLedgerEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetAddOnInventoryLedgerEntriesQuery, GetAddOnInventoryLedgerEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnInventoryLedgerEntriesQuery, GetAddOnInventoryLedgerEntriesQueryVariables>(GetAddOnInventoryLedgerEntriesDocument, options);
      }
export function useGetAddOnInventoryLedgerEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnInventoryLedgerEntriesQuery, GetAddOnInventoryLedgerEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnInventoryLedgerEntriesQuery, GetAddOnInventoryLedgerEntriesQueryVariables>(GetAddOnInventoryLedgerEntriesDocument, options);
        }
export type GetAddOnInventoryLedgerEntriesQueryHookResult = ReturnType<typeof useGetAddOnInventoryLedgerEntriesQuery>;
export type GetAddOnInventoryLedgerEntriesLazyQueryHookResult = ReturnType<typeof useGetAddOnInventoryLedgerEntriesLazyQuery>;
export type GetAddOnInventoryLedgerEntriesQueryResult = Apollo.QueryResult<GetAddOnInventoryLedgerEntriesQuery, GetAddOnInventoryLedgerEntriesQueryVariables>;
export const ReactivateSerializedProductsDocument = gql`
    mutation ReactivateSerializedProducts($input: ReactivateSerializedProductsInput!) {
  reactivateSerializedProducts(input: $input) {
    success
    error
  }
}
    `;
export type ReactivateSerializedProductsMutationFn = Apollo.MutationFunction<ReactivateSerializedProductsMutation, ReactivateSerializedProductsMutationVariables>;

/**
 * __useReactivateSerializedProductsMutation__
 *
 * To run a mutation, you first call `useReactivateSerializedProductsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSerializedProductsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSerializedProductsMutation, { data, loading, error }] = useReactivateSerializedProductsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReactivateSerializedProductsMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSerializedProductsMutation, ReactivateSerializedProductsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSerializedProductsMutation, ReactivateSerializedProductsMutationVariables>(ReactivateSerializedProductsDocument, options);
      }
export type ReactivateSerializedProductsMutationHookResult = ReturnType<typeof useReactivateSerializedProductsMutation>;
export type ReactivateSerializedProductsMutationResult = Apollo.MutationResult<ReactivateSerializedProductsMutation>;
export type ReactivateSerializedProductsMutationOptions = Apollo.BaseMutationOptions<ReactivateSerializedProductsMutation, ReactivateSerializedProductsMutationVariables>;
export const GetPurchaseOrderDocument = gql`
    query GetPurchaseOrder($id: ID!) {
  getPurchaseOrder(id: $id) {
    id
    name
    number
    status
    paymentStatus
    taxPercentage
    completionEstimate
    dateNeeded
    description
    note
    name
    priority
    createdAt
    deliveryCost
    billingSameAsDelivery
    taxType
    deliveryFeeTaxExempt
    purchaseOrderDeliveryFees {
      id
      name
      amount
    }
    documents {
      fileFileName
      fileFileSize
      name
      fileUrl
      fileUpdatedAt
      id
      createdAt
      employee {
        firstName
        lastName
      }
    }
    purchaseOrderTotalCalculation {
      subtotal
      tax
      total
      delivery
      taxableAmount
    }
    purchaseOrderInventories {
      id
      name
      quantity
      fulfilledQuantity
      damagedQuantity
      missingQuantity
      purchaseOrderPrice
      rentalPrice
      inventoryType
      note
      manufacturerPartNumber
      purchaseOrderId
      originalInventoryId
      originalInventory {
        ... on Product {
          serializationStatus
        }
      }
      serializedProducts {
        id
        serialNumber
        productId
        purchaseOrderInventoryId
      }
      itemNotes {
        id
        message
        shouldIncludeNotesInRentals
        visibleToOperations
      }
    }
    purchaseOrderVendorRelationship {
      id
      name
      emailAddress {
        id
        emailAddress
      }
      physicalAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      phoneNumber {
        id
        office
        extension
        cell
        fax
      }
    }
    location {
      name
      locale
      website
      physicalAddress {
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      phoneNumber {
        office
        extension
        cell
        fax
      }
    }
    deliveryAddress {
      id
      name
      country
      streetAddress1
      streetAddress2
      city
      locale
      postalCode
    }
    billingAddress {
      id
      name
      country
      streetAddress1
      streetAddress2
      city
      locale
      postalCode
    }
    deliveryPhoneNumber {
      id
      cell
    }
    billingPhoneNumber {
      id
      cell
    }
    purchaseOrderDeliveryFees {
      id
      name
      amount
    }
  }
}
    `;

/**
 * __useGetPurchaseOrderQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPurchaseOrderQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>(GetPurchaseOrderDocument, options);
      }
export function useGetPurchaseOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>(GetPurchaseOrderDocument, options);
        }
export type GetPurchaseOrderQueryHookResult = ReturnType<typeof useGetPurchaseOrderQuery>;
export type GetPurchaseOrderLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrderLazyQuery>;
export type GetPurchaseOrderQueryResult = Apollo.QueryResult<GetPurchaseOrderQuery, GetPurchaseOrderQueryVariables>;
export const CancelPurchaseOrderDocument = gql`
    mutation CancelPurchaseOrder($input: CancelPurchaseOrderInput!) {
  cancelPurchaseOrder(input: $input) {
    success
    errors
    deletedInventories
  }
}
    `;
export type CancelPurchaseOrderMutationFn = Apollo.MutationFunction<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>;

/**
 * __useCancelPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useCancelPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPurchaseOrderMutation, { data, loading, error }] = useCancelPurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>(CancelPurchaseOrderDocument, options);
      }
export type CancelPurchaseOrderMutationHookResult = ReturnType<typeof useCancelPurchaseOrderMutation>;
export type CancelPurchaseOrderMutationResult = Apollo.MutationResult<CancelPurchaseOrderMutation>;
export type CancelPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<CancelPurchaseOrderMutation, CancelPurchaseOrderMutationVariables>;
export const CheckInAllPurchaseOrderInventoryDocument = gql`
    mutation CheckInAllPurchaseOrderInventory($input: CheckInAllPurchaseOrderInventoryInput!) {
  checkInAllPurchaseOrderInventory(input: $input) {
    success
    errors
  }
}
    `;
export type CheckInAllPurchaseOrderInventoryMutationFn = Apollo.MutationFunction<CheckInAllPurchaseOrderInventoryMutation, CheckInAllPurchaseOrderInventoryMutationVariables>;

/**
 * __useCheckInAllPurchaseOrderInventoryMutation__
 *
 * To run a mutation, you first call `useCheckInAllPurchaseOrderInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInAllPurchaseOrderInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInAllPurchaseOrderInventoryMutation, { data, loading, error }] = useCheckInAllPurchaseOrderInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckInAllPurchaseOrderInventoryMutation(baseOptions?: Apollo.MutationHookOptions<CheckInAllPurchaseOrderInventoryMutation, CheckInAllPurchaseOrderInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInAllPurchaseOrderInventoryMutation, CheckInAllPurchaseOrderInventoryMutationVariables>(CheckInAllPurchaseOrderInventoryDocument, options);
      }
export type CheckInAllPurchaseOrderInventoryMutationHookResult = ReturnType<typeof useCheckInAllPurchaseOrderInventoryMutation>;
export type CheckInAllPurchaseOrderInventoryMutationResult = Apollo.MutationResult<CheckInAllPurchaseOrderInventoryMutation>;
export type CheckInAllPurchaseOrderInventoryMutationOptions = Apollo.BaseMutationOptions<CheckInAllPurchaseOrderInventoryMutation, CheckInAllPurchaseOrderInventoryMutationVariables>;
export const SetPurchaseOrderDocument = gql`
    mutation SetPurchaseOrder($input: SetPurchaseOrderInput!) {
  setPurchaseOrder(input: $input) {
    purchaseOrder {
      id
      number
      dateNeeded
      completionEstimate
      priority
      status
      paymentStatus
      purchaseOrderVendorRelationship {
        vendorId
        name
        physicalAddress {
          name
          streetAddress1
          locale
          city
          country
        }
        emailAddress {
          emailAddress
        }
        phoneNumber {
          cell
        }
      }
      purchaseOrderInventories {
        id
        fulfilledQuantity
        missingQuantity
        damagedQuantity
        purchaseOrderId
        note
        itemNotes {
          id
          message
          shouldIncludeNotesInRentals
        }
        serializedProducts {
          id
          serialNumber
          productId
          purchaseOrderInventoryId
          _destroy
        }
      }
      deliveryAddress {
        name
        streetAddress1
        locale
        city
        country
      }
      deliveryPhoneNumber {
        cell
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetPurchaseOrderMutationFn = Apollo.MutationFunction<SetPurchaseOrderMutation, SetPurchaseOrderMutationVariables>;

/**
 * __useSetPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useSetPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPurchaseOrderMutation, { data, loading, error }] = useSetPurchaseOrderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<SetPurchaseOrderMutation, SetPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPurchaseOrderMutation, SetPurchaseOrderMutationVariables>(SetPurchaseOrderDocument, options);
      }
export type SetPurchaseOrderMutationHookResult = ReturnType<typeof useSetPurchaseOrderMutation>;
export type SetPurchaseOrderMutationResult = Apollo.MutationResult<SetPurchaseOrderMutation>;
export type SetPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<SetPurchaseOrderMutation, SetPurchaseOrderMutationVariables>;
export const ExportPurchaseOrderDocument = gql`
    mutation ExportPurchaseOrder($purchaseOrderId: ID!, $emails: [String!]) {
  exportPurchaseOrder(purchaseOrderId: $purchaseOrderId, emails: $emails) {
    status
    exportProgressId
    errors
  }
}
    `;
export type ExportPurchaseOrderMutationFn = Apollo.MutationFunction<ExportPurchaseOrderMutation, ExportPurchaseOrderMutationVariables>;

/**
 * __useExportPurchaseOrderMutation__
 *
 * To run a mutation, you first call `useExportPurchaseOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportPurchaseOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportPurchaseOrderMutation, { data, loading, error }] = useExportPurchaseOrderMutation({
 *   variables: {
 *      purchaseOrderId: // value for 'purchaseOrderId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useExportPurchaseOrderMutation(baseOptions?: Apollo.MutationHookOptions<ExportPurchaseOrderMutation, ExportPurchaseOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportPurchaseOrderMutation, ExportPurchaseOrderMutationVariables>(ExportPurchaseOrderDocument, options);
      }
export type ExportPurchaseOrderMutationHookResult = ReturnType<typeof useExportPurchaseOrderMutation>;
export type ExportPurchaseOrderMutationResult = Apollo.MutationResult<ExportPurchaseOrderMutation>;
export type ExportPurchaseOrderMutationOptions = Apollo.BaseMutationOptions<ExportPurchaseOrderMutation, ExportPurchaseOrderMutationVariables>;
export const GetPurchaseOrderChangeHistoryEntriesDocument = gql`
    query GetPurchaseOrderChangeHistoryEntries($id: ID!) {
  getPurchaseOrder(id: $id) {
    changeHistoryEntries {
      id
      message
      createdAt
      allowRevert
      employee {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetPurchaseOrderChangeHistoryEntriesQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrderChangeHistoryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrderChangeHistoryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrderChangeHistoryEntriesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPurchaseOrderChangeHistoryEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetPurchaseOrderChangeHistoryEntriesQuery, GetPurchaseOrderChangeHistoryEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrderChangeHistoryEntriesQuery, GetPurchaseOrderChangeHistoryEntriesQueryVariables>(GetPurchaseOrderChangeHistoryEntriesDocument, options);
      }
export function useGetPurchaseOrderChangeHistoryEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrderChangeHistoryEntriesQuery, GetPurchaseOrderChangeHistoryEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrderChangeHistoryEntriesQuery, GetPurchaseOrderChangeHistoryEntriesQueryVariables>(GetPurchaseOrderChangeHistoryEntriesDocument, options);
        }
export type GetPurchaseOrderChangeHistoryEntriesQueryHookResult = ReturnType<typeof useGetPurchaseOrderChangeHistoryEntriesQuery>;
export type GetPurchaseOrderChangeHistoryEntriesLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrderChangeHistoryEntriesLazyQuery>;
export type GetPurchaseOrderChangeHistoryEntriesQueryResult = Apollo.QueryResult<GetPurchaseOrderChangeHistoryEntriesQuery, GetPurchaseOrderChangeHistoryEntriesQueryVariables>;
export const RevertChangeHistoryEntryDocument = gql`
    mutation RevertChangeHistoryEntry($input: RevertChangeHistoryEntryInput!) {
  revertChangeHistoryEntry(input: $input) {
    success
    errors
  }
}
    `;
export type RevertChangeHistoryEntryMutationFn = Apollo.MutationFunction<RevertChangeHistoryEntryMutation, RevertChangeHistoryEntryMutationVariables>;

/**
 * __useRevertChangeHistoryEntryMutation__
 *
 * To run a mutation, you first call `useRevertChangeHistoryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevertChangeHistoryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revertChangeHistoryEntryMutation, { data, loading, error }] = useRevertChangeHistoryEntryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRevertChangeHistoryEntryMutation(baseOptions?: Apollo.MutationHookOptions<RevertChangeHistoryEntryMutation, RevertChangeHistoryEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevertChangeHistoryEntryMutation, RevertChangeHistoryEntryMutationVariables>(RevertChangeHistoryEntryDocument, options);
      }
export type RevertChangeHistoryEntryMutationHookResult = ReturnType<typeof useRevertChangeHistoryEntryMutation>;
export type RevertChangeHistoryEntryMutationResult = Apollo.MutationResult<RevertChangeHistoryEntryMutation>;
export type RevertChangeHistoryEntryMutationOptions = Apollo.BaseMutationOptions<RevertChangeHistoryEntryMutation, RevertChangeHistoryEntryMutationVariables>;
export const GetProductsDocument = gql`
    query GetProducts($search: String) {
  getProducts(search: $search) {
    id
    name
  }
}
    `;

/**
 * __useGetProductsQuery__
 *
 * To run a query within a React component, call `useGetProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProductsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProductsQuery(baseOptions?: Apollo.QueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
      }
export function useGetProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProductsQuery, GetProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProductsQuery, GetProductsQueryVariables>(GetProductsDocument, options);
        }
export type GetProductsQueryHookResult = ReturnType<typeof useGetProductsQuery>;
export type GetProductsLazyQueryHookResult = ReturnType<typeof useGetProductsLazyQuery>;
export type GetProductsQueryResult = Apollo.QueryResult<GetProductsQuery, GetProductsQueryVariables>;
export const GetAddOnsDocument = gql`
    query GetAddOns($search: String) {
  getAddOns(search: $search) {
    id
    name
  }
}
    `;

/**
 * __useGetAddOnsQuery__
 *
 * To run a query within a React component, call `useGetAddOnsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAddOnsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAddOnsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAddOnsQuery(baseOptions?: Apollo.QueryHookOptions<GetAddOnsQuery, GetAddOnsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAddOnsQuery, GetAddOnsQueryVariables>(GetAddOnsDocument, options);
      }
export function useGetAddOnsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAddOnsQuery, GetAddOnsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAddOnsQuery, GetAddOnsQueryVariables>(GetAddOnsDocument, options);
        }
export type GetAddOnsQueryHookResult = ReturnType<typeof useGetAddOnsQuery>;
export type GetAddOnsLazyQueryHookResult = ReturnType<typeof useGetAddOnsLazyQuery>;
export type GetAddOnsQueryResult = Apollo.QueryResult<GetAddOnsQuery, GetAddOnsQueryVariables>;
export const GetAccessoriesDocument = gql`
    query GetAccessories($search: String) {
  getAccessories(search: $search) {
    id
    name
  }
}
    `;

/**
 * __useGetAccessoriesQuery__
 *
 * To run a query within a React component, call `useGetAccessoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccessoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccessoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetAccessoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetAccessoriesQuery, GetAccessoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccessoriesQuery, GetAccessoriesQueryVariables>(GetAccessoriesDocument, options);
      }
export function useGetAccessoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccessoriesQuery, GetAccessoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccessoriesQuery, GetAccessoriesQueryVariables>(GetAccessoriesDocument, options);
        }
export type GetAccessoriesQueryHookResult = ReturnType<typeof useGetAccessoriesQuery>;
export type GetAccessoriesLazyQueryHookResult = ReturnType<typeof useGetAccessoriesLazyQuery>;
export type GetAccessoriesQueryResult = Apollo.QueryResult<GetAccessoriesQuery, GetAccessoriesQueryVariables>;
export const SetProductDocument = gql`
    mutation SetProduct($input: SetProductInput!) {
  setProduct(input: $input) {
    product {
      id
      name
      quantity
      hourlyPrice
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetProductMutationFn = Apollo.MutationFunction<SetProductMutation, SetProductMutationVariables>;

/**
 * __useSetProductMutation__
 *
 * To run a mutation, you first call `useSetProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setProductMutation, { data, loading, error }] = useSetProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetProductMutation(baseOptions?: Apollo.MutationHookOptions<SetProductMutation, SetProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetProductMutation, SetProductMutationVariables>(SetProductDocument, options);
      }
export type SetProductMutationHookResult = ReturnType<typeof useSetProductMutation>;
export type SetProductMutationResult = Apollo.MutationResult<SetProductMutation>;
export type SetProductMutationOptions = Apollo.BaseMutationOptions<SetProductMutation, SetProductMutationVariables>;
export const SetAddOnDocument = gql`
    mutation SetAddOn($input: SetAddOnInput!) {
  setAddOn(input: $input) {
    addOn {
      id
      name
      quantity
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetAddOnMutationFn = Apollo.MutationFunction<SetAddOnMutation, SetAddOnMutationVariables>;

/**
 * __useSetAddOnMutation__
 *
 * To run a mutation, you first call `useSetAddOnMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAddOnMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAddOnMutation, { data, loading, error }] = useSetAddOnMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAddOnMutation(baseOptions?: Apollo.MutationHookOptions<SetAddOnMutation, SetAddOnMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAddOnMutation, SetAddOnMutationVariables>(SetAddOnDocument, options);
      }
export type SetAddOnMutationHookResult = ReturnType<typeof useSetAddOnMutation>;
export type SetAddOnMutationResult = Apollo.MutationResult<SetAddOnMutation>;
export type SetAddOnMutationOptions = Apollo.BaseMutationOptions<SetAddOnMutation, SetAddOnMutationVariables>;
export const SetAccessoryDocument = gql`
    mutation SetAccessory($input: SetAccessoryInput!) {
  setAccessory(input: $input) {
    accessory {
      id
      name
      quantity
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetAccessoryMutationFn = Apollo.MutationFunction<SetAccessoryMutation, SetAccessoryMutationVariables>;

/**
 * __useSetAccessoryMutation__
 *
 * To run a mutation, you first call `useSetAccessoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAccessoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAccessoryMutation, { data, loading, error }] = useSetAccessoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetAccessoryMutation(baseOptions?: Apollo.MutationHookOptions<SetAccessoryMutation, SetAccessoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAccessoryMutation, SetAccessoryMutationVariables>(SetAccessoryDocument, options);
      }
export type SetAccessoryMutationHookResult = ReturnType<typeof useSetAccessoryMutation>;
export type SetAccessoryMutationResult = Apollo.MutationResult<SetAccessoryMutation>;
export type SetAccessoryMutationOptions = Apollo.BaseMutationOptions<SetAccessoryMutation, SetAccessoryMutationVariables>;
export const GetPurchaseOrdersDocument = gql`
    query GetPurchaseOrders($search: String, $numberPer: Int, $page: Int, $status: [String!], $paymentStatus: [String!], $sort: String, $inventoryStatus: [String!], $priority: [String!], $createdAtGte: ISO8601DateTime, $createdAtLte: ISO8601DateTime, $dateNeededGte: ISO8601DateTime, $dateNeededLte: ISO8601DateTime, $completionEstimateGte: ISO8601DateTime, $completionEstimateLte: ISO8601DateTime, $amountGte: Float, $amountLte: Float, $vendorIds: [String!], $employeeIds: [String!]) {
  getPurchaseOrders(
    search: $search
    numberPer: $numberPer
    page: $page
    status: $status
    paymentStatus: $paymentStatus
    sort: $sort
    inventoryStatus: $inventoryStatus
    priority: $priority
    createdAtGte: $createdAtGte
    createdAtLte: $createdAtLte
    dateNeededGte: $dateNeededGte
    dateNeededLte: $dateNeededLte
    completionEstimateGte: $completionEstimateGte
    completionEstimateLte: $completionEstimateLte
    amountGte: $amountGte
    amountLte: $amountLte
    vendorIds: $vendorIds
    employeeIds: $employeeIds
  ) {
    collection {
      id
      name
      number
      status
      paymentStatus
      inventoryStatus
      taxPercentage
      completionEstimate
      dateNeeded
      description
      note
      priority
      createdAt
      total
      purchaseOrderVendorRelationship {
        id
        name
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
    `;

/**
 * __useGetPurchaseOrdersQuery__
 *
 * To run a query within a React component, call `useGetPurchaseOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPurchaseOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPurchaseOrdersQuery({
 *   variables: {
 *      search: // value for 'search'
 *      numberPer: // value for 'numberPer'
 *      page: // value for 'page'
 *      status: // value for 'status'
 *      paymentStatus: // value for 'paymentStatus'
 *      sort: // value for 'sort'
 *      inventoryStatus: // value for 'inventoryStatus'
 *      priority: // value for 'priority'
 *      createdAtGte: // value for 'createdAtGte'
 *      createdAtLte: // value for 'createdAtLte'
 *      dateNeededGte: // value for 'dateNeededGte'
 *      dateNeededLte: // value for 'dateNeededLte'
 *      completionEstimateGte: // value for 'completionEstimateGte'
 *      completionEstimateLte: // value for 'completionEstimateLte'
 *      amountGte: // value for 'amountGte'
 *      amountLte: // value for 'amountLte'
 *      vendorIds: // value for 'vendorIds'
 *      employeeIds: // value for 'employeeIds'
 *   },
 * });
 */
export function useGetPurchaseOrdersQuery(baseOptions?: Apollo.QueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>(GetPurchaseOrdersDocument, options);
      }
export function useGetPurchaseOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>(GetPurchaseOrdersDocument, options);
        }
export type GetPurchaseOrdersQueryHookResult = ReturnType<typeof useGetPurchaseOrdersQuery>;
export type GetPurchaseOrdersLazyQueryHookResult = ReturnType<typeof useGetPurchaseOrdersLazyQuery>;
export type GetPurchaseOrdersQueryResult = Apollo.QueryResult<GetPurchaseOrdersQuery, GetPurchaseOrdersQueryVariables>;
export const GetVendorsDocument = gql`
    query GetVendors($search: String) {
  getVendors(search: $search) {
    id
    name
    sms
    emailAddress {
      id
      emailAddress
    }
    physicalAddress {
      id
      country
      streetAddress1
      streetAddress2
      city
      locale
      postalCode
    }
    phoneNumber {
      id
      office
      extension
      cell
      fax
    }
  }
}
    `;

/**
 * __useGetVendorsQuery__
 *
 * To run a query within a React component, call `useGetVendorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVendorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVendorsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetVendorsQuery(baseOptions?: Apollo.QueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
      }
export function useGetVendorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVendorsQuery, GetVendorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVendorsQuery, GetVendorsQueryVariables>(GetVendorsDocument, options);
        }
export type GetVendorsQueryHookResult = ReturnType<typeof useGetVendorsQuery>;
export type GetVendorsLazyQueryHookResult = ReturnType<typeof useGetVendorsLazyQuery>;
export type GetVendorsQueryResult = Apollo.QueryResult<GetVendorsQuery, GetVendorsQueryVariables>;
export const SetVendorDocument = gql`
    mutation SetVendor($input: SetVendorInput!) {
  setVendor(input: $input) {
    vendor {
      id
      name
      sms
      emailAddress {
        id
        emailAddress
      }
      physicalAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      phoneNumber {
        id
        office
        extension
        cell
        fax
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetVendorMutationFn = Apollo.MutationFunction<SetVendorMutation, SetVendorMutationVariables>;

/**
 * __useSetVendorMutation__
 *
 * To run a mutation, you first call `useSetVendorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVendorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVendorMutation, { data, loading, error }] = useSetVendorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetVendorMutation(baseOptions?: Apollo.MutationHookOptions<SetVendorMutation, SetVendorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVendorMutation, SetVendorMutationVariables>(SetVendorDocument, options);
      }
export type SetVendorMutationHookResult = ReturnType<typeof useSetVendorMutation>;
export type SetVendorMutationResult = Apollo.MutationResult<SetVendorMutation>;
export type SetVendorMutationOptions = Apollo.BaseMutationOptions<SetVendorMutation, SetVendorMutationVariables>;
export const GetChangeHistoryEntriesDocument = gql`
    query GetChangeHistoryEntries($rentalToken: String!, $search: String, $perPage: Int, $page: Int) {
  getChangeHistoryEntries(
    rentalToken: $rentalToken
    search: $search
    perPage: $perPage
    page: $page
  ) {
    collection {
      id
      message
      createdAt
      updatedAt
      employee {
        id
        name
        uid
        updatedAt
        createdAt
        provider
        signInCount
      }
      rental {
        id
        name
        token
        pictures
      }
    }
    metadata {
      totalCount
      totalPages
      currentPage
    }
  }
}
    `;

/**
 * __useGetChangeHistoryEntriesQuery__
 *
 * To run a query within a React component, call `useGetChangeHistoryEntriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChangeHistoryEntriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChangeHistoryEntriesQuery({
 *   variables: {
 *      rentalToken: // value for 'rentalToken'
 *      search: // value for 'search'
 *      perPage: // value for 'perPage'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useGetChangeHistoryEntriesQuery(baseOptions: Apollo.QueryHookOptions<GetChangeHistoryEntriesQuery, GetChangeHistoryEntriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChangeHistoryEntriesQuery, GetChangeHistoryEntriesQueryVariables>(GetChangeHistoryEntriesDocument, options);
      }
export function useGetChangeHistoryEntriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChangeHistoryEntriesQuery, GetChangeHistoryEntriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChangeHistoryEntriesQuery, GetChangeHistoryEntriesQueryVariables>(GetChangeHistoryEntriesDocument, options);
        }
export type GetChangeHistoryEntriesQueryHookResult = ReturnType<typeof useGetChangeHistoryEntriesQuery>;
export type GetChangeHistoryEntriesLazyQueryHookResult = ReturnType<typeof useGetChangeHistoryEntriesLazyQuery>;
export type GetChangeHistoryEntriesQueryResult = Apollo.QueryResult<GetChangeHistoryEntriesQuery, GetChangeHistoryEntriesQueryVariables>;
export const GetRentalEmailsDocument = gql`
    query GetRentalEmails($rentalToken: String!) {
  getRentalEmails(rentalToken: $rentalToken) {
    id
    mailerKlass
    mailerAction
    sentAt
    senderName
    recipient
    body: content
    openedRecipient
    documents {
      id
      url
      fileFileName
    }
  }
}
    `;

/**
 * __useGetRentalEmailsQuery__
 *
 * To run a query within a React component, call `useGetRentalEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalEmailsQuery({
 *   variables: {
 *      rentalToken: // value for 'rentalToken'
 *   },
 * });
 */
export function useGetRentalEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetRentalEmailsQuery, GetRentalEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalEmailsQuery, GetRentalEmailsQueryVariables>(GetRentalEmailsDocument, options);
      }
export function useGetRentalEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalEmailsQuery, GetRentalEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalEmailsQuery, GetRentalEmailsQueryVariables>(GetRentalEmailsDocument, options);
        }
export type GetRentalEmailsQueryHookResult = ReturnType<typeof useGetRentalEmailsQuery>;
export type GetRentalEmailsLazyQueryHookResult = ReturnType<typeof useGetRentalEmailsLazyQuery>;
export type GetRentalEmailsQueryResult = Apollo.QueryResult<GetRentalEmailsQuery, GetRentalEmailsQueryVariables>;
export const GetEmailSettingDocument = gql`
    query GetEmailSetting($emailSettingType: String) {
  getEmailSettings(emailSettingType: $emailSettingType) {
    id
    customName
    customEmailNote
  }
}
    `;

/**
 * __useGetEmailSettingQuery__
 *
 * To run a query within a React component, call `useGetEmailSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailSettingQuery({
 *   variables: {
 *      emailSettingType: // value for 'emailSettingType'
 *   },
 * });
 */
export function useGetEmailSettingQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailSettingQuery, GetEmailSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailSettingQuery, GetEmailSettingQueryVariables>(GetEmailSettingDocument, options);
      }
export function useGetEmailSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailSettingQuery, GetEmailSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailSettingQuery, GetEmailSettingQueryVariables>(GetEmailSettingDocument, options);
        }
export type GetEmailSettingQueryHookResult = ReturnType<typeof useGetEmailSettingQuery>;
export type GetEmailSettingLazyQueryHookResult = ReturnType<typeof useGetEmailSettingLazyQuery>;
export type GetEmailSettingQueryResult = Apollo.QueryResult<GetEmailSettingQuery, GetEmailSettingQueryVariables>;
export const GetRentalForEmailsDocument = gql`
    query GetRentalForEmails($ID: String!) {
  getRentalById(ID: $ID) {
    id
    token
    name
    type
    status
    hasProposalSettings
    hasDocuments
    hasAgreement
    emails {
      id
      mailerAction
      mailerKlass
      recipient
      openedRecipient
      senderName
      body: content
      sentAt
      documents {
        id
        name
        fileUrl
        fileFileName
        url
      }
    }
    secondaryOrders {
      id
      token
      name
    }
    customerRentalRelationships {
      id
      client {
        ... on CustomerLocationRelationship {
          email
          name
        }
      }
    }
    companyRentalRelationship {
      company {
        mainContactEmail {
          emailAddress
        }
        name
      }
    }
    rentalSetting {
      discountSetting
      discountDisplay
    }
    finalPaymentDueDateType
    disclaimerRentalRelationships {
      id
    }
    rentalStaffs {
      id
      staffPricingId
      rentalStaffMembers {
        id
        name
      }
      staffRole {
        id
        name
        taxExempt
        staffPricings {
          id
          price
          pricingType
          customTitle
        }
      }
    }
    notes {
      id
      message
      visibleToCustomer
      visibleToOperations
    }
    payments: transactions {
      id
      amount
      paymentDate
      paymentType
      token
      customer {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetRentalForEmailsQuery__
 *
 * To run a query within a React component, call `useGetRentalForEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalForEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalForEmailsQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetRentalForEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetRentalForEmailsQuery, GetRentalForEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalForEmailsQuery, GetRentalForEmailsQueryVariables>(GetRentalForEmailsDocument, options);
      }
export function useGetRentalForEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalForEmailsQuery, GetRentalForEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalForEmailsQuery, GetRentalForEmailsQueryVariables>(GetRentalForEmailsDocument, options);
        }
export type GetRentalForEmailsQueryHookResult = ReturnType<typeof useGetRentalForEmailsQuery>;
export type GetRentalForEmailsLazyQueryHookResult = ReturnType<typeof useGetRentalForEmailsLazyQuery>;
export type GetRentalForEmailsQueryResult = Apollo.QueryResult<GetRentalForEmailsQuery, GetRentalForEmailsQueryVariables>;
export const GetLoadListInfoDocument = gql`
    query getLoadListInfo($ID: String!) {
  getRentalById(ID: $ID) {
    __typename
    id
    token
    name
    status
    deliveryType
    rentalTransports {
      ...ReusableRentalTransportForLoadList
    }
    rentalSections {
      __typename
      id
      name
      position
      sectionType
      sectionMemberships {
        id
        position
        quantity
        rentalSectionId
        rentalInventoryId
        rentalInventoryType
        parentMembershipId
        parentConnectionType
        rentalInventory {
          __typename
          ... on RentalItem {
            ...ReusableRentalItemSimple
            serializedRentalItemsData
          }
          ... on RentalAccessory {
            ...ReusableRentalAccessorySimple
          }
          ... on RentalAddOn {
            ...ReusableRentalAddOnSimple
          }
          ... on RentalBundle {
            id
            name
            quantity
            bundleId
            inventoryId
            itemNotes {
              id
              message
              shouldIncludeNotesInRentals
              visibleToOperations
            }
            rentalItems {
              ...ReusableRentalItemSimple
            }
            rentalAddOns {
              ...ReusableRentalAddOnSimple
            }
            rentalAccessories {
              ...ReusableRentalAccessorySimple
            }
          }
        }
      }
    }
    schedule {
      startDateTime
      endDateTime
      startWindowFinish
      endWindowBeginning
      eventStartDateTime
      eventEndDateTime
      shelfEnabled
      offShelfAt
      onShelfAt
      timeZone
      eventStartSetting
      eventEndSetting
    }
    products {
      id
      name
      departmentNames
      warehouseLocation
      weight
      length
      width
      height
      lengthFt
      widthFt
      heightFt
      serializationStatus
      pictures {
        imgixUrl
        imgUrl
      }
    }
    accessories {
      id
      name
      departmentNames
      warehouseLocation
      weight
      length
      width
      height
      lengthFt
      widthFt
      heightFt
      serializationStatus
      pictures {
        imgixUrl
        imgUrl
      }
    }
    addOns {
      id
      name
      departmentNames
      warehouseLocation
      weight
      length
      width
      height
      lengthFt
      widthFt
      heightFt
      serializationStatus
      pictures {
        imgixUrl
        imgUrl
      }
    }
    bundles {
      id
      name
      departmentNames
      pictures {
        imgixUrl
        imgUrl
      }
    }
    deliveryType
    deliveryAddressLocationName
    deliveryAddressStreetAddress1
    deliveryAddressStreetAddress2
    deliveryAddressCity
    deliveryAddressLocale
    deliveryAddressPostalCode
    deliveryAddressCountry
  }
  getTrucks {
    __typename
    id
    name
    active
    color
    alphabetId
    description
    notes
  }
}
    ${ReusableRentalTransportForLoadListFragmentDoc}
${ReusableRentalItemSimpleFragmentDoc}
${ReusableRentalAccessorySimpleFragmentDoc}
${ReusableRentalAddOnSimpleFragmentDoc}`;

/**
 * __useGetLoadListInfoQuery__
 *
 * To run a query within a React component, call `useGetLoadListInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoadListInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoadListInfoQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetLoadListInfoQuery(baseOptions: Apollo.QueryHookOptions<GetLoadListInfoQuery, GetLoadListInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoadListInfoQuery, GetLoadListInfoQueryVariables>(GetLoadListInfoDocument, options);
      }
export function useGetLoadListInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoadListInfoQuery, GetLoadListInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoadListInfoQuery, GetLoadListInfoQueryVariables>(GetLoadListInfoDocument, options);
        }
export type GetLoadListInfoQueryHookResult = ReturnType<typeof useGetLoadListInfoQuery>;
export type GetLoadListInfoLazyQueryHookResult = ReturnType<typeof useGetLoadListInfoLazyQuery>;
export type GetLoadListInfoQueryResult = Apollo.QueryResult<GetLoadListInfoQuery, GetLoadListInfoQueryVariables>;
export const AssignTrucksToRentalTransportDocument = gql`
    mutation AssignTrucksToRentalTransport($rentalTransportId: ID!, $truckIds: [ID!]!, $truckIdToAssignItems: ID) {
  assignTrucksToRentalTransport(
    input: {rentalTransportId: $rentalTransportId, truckIds: $truckIds, truckIdToAssignItems: $truckIdToAssignItems}
  ) {
    rentalTransport {
      ...ReusableRentalTransportForLoadList
    }
    errors
  }
}
    ${ReusableRentalTransportForLoadListFragmentDoc}`;
export type AssignTrucksToRentalTransportMutationFn = Apollo.MutationFunction<AssignTrucksToRentalTransportMutation, AssignTrucksToRentalTransportMutationVariables>;

/**
 * __useAssignTrucksToRentalTransportMutation__
 *
 * To run a mutation, you first call `useAssignTrucksToRentalTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTrucksToRentalTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTrucksToRentalTransportMutation, { data, loading, error }] = useAssignTrucksToRentalTransportMutation({
 *   variables: {
 *      rentalTransportId: // value for 'rentalTransportId'
 *      truckIds: // value for 'truckIds'
 *      truckIdToAssignItems: // value for 'truckIdToAssignItems'
 *   },
 * });
 */
export function useAssignTrucksToRentalTransportMutation(baseOptions?: Apollo.MutationHookOptions<AssignTrucksToRentalTransportMutation, AssignTrucksToRentalTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTrucksToRentalTransportMutation, AssignTrucksToRentalTransportMutationVariables>(AssignTrucksToRentalTransportDocument, options);
      }
export type AssignTrucksToRentalTransportMutationHookResult = ReturnType<typeof useAssignTrucksToRentalTransportMutation>;
export type AssignTrucksToRentalTransportMutationResult = Apollo.MutationResult<AssignTrucksToRentalTransportMutation>;
export type AssignTrucksToRentalTransportMutationOptions = Apollo.BaseMutationOptions<AssignTrucksToRentalTransportMutation, AssignTrucksToRentalTransportMutationVariables>;
export const UnassignTrucksFromRentalTransportDocument = gql`
    mutation UnassignTrucksFromRentalTransport($rentalTransportId: ID!, $truckIds: [ID!]!) {
  unassignTrucksFromRentalTransport(
    input: {rentalTransportId: $rentalTransportId, truckIds: $truckIds}
  ) {
    rentalTransport {
      ...ReusableRentalTransportForLoadList
    }
    errors
  }
}
    ${ReusableRentalTransportForLoadListFragmentDoc}`;
export type UnassignTrucksFromRentalTransportMutationFn = Apollo.MutationFunction<UnassignTrucksFromRentalTransportMutation, UnassignTrucksFromRentalTransportMutationVariables>;

/**
 * __useUnassignTrucksFromRentalTransportMutation__
 *
 * To run a mutation, you first call `useUnassignTrucksFromRentalTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignTrucksFromRentalTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignTrucksFromRentalTransportMutation, { data, loading, error }] = useUnassignTrucksFromRentalTransportMutation({
 *   variables: {
 *      rentalTransportId: // value for 'rentalTransportId'
 *      truckIds: // value for 'truckIds'
 *   },
 * });
 */
export function useUnassignTrucksFromRentalTransportMutation(baseOptions?: Apollo.MutationHookOptions<UnassignTrucksFromRentalTransportMutation, UnassignTrucksFromRentalTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignTrucksFromRentalTransportMutation, UnassignTrucksFromRentalTransportMutationVariables>(UnassignTrucksFromRentalTransportDocument, options);
      }
export type UnassignTrucksFromRentalTransportMutationHookResult = ReturnType<typeof useUnassignTrucksFromRentalTransportMutation>;
export type UnassignTrucksFromRentalTransportMutationResult = Apollo.MutationResult<UnassignTrucksFromRentalTransportMutation>;
export type UnassignTrucksFromRentalTransportMutationOptions = Apollo.BaseMutationOptions<UnassignTrucksFromRentalTransportMutation, UnassignTrucksFromRentalTransportMutationVariables>;
export const AssignItemsToLoadListDocument = gql`
    mutation AssignItemsToLoadList($rttrId: ID!, $rentalInventoryIds: [RentalInventoryIdInput!]!) {
  assignItemsToLoadList(
    input: {rentalTransportTruckRelationshipId: $rttrId, rentalInventoryIds: $rentalInventoryIds}
  ) {
    rentalTransport {
      ...ReusableRentalTransportForLoadList
    }
    errors
  }
}
    ${ReusableRentalTransportForLoadListFragmentDoc}`;
export type AssignItemsToLoadListMutationFn = Apollo.MutationFunction<AssignItemsToLoadListMutation, AssignItemsToLoadListMutationVariables>;

/**
 * __useAssignItemsToLoadListMutation__
 *
 * To run a mutation, you first call `useAssignItemsToLoadListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignItemsToLoadListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignItemsToLoadListMutation, { data, loading, error }] = useAssignItemsToLoadListMutation({
 *   variables: {
 *      rttrId: // value for 'rttrId'
 *      rentalInventoryIds: // value for 'rentalInventoryIds'
 *   },
 * });
 */
export function useAssignItemsToLoadListMutation(baseOptions?: Apollo.MutationHookOptions<AssignItemsToLoadListMutation, AssignItemsToLoadListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignItemsToLoadListMutation, AssignItemsToLoadListMutationVariables>(AssignItemsToLoadListDocument, options);
      }
export type AssignItemsToLoadListMutationHookResult = ReturnType<typeof useAssignItemsToLoadListMutation>;
export type AssignItemsToLoadListMutationResult = Apollo.MutationResult<AssignItemsToLoadListMutation>;
export type AssignItemsToLoadListMutationOptions = Apollo.BaseMutationOptions<AssignItemsToLoadListMutation, AssignItemsToLoadListMutationVariables>;
export const ExportRentalSlipsDocument = gql`
    mutation ExportRentalSlips($input: ExportRentalSlipsInput!) {
  exportRentalSlips(input: $input) {
    exportProgressId
  }
}
    `;
export type ExportRentalSlipsMutationFn = Apollo.MutationFunction<ExportRentalSlipsMutation, ExportRentalSlipsMutationVariables>;

/**
 * __useExportRentalSlipsMutation__
 *
 * To run a mutation, you first call `useExportRentalSlipsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportRentalSlipsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportRentalSlipsMutation, { data, loading, error }] = useExportRentalSlipsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportRentalSlipsMutation(baseOptions?: Apollo.MutationHookOptions<ExportRentalSlipsMutation, ExportRentalSlipsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportRentalSlipsMutation, ExportRentalSlipsMutationVariables>(ExportRentalSlipsDocument, options);
      }
export type ExportRentalSlipsMutationHookResult = ReturnType<typeof useExportRentalSlipsMutation>;
export type ExportRentalSlipsMutationResult = Apollo.MutationResult<ExportRentalSlipsMutation>;
export type ExportRentalSlipsMutationOptions = Apollo.BaseMutationOptions<ExportRentalSlipsMutation, ExportRentalSlipsMutationVariables>;
export const RentalSlipsZplDocument = gql`
    query RentalSlipsZpl($rentalToken: String!, $slipCount: Int!, $dpi: Int) {
  rentalSlipsZpl(rentalToken: $rentalToken, slipCount: $slipCount, dpi: $dpi)
}
    `;

/**
 * __useRentalSlipsZplQuery__
 *
 * To run a query within a React component, call `useRentalSlipsZplQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalSlipsZplQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalSlipsZplQuery({
 *   variables: {
 *      rentalToken: // value for 'rentalToken'
 *      slipCount: // value for 'slipCount'
 *      dpi: // value for 'dpi'
 *   },
 * });
 */
export function useRentalSlipsZplQuery(baseOptions: Apollo.QueryHookOptions<RentalSlipsZplQuery, RentalSlipsZplQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RentalSlipsZplQuery, RentalSlipsZplQueryVariables>(RentalSlipsZplDocument, options);
      }
export function useRentalSlipsZplLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RentalSlipsZplQuery, RentalSlipsZplQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RentalSlipsZplQuery, RentalSlipsZplQueryVariables>(RentalSlipsZplDocument, options);
        }
export type RentalSlipsZplQueryHookResult = ReturnType<typeof useRentalSlipsZplQuery>;
export type RentalSlipsZplLazyQueryHookResult = ReturnType<typeof useRentalSlipsZplLazyQuery>;
export type RentalSlipsZplQueryResult = Apollo.QueryResult<RentalSlipsZplQuery, RentalSlipsZplQueryVariables>;
export const GetProposalSettingsDocument = gql`
    query GetProposalSettings($rentalToken: String!, $search: String) {
  getProposalSettings(rentalToken: $rentalToken, search: $search) {
    id
    documentUrl
    authorName
    createdAt
    createdFromTemplate
  }
}
    `;

/**
 * __useGetProposalSettingsQuery__
 *
 * To run a query within a React component, call `useGetProposalSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProposalSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProposalSettingsQuery({
 *   variables: {
 *      rentalToken: // value for 'rentalToken'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetProposalSettingsQuery(baseOptions: Apollo.QueryHookOptions<GetProposalSettingsQuery, GetProposalSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProposalSettingsQuery, GetProposalSettingsQueryVariables>(GetProposalSettingsDocument, options);
      }
export function useGetProposalSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProposalSettingsQuery, GetProposalSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProposalSettingsQuery, GetProposalSettingsQueryVariables>(GetProposalSettingsDocument, options);
        }
export type GetProposalSettingsQueryHookResult = ReturnType<typeof useGetProposalSettingsQuery>;
export type GetProposalSettingsLazyQueryHookResult = ReturnType<typeof useGetProposalSettingsLazyQuery>;
export type GetProposalSettingsQueryResult = Apollo.QueryResult<GetProposalSettingsQuery, GetProposalSettingsQueryVariables>;
export const ContactsGetCustomerLocationRelationshipsDocument = gql`
    query ContactsGetCustomerLocationRelationships($search: String, $page: Int, $perPage: Int) {
  getCustomerLocationRelationships(
    search: $search
    page: $page
    perPage: $perPage
  ) {
    collection {
      id
      name
      customerId
    }
    metadata {
      totalPages
    }
  }
}
    `;

/**
 * __useContactsGetCustomerLocationRelationshipsQuery__
 *
 * To run a query within a React component, call `useContactsGetCustomerLocationRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsGetCustomerLocationRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGetCustomerLocationRelationshipsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useContactsGetCustomerLocationRelationshipsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsGetCustomerLocationRelationshipsQuery, ContactsGetCustomerLocationRelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGetCustomerLocationRelationshipsQuery, ContactsGetCustomerLocationRelationshipsQueryVariables>(ContactsGetCustomerLocationRelationshipsDocument, options);
      }
export function useContactsGetCustomerLocationRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGetCustomerLocationRelationshipsQuery, ContactsGetCustomerLocationRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGetCustomerLocationRelationshipsQuery, ContactsGetCustomerLocationRelationshipsQueryVariables>(ContactsGetCustomerLocationRelationshipsDocument, options);
        }
export type ContactsGetCustomerLocationRelationshipsQueryHookResult = ReturnType<typeof useContactsGetCustomerLocationRelationshipsQuery>;
export type ContactsGetCustomerLocationRelationshipsLazyQueryHookResult = ReturnType<typeof useContactsGetCustomerLocationRelationshipsLazyQuery>;
export type ContactsGetCustomerLocationRelationshipsQueryResult = Apollo.QueryResult<ContactsGetCustomerLocationRelationshipsQuery, ContactsGetCustomerLocationRelationshipsQueryVariables>;
export const ContactsGetCompanyLocationRelationshipsDocument = gql`
    query ContactsGetCompanyLocationRelationships($search: String, $page: Int, $perPage: Int) {
  getCompanyLocationRelationships(search: $search, page: $page, perPage: $perPage) {
    collection {
      id
      name
      companyId
    }
    metadata {
      totalPages
    }
  }
}
    `;

/**
 * __useContactsGetCompanyLocationRelationshipsQuery__
 *
 * To run a query within a React component, call `useContactsGetCompanyLocationRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsGetCompanyLocationRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGetCompanyLocationRelationshipsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useContactsGetCompanyLocationRelationshipsQuery(baseOptions?: Apollo.QueryHookOptions<ContactsGetCompanyLocationRelationshipsQuery, ContactsGetCompanyLocationRelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGetCompanyLocationRelationshipsQuery, ContactsGetCompanyLocationRelationshipsQueryVariables>(ContactsGetCompanyLocationRelationshipsDocument, options);
      }
export function useContactsGetCompanyLocationRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGetCompanyLocationRelationshipsQuery, ContactsGetCompanyLocationRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGetCompanyLocationRelationshipsQuery, ContactsGetCompanyLocationRelationshipsQueryVariables>(ContactsGetCompanyLocationRelationshipsDocument, options);
        }
export type ContactsGetCompanyLocationRelationshipsQueryHookResult = ReturnType<typeof useContactsGetCompanyLocationRelationshipsQuery>;
export type ContactsGetCompanyLocationRelationshipsLazyQueryHookResult = ReturnType<typeof useContactsGetCompanyLocationRelationshipsLazyQuery>;
export type ContactsGetCompanyLocationRelationshipsQueryResult = Apollo.QueryResult<ContactsGetCompanyLocationRelationshipsQuery, ContactsGetCompanyLocationRelationshipsQueryVariables>;
export const ContactsGetCustomerLocationRelationshipDocument = gql`
    query ContactsGetCustomerLocationRelationship($id: String!) {
  getCustomerLocationRelationship(id: $id) {
    id
    firstName
    lastName
    name
    title
    email
    driverLicenseNumber
    driverLicenseState
    notes
    shouldApplyDiscounts
    token
    depositType
    customDepositAmount
    shouldApplyDeposits
    documents {
      fileFileName
      fileFileSize
      name
      fileUrl
      fileUpdatedAt
      id
      createdAt
      documentType
      visibleToCustomer
      fileContentType
      file
      expirable
      expiresAt
      employee {
        firstName
        lastName
      }
    }
    venues {
      id
      name
      notes
      mainContactAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      documents {
        fileFileName
        fileFileSize
        name
        fileUrl
        fileUpdatedAt
        id
        createdAt
        documentType
        visibleToCustomer
        fileContentType
        file
        expirable
        expiresAt
        employee {
          firstName
          lastName
        }
      }
    }
    phoneNumber {
      id
      office
      extension
      cell
      fax
    }
    physicalAddress {
      id
      country
      streetAddress1
      streetAddress2
      city
      locale
      postalCode
    }
    discounts {
      id
      name
      discountTargetType
      valueType
      amount
    }
    companies {
      id
      name
      taxExempt
      mainContactAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      customerLocationRelationships {
        id
        name
        firstName
        lastName
        physicalAddress {
          id
          country
          streetAddress1
          streetAddress2
          city
          locale
          postalCode
        }
        depositType
        documents {
          fileFileName
          fileFileSize
          name
          fileUrl
          fileUpdatedAt
          id
          createdAt
          documentType
          visibleToCustomer
          fileContentType
          file
          expirable
          expiresAt
          employee {
            firstName
            lastName
          }
        }
      }
      depositType
      documents {
        fileFileName
        fileFileSize
        name
        fileUrl
        fileUpdatedAt
        id
        createdAt
        documentType
        visibleToCustomer
        fileContentType
        file
        expirable
        expiresAt
        employee {
          firstName
          lastName
        }
      }
      companyLocationRelationships {
        id
        locationId
        companyId
      }
      discounts {
        id
        name
        discountTargetType
        valueType
        amount
      }
    }
  }
}
    `;

/**
 * __useContactsGetCustomerLocationRelationshipQuery__
 *
 * To run a query within a React component, call `useContactsGetCustomerLocationRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsGetCustomerLocationRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGetCustomerLocationRelationshipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactsGetCustomerLocationRelationshipQuery(baseOptions: Apollo.QueryHookOptions<ContactsGetCustomerLocationRelationshipQuery, ContactsGetCustomerLocationRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGetCustomerLocationRelationshipQuery, ContactsGetCustomerLocationRelationshipQueryVariables>(ContactsGetCustomerLocationRelationshipDocument, options);
      }
export function useContactsGetCustomerLocationRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGetCustomerLocationRelationshipQuery, ContactsGetCustomerLocationRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGetCustomerLocationRelationshipQuery, ContactsGetCustomerLocationRelationshipQueryVariables>(ContactsGetCustomerLocationRelationshipDocument, options);
        }
export type ContactsGetCustomerLocationRelationshipQueryHookResult = ReturnType<typeof useContactsGetCustomerLocationRelationshipQuery>;
export type ContactsGetCustomerLocationRelationshipLazyQueryHookResult = ReturnType<typeof useContactsGetCustomerLocationRelationshipLazyQuery>;
export type ContactsGetCustomerLocationRelationshipQueryResult = Apollo.QueryResult<ContactsGetCustomerLocationRelationshipQuery, ContactsGetCustomerLocationRelationshipQueryVariables>;
export const ContactsGetCompanyLocationRelationshipDocument = gql`
    query ContactsGetCompanyLocationRelationship($id: String!) {
  getCompanyLocationRelationship(id: $id) {
    id
    name
    company {
      id
      name
      notes
      token
      depositType
      customDepositAmount
      shouldApplyDeposits
      venues {
        id
        name
        notes
        mainContactAddress {
          id
          country
          streetAddress1
          streetAddress2
          city
          locale
          postalCode
        }
        documents {
          fileFileName
          fileFileSize
          name
          fileUrl
          fileUpdatedAt
          id
          createdAt
          documentType
          visibleToCustomer
          fileContentType
          file
          expirable
          expiresAt
          employee {
            firstName
            lastName
          }
        }
      }
      mainPhoneNumber {
        id
        office
        extension
        cell
        fax
      }
      mainContactAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      mainContactEmail {
        id
        emailAddress
      }
      discounts {
        id
        name
        discountTargetType
        valueType
        amount
      }
      customerLocationRelationships {
        id
        firstName
        lastName
        name
        physicalAddress {
          id
          country
          streetAddress1
          streetAddress2
          city
          locale
          postalCode
        }
        depositType
        documents {
          fileFileName
          fileFileSize
          name
          fileUrl
          fileUpdatedAt
          id
          createdAt
          documentType
          visibleToCustomer
          fileContentType
          file
          expirable
          expiresAt
          employee {
            firstName
            lastName
          }
        }
      }
      documents {
        fileFileName
        fileFileSize
        name
        fileUrl
        fileUpdatedAt
        id
        createdAt
        documentType
        file
        visibleToCustomer
        fileContentType
        expirable
        expiresAt
        employee {
          firstName
          lastName
        }
      }
      taxExempt
    }
  }
}
    `;

/**
 * __useContactsGetCompanyLocationRelationshipQuery__
 *
 * To run a query within a React component, call `useContactsGetCompanyLocationRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsGetCompanyLocationRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsGetCompanyLocationRelationshipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactsGetCompanyLocationRelationshipQuery(baseOptions: Apollo.QueryHookOptions<ContactsGetCompanyLocationRelationshipQuery, ContactsGetCompanyLocationRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsGetCompanyLocationRelationshipQuery, ContactsGetCompanyLocationRelationshipQueryVariables>(ContactsGetCompanyLocationRelationshipDocument, options);
      }
export function useContactsGetCompanyLocationRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsGetCompanyLocationRelationshipQuery, ContactsGetCompanyLocationRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsGetCompanyLocationRelationshipQuery, ContactsGetCompanyLocationRelationshipQueryVariables>(ContactsGetCompanyLocationRelationshipDocument, options);
        }
export type ContactsGetCompanyLocationRelationshipQueryHookResult = ReturnType<typeof useContactsGetCompanyLocationRelationshipQuery>;
export type ContactsGetCompanyLocationRelationshipLazyQueryHookResult = ReturnType<typeof useContactsGetCompanyLocationRelationshipLazyQuery>;
export type ContactsGetCompanyLocationRelationshipQueryResult = Apollo.QueryResult<ContactsGetCompanyLocationRelationshipQuery, ContactsGetCompanyLocationRelationshipQueryVariables>;
export const GetCompanyLocationRelationshipsDocument = gql`
    query GetCompanyLocationRelationships($search: String, $page: Int, $perPage: Int) {
  getCompanyLocationRelationships(search: $search, page: $page, perPage: $perPage) {
    collection {
      id
      name
      depositType
      companyId
      company {
        accountOwner {
          id
          name
          role
        }
      }
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
    `;

/**
 * __useGetCompanyLocationRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetCompanyLocationRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyLocationRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyLocationRelationshipsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetCompanyLocationRelationshipsQuery(baseOptions?: Apollo.QueryHookOptions<GetCompanyLocationRelationshipsQuery, GetCompanyLocationRelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompanyLocationRelationshipsQuery, GetCompanyLocationRelationshipsQueryVariables>(GetCompanyLocationRelationshipsDocument, options);
      }
export function useGetCompanyLocationRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompanyLocationRelationshipsQuery, GetCompanyLocationRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompanyLocationRelationshipsQuery, GetCompanyLocationRelationshipsQueryVariables>(GetCompanyLocationRelationshipsDocument, options);
        }
export type GetCompanyLocationRelationshipsQueryHookResult = ReturnType<typeof useGetCompanyLocationRelationshipsQuery>;
export type GetCompanyLocationRelationshipsLazyQueryHookResult = ReturnType<typeof useGetCompanyLocationRelationshipsLazyQuery>;
export type GetCompanyLocationRelationshipsQueryResult = Apollo.QueryResult<GetCompanyLocationRelationshipsQuery, GetCompanyLocationRelationshipsQueryVariables>;
export const GetCustomerLocationRelationshipsDocument = gql`
    query GetCustomerLocationRelationships($search: String, $page: Int, $perPage: Int) {
  getCustomerLocationRelationships(
    search: $search
    page: $page
    perPage: $perPage
  ) {
    collection {
      id
      name
      depositType
      customerId
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
    `;

/**
 * __useGetCustomerLocationRelationshipsQuery__
 *
 * To run a query within a React component, call `useGetCustomerLocationRelationshipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomerLocationRelationshipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomerLocationRelationshipsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetCustomerLocationRelationshipsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomerLocationRelationshipsQuery, GetCustomerLocationRelationshipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomerLocationRelationshipsQuery, GetCustomerLocationRelationshipsQueryVariables>(GetCustomerLocationRelationshipsDocument, options);
      }
export function useGetCustomerLocationRelationshipsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomerLocationRelationshipsQuery, GetCustomerLocationRelationshipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomerLocationRelationshipsQuery, GetCustomerLocationRelationshipsQueryVariables>(GetCustomerLocationRelationshipsDocument, options);
        }
export type GetCustomerLocationRelationshipsQueryHookResult = ReturnType<typeof useGetCustomerLocationRelationshipsQuery>;
export type GetCustomerLocationRelationshipsLazyQueryHookResult = ReturnType<typeof useGetCustomerLocationRelationshipsLazyQuery>;
export type GetCustomerLocationRelationshipsQueryResult = Apollo.QueryResult<GetCustomerLocationRelationshipsQuery, GetCustomerLocationRelationshipsQueryVariables>;
export const ContactsDrawerGetCustomerLocationRelationshipDocument = gql`
    query ContactsDrawerGetCustomerLocationRelationship($id: String!) {
  getCustomerLocationRelationship(id: $id) {
    id
    firstName
    lastName
    title
    email
    driverLicenseNumber
    driverLicenseState
    phoneNumber {
      id
      office
      extension
      cell
      fax
    }
    physicalAddress {
      id
      country
      streetAddress1
      streetAddress2
      city
      locale
      postalCode
    }
  }
}
    `;

/**
 * __useContactsDrawerGetCustomerLocationRelationshipQuery__
 *
 * To run a query within a React component, call `useContactsDrawerGetCustomerLocationRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsDrawerGetCustomerLocationRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsDrawerGetCustomerLocationRelationshipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactsDrawerGetCustomerLocationRelationshipQuery(baseOptions: Apollo.QueryHookOptions<ContactsDrawerGetCustomerLocationRelationshipQuery, ContactsDrawerGetCustomerLocationRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsDrawerGetCustomerLocationRelationshipQuery, ContactsDrawerGetCustomerLocationRelationshipQueryVariables>(ContactsDrawerGetCustomerLocationRelationshipDocument, options);
      }
export function useContactsDrawerGetCustomerLocationRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsDrawerGetCustomerLocationRelationshipQuery, ContactsDrawerGetCustomerLocationRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsDrawerGetCustomerLocationRelationshipQuery, ContactsDrawerGetCustomerLocationRelationshipQueryVariables>(ContactsDrawerGetCustomerLocationRelationshipDocument, options);
        }
export type ContactsDrawerGetCustomerLocationRelationshipQueryHookResult = ReturnType<typeof useContactsDrawerGetCustomerLocationRelationshipQuery>;
export type ContactsDrawerGetCustomerLocationRelationshipLazyQueryHookResult = ReturnType<typeof useContactsDrawerGetCustomerLocationRelationshipLazyQuery>;
export type ContactsDrawerGetCustomerLocationRelationshipQueryResult = Apollo.QueryResult<ContactsDrawerGetCustomerLocationRelationshipQuery, ContactsDrawerGetCustomerLocationRelationshipQueryVariables>;
export const ContactsDrawerGetCompanyLocationRelationshipDocument = gql`
    query ContactsDrawerGetCompanyLocationRelationship($id: String!) {
  getCompanyLocationRelationship(id: $id) {
    id
    name
    company {
      id
      name
      mainPhoneNumber {
        id
        office
        extension
        cell
        fax
      }
      mainContactAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      mainContactEmail {
        id
        emailAddress
      }
    }
  }
}
    `;

/**
 * __useContactsDrawerGetCompanyLocationRelationshipQuery__
 *
 * To run a query within a React component, call `useContactsDrawerGetCompanyLocationRelationshipQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactsDrawerGetCompanyLocationRelationshipQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactsDrawerGetCompanyLocationRelationshipQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactsDrawerGetCompanyLocationRelationshipQuery(baseOptions: Apollo.QueryHookOptions<ContactsDrawerGetCompanyLocationRelationshipQuery, ContactsDrawerGetCompanyLocationRelationshipQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactsDrawerGetCompanyLocationRelationshipQuery, ContactsDrawerGetCompanyLocationRelationshipQueryVariables>(ContactsDrawerGetCompanyLocationRelationshipDocument, options);
      }
export function useContactsDrawerGetCompanyLocationRelationshipLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactsDrawerGetCompanyLocationRelationshipQuery, ContactsDrawerGetCompanyLocationRelationshipQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactsDrawerGetCompanyLocationRelationshipQuery, ContactsDrawerGetCompanyLocationRelationshipQueryVariables>(ContactsDrawerGetCompanyLocationRelationshipDocument, options);
        }
export type ContactsDrawerGetCompanyLocationRelationshipQueryHookResult = ReturnType<typeof useContactsDrawerGetCompanyLocationRelationshipQuery>;
export type ContactsDrawerGetCompanyLocationRelationshipLazyQueryHookResult = ReturnType<typeof useContactsDrawerGetCompanyLocationRelationshipLazyQuery>;
export type ContactsDrawerGetCompanyLocationRelationshipQueryResult = Apollo.QueryResult<ContactsDrawerGetCompanyLocationRelationshipQuery, ContactsDrawerGetCompanyLocationRelationshipQueryVariables>;
export const SetCustomerLocationRelationshipDocument = gql`
    mutation SetCustomerLocationRelationship($input: SetCustomerLocationRelationshipInput!) {
  setCustomerLocationRelationship(input: $input) {
    customer {
      id
      name
      title
      email
      driverLicenseNumber
      driverLicenseState
      phoneNumber {
        id
        office
        extension
        cell
        fax
      }
      physicalAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetCustomerLocationRelationshipMutationFn = Apollo.MutationFunction<SetCustomerLocationRelationshipMutation, SetCustomerLocationRelationshipMutationVariables>;

/**
 * __useSetCustomerLocationRelationshipMutation__
 *
 * To run a mutation, you first call `useSetCustomerLocationRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCustomerLocationRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCustomerLocationRelationshipMutation, { data, loading, error }] = useSetCustomerLocationRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCustomerLocationRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<SetCustomerLocationRelationshipMutation, SetCustomerLocationRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCustomerLocationRelationshipMutation, SetCustomerLocationRelationshipMutationVariables>(SetCustomerLocationRelationshipDocument, options);
      }
export type SetCustomerLocationRelationshipMutationHookResult = ReturnType<typeof useSetCustomerLocationRelationshipMutation>;
export type SetCustomerLocationRelationshipMutationResult = Apollo.MutationResult<SetCustomerLocationRelationshipMutation>;
export type SetCustomerLocationRelationshipMutationOptions = Apollo.BaseMutationOptions<SetCustomerLocationRelationshipMutation, SetCustomerLocationRelationshipMutationVariables>;
export const SetCompanyLocationRelationshipDocument = gql`
    mutation SetCompanyLocationRelationship($input: SetCompanyLocationRelationshipInput!) {
  setCompanyLocationRelationship(input: $input) {
    company {
      id
      name
      companyId
      company {
        id
        mainContactEmail {
          id
          emailAddress
        }
        mainContactAddress {
          id
          country
          streetAddress1
          streetAddress2
          city
          locale
          postalCode
        }
        mainPhoneNumber {
          id
          office
          extension
          cell
          fax
        }
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetCompanyLocationRelationshipMutationFn = Apollo.MutationFunction<SetCompanyLocationRelationshipMutation, SetCompanyLocationRelationshipMutationVariables>;

/**
 * __useSetCompanyLocationRelationshipMutation__
 *
 * To run a mutation, you first call `useSetCompanyLocationRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCompanyLocationRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCompanyLocationRelationshipMutation, { data, loading, error }] = useSetCompanyLocationRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetCompanyLocationRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<SetCompanyLocationRelationshipMutation, SetCompanyLocationRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCompanyLocationRelationshipMutation, SetCompanyLocationRelationshipMutationVariables>(SetCompanyLocationRelationshipDocument, options);
      }
export type SetCompanyLocationRelationshipMutationHookResult = ReturnType<typeof useSetCompanyLocationRelationshipMutation>;
export type SetCompanyLocationRelationshipMutationResult = Apollo.MutationResult<SetCompanyLocationRelationshipMutation>;
export type SetCompanyLocationRelationshipMutationOptions = Apollo.BaseMutationOptions<SetCompanyLocationRelationshipMutation, SetCompanyLocationRelationshipMutationVariables>;
export const GetCommissionedCustomersDocument = gql`
    query GetCommissionedCustomers($companyLocationRelationshipId: ID!) {
  getCommissionedCustomers(
    companyLocationRelationshipId: $companyLocationRelationshipId
  ) {
    rate
    id
    firstName
    lastName
  }
}
    `;

/**
 * __useGetCommissionedCustomersQuery__
 *
 * To run a query within a React component, call `useGetCommissionedCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCommissionedCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCommissionedCustomersQuery({
 *   variables: {
 *      companyLocationRelationshipId: // value for 'companyLocationRelationshipId'
 *   },
 * });
 */
export function useGetCommissionedCustomersQuery(baseOptions: Apollo.QueryHookOptions<GetCommissionedCustomersQuery, GetCommissionedCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCommissionedCustomersQuery, GetCommissionedCustomersQueryVariables>(GetCommissionedCustomersDocument, options);
      }
export function useGetCommissionedCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCommissionedCustomersQuery, GetCommissionedCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCommissionedCustomersQuery, GetCommissionedCustomersQueryVariables>(GetCommissionedCustomersDocument, options);
        }
export type GetCommissionedCustomersQueryHookResult = ReturnType<typeof useGetCommissionedCustomersQuery>;
export type GetCommissionedCustomersLazyQueryHookResult = ReturnType<typeof useGetCommissionedCustomersLazyQuery>;
export type GetCommissionedCustomersQueryResult = Apollo.QueryResult<GetCommissionedCustomersQuery, GetCommissionedCustomersQueryVariables>;
export const GetZipCodeDeliveryFeesDocument = gql`
    query GetZipCodeDeliveryFees($search: String) {
  getZipCodeDeliveryFees(search: $search) {
    zipCodes
    amount
    name
    id
  }
}
    `;

/**
 * __useGetZipCodeDeliveryFeesQuery__
 *
 * To run a query within a React component, call `useGetZipCodeDeliveryFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZipCodeDeliveryFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZipCodeDeliveryFeesQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetZipCodeDeliveryFeesQuery(baseOptions?: Apollo.QueryHookOptions<GetZipCodeDeliveryFeesQuery, GetZipCodeDeliveryFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZipCodeDeliveryFeesQuery, GetZipCodeDeliveryFeesQueryVariables>(GetZipCodeDeliveryFeesDocument, options);
      }
export function useGetZipCodeDeliveryFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZipCodeDeliveryFeesQuery, GetZipCodeDeliveryFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZipCodeDeliveryFeesQuery, GetZipCodeDeliveryFeesQueryVariables>(GetZipCodeDeliveryFeesDocument, options);
        }
export type GetZipCodeDeliveryFeesQueryHookResult = ReturnType<typeof useGetZipCodeDeliveryFeesQuery>;
export type GetZipCodeDeliveryFeesLazyQueryHookResult = ReturnType<typeof useGetZipCodeDeliveryFeesLazyQuery>;
export type GetZipCodeDeliveryFeesQueryResult = Apollo.QueryResult<GetZipCodeDeliveryFeesQuery, GetZipCodeDeliveryFeesQueryVariables>;
export const GetEmployeesDocument = gql`
    query GetEmployees($search: String, $id: [String!]) {
  getEmployees(search: $search, id: $id) {
    id
    name
    role
  }
}
    `;

/**
 * __useGetEmployeesQuery__
 *
 * To run a query within a React component, call `useGetEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
      }
export function useGetEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployeesQuery, GetEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployeesQuery, GetEmployeesQueryVariables>(GetEmployeesDocument, options);
        }
export type GetEmployeesQueryHookResult = ReturnType<typeof useGetEmployeesQuery>;
export type GetEmployeesLazyQueryHookResult = ReturnType<typeof useGetEmployeesLazyQuery>;
export type GetEmployeesQueryResult = Apollo.QueryResult<GetEmployeesQuery, GetEmployeesQueryVariables>;
export const GetVenuesDocument = gql`
    query GetVenues($search: String, $page: Int, $perPage: Int) {
  getVenues(search: $search, page: $page, perPage: $perPage) {
    id
    name
    notes
  }
}
    `;

/**
 * __useGetVenuesQuery__
 *
 * To run a query within a React component, call `useGetVenuesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenuesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenuesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useGetVenuesQuery(baseOptions?: Apollo.QueryHookOptions<GetVenuesQuery, GetVenuesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenuesQuery, GetVenuesQueryVariables>(GetVenuesDocument, options);
      }
export function useGetVenuesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenuesQuery, GetVenuesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenuesQuery, GetVenuesQueryVariables>(GetVenuesDocument, options);
        }
export type GetVenuesQueryHookResult = ReturnType<typeof useGetVenuesQuery>;
export type GetVenuesLazyQueryHookResult = ReturnType<typeof useGetVenuesLazyQuery>;
export type GetVenuesQueryResult = Apollo.QueryResult<GetVenuesQuery, GetVenuesQueryVariables>;
export const GetVenueDocument = gql`
    query GetVenue($id: String!) {
  getVenue(id: $id) {
    id
    name
    notes
    mainContactAddress {
      id
      country
      streetAddress1
      streetAddress2
      city
      locale
      postalCode
    }
    documents {
      fileFileName
      fileFileSize
      name
      fileUrl
      file
      fileUpdatedAt
      fileContentType
      id
      createdAt
      documentType
      visibleToCustomer
      expirable
      expiresAt
      employee {
        firstName
        lastName
      }
    }
  }
}
    `;

/**
 * __useGetVenueQuery__
 *
 * To run a query within a React component, call `useGetVenueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVenueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVenueQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVenueQuery(baseOptions: Apollo.QueryHookOptions<GetVenueQuery, GetVenueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVenueQuery, GetVenueQueryVariables>(GetVenueDocument, options);
      }
export function useGetVenueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVenueQuery, GetVenueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVenueQuery, GetVenueQueryVariables>(GetVenueDocument, options);
        }
export type GetVenueQueryHookResult = ReturnType<typeof useGetVenueQuery>;
export type GetVenueLazyQueryHookResult = ReturnType<typeof useGetVenueLazyQuery>;
export type GetVenueQueryResult = Apollo.QueryResult<GetVenueQuery, GetVenueQueryVariables>;
export const SetVenueDocument = gql`
    mutation SetVenue($input: SetVenueInput!) {
  setVenue(input: $input) {
    venue {
      id
      name
      notes
      phoneNumbers {
        office
        extension
        cell
        fax
        mainContactNumber
      }
      mainContactAddress {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      physicalAddresses {
        id
        country
        streetAddress1
        streetAddress2
        city
        locale
        postalCode
      }
      names {
        id
        firstName
        lastName
      }
      emailAddresses {
        id
        emailAddress
        primaryContactEmail
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetVenueMutationFn = Apollo.MutationFunction<SetVenueMutation, SetVenueMutationVariables>;

/**
 * __useSetVenueMutation__
 *
 * To run a mutation, you first call `useSetVenueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetVenueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setVenueMutation, { data, loading, error }] = useSetVenueMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetVenueMutation(baseOptions?: Apollo.MutationHookOptions<SetVenueMutation, SetVenueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetVenueMutation, SetVenueMutationVariables>(SetVenueDocument, options);
      }
export type SetVenueMutationHookResult = ReturnType<typeof useSetVenueMutation>;
export type SetVenueMutationResult = Apollo.MutationResult<SetVenueMutation>;
export type SetVenueMutationOptions = Apollo.BaseMutationOptions<SetVenueMutation, SetVenueMutationVariables>;
export const GetRentalConversionStatusDocument = gql`
    query GetRentalConversionStatus($ID: String!) {
  getRentalById(ID: $ID) {
    conversionStatus
    conversionErrorFormId
  }
}
    `;

/**
 * __useGetRentalConversionStatusQuery__
 *
 * To run a query within a React component, call `useGetRentalConversionStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalConversionStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalConversionStatusQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetRentalConversionStatusQuery(baseOptions: Apollo.QueryHookOptions<GetRentalConversionStatusQuery, GetRentalConversionStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalConversionStatusQuery, GetRentalConversionStatusQueryVariables>(GetRentalConversionStatusDocument, options);
      }
export function useGetRentalConversionStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalConversionStatusQuery, GetRentalConversionStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalConversionStatusQuery, GetRentalConversionStatusQueryVariables>(GetRentalConversionStatusDocument, options);
        }
export type GetRentalConversionStatusQueryHookResult = ReturnType<typeof useGetRentalConversionStatusQuery>;
export type GetRentalConversionStatusLazyQueryHookResult = ReturnType<typeof useGetRentalConversionStatusLazyQuery>;
export type GetRentalConversionStatusQueryResult = Apollo.QueryResult<GetRentalConversionStatusQuery, GetRentalConversionStatusQueryVariables>;
export const GetDisclaimersDocument = gql`
    query GetDisclaimers($search: String) {
  getDisclaimers(search: $search) {
    id
    name
  }
}
    `;

/**
 * __useGetDisclaimersQuery__
 *
 * To run a query within a React component, call `useGetDisclaimersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclaimersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclaimersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetDisclaimersQuery(baseOptions?: Apollo.QueryHookOptions<GetDisclaimersQuery, GetDisclaimersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclaimersQuery, GetDisclaimersQueryVariables>(GetDisclaimersDocument, options);
      }
export function useGetDisclaimersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclaimersQuery, GetDisclaimersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclaimersQuery, GetDisclaimersQueryVariables>(GetDisclaimersDocument, options);
        }
export type GetDisclaimersQueryHookResult = ReturnType<typeof useGetDisclaimersQuery>;
export type GetDisclaimersLazyQueryHookResult = ReturnType<typeof useGetDisclaimersLazyQuery>;
export type GetDisclaimersQueryResult = Apollo.QueryResult<GetDisclaimersQuery, GetDisclaimersQueryVariables>;
export const GetDisclaimerDocument = gql`
    query GetDisclaimer($id: String!) {
  getDisclaimer(id: $id) {
    id
    title
  }
}
    `;

/**
 * __useGetDisclaimerQuery__
 *
 * To run a query within a React component, call `useGetDisclaimerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDisclaimerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDisclaimerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetDisclaimerQuery(baseOptions: Apollo.QueryHookOptions<GetDisclaimerQuery, GetDisclaimerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDisclaimerQuery, GetDisclaimerQueryVariables>(GetDisclaimerDocument, options);
      }
export function useGetDisclaimerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDisclaimerQuery, GetDisclaimerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDisclaimerQuery, GetDisclaimerQueryVariables>(GetDisclaimerDocument, options);
        }
export type GetDisclaimerQueryHookResult = ReturnType<typeof useGetDisclaimerQuery>;
export type GetDisclaimerLazyQueryHookResult = ReturnType<typeof useGetDisclaimerLazyQuery>;
export type GetDisclaimerQueryResult = Apollo.QueryResult<GetDisclaimerQuery, GetDisclaimerQueryVariables>;
export const GetDiscountsDocument = gql`
    query GetDiscounts($search: String, $discountTargetType: [String!]) {
  getDiscounts(search: $search, discountTargetType: $discountTargetType) {
    id
    name
    valueType
    amount
    discountTargetType
  }
}
    `;

/**
 * __useGetDiscountsQuery__
 *
 * To run a query within a React component, call `useGetDiscountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDiscountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDiscountsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      discountTargetType: // value for 'discountTargetType'
 *   },
 * });
 */
export function useGetDiscountsQuery(baseOptions?: Apollo.QueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
      }
export function useGetDiscountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDiscountsQuery, GetDiscountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDiscountsQuery, GetDiscountsQueryVariables>(GetDiscountsDocument, options);
        }
export type GetDiscountsQueryHookResult = ReturnType<typeof useGetDiscountsQuery>;
export type GetDiscountsLazyQueryHookResult = ReturnType<typeof useGetDiscountsLazyQuery>;
export type GetDiscountsQueryResult = Apollo.QueryResult<GetDiscountsQuery, GetDiscountsQueryVariables>;
export const GetFeesDocument = gql`
    query GetFees($search: String, $feeTargetType: [String!]) {
  getFees(search: $search, feeTargetType: $feeTargetType) {
    id
    name
    valueType
    amount
    feeTargetType
    taxExempt
  }
}
    `;

/**
 * __useGetFeesQuery__
 *
 * To run a query within a React component, call `useGetFeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      feeTargetType: // value for 'feeTargetType'
 *   },
 * });
 */
export function useGetFeesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeesQuery, GetFeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeesQuery, GetFeesQueryVariables>(GetFeesDocument, options);
      }
export function useGetFeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeesQuery, GetFeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeesQuery, GetFeesQueryVariables>(GetFeesDocument, options);
        }
export type GetFeesQueryHookResult = ReturnType<typeof useGetFeesQuery>;
export type GetFeesLazyQueryHookResult = ReturnType<typeof useGetFeesLazyQuery>;
export type GetFeesQueryResult = Apollo.QueryResult<GetFeesQuery, GetFeesQueryVariables>;
export const GetRentalAgreementsDocument = gql`
    query GetRentalAgreements($search: String) {
  getRentalAgreements(search: $search) {
    id
    title
    name
  }
}
    `;

/**
 * __useGetRentalAgreementsQuery__
 *
 * To run a query within a React component, call `useGetRentalAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalAgreementsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetRentalAgreementsQuery(baseOptions?: Apollo.QueryHookOptions<GetRentalAgreementsQuery, GetRentalAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalAgreementsQuery, GetRentalAgreementsQueryVariables>(GetRentalAgreementsDocument, options);
      }
export function useGetRentalAgreementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalAgreementsQuery, GetRentalAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalAgreementsQuery, GetRentalAgreementsQueryVariables>(GetRentalAgreementsDocument, options);
        }
export type GetRentalAgreementsQueryHookResult = ReturnType<typeof useGetRentalAgreementsQuery>;
export type GetRentalAgreementsLazyQueryHookResult = ReturnType<typeof useGetRentalAgreementsLazyQuery>;
export type GetRentalAgreementsQueryResult = Apollo.QueryResult<GetRentalAgreementsQuery, GetRentalAgreementsQueryVariables>;
export const FetchMissingSubrentedInventoryDocument = gql`
    mutation FetchMissingSubrentedInventory($input: FetchMissingSubrentedInventoryInput!) {
  fetchMissingSubrentedInventory(input: $input) {
    hasMismatch
    inventories {
      id
      type
      title
      missingItems
      subrentedLocations {
        id
        name
        amountSubrented
        isCurrentLocation
      }
    }
  }
}
    `;
export type FetchMissingSubrentedInventoryMutationFn = Apollo.MutationFunction<FetchMissingSubrentedInventoryMutation, FetchMissingSubrentedInventoryMutationVariables>;

/**
 * __useFetchMissingSubrentedInventoryMutation__
 *
 * To run a mutation, you first call `useFetchMissingSubrentedInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchMissingSubrentedInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchMissingSubrentedInventoryMutation, { data, loading, error }] = useFetchMissingSubrentedInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFetchMissingSubrentedInventoryMutation(baseOptions?: Apollo.MutationHookOptions<FetchMissingSubrentedInventoryMutation, FetchMissingSubrentedInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchMissingSubrentedInventoryMutation, FetchMissingSubrentedInventoryMutationVariables>(FetchMissingSubrentedInventoryDocument, options);
      }
export type FetchMissingSubrentedInventoryMutationHookResult = ReturnType<typeof useFetchMissingSubrentedInventoryMutation>;
export type FetchMissingSubrentedInventoryMutationResult = Apollo.MutationResult<FetchMissingSubrentedInventoryMutation>;
export type FetchMissingSubrentedInventoryMutationOptions = Apollo.BaseMutationOptions<FetchMissingSubrentedInventoryMutation, FetchMissingSubrentedInventoryMutationVariables>;
export const ResolveMissingSubrentedInventoryDocument = gql`
    mutation ResolveMissingSubrentedInventory($rentalId: ID!, $itemsToRemove: JSON!) {
  resolveMissingSubrentedInventory(
    input: {rentalId: $rentalId, itemsToRemove: $itemsToRemove}
  ) {
    success
    errors
  }
}
    `;
export type ResolveMissingSubrentedInventoryMutationFn = Apollo.MutationFunction<ResolveMissingSubrentedInventoryMutation, ResolveMissingSubrentedInventoryMutationVariables>;

/**
 * __useResolveMissingSubrentedInventoryMutation__
 *
 * To run a mutation, you first call `useResolveMissingSubrentedInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveMissingSubrentedInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveMissingSubrentedInventoryMutation, { data, loading, error }] = useResolveMissingSubrentedInventoryMutation({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      itemsToRemove: // value for 'itemsToRemove'
 *   },
 * });
 */
export function useResolveMissingSubrentedInventoryMutation(baseOptions?: Apollo.MutationHookOptions<ResolveMissingSubrentedInventoryMutation, ResolveMissingSubrentedInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveMissingSubrentedInventoryMutation, ResolveMissingSubrentedInventoryMutationVariables>(ResolveMissingSubrentedInventoryDocument, options);
      }
export type ResolveMissingSubrentedInventoryMutationHookResult = ReturnType<typeof useResolveMissingSubrentedInventoryMutation>;
export type ResolveMissingSubrentedInventoryMutationResult = Apollo.MutationResult<ResolveMissingSubrentedInventoryMutation>;
export type ResolveMissingSubrentedInventoryMutationOptions = Apollo.BaseMutationOptions<ResolveMissingSubrentedInventoryMutation, ResolveMissingSubrentedInventoryMutationVariables>;
export const RentalPickListDocument = gql`
    query RentalPickList($rentalId: String!) {
  rentalPickList(rentalId: $rentalId) {
    __typename
    ... on RentalItem {
      id
      name
      quantity
      pickedQuantity
      pickListPickedQuantity
      checkedInQuantity
      missingQuantity
      damagedQuantity
      lackNotes
      status
      pictures
      departmentName
      warehouseLocation
      pickListItemId
      pickListStatus
      rentalSectionId
      serialNumbers
      itemNotes {
        ...SectionPickListNote
      }
      rentalSection {
        ...SectionPickListSection
      }
      inventoryObject {
        ...SectionPickListProduct
      }
      subRentals {
        ...SectionPickListSubRental
      }
    }
    ... on RentalAccessory {
      id
      name
      quantity
      pickedQuantity
      pickListPickedQuantity
      checkedInQuantity
      missingQuantity
      damagedQuantity
      lackNotes
      status
      pictures
      departmentName
      warehouseLocation
      pickListAccessoryId
      pickListStatus
      itemNotes {
        ...SectionPickListNote
      }
      rentalSection {
        ...SectionPickListSection
      }
      inventoryObject {
        ...SectionPickListAccessoryInventory
      }
      subRentals {
        ...SectionPickListSubRental
      }
    }
    ... on RentalAddOn {
      id
      name
      quantity
      pickedQuantity
      pickListPickedQuantity
      returnedQuantity
      lackNotes
      status
      pictures
      departmentName
      warehouseLocation
      pickListAddOnId
      pickListStatus
      rentalSectionId
      itemNotes {
        ...SectionPickListNote
      }
      rentalSection {
        ...SectionPickListSection
      }
      inventoryObject {
        ...SectionPickListAddOnInventory
      }
      subRentals {
        ...SectionPickListSubRental
      }
    }
  }
}
    ${SectionPickListNoteFragmentDoc}
${SectionPickListSectionFragmentDoc}
${SectionPickListProductFragmentDoc}
${SectionPickListSubRentalFragmentDoc}
${SectionPickListAccessoryInventoryFragmentDoc}
${SectionPickListAddOnInventoryFragmentDoc}`;

/**
 * __useRentalPickListQuery__
 *
 * To run a query within a React component, call `useRentalPickListQuery` and pass it any options that fit your needs.
 * When your component renders, `useRentalPickListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRentalPickListQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *   },
 * });
 */
export function useRentalPickListQuery(baseOptions: Apollo.QueryHookOptions<RentalPickListQuery, RentalPickListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RentalPickListQuery, RentalPickListQueryVariables>(RentalPickListDocument, options);
      }
export function useRentalPickListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RentalPickListQuery, RentalPickListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RentalPickListQuery, RentalPickListQueryVariables>(RentalPickListDocument, options);
        }
export type RentalPickListQueryHookResult = ReturnType<typeof useRentalPickListQuery>;
export type RentalPickListLazyQueryHookResult = ReturnType<typeof useRentalPickListLazyQuery>;
export type RentalPickListQueryResult = Apollo.QueryResult<RentalPickListQuery, RentalPickListQueryVariables>;
export const ReturnPickedSerializedInventoryDocument = gql`
    mutation ReturnPickedSerializedInventory($input: ReturnPickedSerializedInventoryInput!) {
  returnPickedSerializedInventory(input: $input) {
    success
    errors
  }
}
    `;
export type ReturnPickedSerializedInventoryMutationFn = Apollo.MutationFunction<ReturnPickedSerializedInventoryMutation, ReturnPickedSerializedInventoryMutationVariables>;

/**
 * __useReturnPickedSerializedInventoryMutation__
 *
 * To run a mutation, you first call `useReturnPickedSerializedInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReturnPickedSerializedInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [returnPickedSerializedInventoryMutation, { data, loading, error }] = useReturnPickedSerializedInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReturnPickedSerializedInventoryMutation(baseOptions?: Apollo.MutationHookOptions<ReturnPickedSerializedInventoryMutation, ReturnPickedSerializedInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReturnPickedSerializedInventoryMutation, ReturnPickedSerializedInventoryMutationVariables>(ReturnPickedSerializedInventoryDocument, options);
      }
export type ReturnPickedSerializedInventoryMutationHookResult = ReturnType<typeof useReturnPickedSerializedInventoryMutation>;
export type ReturnPickedSerializedInventoryMutationResult = Apollo.MutationResult<ReturnPickedSerializedInventoryMutation>;
export type ReturnPickedSerializedInventoryMutationOptions = Apollo.BaseMutationOptions<ReturnPickedSerializedInventoryMutation, ReturnPickedSerializedInventoryMutationVariables>;
export const ArchivePickedSerializedInventoryDocument = gql`
    mutation ArchivePickedSerializedInventory($input: ArchivePickedSerializedInventoryInput!) {
  archivePickedSerializedInventory(input: $input) {
    success
    errors
  }
}
    `;
export type ArchivePickedSerializedInventoryMutationFn = Apollo.MutationFunction<ArchivePickedSerializedInventoryMutation, ArchivePickedSerializedInventoryMutationVariables>;

/**
 * __useArchivePickedSerializedInventoryMutation__
 *
 * To run a mutation, you first call `useArchivePickedSerializedInventoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchivePickedSerializedInventoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archivePickedSerializedInventoryMutation, { data, loading, error }] = useArchivePickedSerializedInventoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchivePickedSerializedInventoryMutation(baseOptions?: Apollo.MutationHookOptions<ArchivePickedSerializedInventoryMutation, ArchivePickedSerializedInventoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchivePickedSerializedInventoryMutation, ArchivePickedSerializedInventoryMutationVariables>(ArchivePickedSerializedInventoryDocument, options);
      }
export type ArchivePickedSerializedInventoryMutationHookResult = ReturnType<typeof useArchivePickedSerializedInventoryMutation>;
export type ArchivePickedSerializedInventoryMutationResult = Apollo.MutationResult<ArchivePickedSerializedInventoryMutation>;
export type ArchivePickedSerializedInventoryMutationOptions = Apollo.BaseMutationOptions<ArchivePickedSerializedInventoryMutation, ArchivePickedSerializedInventoryMutationVariables>;
export const ExportInvoicesDocument = gql`
    mutation ExportInvoices($input: ExportInvoicesInput!) {
  exportInvoices(input: $input) {
    message
  }
}
    `;
export type ExportInvoicesMutationFn = Apollo.MutationFunction<ExportInvoicesMutation, ExportInvoicesMutationVariables>;

/**
 * __useExportInvoicesMutation__
 *
 * To run a mutation, you first call `useExportInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportInvoicesMutation, { data, loading, error }] = useExportInvoicesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportInvoicesMutation(baseOptions?: Apollo.MutationHookOptions<ExportInvoicesMutation, ExportInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportInvoicesMutation, ExportInvoicesMutationVariables>(ExportInvoicesDocument, options);
      }
export type ExportInvoicesMutationHookResult = ReturnType<typeof useExportInvoicesMutation>;
export type ExportInvoicesMutationResult = Apollo.MutationResult<ExportInvoicesMutation>;
export type ExportInvoicesMutationOptions = Apollo.BaseMutationOptions<ExportInvoicesMutation, ExportInvoicesMutationVariables>;
export const GetSalesTaxReportDocument = gql`
    query GetSalesTaxReport($locationIds: [Int!]!, $startDate: ISO8601DateTime, $endDate: ISO8601DateTime, $accountingMethod: String!) {
  getSalesTaxCashBasisReport(
    locationIds: $locationIds
    startDate: $startDate
    endDate: $endDate
    accountingMethod: $accountingMethod
  ) {
    summaryByState {
      ...SummaryFragment
    }
    summaryByCounty {
      ...SummaryFragment
    }
    summary {
      ...SummaryFragment
    }
    totals {
      totalTransactionVolume
      subTotalForTaxVolume
      totalOrderVolume
      totalNonTaxableOrderVolume
      proportionalSubTotalForTax
      proportionalPercent
    }
    details {
      token
      orderName
      payment
      taxPercent
      paymentDate
      amount
      overallTotal
      taxAmountDue
      grandTaxTotal
      taxName
      taxType
      refundAmount
      taxPaymentsBasedOnTotal
      subTotalForTax
      displayOrder
      eventStartDate
    }
  }
}
    ${SummaryFragmentFragmentDoc}`;

/**
 * __useGetSalesTaxReportQuery__
 *
 * To run a query within a React component, call `useGetSalesTaxReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSalesTaxReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSalesTaxReportQuery({
 *   variables: {
 *      locationIds: // value for 'locationIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      accountingMethod: // value for 'accountingMethod'
 *   },
 * });
 */
export function useGetSalesTaxReportQuery(baseOptions: Apollo.QueryHookOptions<GetSalesTaxReportQuery, GetSalesTaxReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSalesTaxReportQuery, GetSalesTaxReportQueryVariables>(GetSalesTaxReportDocument, options);
      }
export function useGetSalesTaxReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSalesTaxReportQuery, GetSalesTaxReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSalesTaxReportQuery, GetSalesTaxReportQueryVariables>(GetSalesTaxReportDocument, options);
        }
export type GetSalesTaxReportQueryHookResult = ReturnType<typeof useGetSalesTaxReportQuery>;
export type GetSalesTaxReportLazyQueryHookResult = ReturnType<typeof useGetSalesTaxReportLazyQuery>;
export type GetSalesTaxReportQueryResult = Apollo.QueryResult<GetSalesTaxReportQuery, GetSalesTaxReportQueryVariables>;
export const EditTrucksForRentalTransportDocument = gql`
    mutation EditTrucksForRentalTransport($rentalTransportId: ID!, $truckIdsToAssign: [ID!]!, $truckIdsToUnassign: [ID!]!, $truckIdToAssignItems: ID) {
  assignTrucksToRentalTransport(
    input: {rentalTransportId: $rentalTransportId, truckIds: $truckIdsToAssign, truckIdToAssignItems: $truckIdToAssignItems}
  ) {
    errors
  }
  unassignTrucksFromRentalTransport(
    input: {rentalTransportId: $rentalTransportId, truckIds: $truckIdsToUnassign}
  ) {
    errors
  }
}
    `;
export type EditTrucksForRentalTransportMutationFn = Apollo.MutationFunction<EditTrucksForRentalTransportMutation, EditTrucksForRentalTransportMutationVariables>;

/**
 * __useEditTrucksForRentalTransportMutation__
 *
 * To run a mutation, you first call `useEditTrucksForRentalTransportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditTrucksForRentalTransportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editTrucksForRentalTransportMutation, { data, loading, error }] = useEditTrucksForRentalTransportMutation({
 *   variables: {
 *      rentalTransportId: // value for 'rentalTransportId'
 *      truckIdsToAssign: // value for 'truckIdsToAssign'
 *      truckIdsToUnassign: // value for 'truckIdsToUnassign'
 *      truckIdToAssignItems: // value for 'truckIdToAssignItems'
 *   },
 * });
 */
export function useEditTrucksForRentalTransportMutation(baseOptions?: Apollo.MutationHookOptions<EditTrucksForRentalTransportMutation, EditTrucksForRentalTransportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditTrucksForRentalTransportMutation, EditTrucksForRentalTransportMutationVariables>(EditTrucksForRentalTransportDocument, options);
      }
export type EditTrucksForRentalTransportMutationHookResult = ReturnType<typeof useEditTrucksForRentalTransportMutation>;
export type EditTrucksForRentalTransportMutationResult = Apollo.MutationResult<EditTrucksForRentalTransportMutation>;
export type EditTrucksForRentalTransportMutationOptions = Apollo.BaseMutationOptions<EditTrucksForRentalTransportMutation, EditTrucksForRentalTransportMutationVariables>;
export const ReassignDriversDocument = gql`
    mutation ReassignDrivers($input: ReassignDriversInput!) {
  reassignDrivers(input: $input) {
    drivers {
      id
      employeeId
      role
      truckRouteId
      createdAt
      updatedAt
      name
    }
    errors
  }
}
    `;
export type ReassignDriversMutationFn = Apollo.MutationFunction<ReassignDriversMutation, ReassignDriversMutationVariables>;

/**
 * __useReassignDriversMutation__
 *
 * To run a mutation, you first call `useReassignDriversMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReassignDriversMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reassignDriversMutation, { data, loading, error }] = useReassignDriversMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReassignDriversMutation(baseOptions?: Apollo.MutationHookOptions<ReassignDriversMutation, ReassignDriversMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReassignDriversMutation, ReassignDriversMutationVariables>(ReassignDriversDocument, options);
      }
export type ReassignDriversMutationHookResult = ReturnType<typeof useReassignDriversMutation>;
export type ReassignDriversMutationResult = Apollo.MutationResult<ReassignDriversMutation>;
export type ReassignDriversMutationOptions = Apollo.BaseMutationOptions<ReassignDriversMutation, ReassignDriversMutationVariables>;
export const SetTruckRouteDocument = gql`
    mutation SetTruckRoute($input: SetTruckRouteInput!) {
  setTruckRoute(input: $input) {
    truckRoute {
      id
      truck {
        id
        name
        color
      }
      deliveryDate
      startTime
    }
  }
}
    `;
export type SetTruckRouteMutationFn = Apollo.MutationFunction<SetTruckRouteMutation, SetTruckRouteMutationVariables>;

/**
 * __useSetTruckRouteMutation__
 *
 * To run a mutation, you first call `useSetTruckRouteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTruckRouteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTruckRouteMutation, { data, loading, error }] = useSetTruckRouteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTruckRouteMutation(baseOptions?: Apollo.MutationHookOptions<SetTruckRouteMutation, SetTruckRouteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTruckRouteMutation, SetTruckRouteMutationVariables>(SetTruckRouteDocument, options);
      }
export type SetTruckRouteMutationHookResult = ReturnType<typeof useSetTruckRouteMutation>;
export type SetTruckRouteMutationResult = Apollo.MutationResult<SetTruckRouteMutation>;
export type SetTruckRouteMutationOptions = Apollo.BaseMutationOptions<SetTruckRouteMutation, SetTruckRouteMutationVariables>;
export const GetRentalsByTransportsDocument = gql`
    query GetRentalsByTransports($startDateTimeGte: String, $startDateTimeLte: String, $employeeIds: [Int!], $rentalStatus: [String!], $transportType: [String!], $truckIds: [Int!]) {
  getRentalsByTransports(
    startDateTimeGte: $startDateTimeGte
    startDateTimeLte: $startDateTimeLte
    employeeIds: $employeeIds
    rentalStatus: $rentalStatus
    transportType: $transportType
    truckIds: $truckIds
  ) {
    token
    name
    hasDocuments
    totalInventoryCount
    startDateTime
    endDateTime
    eventStartSetting
    eventEndSetting
    hasSetByTime
    setByTimeDateTime
    hasDocuments
    customers {
      name
      email
    }
    company {
      name
      primaryContactEmail
    }
    pickListItems {
      name
      quantity
    }
    pickListAddOns {
      name
      quantity
    }
    pickListAccessories {
      name
      quantity
    }
    rentalTransports {
      id
      rentalStaffId
      transportType
      startDateTime
      endDateTime
      drivers {
        name
        role
        rentalTransportId
      }
      rentalTransportTruckRelationships {
        id
        truckRouteId
        truckRoute {
          id
          deliveryDate
          startTime
          truck {
            name
            color
          }
          drivers {
            name
            role
            rentalTransportId
          }
        }
      }
    }
    serviceTickets {
      routingStartDateTime
      routingEndDateTime
      startDateTime
      endDateTime
      rentalStaffId
    }
    rentalStaffs {
      id
      name
    }
    event {
      __typename
      id
      name
      token
      eventEndDateTime
      eventStartDateTime
    }
  }
}
    `;

/**
 * __useGetRentalsByTransportsQuery__
 *
 * To run a query within a React component, call `useGetRentalsByTransportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalsByTransportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalsByTransportsQuery({
 *   variables: {
 *      startDateTimeGte: // value for 'startDateTimeGte'
 *      startDateTimeLte: // value for 'startDateTimeLte'
 *      employeeIds: // value for 'employeeIds'
 *      rentalStatus: // value for 'rentalStatus'
 *      transportType: // value for 'transportType'
 *      truckIds: // value for 'truckIds'
 *   },
 * });
 */
export function useGetRentalsByTransportsQuery(baseOptions?: Apollo.QueryHookOptions<GetRentalsByTransportsQuery, GetRentalsByTransportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalsByTransportsQuery, GetRentalsByTransportsQueryVariables>(GetRentalsByTransportsDocument, options);
      }
export function useGetRentalsByTransportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalsByTransportsQuery, GetRentalsByTransportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalsByTransportsQuery, GetRentalsByTransportsQueryVariables>(GetRentalsByTransportsDocument, options);
        }
export type GetRentalsByTransportsQueryHookResult = ReturnType<typeof useGetRentalsByTransportsQuery>;
export type GetRentalsByTransportsLazyQueryHookResult = ReturnType<typeof useGetRentalsByTransportsLazyQuery>;
export type GetRentalsByTransportsQueryResult = Apollo.QueryResult<GetRentalsByTransportsQuery, GetRentalsByTransportsQueryVariables>;
export const GetTrucksDocument = gql`
    query GetTrucks {
  getTrucks {
    id
    name
    color
    notes
    active
    alphabetId
    locationId
    createdAt
    updatedAt
  }
}
    `;

/**
 * __useGetTrucksQuery__
 *
 * To run a query within a React component, call `useGetTrucksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTrucksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTrucksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTrucksQuery(baseOptions?: Apollo.QueryHookOptions<GetTrucksQuery, GetTrucksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTrucksQuery, GetTrucksQueryVariables>(GetTrucksDocument, options);
      }
export function useGetTrucksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTrucksQuery, GetTrucksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTrucksQuery, GetTrucksQueryVariables>(GetTrucksDocument, options);
        }
export type GetTrucksQueryHookResult = ReturnType<typeof useGetTrucksQuery>;
export type GetTrucksLazyQueryHookResult = ReturnType<typeof useGetTrucksLazyQuery>;
export type GetTrucksQueryResult = Apollo.QueryResult<GetTrucksQuery, GetTrucksQueryVariables>;
export const GetPricingPreviewDocument = gql`
    query GetPricingPreview($pricingTier: String!) {
  getPricingPreview(pricingTier: $pricingTier) {
    amount
    billingCycle
    newSubscriptionAmount
  }
}
    `;

/**
 * __useGetPricingPreviewQuery__
 *
 * To run a query within a React component, call `useGetPricingPreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPricingPreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPricingPreviewQuery({
 *   variables: {
 *      pricingTier: // value for 'pricingTier'
 *   },
 * });
 */
export function useGetPricingPreviewQuery(baseOptions: Apollo.QueryHookOptions<GetPricingPreviewQuery, GetPricingPreviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPricingPreviewQuery, GetPricingPreviewQueryVariables>(GetPricingPreviewDocument, options);
      }
export function useGetPricingPreviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPricingPreviewQuery, GetPricingPreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPricingPreviewQuery, GetPricingPreviewQueryVariables>(GetPricingPreviewDocument, options);
        }
export type GetPricingPreviewQueryHookResult = ReturnType<typeof useGetPricingPreviewQuery>;
export type GetPricingPreviewLazyQueryHookResult = ReturnType<typeof useGetPricingPreviewLazyQuery>;
export type GetPricingPreviewQueryResult = Apollo.QueryResult<GetPricingPreviewQuery, GetPricingPreviewQueryVariables>;
export const GetSfCategoriesForCategoryModalDocument = gql`
    query GetSfCategoriesForCategoryModal($locationId: Int!, $order: StorefrontCategoryOrderEnum = NAME, $orderDirection: StorefrontCategoryDirectionEnum = ASC) {
  getStorefrontCategories(
    locationId: $locationId
    order: $order
    direction: $orderDirection
  ) {
    id
    name
    depth
    path
    visibleOnSf
    __typename
  }
}
    `;

/**
 * __useGetSfCategoriesForCategoryModalQuery__
 *
 * To run a query within a React component, call `useGetSfCategoriesForCategoryModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSfCategoriesForCategoryModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSfCategoriesForCategoryModalQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      order: // value for 'order'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useGetSfCategoriesForCategoryModalQuery(baseOptions: Apollo.QueryHookOptions<GetSfCategoriesForCategoryModalQuery, GetSfCategoriesForCategoryModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSfCategoriesForCategoryModalQuery, GetSfCategoriesForCategoryModalQueryVariables>(GetSfCategoriesForCategoryModalDocument, options);
      }
export function useGetSfCategoriesForCategoryModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSfCategoriesForCategoryModalQuery, GetSfCategoriesForCategoryModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSfCategoriesForCategoryModalQuery, GetSfCategoriesForCategoryModalQueryVariables>(GetSfCategoriesForCategoryModalDocument, options);
        }
export type GetSfCategoriesForCategoryModalQueryHookResult = ReturnType<typeof useGetSfCategoriesForCategoryModalQuery>;
export type GetSfCategoriesForCategoryModalLazyQueryHookResult = ReturnType<typeof useGetSfCategoriesForCategoryModalLazyQuery>;
export type GetSfCategoriesForCategoryModalQueryResult = Apollo.QueryResult<GetSfCategoriesForCategoryModalQuery, GetSfCategoriesForCategoryModalQueryVariables>;
export const CreateCategoryDocument = gql`
    mutation CreateCategory($input: SetStorefrontCategoryInput!) {
  setStorefrontCategory(input: $input) {
    sfCategory {
      id
      name
      slug
      parentId
      visibleOnSf
      __typename
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type CreateCategoryMutationFn = Apollo.MutationFunction<CreateCategoryMutation, CreateCategoryMutationVariables>;

/**
 * __useCreateCategoryMutation__
 *
 * To run a mutation, you first call `useCreateCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCategoryMutation, { data, loading, error }] = useCreateCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCategoryMutation(baseOptions?: Apollo.MutationHookOptions<CreateCategoryMutation, CreateCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCategoryMutation, CreateCategoryMutationVariables>(CreateCategoryDocument, options);
      }
export type CreateCategoryMutationHookResult = ReturnType<typeof useCreateCategoryMutation>;
export type CreateCategoryMutationResult = Apollo.MutationResult<CreateCategoryMutation>;
export type CreateCategoryMutationOptions = Apollo.BaseMutationOptions<CreateCategoryMutation, CreateCategoryMutationVariables>;
export const BulkCreateTagsDocument = gql`
    mutation BulkCreateTags($input: BulkSetStorefrontTagsInput!) {
  bulkSetStorefrontTags(input: $input) {
    sfTags {
      id
      locationId
      name
      __typename
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type BulkCreateTagsMutationFn = Apollo.MutationFunction<BulkCreateTagsMutation, BulkCreateTagsMutationVariables>;

/**
 * __useBulkCreateTagsMutation__
 *
 * To run a mutation, you first call `useBulkCreateTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBulkCreateTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [bulkCreateTagsMutation, { data, loading, error }] = useBulkCreateTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBulkCreateTagsMutation(baseOptions?: Apollo.MutationHookOptions<BulkCreateTagsMutation, BulkCreateTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BulkCreateTagsMutation, BulkCreateTagsMutationVariables>(BulkCreateTagsDocument, options);
      }
export type BulkCreateTagsMutationHookResult = ReturnType<typeof useBulkCreateTagsMutation>;
export type BulkCreateTagsMutationResult = Apollo.MutationResult<BulkCreateTagsMutation>;
export type BulkCreateTagsMutationOptions = Apollo.BaseMutationOptions<BulkCreateTagsMutation, BulkCreateTagsMutationVariables>;
export const ListSfCategoriesDocument = gql`
    query ListSfCategories($search: String, $locationId: Int!, $order: StorefrontCategoryOrderEnum = NAME, $orderDirection: StorefrontCategoryDirectionEnum = ASC) {
  getStorefrontCategories(
    search: $search
    locationId: $locationId
    order: $order
    direction: $orderDirection
  ) {
    id
    name
    depth
    path
    slug
    parentId
    visibleOnSf
    childrenCount
    locationId
    __typename
  }
}
    `;

/**
 * __useListSfCategoriesQuery__
 *
 * To run a query within a React component, call `useListSfCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSfCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSfCategoriesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      locationId: // value for 'locationId'
 *      order: // value for 'order'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useListSfCategoriesQuery(baseOptions: Apollo.QueryHookOptions<ListSfCategoriesQuery, ListSfCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSfCategoriesQuery, ListSfCategoriesQueryVariables>(ListSfCategoriesDocument, options);
      }
export function useListSfCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSfCategoriesQuery, ListSfCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSfCategoriesQuery, ListSfCategoriesQueryVariables>(ListSfCategoriesDocument, options);
        }
export type ListSfCategoriesQueryHookResult = ReturnType<typeof useListSfCategoriesQuery>;
export type ListSfCategoriesLazyQueryHookResult = ReturnType<typeof useListSfCategoriesLazyQuery>;
export type ListSfCategoriesQueryResult = Apollo.QueryResult<ListSfCategoriesQuery, ListSfCategoriesQueryVariables>;
export const DeleteSfCategoryDocument = gql`
    mutation DeleteSfCategory($input: DeleteStorefrontCategoryInput!) {
  deleteStorefrontCategory(input: $input) {
    sfCategory {
      id
      name
      depth
      path
      slug
      parentId
      visibleOnSf
      __typename
    }
    errors {
      fullMessages
    }
  }
}
    `;
export type DeleteSfCategoryMutationFn = Apollo.MutationFunction<DeleteSfCategoryMutation, DeleteSfCategoryMutationVariables>;

/**
 * __useDeleteSfCategoryMutation__
 *
 * To run a mutation, you first call `useDeleteSfCategoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSfCategoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSfCategoryMutation, { data, loading, error }] = useDeleteSfCategoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSfCategoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSfCategoryMutation, DeleteSfCategoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSfCategoryMutation, DeleteSfCategoryMutationVariables>(DeleteSfCategoryDocument, options);
      }
export type DeleteSfCategoryMutationHookResult = ReturnType<typeof useDeleteSfCategoryMutation>;
export type DeleteSfCategoryMutationResult = Apollo.MutationResult<DeleteSfCategoryMutation>;
export type DeleteSfCategoryMutationOptions = Apollo.BaseMutationOptions<DeleteSfCategoryMutation, DeleteSfCategoryMutationVariables>;
export const SetStorefrontTagDocument = gql`
    mutation SetStorefrontTag($input: SetStorefrontTagInput!) {
  setStorefrontTag(input: $input) {
    sfTag {
      ...StorefrontTag
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    ${StorefrontTagFragmentDoc}`;
export type SetStorefrontTagMutationFn = Apollo.MutationFunction<SetStorefrontTagMutation, SetStorefrontTagMutationVariables>;

/**
 * __useSetStorefrontTagMutation__
 *
 * To run a mutation, you first call `useSetStorefrontTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStorefrontTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStorefrontTagMutation, { data, loading, error }] = useSetStorefrontTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStorefrontTagMutation(baseOptions?: Apollo.MutationHookOptions<SetStorefrontTagMutation, SetStorefrontTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStorefrontTagMutation, SetStorefrontTagMutationVariables>(SetStorefrontTagDocument, options);
      }
export type SetStorefrontTagMutationHookResult = ReturnType<typeof useSetStorefrontTagMutation>;
export type SetStorefrontTagMutationResult = Apollo.MutationResult<SetStorefrontTagMutation>;
export type SetStorefrontTagMutationOptions = Apollo.BaseMutationOptions<SetStorefrontTagMutation, SetStorefrontTagMutationVariables>;
export const SetStorefrontTagItemRelationshipDocument = gql`
    mutation SetStorefrontTagItemRelationship($input: SetStorefrontTagItemRelationshipInput!) {
  setStorefrontTagItemRelationship(input: $input) {
    sfTagItemRelationship {
      ...StorefrontTagItemRelationship
      sfTag {
        ...StorefrontTag
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    ${StorefrontTagItemRelationshipFragmentDoc}
${StorefrontTagFragmentDoc}`;
export type SetStorefrontTagItemRelationshipMutationFn = Apollo.MutationFunction<SetStorefrontTagItemRelationshipMutation, SetStorefrontTagItemRelationshipMutationVariables>;

/**
 * __useSetStorefrontTagItemRelationshipMutation__
 *
 * To run a mutation, you first call `useSetStorefrontTagItemRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetStorefrontTagItemRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setStorefrontTagItemRelationshipMutation, { data, loading, error }] = useSetStorefrontTagItemRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetStorefrontTagItemRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<SetStorefrontTagItemRelationshipMutation, SetStorefrontTagItemRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetStorefrontTagItemRelationshipMutation, SetStorefrontTagItemRelationshipMutationVariables>(SetStorefrontTagItemRelationshipDocument, options);
      }
export type SetStorefrontTagItemRelationshipMutationHookResult = ReturnType<typeof useSetStorefrontTagItemRelationshipMutation>;
export type SetStorefrontTagItemRelationshipMutationResult = Apollo.MutationResult<SetStorefrontTagItemRelationshipMutation>;
export type SetStorefrontTagItemRelationshipMutationOptions = Apollo.BaseMutationOptions<SetStorefrontTagItemRelationshipMutation, SetStorefrontTagItemRelationshipMutationVariables>;
export const DeleteStorefrontTagDocument = gql`
    mutation DeleteStorefrontTag($input: DeleteStorefrontTagInput!) {
  deleteStorefrontTag(input: $input) {
    sfTag {
      ...StorefrontTag
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    ${StorefrontTagFragmentDoc}`;
export type DeleteStorefrontTagMutationFn = Apollo.MutationFunction<DeleteStorefrontTagMutation, DeleteStorefrontTagMutationVariables>;

/**
 * __useDeleteStorefrontTagMutation__
 *
 * To run a mutation, you first call `useDeleteStorefrontTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorefrontTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorefrontTagMutation, { data, loading, error }] = useDeleteStorefrontTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStorefrontTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStorefrontTagMutation, DeleteStorefrontTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStorefrontTagMutation, DeleteStorefrontTagMutationVariables>(DeleteStorefrontTagDocument, options);
      }
export type DeleteStorefrontTagMutationHookResult = ReturnType<typeof useDeleteStorefrontTagMutation>;
export type DeleteStorefrontTagMutationResult = Apollo.MutationResult<DeleteStorefrontTagMutation>;
export type DeleteStorefrontTagMutationOptions = Apollo.BaseMutationOptions<DeleteStorefrontTagMutation, DeleteStorefrontTagMutationVariables>;
export const DeleteStorefrontTagItemRelationshipDocument = gql`
    mutation DeleteStorefrontTagItemRelationship($input: DeleteStorefrontTagItemRelationshipInput!) {
  deleteStorefrontTagItemRelationship(input: $input) {
    sfTagItemRelationship {
      ...StorefrontTagItemRelationship
      sfTag {
        ...StorefrontTag
      }
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    ${StorefrontTagItemRelationshipFragmentDoc}
${StorefrontTagFragmentDoc}`;
export type DeleteStorefrontTagItemRelationshipMutationFn = Apollo.MutationFunction<DeleteStorefrontTagItemRelationshipMutation, DeleteStorefrontTagItemRelationshipMutationVariables>;

/**
 * __useDeleteStorefrontTagItemRelationshipMutation__
 *
 * To run a mutation, you first call `useDeleteStorefrontTagItemRelationshipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteStorefrontTagItemRelationshipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteStorefrontTagItemRelationshipMutation, { data, loading, error }] = useDeleteStorefrontTagItemRelationshipMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteStorefrontTagItemRelationshipMutation(baseOptions?: Apollo.MutationHookOptions<DeleteStorefrontTagItemRelationshipMutation, DeleteStorefrontTagItemRelationshipMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteStorefrontTagItemRelationshipMutation, DeleteStorefrontTagItemRelationshipMutationVariables>(DeleteStorefrontTagItemRelationshipDocument, options);
      }
export type DeleteStorefrontTagItemRelationshipMutationHookResult = ReturnType<typeof useDeleteStorefrontTagItemRelationshipMutation>;
export type DeleteStorefrontTagItemRelationshipMutationResult = Apollo.MutationResult<DeleteStorefrontTagItemRelationshipMutation>;
export type DeleteStorefrontTagItemRelationshipMutationOptions = Apollo.BaseMutationOptions<DeleteStorefrontTagItemRelationshipMutation, DeleteStorefrontTagItemRelationshipMutationVariables>;
export const ListTagsDocument = gql`
    query ListTags($ids: [Int!]) {
  getStorefrontTags(ids: $ids) {
    ...StorefrontTag
    sfTagItemRelationships {
      ...StorefrontTagItemRelationship
    }
  }
}
    ${StorefrontTagFragmentDoc}
${StorefrontTagItemRelationshipFragmentDoc}`;

/**
 * __useListTagsQuery__
 *
 * To run a query within a React component, call `useListTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListTagsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useListTagsQuery(baseOptions?: Apollo.QueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
      }
export function useListTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListTagsQuery, ListTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListTagsQuery, ListTagsQueryVariables>(ListTagsDocument, options);
        }
export type ListTagsQueryHookResult = ReturnType<typeof useListTagsQuery>;
export type ListTagsLazyQueryHookResult = ReturnType<typeof useListTagsLazyQuery>;
export type ListTagsQueryResult = Apollo.QueryResult<ListTagsQuery, ListTagsQueryVariables>;
export const GenerateBearerTokenDocument = gql`
    mutation GenerateBearerToken($accessType: String) {
  generateBearerToken(input: {accessType: $accessType}) {
    response
    errors {
      fullMessages
    }
  }
}
    `;
export type GenerateBearerTokenMutationFn = Apollo.MutationFunction<GenerateBearerTokenMutation, GenerateBearerTokenMutationVariables>;

/**
 * __useGenerateBearerTokenMutation__
 *
 * To run a mutation, you first call `useGenerateBearerTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateBearerTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateBearerTokenMutation, { data, loading, error }] = useGenerateBearerTokenMutation({
 *   variables: {
 *      accessType: // value for 'accessType'
 *   },
 * });
 */
export function useGenerateBearerTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateBearerTokenMutation, GenerateBearerTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateBearerTokenMutation, GenerateBearerTokenMutationVariables>(GenerateBearerTokenDocument, options);
      }
export type GenerateBearerTokenMutationHookResult = ReturnType<typeof useGenerateBearerTokenMutation>;
export type GenerateBearerTokenMutationResult = Apollo.MutationResult<GenerateBearerTokenMutation>;
export type GenerateBearerTokenMutationOptions = Apollo.BaseMutationOptions<GenerateBearerTokenMutation, GenerateBearerTokenMutationVariables>;
export const GetRedirectHostsDocument = gql`
    query GetRedirectHosts {
  getRedirectHosts {
    id
    hostname
    __typename
  }
}
    `;

/**
 * __useGetRedirectHostsQuery__
 *
 * To run a query within a React component, call `useGetRedirectHostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRedirectHostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRedirectHostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRedirectHostsQuery(baseOptions?: Apollo.QueryHookOptions<GetRedirectHostsQuery, GetRedirectHostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRedirectHostsQuery, GetRedirectHostsQueryVariables>(GetRedirectHostsDocument, options);
      }
export function useGetRedirectHostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRedirectHostsQuery, GetRedirectHostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRedirectHostsQuery, GetRedirectHostsQueryVariables>(GetRedirectHostsDocument, options);
        }
export type GetRedirectHostsQueryHookResult = ReturnType<typeof useGetRedirectHostsQuery>;
export type GetRedirectHostsLazyQueryHookResult = ReturnType<typeof useGetRedirectHostsLazyQuery>;
export type GetRedirectHostsQueryResult = Apollo.QueryResult<GetRedirectHostsQuery, GetRedirectHostsQueryVariables>;
export const DeleteBearerTokenDocument = gql`
    mutation DeleteBearerToken($id: Int!) {
  deleteBearerToken(input: {id: $id}) {
    success
    errors {
      fullMessages
    }
  }
}
    `;
export type DeleteBearerTokenMutationFn = Apollo.MutationFunction<DeleteBearerTokenMutation, DeleteBearerTokenMutationVariables>;

/**
 * __useDeleteBearerTokenMutation__
 *
 * To run a mutation, you first call `useDeleteBearerTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBearerTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBearerTokenMutation, { data, loading, error }] = useDeleteBearerTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBearerTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBearerTokenMutation, DeleteBearerTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBearerTokenMutation, DeleteBearerTokenMutationVariables>(DeleteBearerTokenDocument, options);
      }
export type DeleteBearerTokenMutationHookResult = ReturnType<typeof useDeleteBearerTokenMutation>;
export type DeleteBearerTokenMutationResult = Apollo.MutationResult<DeleteBearerTokenMutation>;
export type DeleteBearerTokenMutationOptions = Apollo.BaseMutationOptions<DeleteBearerTokenMutation, DeleteBearerTokenMutationVariables>;
export const GetApiKeysDocument = gql`
    query GetApiKeys {
  getApiKeys {
    id
    businessId
    createdAt
    tokenSuffix
    accessType
  }
}
    `;

/**
 * __useGetApiKeysQuery__
 *
 * To run a query within a React component, call `useGetApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetApiKeysQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetApiKeysQuery(baseOptions?: Apollo.QueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
      }
export function useGetApiKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetApiKeysQuery, GetApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetApiKeysQuery, GetApiKeysQueryVariables>(GetApiKeysDocument, options);
        }
export type GetApiKeysQueryHookResult = ReturnType<typeof useGetApiKeysQuery>;
export type GetApiKeysLazyQueryHookResult = ReturnType<typeof useGetApiKeysLazyQuery>;
export type GetApiKeysQueryResult = Apollo.QueryResult<GetApiKeysQuery, GetApiKeysQueryVariables>;
export const SetRedirectHostDocument = gql`
    mutation SetRedirectHost($input: SetRedirectHostInput!) {
  setRedirectHost(input: $input) {
    redirectHost {
      id
      hostname
      __typename
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetRedirectHostMutationFn = Apollo.MutationFunction<SetRedirectHostMutation, SetRedirectHostMutationVariables>;

/**
 * __useSetRedirectHostMutation__
 *
 * To run a mutation, you first call `useSetRedirectHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRedirectHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRedirectHostMutation, { data, loading, error }] = useSetRedirectHostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRedirectHostMutation(baseOptions?: Apollo.MutationHookOptions<SetRedirectHostMutation, SetRedirectHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRedirectHostMutation, SetRedirectHostMutationVariables>(SetRedirectHostDocument, options);
      }
export type SetRedirectHostMutationHookResult = ReturnType<typeof useSetRedirectHostMutation>;
export type SetRedirectHostMutationResult = Apollo.MutationResult<SetRedirectHostMutation>;
export type SetRedirectHostMutationOptions = Apollo.BaseMutationOptions<SetRedirectHostMutation, SetRedirectHostMutationVariables>;
export const DeleteRedirectHostDocument = gql`
    mutation DeleteRedirectHost($input: DeleteRedirectHostInput!) {
  deleteRedirectHost(input: $input) {
    redirectHost {
      id
      hostname
      __typename
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type DeleteRedirectHostMutationFn = Apollo.MutationFunction<DeleteRedirectHostMutation, DeleteRedirectHostMutationVariables>;

/**
 * __useDeleteRedirectHostMutation__
 *
 * To run a mutation, you first call `useDeleteRedirectHostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRedirectHostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRedirectHostMutation, { data, loading, error }] = useDeleteRedirectHostMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRedirectHostMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRedirectHostMutation, DeleteRedirectHostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRedirectHostMutation, DeleteRedirectHostMutationVariables>(DeleteRedirectHostDocument, options);
      }
export type DeleteRedirectHostMutationHookResult = ReturnType<typeof useDeleteRedirectHostMutation>;
export type DeleteRedirectHostMutationResult = Apollo.MutationResult<DeleteRedirectHostMutation>;
export type DeleteRedirectHostMutationOptions = Apollo.BaseMutationOptions<DeleteRedirectHostMutation, DeleteRedirectHostMutationVariables>;
export const SetWebhookSettingsDocument = gql`
    mutation SetWebhookSettings($input: SetWebhookSettingsInput!) {
  setWebhookSettings(input: $input) {
    business {
      id
      webhookMode
      webhookLive
      webhookTest
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetWebhookSettingsMutationFn = Apollo.MutationFunction<SetWebhookSettingsMutation, SetWebhookSettingsMutationVariables>;

/**
 * __useSetWebhookSettingsMutation__
 *
 * To run a mutation, you first call `useSetWebhookSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetWebhookSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setWebhookSettingsMutation, { data, loading, error }] = useSetWebhookSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetWebhookSettingsMutation(baseOptions?: Apollo.MutationHookOptions<SetWebhookSettingsMutation, SetWebhookSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetWebhookSettingsMutation, SetWebhookSettingsMutationVariables>(SetWebhookSettingsDocument, options);
      }
export type SetWebhookSettingsMutationHookResult = ReturnType<typeof useSetWebhookSettingsMutation>;
export type SetWebhookSettingsMutationResult = Apollo.MutationResult<SetWebhookSettingsMutation>;
export type SetWebhookSettingsMutationOptions = Apollo.BaseMutationOptions<SetWebhookSettingsMutation, SetWebhookSettingsMutationVariables>;
export const GetRolesDocument = gql`
    query GetRoles($search: String, $roleType: String) {
  getRoles(search: $search, roleType: $roleType) {
    id
    name
    roleType
    roleTypeString
    roleKey
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      roleType: // value for 'roleType'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions?: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const SetRoleDocument = gql`
    mutation SetRole($input: SetRoleInput!) {
  setRole(input: $input) {
    role {
      id
      name
      roleType
    }
    errors {
      details {
        field
        messages
      }
      fullMessages
    }
  }
}
    `;
export type SetRoleMutationFn = Apollo.MutationFunction<SetRoleMutation, SetRoleMutationVariables>;

/**
 * __useSetRoleMutation__
 *
 * To run a mutation, you first call `useSetRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRoleMutation, { data, loading, error }] = useSetRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRoleMutation(baseOptions?: Apollo.MutationHookOptions<SetRoleMutation, SetRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRoleMutation, SetRoleMutationVariables>(SetRoleDocument, options);
      }
export type SetRoleMutationHookResult = ReturnType<typeof useSetRoleMutation>;
export type SetRoleMutationResult = Apollo.MutationResult<SetRoleMutation>;
export type SetRoleMutationOptions = Apollo.BaseMutationOptions<SetRoleMutation, SetRoleMutationVariables>;
export const DeleteRoleDocument = gql`
    mutation DeleteRole($input: DeleteRoleInput!) {
  deleteRole(input: $input) {
    success
    errors
    deletedRole
  }
}
    `;
export type DeleteRoleMutationFn = Apollo.MutationFunction<DeleteRoleMutation, DeleteRoleMutationVariables>;

/**
 * __useDeleteRoleMutation__
 *
 * To run a mutation, you first call `useDeleteRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoleMutation, { data, loading, error }] = useDeleteRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRoleMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRoleMutation, DeleteRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRoleMutation, DeleteRoleMutationVariables>(DeleteRoleDocument, options);
      }
export type DeleteRoleMutationHookResult = ReturnType<typeof useDeleteRoleMutation>;
export type DeleteRoleMutationResult = Apollo.MutationResult<DeleteRoleMutation>;
export type DeleteRoleMutationOptions = Apollo.BaseMutationOptions<DeleteRoleMutation, DeleteRoleMutationVariables>;
export const GetBusinessEmployeesExcludingCurrentLocationWithEmailsDocument = gql`
    query GetBusinessEmployeesExcludingCurrentLocationWithEmails($locationId: String!) {
  getUniqueLocationEmployeeEmails(locationId: $locationId) {
    employeeId
    employeeEmail
  }
}
    `;

/**
 * __useGetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery__
 *
 * To run a query within a React component, call `useGetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery, GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery, GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryVariables>(GetBusinessEmployeesExcludingCurrentLocationWithEmailsDocument, options);
      }
export function useGetBusinessEmployeesExcludingCurrentLocationWithEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery, GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery, GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryVariables>(GetBusinessEmployeesExcludingCurrentLocationWithEmailsDocument, options);
        }
export type GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryHookResult = ReturnType<typeof useGetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery>;
export type GetBusinessEmployeesExcludingCurrentLocationWithEmailsLazyQueryHookResult = ReturnType<typeof useGetBusinessEmployeesExcludingCurrentLocationWithEmailsLazyQuery>;
export type GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryResult = Apollo.QueryResult<GetBusinessEmployeesExcludingCurrentLocationWithEmailsQuery, GetBusinessEmployeesExcludingCurrentLocationWithEmailsQueryVariables>;
export const SetRefundDocument = gql`
    mutation SetRefund($input: SetRefundInput!) {
  setRefund(input: $input) {
    success
    error
  }
}
    `;
export type SetRefundMutationFn = Apollo.MutationFunction<SetRefundMutation, SetRefundMutationVariables>;

/**
 * __useSetRefundMutation__
 *
 * To run a mutation, you first call `useSetRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRefundMutation, { data, loading, error }] = useSetRefundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetRefundMutation(baseOptions?: Apollo.MutationHookOptions<SetRefundMutation, SetRefundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetRefundMutation, SetRefundMutationVariables>(SetRefundDocument, options);
      }
export type SetRefundMutationHookResult = ReturnType<typeof useSetRefundMutation>;
export type SetRefundMutationResult = Apollo.MutationResult<SetRefundMutation>;
export type SetRefundMutationOptions = Apollo.BaseMutationOptions<SetRefundMutation, SetRefundMutationVariables>;
export const GetGrailpayOwnerBankAccountsDocument = gql`
    query GetGrailpayOwnerBankAccounts($ownerId: ID!, $ownerType: String!) {
  getGrailpayOwnerBankAccounts(ownerId: $ownerId, ownerType: $ownerType) {
    id
    token
    last4
    active
    bankName
    createdAt
    updatedAt
    paymentProcessor
  }
}
    `;

/**
 * __useGetGrailpayOwnerBankAccountsQuery__
 *
 * To run a query within a React component, call `useGetGrailpayOwnerBankAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGrailpayOwnerBankAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGrailpayOwnerBankAccountsQuery({
 *   variables: {
 *      ownerId: // value for 'ownerId'
 *      ownerType: // value for 'ownerType'
 *   },
 * });
 */
export function useGetGrailpayOwnerBankAccountsQuery(baseOptions: Apollo.QueryHookOptions<GetGrailpayOwnerBankAccountsQuery, GetGrailpayOwnerBankAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGrailpayOwnerBankAccountsQuery, GetGrailpayOwnerBankAccountsQueryVariables>(GetGrailpayOwnerBankAccountsDocument, options);
      }
export function useGetGrailpayOwnerBankAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGrailpayOwnerBankAccountsQuery, GetGrailpayOwnerBankAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGrailpayOwnerBankAccountsQuery, GetGrailpayOwnerBankAccountsQueryVariables>(GetGrailpayOwnerBankAccountsDocument, options);
        }
export type GetGrailpayOwnerBankAccountsQueryHookResult = ReturnType<typeof useGetGrailpayOwnerBankAccountsQuery>;
export type GetGrailpayOwnerBankAccountsLazyQueryHookResult = ReturnType<typeof useGetGrailpayOwnerBankAccountsLazyQuery>;
export type GetGrailpayOwnerBankAccountsQueryResult = Apollo.QueryResult<GetGrailpayOwnerBankAccountsQuery, GetGrailpayOwnerBankAccountsQueryVariables>;
export const GetRentalInventoryForOverbookingModalDocument = gql`
    query GetRentalInventoryForOverbookingModal($rentalId: Int!) {
  getRentalInventory(rentalId: $rentalId, includeBundleInventory: true) {
    ... on RentalItem {
      id
      name
      quantity
      inventoryId
      subRentedQuantity
      __typename
    }
    ... on RentalAccessory {
      id
      name
      quantity
      inventoryId
      subRentedQuantity
      __typename
    }
    ... on RentalBundle {
      id
      name
      quantity
      inventoryId
      __typename
    }
    ... on RentalAddOn {
      id
      name
      quantity
      inventoryId
      subRentedQuantity
      __typename
    }
    ... on RentalStaff {
      id
      name
      size
      inventoryId
      __typename
    }
  }
}
    `;

/**
 * __useGetRentalInventoryForOverbookingModalQuery__
 *
 * To run a query within a React component, call `useGetRentalInventoryForOverbookingModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalInventoryForOverbookingModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalInventoryForOverbookingModalQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *   },
 * });
 */
export function useGetRentalInventoryForOverbookingModalQuery(baseOptions: Apollo.QueryHookOptions<GetRentalInventoryForOverbookingModalQuery, GetRentalInventoryForOverbookingModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalInventoryForOverbookingModalQuery, GetRentalInventoryForOverbookingModalQueryVariables>(GetRentalInventoryForOverbookingModalDocument, options);
      }
export function useGetRentalInventoryForOverbookingModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalInventoryForOverbookingModalQuery, GetRentalInventoryForOverbookingModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalInventoryForOverbookingModalQuery, GetRentalInventoryForOverbookingModalQueryVariables>(GetRentalInventoryForOverbookingModalDocument, options);
        }
export type GetRentalInventoryForOverbookingModalQueryHookResult = ReturnType<typeof useGetRentalInventoryForOverbookingModalQuery>;
export type GetRentalInventoryForOverbookingModalLazyQueryHookResult = ReturnType<typeof useGetRentalInventoryForOverbookingModalLazyQuery>;
export type GetRentalInventoryForOverbookingModalQueryResult = Apollo.QueryResult<GetRentalInventoryForOverbookingModalQuery, GetRentalInventoryForOverbookingModalQueryVariables>;
export const GetNestedSfCategoriesForLinkBuilderDocument = gql`
    query GetNestedSfCategoriesForLinkBuilder($locationId: Int!, $order: StorefrontCategoryOrderEnum, $direction: StorefrontCategoryDirectionEnum) {
  getStorefrontCategories(
    locationId: $locationId
    order: $order
    direction: $direction
  ) {
    id
    name
    path
    parentId
    depth
    __typename
  }
}
    `;

/**
 * __useGetNestedSfCategoriesForLinkBuilderQuery__
 *
 * To run a query within a React component, call `useGetNestedSfCategoriesForLinkBuilderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNestedSfCategoriesForLinkBuilderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNestedSfCategoriesForLinkBuilderQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      order: // value for 'order'
 *      direction: // value for 'direction'
 *   },
 * });
 */
export function useGetNestedSfCategoriesForLinkBuilderQuery(baseOptions: Apollo.QueryHookOptions<GetNestedSfCategoriesForLinkBuilderQuery, GetNestedSfCategoriesForLinkBuilderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNestedSfCategoriesForLinkBuilderQuery, GetNestedSfCategoriesForLinkBuilderQueryVariables>(GetNestedSfCategoriesForLinkBuilderDocument, options);
      }
export function useGetNestedSfCategoriesForLinkBuilderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNestedSfCategoriesForLinkBuilderQuery, GetNestedSfCategoriesForLinkBuilderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNestedSfCategoriesForLinkBuilderQuery, GetNestedSfCategoriesForLinkBuilderQueryVariables>(GetNestedSfCategoriesForLinkBuilderDocument, options);
        }
export type GetNestedSfCategoriesForLinkBuilderQueryHookResult = ReturnType<typeof useGetNestedSfCategoriesForLinkBuilderQuery>;
export type GetNestedSfCategoriesForLinkBuilderLazyQueryHookResult = ReturnType<typeof useGetNestedSfCategoriesForLinkBuilderLazyQuery>;
export type GetNestedSfCategoriesForLinkBuilderQueryResult = Apollo.QueryResult<GetNestedSfCategoriesForLinkBuilderQuery, GetNestedSfCategoriesForLinkBuilderQueryVariables>;
export const ProductPaginatedAlertingDocument = gql`
    query ProductPaginatedAlerting($rentalId: ID, $timeZoneOffset: String, $productId: String, $combineLikeItems: Boolean, $page: Int, $per: Int, $selectedDate: String) {
  productPaginatedAlerting(
    rentalId: $rentalId
    timeZoneOffset: $timeZoneOffset
    productId: $productId
    combineLikeItems: $combineLikeItems
    page: $page
    per: $per
    selectedDate: $selectedDate
  ) {
    rentalItems {
      quantity
      hasShortage
      rentalStatus
      rentalName
      rentalSchedule {
        endDateTime
        offShelfAt
        onShelfAt
        startDateTime
      }
      rentalToken
      unavailabilityReason
      subRentals {
        id
        supplierName
        rentalItemId
        quantity
        expense
        createdAt
        updatedAt
        rentalAccessoryId
        subRentalOwnerId
        subRentalOwnerType
        fulfilled
        subRentalSupplierId
        subRentalSupplierType
        name
        customerName
        contact
      }
    }
    meta
    error
  }
}
    `;

/**
 * __useProductPaginatedAlertingQuery__
 *
 * To run a query within a React component, call `useProductPaginatedAlertingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPaginatedAlertingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPaginatedAlertingQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      timeZoneOffset: // value for 'timeZoneOffset'
 *      productId: // value for 'productId'
 *      combineLikeItems: // value for 'combineLikeItems'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      selectedDate: // value for 'selectedDate'
 *   },
 * });
 */
export function useProductPaginatedAlertingQuery(baseOptions?: Apollo.QueryHookOptions<ProductPaginatedAlertingQuery, ProductPaginatedAlertingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPaginatedAlertingQuery, ProductPaginatedAlertingQueryVariables>(ProductPaginatedAlertingDocument, options);
      }
export function useProductPaginatedAlertingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPaginatedAlertingQuery, ProductPaginatedAlertingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPaginatedAlertingQuery, ProductPaginatedAlertingQueryVariables>(ProductPaginatedAlertingDocument, options);
        }
export type ProductPaginatedAlertingQueryHookResult = ReturnType<typeof useProductPaginatedAlertingQuery>;
export type ProductPaginatedAlertingLazyQueryHookResult = ReturnType<typeof useProductPaginatedAlertingLazyQuery>;
export type ProductPaginatedAlertingQueryResult = Apollo.QueryResult<ProductPaginatedAlertingQuery, ProductPaginatedAlertingQueryVariables>;
export const AddOnPaginatedAlertingDocument = gql`
    query AddOnPaginatedAlerting($rentalId: ID, $timeZoneOffset: String, $addOnId: String, $combineLikeItems: Boolean, $page: Int, $per: Int, $selectedDate: String) {
  addOnPaginatedAlerting(
    rentalId: $rentalId
    timeZoneOffset: $timeZoneOffset
    addOnId: $addOnId
    combineLikeItems: $combineLikeItems
    page: $page
    per: $per
    selectedDate: $selectedDate
  ) {
    rentalAddOns {
      quantity
      hasShortage
      rentalStatus
      rentalName
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        offShelfAt
        onShelfAt
        endWindowBeginning
        startDateTime
      }
      rentalToken
      unavailabilityReason
      subRentals {
        id
        supplierName
        rentalItemId
        quantity
        expense
        createdAt
        updatedAt
        rentalAccessoryId
        subRentalOwnerId
        subRentalOwnerType
        fulfilled
        subRentalSupplierId
        subRentalSupplierType
        name
        customerName
        contact
      }
    }
    meta
    error
  }
}
    `;

/**
 * __useAddOnPaginatedAlertingQuery__
 *
 * To run a query within a React component, call `useAddOnPaginatedAlertingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOnPaginatedAlertingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOnPaginatedAlertingQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      timeZoneOffset: // value for 'timeZoneOffset'
 *      addOnId: // value for 'addOnId'
 *      combineLikeItems: // value for 'combineLikeItems'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      selectedDate: // value for 'selectedDate'
 *   },
 * });
 */
export function useAddOnPaginatedAlertingQuery(baseOptions?: Apollo.QueryHookOptions<AddOnPaginatedAlertingQuery, AddOnPaginatedAlertingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddOnPaginatedAlertingQuery, AddOnPaginatedAlertingQueryVariables>(AddOnPaginatedAlertingDocument, options);
      }
export function useAddOnPaginatedAlertingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddOnPaginatedAlertingQuery, AddOnPaginatedAlertingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddOnPaginatedAlertingQuery, AddOnPaginatedAlertingQueryVariables>(AddOnPaginatedAlertingDocument, options);
        }
export type AddOnPaginatedAlertingQueryHookResult = ReturnType<typeof useAddOnPaginatedAlertingQuery>;
export type AddOnPaginatedAlertingLazyQueryHookResult = ReturnType<typeof useAddOnPaginatedAlertingLazyQuery>;
export type AddOnPaginatedAlertingQueryResult = Apollo.QueryResult<AddOnPaginatedAlertingQuery, AddOnPaginatedAlertingQueryVariables>;
export const AccessoryPaginatedAlertingDocument = gql`
    query AccessoryPaginatedAlerting($rentalId: ID, $timeZoneOffset: String, $accessoryId: String, $combineLikeItems: Boolean, $page: Int, $per: Int, $selectedDate: String) {
  accessoryPaginatedAlerting(
    rentalId: $rentalId
    timeZoneOffset: $timeZoneOffset
    accessoryId: $accessoryId
    combineLikeItems: $combineLikeItems
    page: $page
    per: $per
    selectedDate: $selectedDate
  ) {
    rentalAccessories {
      quantity
      hasShortage
      rentalStatus
      rentalName
      rentalSchedule {
        eventStartDateTime
        eventEndDateTime
        offShelfAt
        onShelfAt
        endWindowBeginning
        startDateTime
      }
      rentalToken
      unavailabilityReason
      subRentals {
        id
        supplierName
        rentalItemId
        quantity
        expense
        createdAt
        updatedAt
        rentalAccessoryId
        subRentalOwnerId
        subRentalOwnerType
        fulfilled
        subRentalSupplierId
        subRentalSupplierType
        name
        customerName
        contact
      }
    }
    meta
    error
  }
}
    `;

/**
 * __useAccessoryPaginatedAlertingQuery__
 *
 * To run a query within a React component, call `useAccessoryPaginatedAlertingQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessoryPaginatedAlertingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessoryPaginatedAlertingQuery({
 *   variables: {
 *      rentalId: // value for 'rentalId'
 *      timeZoneOffset: // value for 'timeZoneOffset'
 *      accessoryId: // value for 'accessoryId'
 *      combineLikeItems: // value for 'combineLikeItems'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      selectedDate: // value for 'selectedDate'
 *   },
 * });
 */
export function useAccessoryPaginatedAlertingQuery(baseOptions?: Apollo.QueryHookOptions<AccessoryPaginatedAlertingQuery, AccessoryPaginatedAlertingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessoryPaginatedAlertingQuery, AccessoryPaginatedAlertingQueryVariables>(AccessoryPaginatedAlertingDocument, options);
      }
export function useAccessoryPaginatedAlertingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessoryPaginatedAlertingQuery, AccessoryPaginatedAlertingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessoryPaginatedAlertingQuery, AccessoryPaginatedAlertingQueryVariables>(AccessoryPaginatedAlertingDocument, options);
        }
export type AccessoryPaginatedAlertingQueryHookResult = ReturnType<typeof useAccessoryPaginatedAlertingQuery>;
export type AccessoryPaginatedAlertingLazyQueryHookResult = ReturnType<typeof useAccessoryPaginatedAlertingLazyQuery>;
export type AccessoryPaginatedAlertingQueryResult = Apollo.QueryResult<AccessoryPaginatedAlertingQuery, AccessoryPaginatedAlertingQueryVariables>;
export const GetColumnFilterDocument = gql`
    query GetColumnFilter($rentalStatus: String!) {
  getColumnFilter(rentalStatus: $rentalStatus) {
    id
    rentalStatus
    settings
  }
}
    `;

/**
 * __useGetColumnFilterQuery__
 *
 * To run a query within a React component, call `useGetColumnFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetColumnFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetColumnFilterQuery({
 *   variables: {
 *      rentalStatus: // value for 'rentalStatus'
 *   },
 * });
 */
export function useGetColumnFilterQuery(baseOptions: Apollo.QueryHookOptions<GetColumnFilterQuery, GetColumnFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetColumnFilterQuery, GetColumnFilterQueryVariables>(GetColumnFilterDocument, options);
      }
export function useGetColumnFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetColumnFilterQuery, GetColumnFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetColumnFilterQuery, GetColumnFilterQueryVariables>(GetColumnFilterDocument, options);
        }
export type GetColumnFilterQueryHookResult = ReturnType<typeof useGetColumnFilterQuery>;
export type GetColumnFilterLazyQueryHookResult = ReturnType<typeof useGetColumnFilterLazyQuery>;
export type GetColumnFilterQueryResult = Apollo.QueryResult<GetColumnFilterQuery, GetColumnFilterQueryVariables>;
export const UpdateColumnFilterDocument = gql`
    mutation UpdateColumnFilter($rentalStatus: String!, $settings: JSON!) {
  updateColumnFilter(input: {rentalStatus: $rentalStatus, settings: $settings}) {
    columnFilter {
      id
      rentalStatus
      settings
    }
    errors
  }
}
    `;
export type UpdateColumnFilterMutationFn = Apollo.MutationFunction<UpdateColumnFilterMutation, UpdateColumnFilterMutationVariables>;

/**
 * __useUpdateColumnFilterMutation__
 *
 * To run a mutation, you first call `useUpdateColumnFilterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateColumnFilterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateColumnFilterMutation, { data, loading, error }] = useUpdateColumnFilterMutation({
 *   variables: {
 *      rentalStatus: // value for 'rentalStatus'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useUpdateColumnFilterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateColumnFilterMutation, UpdateColumnFilterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateColumnFilterMutation, UpdateColumnFilterMutationVariables>(UpdateColumnFilterDocument, options);
      }
export type UpdateColumnFilterMutationHookResult = ReturnType<typeof useUpdateColumnFilterMutation>;
export type UpdateColumnFilterMutationResult = Apollo.MutationResult<UpdateColumnFilterMutation>;
export type UpdateColumnFilterMutationOptions = Apollo.BaseMutationOptions<UpdateColumnFilterMutation, UpdateColumnFilterMutationVariables>;
export const GetRentalInventoryShortagesDocument = gql`
    query GetRentalInventoryShortages($locationId: Int!, $startDate: String!, $endDate: String!, $departmentIds: [String!], $search: String, $timeZoneOffset: String, $deliveryTypes: [String!]) {
  getRentalInventoryShortages(
    locationId: $locationId
    startDate: $startDate
    endDate: $endDate
    departmentIds: $departmentIds
    search: $search
    timeZoneOffset: $timeZoneOffset
    deliveryTypes: $deliveryTypes
  ) {
    rentalInventories {
      ... on RentalItem {
        id
        name
        quantity
        hasShortage
        hasSoftHold
        shortageQuantity
        softHoldQuantity
        productType
        inventoryId
        inventoryToken
        warehouseQuantity
        maintenanceQuantity
        subRentedQuantity
        deliveryType
        customerContactName
        itemType
        rentalSectionName
        groupInfo
        inventoryName
        __typename
        parentRental {
          id
          locationId
          token
          name
          status
          source
          schedule {
            offShelfAt
            onShelfAt
            startDateTime
            endDateTime
          }
        }
        subRentals {
          id
          quantity
        }
      }
      ... on RentalAccessory {
        id
        name
        quantity
        hasShortage
        hasSoftHold
        shortageQuantity
        softHoldQuantity
        productType
        inventoryId
        inventoryToken
        warehouseQuantity
        maintenanceQuantity
        subRentedQuantity
        deliveryType
        customerContactName
        itemType
        rentalSectionName
        groupInfo
        inventoryName
        __typename
        parentRental {
          id
          locationId
          token
          name
          status
          source
          schedule {
            offShelfAt
            onShelfAt
            startDateTime
            endDateTime
          }
        }
        subRentals {
          id
          quantity
        }
      }
      ... on RentalAddOn {
        id
        name
        quantity
        hasShortage
        hasSoftHold
        shortageQuantity
        softHoldQuantity
        productType
        inventoryId
        inventoryToken
        warehouseQuantity
        maintenanceQuantity
        subRentedQuantity
        deliveryType
        customerContactName
        itemType
        rentalSectionName
        groupInfo
        inventoryName
        __typename
        parentRental {
          id
          locationId
          token
          name
          status
          source
          schedule {
            offShelfAt
            onShelfAt
            startDateTime
            endDateTime
          }
        }
        subRentals {
          id
          quantity
        }
      }
    }
  }
}
    `;

/**
 * __useGetRentalInventoryShortagesQuery__
 *
 * To run a query within a React component, call `useGetRentalInventoryShortagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalInventoryShortagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalInventoryShortagesQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      departmentIds: // value for 'departmentIds'
 *      search: // value for 'search'
 *      timeZoneOffset: // value for 'timeZoneOffset'
 *      deliveryTypes: // value for 'deliveryTypes'
 *   },
 * });
 */
export function useGetRentalInventoryShortagesQuery(baseOptions: Apollo.QueryHookOptions<GetRentalInventoryShortagesQuery, GetRentalInventoryShortagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalInventoryShortagesQuery, GetRentalInventoryShortagesQueryVariables>(GetRentalInventoryShortagesDocument, options);
      }
export function useGetRentalInventoryShortagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalInventoryShortagesQuery, GetRentalInventoryShortagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalInventoryShortagesQuery, GetRentalInventoryShortagesQueryVariables>(GetRentalInventoryShortagesDocument, options);
        }
export type GetRentalInventoryShortagesQueryHookResult = ReturnType<typeof useGetRentalInventoryShortagesQuery>;
export type GetRentalInventoryShortagesLazyQueryHookResult = ReturnType<typeof useGetRentalInventoryShortagesLazyQuery>;
export type GetRentalInventoryShortagesQueryResult = Apollo.QueryResult<GetRentalInventoryShortagesQuery, GetRentalInventoryShortagesQueryVariables>;
export const GetRentalInventoriesDocument = gql`
    query GetRentalInventories($status: String!, $locationId: Int!, $page: Int!, $numberPer: Int, $startDateLte: String, $startDateGte: String, $endDateLte: String, $endDateGte: String, $startWindowFinishLte: String, $startWindowFinishGte: String, $endWindowBeginningLte: String, $endWindowBeginningGte: String, $departmentIds: [String!], $pickedStatus: [String!], $deliveryType: [String!], $deliveryTime: [String!], $truckIds: [String!], $inventoryId: String, $pickListStatus: [String!], $productType: String, $sortField: String, $sortDirection: String, $search: String) {
  getRentalInventories(
    locationId: $locationId
    status: $status
    page: $page
    numberPer: $numberPer
    startDateLte: $startDateLte
    startDateGte: $startDateGte
    endDateLte: $endDateLte
    endDateGte: $endDateGte
    startWindowFinishLte: $startWindowFinishLte
    startWindowFinishGte: $startWindowFinishGte
    endWindowBeginningLte: $endWindowBeginningLte
    endWindowBeginningGte: $endWindowBeginningGte
    departmentIds: $departmentIds
    pickedStatus: $pickedStatus
    deliveryType: $deliveryType
    deliveryTime: $deliveryTime
    truckIds: $truckIds
    inventoryId: $inventoryId
    pickListStatus: $pickListStatus
    productType: $productType
    sortField: $sortField
    sortDirection: $sortDirection
    search: $search
  ) {
    rentalInventories {
      ... on RentalItem {
        id
        name
        quantity
        departmentName
        warehouseLocation
        __typename
        status
        hasShortage
        pickListStatus
        pickListQuantity
        pickListPickedQuantity
        pickListMissingQuantity
        pictures
        rentalSchedule {
          endDateTime
          startDateTime
          eventEndSetting
          eventStartSetting
          endWindowBeginning
        }
        parentRental {
          locationId
          token
          name
          status
          schedule {
            endDateTime
            startDateTime
            eventEndSetting
            eventStartSetting
          }
        }
      }
      ... on RentalAddOn {
        id
        name
        quantity
        departmentName
        warehouseLocation
        __typename
        hasShortage
        status
        pickListStatus
        pickListQuantity
        pickListPickedQuantity
        pickListMissingQuantity
        pictures
        rentalSchedule {
          endDateTime
          startDateTime
          eventEndSetting
          eventStartSetting
          endWindowBeginning
        }
        parentRental {
          locationId
          token
          name
          schedule {
            endDateTime
            startDateTime
            eventEndSetting
            eventStartSetting
          }
        }
      }
      ... on RentalAccessory {
        id
        name
        quantity
        departmentName
        warehouseLocation
        hasShortage
        __typename
        status
        pickListStatus
        pickListQuantity
        pickListPickedQuantity
        pickListMissingQuantity
        pictures
        rentalSchedule {
          endDateTime
          startDateTime
          eventEndSetting
          eventStartSetting
          endWindowBeginning
        }
        parentRental {
          locationId
          token
          name
          schedule {
            endDateTime
            startDateTime
            eventEndSetting
            eventStartSetting
          }
        }
      }
    }
    pagination
  }
}
    `;

/**
 * __useGetRentalInventoriesQuery__
 *
 * To run a query within a React component, call `useGetRentalInventoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalInventoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalInventoriesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      locationId: // value for 'locationId'
 *      page: // value for 'page'
 *      numberPer: // value for 'numberPer'
 *      startDateLte: // value for 'startDateLte'
 *      startDateGte: // value for 'startDateGte'
 *      endDateLte: // value for 'endDateLte'
 *      endDateGte: // value for 'endDateGte'
 *      startWindowFinishLte: // value for 'startWindowFinishLte'
 *      startWindowFinishGte: // value for 'startWindowFinishGte'
 *      endWindowBeginningLte: // value for 'endWindowBeginningLte'
 *      endWindowBeginningGte: // value for 'endWindowBeginningGte'
 *      departmentIds: // value for 'departmentIds'
 *      pickedStatus: // value for 'pickedStatus'
 *      deliveryType: // value for 'deliveryType'
 *      deliveryTime: // value for 'deliveryTime'
 *      truckIds: // value for 'truckIds'
 *      inventoryId: // value for 'inventoryId'
 *      pickListStatus: // value for 'pickListStatus'
 *      productType: // value for 'productType'
 *      sortField: // value for 'sortField'
 *      sortDirection: // value for 'sortDirection'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetRentalInventoriesQuery(baseOptions: Apollo.QueryHookOptions<GetRentalInventoriesQuery, GetRentalInventoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalInventoriesQuery, GetRentalInventoriesQueryVariables>(GetRentalInventoriesDocument, options);
      }
export function useGetRentalInventoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalInventoriesQuery, GetRentalInventoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalInventoriesQuery, GetRentalInventoriesQueryVariables>(GetRentalInventoriesDocument, options);
        }
export type GetRentalInventoriesQueryHookResult = ReturnType<typeof useGetRentalInventoriesQuery>;
export type GetRentalInventoriesLazyQueryHookResult = ReturnType<typeof useGetRentalInventoriesLazyQuery>;
export type GetRentalInventoriesQueryResult = Apollo.QueryResult<GetRentalInventoriesQuery, GetRentalInventoriesQueryVariables>;
export const GetRentalUpdatedAtDocument = gql`
    query GetRentalUpdatedAt($ID: String!) {
  getRentalById(ID: $ID) {
    id
    updatedAt
  }
}
    `;

/**
 * __useGetRentalUpdatedAtQuery__
 *
 * To run a query within a React component, call `useGetRentalUpdatedAtQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalUpdatedAtQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalUpdatedAtQuery({
 *   variables: {
 *      ID: // value for 'ID'
 *   },
 * });
 */
export function useGetRentalUpdatedAtQuery(baseOptions: Apollo.QueryHookOptions<GetRentalUpdatedAtQuery, GetRentalUpdatedAtQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalUpdatedAtQuery, GetRentalUpdatedAtQueryVariables>(GetRentalUpdatedAtDocument, options);
      }
export function useGetRentalUpdatedAtLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalUpdatedAtQuery, GetRentalUpdatedAtQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalUpdatedAtQuery, GetRentalUpdatedAtQueryVariables>(GetRentalUpdatedAtDocument, options);
        }
export type GetRentalUpdatedAtQueryHookResult = ReturnType<typeof useGetRentalUpdatedAtQuery>;
export type GetRentalUpdatedAtLazyQueryHookResult = ReturnType<typeof useGetRentalUpdatedAtLazyQuery>;
export type GetRentalUpdatedAtQueryResult = Apollo.QueryResult<GetRentalUpdatedAtQuery, GetRentalUpdatedAtQueryVariables>;
export const GetRentalsDocument = gql`
    query getRentals($search: String, $status: [String!], $eventId: ID) {
  getRentals(search: $search, status: $status, eventId: $eventId) {
    id
    name
  }
}
    `;

/**
 * __useGetRentalsQuery__
 *
 * To run a query within a React component, call `useGetRentalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRentalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRentalsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRentalsQuery(baseOptions?: Apollo.QueryHookOptions<GetRentalsQuery, GetRentalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRentalsQuery, GetRentalsQueryVariables>(GetRentalsDocument, options);
      }
export function useGetRentalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRentalsQuery, GetRentalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRentalsQuery, GetRentalsQueryVariables>(GetRentalsDocument, options);
        }
export type GetRentalsQueryHookResult = ReturnType<typeof useGetRentalsQuery>;
export type GetRentalsLazyQueryHookResult = ReturnType<typeof useGetRentalsLazyQuery>;
export type GetRentalsQueryResult = Apollo.QueryResult<GetRentalsQuery, GetRentalsQueryVariables>;
